import React, { Component } from 'react';
import * as XLSX from 'xlsx'

import { CSVLink } from "react-csv";
import $, { param } from 'jquery';
import '../css/dataTables.css';
import { FORMAT_NUMBER, invFields, json, Modules, OPRQFields, userPropsTemplate, validCoordinate, Granel, Envasados, transferFields, Sections } from '../libs/utils/Const';
import {
    renderTableOrderSales,
    renderTableInvoice,
    renderTableInvoiceAdvance,
    renderTablePurchaseDownPayments,
    renderTableTransfers,
    renderTableBorrador,
    renderBussinesPartner,
    renderTablePurchaseOrder,
    renderTablePurchaseRequest,
    renderTableGoodsReceipt,
    RenderConfigHeaderDataTableEnabled,
    RenderConfigUserFieldsEnabled,
    renderDataTableActions,
    DocumentCreateModal,
    BillingResponseModal,
    SelectSeriesModal,
    renderInventoryData,
    InventoryDataModal,
    BussinesPartnerModal,
    renderTableTransfersRequest,
    renderTableAuthorization,
    AuthorizationModel,
    PrintToDocumentsModal,
    renderTableMiddleware,
    AdministratorUsersModal,
    renderTableUsers,
    BatchDefinitionModal,
    BatchSelectionModal,
    // #region Componentes CARTA PORTE
    renderFiguraTransporte,
    FiguraTransporteModal,
    renderTransporte,
    TransporteModal,
    renderCartaPorte,
    renderPendingTimbraDocs,
    CartaPorteModal,
    MercanciaPorteModal,
    // #endregion
    UpdateTimbraDocs,
    renderCitibanamex,
    VendorsModal,
    // timbrado nominas
    renderTableNominas,
    renderEmployeeNomina,
    NominaModal,
    EmployeeNominaModal,
    // m-suite
    renderAuthorizePartners,
    ApproveBusinessPartnerModal,
    renderAdminDeliveries20,
    DocDelivery,
    WarningModal,
    //#region MRP
    renderStandardDataTableDocuments,
    renderReportSelectionCriteria,
    //#endregion
    // LandedCosts
    renderTableLandedCosts,
    renderTableSuggestRefill,

    // suggestRefillDoc
    SuggestRefillModal,
    MVentasAdminUsersModal,
    ReconciliationModal,
    GroupNumbersModal,
    renderPriceLists,
    NewPriceListModal,
    renderTableInventoryDocuments,
    AreYouAgreeModal,
    AuthorizationModalParnter,
    RoadMapPreviewModal,
    renderCollect,
    MassiveUsersModal,
    CancelPaymentModal,
    renderTableIncomingPayment,
    renderTablePurchaseQuotation,
    renderTableDraft,
} from '../components';
import ContinueModal from './ContinueModal'
import moment from "moment";
import { DISPATCH_ID, SERVICE_RESPONSE, RFC_FORMAT, GET_VIEW_NAME_BY_DOCTYPE } from "../libs/utils/Const";
import { connect } from "react-redux";
import Select from 'react-select';
import { ApiClient } from "../libs/apiClient";

import config from "../config";
import {
    NewOrder,
    NewItem,
    NewItemPayment,
    Permissions,
    UserFields,
    BusinessPartner,
    ContactPersons,
    Addresses,
    InventoryModel,
    NewService,
    UserFieldsItem,
    AdministratorUsers,
    CounterPermissions,
    BranchPermissions,
    ConceptoPorte,
    //#region Modelos Carta Porte 
    // FiguraTransporte
    TiposFigura,

    // Transportes
    Autotransporte,
    TransporteAereo,
    TransporteFerroviario,
    TransporteMaritimo,

    // Carta Porte
    Mercancia,
    UbicacionPorte,
    CartaPorte,
    //#endregion
    TimbraDocModel,

    // M-SUITE
    Driver,
    Vehicle,
    AuthorizePartnerModel,
    RouteDocDelivery,
    DocsLineRouteDelivery,
    // refill module
    SuggestRefillDocument,
    PriceListsModel,
    TimbradoNomina,
    EmployeeNomina,

} from '../components/NewOrder';
import { CURRENCY } from '../libs/utils/Const';
import CitibanamexTransactionsModal from './CitibanamexTransactionsModal';
import FileUploaderModal from './FileUploaderModal';
import { number } from 'prop-types';
import { renderMVentasAdminUser } from './renderMVentasAdminUser';
import PrintDocumentsModal from './PrintDocumentsModal';
import { renderWareHouseAdminList } from './renderWareHouseAdminList';
import { columnOrderByView, getNCStatus, isMarketingDoc, roundToDecimals, isSalesDocument, isPurchaseDocument } from '../libs/utils/GlobalFunc';
import download from 'js-file-download';
import TransfersDocumentModal from './TransfersDocumentModal';
import { renderCanalizadoTanque } from './renderCanalizadoTanque';
import FactoryActions from './FactoryActions/FactoryActions';
import ResumeTransportModal from './ResumeTransportModal';
import SunatGuideModal from './SunatGuideModal';
import DocumentModal from './document/DocumentModal';
import { renderReabsResume } from './renderReabsResume';
import { renderCutTransfers } from './renderCutTransfers';
import { renderMVentasDocs } from './renderMVentasDocs';
// Renderizador especializado para filas de Cortes Pendientes, de solo lectura y paginadas en servidor.
import { renderPendingCuts } from './renderPendingCuts';

const CryptoJS = require("crypto-js");
$.DataTable = require('datatables.net-bs4');
const EMAIL_FORMAT_REGEX = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
let apiClient = ApiClient.getInstance();
const bussinesPartner = [
    { title: 'Código', value: false, "position": 0 },
    { title: 'Tipo', value: false, "position": 1 },
    { title: 'Nombre', value: false, "position": 2 },
    { title: 'Grupo', value: false, "position": 3 },
    { title: 'Moneda', value: false, "position": 4 },
    { title: 'RUT', value: false, "position": 5 },
    { title: 'General', value: false, "position": 6 },
    { title: 'Telefono 1', value: false, "position": 7 },
    { title: 'Telefono 2', value: false, "position": 8 },
];

const USO_CFDI_CATALOG = [
    { code: "I07", Description: "Comunicaciones satelitales" },
    { code: "I06", Description: "Comunicaciones telefónicas" },
    { code: "I01", Description: "Construcciones" },
    { code: "I05", Description: "Dados, troqueles, moldes, matrices y herramental" },
    { code: "G02", Description: "Devoluciones, descuentos o bonificaciones" },
    { code: "I04", Description: "Equipo de computo y accesorios" },
    { code: "I03", Description: "Equipo de transporte" },
    { code: "G03", Description: "Gastos en general" },
    { code: "I02", Description: "Mobiliario y equipo de oficina por inversiones" },
    { code: "I08", Description: "Otra maquinaria y equipo" },
    { code: "S01", Description: "Sin efectos fiscales." },
]
const restrictedViewsSearch = [
    // Cortes Pendientes gestiona sus filtros en PendingCutsView, por lo que oculta controles genéricos de tabla.
    'reportSelectionCriteria', 'adminUsersMVentas', 'wareHouseAdmin', 'canalizadoTanque', 'transports', 'collectView', 'reabsResume', 'cutTransfers', 'pendingCuts'
];
const labelViewsSearch = [
    'bussinesPartner', 'inventoryData', 'administratorUsers'
];
class DataTables extends Component {
    csvLink = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            excelFile: "",
            dateInit: "",
            dateFinal: "",
            refresh: true,
            action: null,
            configHeaderTable: [],
            configHeaderUserFields: [],
            billingResponseArray: [],
            seriesArray: [],
            seriesDefault: "",
            seriesDefaultName: "",
            newOrderModel: {
                Items: [],
                ItemsPayments: [],
            },
            newOrderModelEditMode: {
                Items: [],
                ItemsPayments: [],
            },
            partnerModel: {},
            newBusinessPartnerEditMode: {},
            newInventoryDataEditMode: {},
            documentModalAction: "",
            partnerModalAction: "",
            checkboxDataTables: (new Map()),
            prices: [],
            priceValue: '---',
            groupCodeValue: '---',
            employeeValue: '---',
            inventoryModalAction: "",
            inventoryModel: {},
            ListItemsGroup: [],
            Producers: [],
            ListUnitMeasuGroup: [],
            hoja: "",
            template: [],
            file: false,
            partners: [],
            Continue: false,
            PageNumber: 1,
            itemsPage: 10,
            rows: 30,
            TotalRows: 30,
            searchValue: '',
            switch1: false,
            dataCsv: [],
            docStatus: '---',
            noOrder: '',
            taxCodeExce: '',
            authorizedFilter: '',
            handleRemarksState: [],
            docNumSearch: '',
            comments: [],
            auths: [],
            documentsToPrint: [],
            showDocumentModal: false,
            showInventoryModal: false,
            showPartnerModal: false,
            showGroupNumModal: false,
            searchGroupNum: false,
            groupNum: null,
            adminUsersModalAction: "",
            showAdminUsersModal: false,
            adminUsersModel: {},
            newAdminUsersEditMode: {},
            itemsDashboard: {},
            groupSucursal: '---',
            bussinesPartnerArray: bussinesPartner,
            showBatchDefinitionModal: false,
            showBatchSelectionModal: false,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            showBusinessPartnerFields: false,
            // Token de acceso
            token: {},
            infoToken: null,
            //#region  ### CARTA PORTE
            // FiguraTransporte
            tipoFiguraModel: new TiposFigura(),
            newTipoFiguraEditMode: {},
            tipoFiguraModalAction: "",

            // Transportes
            transporteModel: {},
            newTransporteEditMode: {},
            transporteModalAction: "",
            tipoTransporte: 'Autotransporte',

            // Carta Porte
            cartaPorteModel: new CartaPorte(),
            newCartaPorteEditMode: {},
            cartaPorteModalAction: "",
            disableButton: false,

            // Direcciones
            ubicacionesModel: new UbicacionPorte(),
            newUbicacionesEditMode: {},
            ubicacionesModalAction: "",

            // Mercancia
            mercanciaModel: new Mercancia(),
            newMercanciaEditMode: {},
            mercanciaModalAction: "",

            // Catalogs
            listCountries: [],
            //#endregion 

            isPorteFields: false,
            updateTimbraDocModel: new TimbraDocModel(),
            showUpdateTimbraDocModal: false,
            CFDI: [],
            RegimenFiscal: [],
            GroupNumList: [],
            editModeUpdateTimbraDocModel: false,
            actionUpdateTimbraDoc: true,
            timbraDocCache: null,
            searchSerieName: '',
            searchVendor: '',
            docFilter: 'OPCH',

            //#region  ### M-SUITE
            driverModel: new Driver(),
            vehicleModel: new Vehicle(),
            driverModalAction: "",
            vehicleModalAction: "",
            docStatusSearchAuthoBP: 'W',
            authoPartnersAction: '',
            ennableDetailAuthoPartner: false,
            typeAuthoPartner: 1,
            authorizePartnerModel: new AuthorizePartnerModel(),
            viewDetails: '',
            suggestionDocs: false,

            //#region  ### ADMIN DELIVERIES 2.0
            DeliveryRouteDoc: null,
            availableVehicles: [],
            availableDrivers: [],
            ActualRoutes: [],
            Waypoints: [],
            DocDeliveryAction: "",
            AvailableDeliveryLines: [],
            MountListAvailableLines: false,
            MountDocDeliveryModal: false,
            checkboxDocDeliveries: (new Map()),
            //#endregion 
            //#endregion 


            showWarningModal: false,

            //#region MRP
            scenarios: [],
            //#endregion

            //#region Suggest Refill Modal
            showSuggestRefill: false,
            refillModel: new SuggestRefillDocument(),
            refillModelAction: 1,
            //#endregion

            //#region TIMBRADO DE NOMINA 
            enableTimbraNomModal: false,
            timbraNomModel: new TimbradoNomina(),
            nominaModalAction: 1,

            enableEmployeeNomModal: false,
            employeeNomModel: new EmployeeNomina(),
            employeeNomModalAction: 1,


            //#endregion
            showReconciliationModal: false,
            clientList: [],
            itemList: [],
            showPriceListModal: false,
            priceListAction: 1,
            priceListsModel: '',
            newArrayLists: [],
            editModePriceList: false,
            showRequestPartialEdit: false,
            ObjType: '',
            userFieldsPartner: null,

            property: '',
            propertyCode: null,
            showSeriesModal: false,
            checkboxDocSeries: (new Map()),

            //#region GESTOR DE ENTREGAS FÍSICAS
            U_FMB_AttentionType: '',
            U_FMB_AttentionType2: '',
            //#endregion GESTOR DE ENTREGAS FÍSICAS

            showTransfersDocumentModal: false,
            glAccounts: null,

            //#region ATTACHMENT
            files: [],
            //#endregion ATTACHMENT
            docformat: 1,
            showRoadmapPreview: false,
            RoadmapPreview: [],
            optionSelected: 0,
            showResumeTransportModal: false,
            sunatGuideData: [],
            showSunatGuideModal: false,
            action0GuideData: null,
            forceProcess: null,
            useNewModal: false,
            massiveUsers: [],
            //#region Massive Incoming Payments Cancellation
            showCancelPaymentModal: false,
            cancelPaymentCurrentDate: false,
            isMassive: false,
            paymentsToCancel: [],
            cancelPaymentMode: 'global',
            paymentDocumentDates: {},
            //#endregion Massive Incoming Payments Cancellation
            CFWOptions: [],
            selectedSucursal: [],
            selectedAnalista: [],
        };

        this.table = null;
        this.documentCreateModal = null;
        this.bussinesPartnerModal = null;
        this.inventoryDataModal = null;
        this.administratorUsersModal = null;
        this.handleInputChange = this.handleInputChange.bind(this);
        //#region 
        this.tipoFiguraModal = null;
        this.transporteModal = null;
        this.cartaPorteModal = null;

        this.ubicacionesModal = null;
        this.mercanciaModal = null;
        //#endregion

        this.docDeliveryModal = null;
    }

    componentDidMount = async () => {
        const { view } = this.props;
        // Un resultado inicial vacío no tiene filas DOM para el plugin jQuery; inicializa cuando llegan datos.
        if (view !== 'pendingCuts') {
            this.createDataTable();
        }
        if (view !== 'bussinesPartner' && view !== 'inventoryData' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== "reportSelectionCriteria" && view !== 'adminUsersMVentas' && view !== 'wareHouseAdmin' && view !== 'priceLists' && view !== 'collectView' && view !== 'reabsResume' && view !== 'cutTransfers' && view !== 'pendingCuts') {
            document.getElementById("fechaInicio").value = moment(new Date()).format('YYYY-MM-DD');
            document.getElementById("fechaFin").value = moment(new Date()).format('YYYY-MM-DD');
        }
        if (view === 'consignmentNote') document.getElementById("fechaInicio").value = moment().subtract(15, 'days').format('YYYY-MM-DD');
        if (view === 'mrpAssistant' || view === 'salesForecast') {
            document.getElementById("fechaInicio").value = moment().startOf("month").format('YYYY-MM-DD');
            document.getElementById("fechaFin").value = moment().endOf("month").format('YYYY-MM-DD');
        }
        if (view === 'payment') {
            this.getSuggestionsList();
            this.setState({ docStatus: 'N' });
        }
        const getSatCatalogs = view === "consignmentNote" || view === "figuresTransport" || view === "transports";
        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        let bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        let countrySATResponse = { data: [] };
        if (getSatCatalogs) { countrySATResponse = await apiClient.getCountrySAT(); }
        this.setState({
            itemsDashboard,
            listCountries: countrySATResponse.data,
            isCanceled: 'N',
        });

        if (view === 'adminDeliveries20' || view === 'transports') this.GetAdminDeliveriesData();
    }

    getSuggestionsList = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        const clientListResponseApi = await apiClient.getClientListDocument();
        if (clientListResponseApi.status === SERVICE_RESPONSE.SUCCESS) { await this.setState({ clientList: clientListResponseApi?.data ?? [] }); }
        const itemListResponseApi = await apiClient.getSuggestionsDocument({ view: 'transfers' });
        if (itemListResponseApi.status === SERVICE_RESPONSE.SUCCESS) { await this.setState({ itemList: itemListResponseApi?.data ?? [] }); }
        enableSpinner(false);
    }

    componentDidUpdate = () => {
        // También cubre una primera búsqueda que cambia un reporte vacío a uno con resultados.
        if (this.table === null) {
            this.createDataTable();
        }
        // return true
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (this.props.DraftObjType !== nextProps.DraftObjType) {
            if (this.table) {
                this.table.destroy();
                this.table = null;
            }
        } else if (this.props.data !== nextProps.data) {
            if (this.table) {
                this.table.destroy();
                this.table = null;
            }
        } else if (this.state.selectedSucursal !== nextState.selectedSucursal) {
            if (this.table) {
                this.table.destroy();
                this.table = null;
            }
        } else if (this.state.selectedAnalista !== nextState.selectedAnalista) {
            if (this.table) {
                this.table.destroy();
                this.table = null;
            }
        }
        return true;
    }

    createDataTable = () => {
        const { view } = this.props
        this.table = $('#dataTableTimbra').DataTable({
            "dom": '<"toolbar">frtip',
            "pagingType": "full_numbers",
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            // order: [[columnOrderByView(view)?.column || 0, columnOrderByView(view)?.order || 'asc']],
            responsive: true,
        });

        this.getTableInfoResult();
        this.changePaging();
    };
    selectAll = async (value) => {
        const { transporteModel } = this.state
        await this.setState(state => {
            let newSeries = [...transporteModel.newSeries];

            newSeries = newSeries.map((item, index) => ({
                ...item,
                selected: value
            }));
            transporteModel.newSeries = newSeries;
            this.refreshTransporteModel(transporteModel);
        });
    }
    toggleDocumentSelected = async (id, option = null) => {
        const { transporteModel } = this.state
        switch (option) {
            case 2:
                await this.setState(state => {
                    let newSeries = transporteModel.newSeries;
                    newSeries[id].selected = !newSeries[id].selected;
                    this.refreshTransporteModel(transporteModel);
                });
                break;
            case 3:
                await this.setState(state => {
                    let newSeries = [...transporteModel.newSeries];

                    newSeries = newSeries.map((item, index) => ({
                        ...item,
                        default: index === id,
                        selected: index === id ? true : (item?.selected ?? false)
                    }));
                    transporteModel.newSeries = newSeries;
                    this.refreshTransporteModel(transporteModel);
                });
                break;

            default:
                this.setState(state => {
                    const checkboxDataTables = new Map(state.checkboxDataTables);
                    checkboxDataTables.set(id, !checkboxDataTables.get(id)); // toggle
                    return { checkboxDataTables };
                });
                break;
        }
    };

    toggleDocumentSelectedAll = (action) => {
        const { data } = this.props;
        let newCheckbox = (new Map());

        for (let index = 0; index < data.length; index++) {
            const register = data[index];
            if (register.statusBorrador !== 'W' && register.statusBorrador !== 'Y' && !register.U_UDF_UUID) {
                newCheckbox.set(index, action)
            }
        }

        this.setState({
            checkboxDataTables: newCheckbox
        });
    };

    searchBySucursal = (event) => {
        this.setState({ sucursalSearch: event.nativeEvent.target.value });
    };

    Change_ListName = async (event, index) => {
        const { Change_ListName } = this.props;
        // IR HASTA LA ULTIMA PAGINA DEL DOCUMENTO
        await Change_ListName(event, index);
        this.table.page('last').draw('page');
        // this.getTableInfoResult();
        // setTimeout(() => {
        const lastInput = document.querySelector(`#txtListName`);
        if (lastInput) lastInput.focus();
        // }, 100);
    };

    renderTable = () => {
        const { view, headers, data: rawData, refs, Change_ListName, DraftObjType = '' } = this.props;
        const { checkboxDataTables, selectedSucursal, selectedAnalista } = this.state;

        const sucursalesSeleccionadas = (selectedSucursal || [])?.map(s => s.value);
        const analistasSeleccionados = (selectedAnalista || [])?.map(a => a.value);

        const isOPORView = view === 'PurchaseOrder' || (view === 'draft' && String(DraftObjType) === '22');
        const data = ((view === 'PurchaseRequest' || isOPORView) && (sucursalesSeleccionadas?.length > 0 || (isOPORView && analistasSeleccionados?.length > 0)))
            ? (rawData || []).filter(d =>
                (sucursalesSeleccionadas?.length === 0 || sucursalesSeleccionadas?.includes(isOPORView ? d.SucursalLinea : d.Sucursal)) &&
                (!isOPORView || analistasSeleccionados?.length === 0 || analistasSeleccionados?.includes(d.SlpCode))
            )
            : rawData;
        let table = "";
        let configStorage = JSON.parse(localStorage.getItem(view + 'configHeader'));
        let newHeaders = [];
        if (!configStorage) {

            localStorage.setItem(view + 'configHeader', JSON.stringify(headers));
            newHeaders = headers;
        } else {
            newHeaders = configStorage;
        }

        if (view === 'draft' && (DraftObjType === '540000006' || DraftObjType === '22' || DraftObjType === '1250000001')) {
            newHeaders = headers;
        }

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        let texArea = {
            handleRemarks: this.comentsDocuments,
            handleAuthorization: this.handleAutorization,
        }


        switch (view) {
            case 'quotations':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'orderSales':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails, view);
                break;
            case 'deliveries':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'invoice':
                table = renderTableInvoice(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'invoiceAdvance':
                table = renderTableInvoiceAdvance(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'purchaseDownPayments':
                table = renderTablePurchaseDownPayments(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'invoiceReserve':
                table = renderTableInvoice(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'debitNote':
                table = renderTableInvoice(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'return':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'creditNote':
                table = renderTableInvoice(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'purchaseReturn':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'payment':
                table = renderTableIncomingPayment(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'transfers':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails, view);
                break;
            case 'transfersRequest':
                table = renderTableTransfersRequest(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'transfersEntry':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails, view);
                break;
            case 'transfersOutput':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails, view);
                break;
            case 'invoiceBorrador':
                table = renderTableBorrador(newHeaders, data, checkbox, this.openDocumentDetails, view, texArea);
                break;
            case 'invoiceAuthorization':
                table = renderTableAuthorization(newHeaders, data, checkbox, this.openDocumentDetails, view, texArea);
                break;
            case 'bussinesPartner':
                table = renderBussinesPartner(newHeaders, data, checkbox, this.openBusinessPartnerDetails);
                break;
            case 'PurchaseOrder':
                table = renderTablePurchaseOrder(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'middleware':
                table = renderTableMiddleware(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'GoodsReceipt':
                table = renderTableGoodsReceipt(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'PurchaseRequest':
                table = renderTablePurchaseRequest(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'inventoryData':
                table = renderInventoryData(newHeaders, data, checkbox, this.openInventoryDataDetails);
                break;
            case 'inventoryCounting':
                table = renderTableInventoryDocuments(headers, data, checkbox, this.props.actions.openDocumentDetails);
                break;
            case 'inventoryPosting':
                table = renderTableInventoryDocuments(headers, data, checkbox, this.props.actions.openDocumentDetails);
                break;
            case 'inventoryRevaluation':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'SalesHelmets':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails, view);
                break;
            case 'ExitHelmets':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails, view);
                break;
            case 'purchaseInvoice':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'purchaseCreditNotes':
                table = renderTableOrderSales(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'outgoingPayment':
                table = renderTableTransfers(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'administratorUsers':
                table = renderTableUsers(newHeaders, data, checkbox, this.OpenAdministratorUsersDetails);
                break;
            //#region CARTA PORTE
            case 'figuresTransport':
                table = renderFiguraTransporte(newHeaders, data, checkbox, this.openTipoFiguraDetails);
                break;
            case 'transports':
                table = renderTransporte(newHeaders, data, checkbox, this.openTransporteDetails);
                break;
            case 'consignmentNote':
                table = renderCartaPorte(newHeaders, data, checkbox, this.openCartaPorteDetails);
                break;
            //#endregion
            //#region MRP
            case 'salesForecast':
                table = renderStandardDataTableDocuments({ headers, data, checkbox, action: this.props.actions.openDocumentDetails, noSelectable: true });
                break;
            case 'mrpAssistant':
                table = renderStandardDataTableDocuments({ headers, data, checkbox, action: this.props.actions.openDocumentDetails, noSelectable: true });
                break;
            //#endregion
            case 'pendingTimbraDoc':
                table = renderPendingTimbraDocs(newHeaders, data, checkbox, this.OpenPendingTimbraDocsDetail);
                break;
            case 'citibanamex':
                table = renderCitibanamex(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'authorizePartners':
                table = renderAuthorizePartners(headers, data, checkbox, this.ShowAuthorizePartnersDetails);
                break;
            case "adminDeliveries20":
                table = renderAdminDeliveries20(newHeaders, data, checkbox, this.OpenDeliveryDocDetails20);
                break;
            case 'reportSelectionCriteria':
                table = renderReportSelectionCriteria(headers, data);
                break;
            case "landedCosts":
                table = renderTableLandedCosts(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'suggestRefill':
                table = renderTableSuggestRefill(newHeaders, data, checkbox, this.openSuggestRefillDetails);
                break;
            case 'adminUsersMVentas':
                table = renderMVentasAdminUser(newHeaders, data, checkbox, this.props.openDetails);
                break;
            case 'wareHouseAdmin':
                table = renderWareHouseAdminList(newHeaders, data, checkbox, this.props.openDetails);
                break;
            case 'priceLists':
                table = renderPriceLists(newHeaders, data, checkbox, this.DetailsPriceList, Change_ListName, refs);
                break;
            case 'PurchaseQuotation':
                table = renderTablePurchaseQuotation(newHeaders, data, checkbox, this.openDocumentDetails);
                break;
            case 'draft':
                if (DraftObjType === '540000006') {
                    table = renderTableDraft(newHeaders, data, checkbox, this.openDocumentDetails);
                } else if (DraftObjType === '22') {
                    table = renderTablePurchaseOrder(newHeaders, data, checkbox, this.openDocumentDetails);
                } else if (DraftObjType === '1250000001') {
                    table = renderTableTransfersRequest(newHeaders, data, checkbox, this.openDocumentDetails);
                } else {
                    table = renderTableDraft(newHeaders, data, checkbox, this.openDocumentDetails);
                }
                break;
            case 'timbNominas':
                table = renderTableNominas(newHeaders, data, checkbox, this.OpenDocumentNominaDetails);
                break;
            case 'employeeNomina':
                table = renderEmployeeNomina(newHeaders, data, checkbox, this.OpenDocumentEmployeeNomDetails);
                break;
            case 'canalizadoTanque':
                table = renderCanalizadoTanque(newHeaders, data, checkbox, this.openTanquesModal);
                break;
            case "collectView":
                table = renderCollect(headers, data, checkbox);
                break;
            case "reabsResume":
                table = renderReabsResume(newHeaders, data, checkbox, this.props.openDetails);
                break;
            case "cutTransfers":
                table = renderCutTransfers(newHeaders, data, checkbox, this.props.openDetails);
                break;
            case "reprocessDocumentsMVentas":
                table = renderMVentasDocs(newHeaders, data, checkbox, this.props.openDetails);
                break;
            // Delega columnas, formato de valores y botón de detalle al renderizador del módulo.
            case "pendingCuts":
                table = renderPendingCuts(newHeaders, data, this.props.pendingCutsSelection || checkbox, this.props.openDetails);
                break;
            default:
                table = "";
        }
        return table;
    }
    openTransportResume = () => {
        this.setState({
            showResumeTransportModal: true
        }, () => {
            $('#ResumeTransportModal').modal('show');
        })
    }
    searchDocuments = () => {
        const { search, view, searchSuggestDoc, refreshSearch, searchData } = this.props;
        const { priceValue, groupCodeValue, employeeValue, PageNumber, searchValue, docStatus, docNumSearch, groupSucursal, searchSerieName, docFilter, docStatusSearchAuthoBP, U_FMB_AttentionType
            , isCanceled
        } = this.state;
        let date = {};
        // No lee filtros genéricos del DOM: esta vista mantiene sus filtros y envía la página al servidor.
        if (view === 'pendingCuts') {
            refreshSearch(searchData);
            search({ ...searchData, PageNumber: PageNumber || 1 });
            return;
        }
        if (view !== 'bussinesPartner' && view !== 'inventoryData' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== 'pendingTimbraDoc' && view !== 'authorizePartners' && view !== 'adminDeliveries20' && view !== 'reportSelectionCriteria' && view !== "adminUsersMVentas" && view !== "priceLists" && view !== "canalizadoTanque" && view !== "collectView" && view !== 'payment') {
            date = {
                dateInit: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD'),
                dateFinal: moment(document.getElementById("fechaFin").value).format('YYYYMMDD'),
                groupCodeValue,
                employeeValue,
                docStatus,
                docNumSearch: docNumSearch ? docNumSearch === '' ? '--' : docNumSearch : '--',
                searchSerieName: searchSerieName ? searchSerieName === '' ? '--' : searchSerieName : '--',
                docFilter: docFilter ? docFilter : 'OPCH',
                isCanceled: isCanceled || 'N',
            };

            if (view === 'invoiceBorrador' || view === 'draft') {
                this.setState({
                    ObjType: $('#selectDocTypeDocumentSearch').val(),
                });
            }
        } else if (view === 'inventoryData') {
            date = {
                searchValue,
                groupCodeValue,
                PageNumber
            };
        } else if (view === 'administratorUsers') {
            date = {
                groupSucursal,
                searchValue,
                PageNumber,
            };
        } else if (view === 'payment') {
            date = {
                dateInit: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD'),
                dateFinal: moment(document.getElementById("fechaFin").value).format('YYYYMMDD'),
                docStatus
            }
        } else if (view === 'pendingTimbraDoc') {
            date = {
                initDate: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD'),
                finalDate: moment(document.getElementById("fechaFin").value).format('YYYYMMDD'),
                docType: $('#selectDocTypeDocumentSearchPTD').val() ?? '--',
                cardCode: $('#PTD_CardCode').val() ?? '',
                docNum: $('#PTD_DocNum').val() ?? '',
            }
        } else if (view === 'consignmentNote') {
            date = {
                initDate: moment(document.getElementById("fechaInicio").value).format('YYYY-MM-DD'),
                finalDate: moment(document.getElementById("fechaFin").value).format('YYYY-MM-DD'),
                docType: $('#selectDocTypeDocumentSearchCP').val() ?? '',
            }
        } else if (view === 'authorizePartners') {
            date = {
                dateInit: moment(document.getElementById("fechaInicio").value).format('YYYY-MM-DD'),
                dateFinal: moment(document.getElementById("fechaFin").value).format('YYYY-MM-DD'),
                docStatusSearchAuthoBP
            };
        } else if (view === 'adminDeliveries20') {
            date = {
                dateInit: moment(document.getElementById("fechaInicio").value).format('YYYY-MM-DD'),
                dateFinal: moment(document.getElementById("fechaFin").value).format('YYYY-MM-DD'),
                U_FMB_AttentionType,
            };
        } else if (view === 'canalizadoTanque') {
            searchData.initDate = moment(document.getElementById("fechaInicio").value).format('YYYY-MM-DD');
            searchData.endDate = moment(document.getElementById("fechaFin").value).format('YYYY-MM-DD');
            refreshSearch(searchData);
            search(searchData);
            return;
        } else if (view === 'reprocessDocumentsMVentas') {
            searchData.initDate = moment(document.getElementById("fechaInicio").value).format('YYYY-MM-DD');
            searchData.endDate = moment(document.getElementById("fechaFin").value).format('YYYY-MM-DD');
            refreshSearch(searchData);
            search(searchData);
            return;
        } else {
            date = {
                searchValue,
                priceValue,
                groupCodeValue,
                employeeValue,
                PageNumber
            };
        }

        this.toggleDocumentSelectedAll(false);

        this.setState({
            checkboxDataTables: (new Map()),
        });
        if (view == 'citibanamex' && this.state.suggestionDocs) {
            searchSuggestDoc(date)
        } else {
            search(date);
        }
        setTimeout(() => {
            this.setState({
                docNumSearch: '',
            });
        }, 250);
    };

    comentsDocuments = async (event, docEntry, wtmName, index) => {
        const { handleRemarks } = this.props;

        await handleRemarks(event, docEntry, wtmName);

        await this.toggleDocumentSelected(index)

        await this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(index, true); // toggle
            return { checkboxDataTables };
        });

        await this.setState({
            docNumSearch: '',
        });
    };

    handleAutorization = (event, docEntry, wtmName, index) => {
        const { handleStatusAuthorization } = this.props;
        handleStatusAuthorization(event, docEntry, wtmName);
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(index, true); // toggle
            return { checkboxDataTables };
        });
        this.setState({
            docNumSearch: '',
        });
    }

    getTableInfoResult = () => {

        let info = this.table.page.info();

        let num = 0;
        try {
            if (info && info.recordsDisplay !== 0) {
                num = 1;
            }
        } catch (error) {
            console.log(error)
        }

        $('#tableInfo').text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    };

    SearchInTable = key => {
        const { view } = this.props;
        let value = key.target.value;
        if (view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers') {
            this.setState({
                PageNumber: 1,
                rows: 30,
                searchValue: value
            });
            setTimeout(() => {
                this.searchDocuments();
            }, 100);
        } else {
            let tabla = $('#dataTableTimbra').DataTable();
            tabla.search(value);
            tabla.draw();
            this.getTableInfoResult();
        }
    }

    searchByDocNum = (event) => {
        let docNumSearchEvent = event.nativeEvent.target.value;

        this.setState({
            docNumSearch: docNumSearchEvent,
            searchSerieName: ''
        });
    };

    ChangeSearchSerieName = async (value) => {
        await this.setState({
            searchSerieName: value,
            docNumSearch: ''
        })
    };

    first = () => {
        const { view } = this.props;
        // Cortes Pendientes usa paginación API en bloques fijos de 30 como otras vistas de servidor.
        if (view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === 'figuresTransport' || view === 'transports' || view === 'consignmentNote' || view === "adminUsersMVentas" || view === "collectView" || view === "pendingCuts") {
            this.setState({
                PageNumber: 1,
                rows: 30
            });
            setTimeout(() => {
                this.searchDocuments();
            }, 100);
        } else {
            this.table.page('first').draw('page');
            this.getTableInfoResult();
        }


    }

    previous = () => {
        const { PageNumber, rows } = this.state;
        const { view } = this.props;
        // Solicita la página API anterior en vez de usar la página local de jQuery DataTables.
        if (view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === "adminUsersMVentas" || view === "pendingCuts") {
            let previousPage = PageNumber;
            let row = rows;
            if ((PageNumber - 1) > 0) {
                previousPage -= 1;
                if (row - 30 > 0) {
                    row -= 30;
                }

            }
            this.setState({
                PageNumber: previousPage,
                rows: row,
            });
            setTimeout(() => {
                this.searchDocuments();
            }, 100);
        } else {
            this.table.page('previous').draw('page');
            this.getTableInfoResult();
        }



    }

    next = () => {
        const { rows } = this.state;
        const { totalRows, view } = this.props;

        // Calcula la última página API desde el total devuelto por HANA.
        if (view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === "adminUsersMVentas" || view === "pendingCuts") {
            const { PageNumber } = this.state;
            let total = totalRows[0] ? totalRows[0].TotalRows : 30
            let last = Math.ceil(total / 30);
            let nexPage = PageNumber;
            let row = rows;
            if (PageNumber < last) {
                nexPage += 1;
                if (row < total - 30) {
                    row += 30;
                }

            }
            this.setState({
                PageNumber: nexPage,
                rows: row,
                TotalRows: total
            });

            setTimeout(() => {
                this.searchDocuments();
            }, 100);

        } else {
            this.table.page('next').draw('page');
            this.getTableInfoResult();
        }


    }

    last = () => {
        const { view } = this.props;
        const { rows } = this.state;
        // Evita calcular la página cero cuando el reporte filtrado no tiene filas.
        if (view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === "adminUsersMVentas" || view === "pendingCuts") {
            const { totalRows } = this.props;
            let total = totalRows[0] ? totalRows[0].TotalRows : 30
            if (view === "pendingCuts" && Number(total) <= 0) {
                this.setState({ PageNumber: 1, rows: 0, TotalRows: 0 });
                return;
            }
            let last = Math.ceil(total / 30);
            let row = rows;
            row = (last - 1) * 30;

            this.setState({
                PageNumber: last,
                rows: row,
                TotalRows: total
            });

            setTimeout(() => {
                this.searchDocuments();
            }, 100);
        } else {
            this.table.page('last').draw('page');
            this.getTableInfoResult();
        }


    }

    changePaging = () => {
        const { view } = this.props;
        // El tamaño de página está fijado por la consulta backend y el selector no puede cambiarlo.
        if (view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === "adminUsersMVentas" || view === "pendingCuts") {
            this.table.page.len(30).draw();
            this.getTableInfoResult();
        }
        else {
            let value = $('#changePaginateSelect').val();
            this.table.page.len(value).draw();
            this.getTableInfoResult();
        }
    }

    openConfigTableHeaders = () => {
        const { view } = this.props;
        let configStorage = JSON.parse(localStorage.getItem(view + 'configHeader'));
        $('#ConfigHeadersModal').modal('show');
        this.setState({
            configHeaderTable: configStorage,
            isPorteFields: false,
        })

    }

    //#region CARTA PORTE Administrar campos a mostrar del Modal CartaPorte
    openConfigFieldsModal = () => {
        const { view } = this.props;
        let configStorage = JSON.parse(localStorage.getItem(view + 'configFields'));
        $('#ConfigHeadersModal').modal('show');
        this.setState({
            configHeaderTable: configStorage,
            isPorteFields: true,
        })
    }
    onAcceptConfigFields = () => {

        const { view } = this.props;
        localStorage.setItem(view + 'configFields', JSON.stringify(this.state.configHeaderTable));
        $('#ConfigHeadersModal').modal('hide');
        this.setState({
            refresh: !this.state.refresh,
        })
    };
    //#endregion

    openConfigUserFieldsHeaders = () => {
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let userFields = user ? user.U_FMB_UserFields ? JSON.parse(user.U_FMB_UserFields) : json.allEnableUserFields : json.allEnableUserFields;
        $('#configUserFieldsModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        this.setState({
            configHeaderUserFields: userFields,
        })

    }

    onAcceptConfigUserFields = async () => {
        const { configHeaderUserFields } = this.state;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let email = user.E_Mail;
        await apiClient.saveConfigHeaderUserFields(configHeaderUserFields, email);
        user.U_FMB_UserFields = JSON.stringify(this.state.configHeaderUserFields);
        localStorage.setItem(config.localStorageNamed + 'currentUser', JSON.stringify(user));
        $('#configUserFieldsModal').modal('hide');
    };

    onCloseConfigUserFields = async () => {
        $('#configUserFieldsModal').modal('hide');
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let userFieldsConfig = user ? user.U_FMB_UserFields ? JSON.parse(user.U_FMB_UserFields) : json.allEnableUserFields : json.allEnableUserFields;
        this.setState({
            configHeaderUserFields: userFieldsConfig,
        })
    }

    toggleConfigUserFields = index => {
        let state = this.state.configHeaderUserFields;
        state[index].enabled = !state[index].enabled;
        this.setState({
            configHeaderUserFields: state,
        })
    }

    onAcceptConfig = () => {
        const { view } = this.props;
        const { isPorteFields } = this.state;
        if (isPorteFields) {
            localStorage.setItem(view + 'configFields', JSON.stringify(this.state.configHeaderTable));
        } else {
            localStorage.setItem(view + 'configHeader', JSON.stringify(this.state.configHeaderTable));
        }
        $('#ConfigHeadersModal').modal('hide');
        this.setState({
            refresh: !this.state.refresh,
        })
    };

    toggleConfig = index => {

        let state = this.state.configHeaderTable;
        state[index].value = !state[index].value;
        this.setState({
            configHeaderTable: state,
        })
    }

    billingCheckboxActions = async (docEntryArray, actiond = null, dataGuides = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { seriesDefault, seriesDefaultName, action } = this.state;

        let newView = view;
        // pendingTimbraDocs

        if (view === 'pendingTimbraDoc') {
            const typeDoc = $('#selectDocTypeDocumentSearchPTD').val() ?? '--';
            if (typeDoc === '--') {
                showAlert({ type: 'info', message: "Selecciona el tipo de documento para continuar", timeOut: 5000 });
                return
            }
            const returnNewView = GET_VIEW_NAME_BY_DOCTYPE(typeDoc);
            newView = returnNewView;
        }

        let table = this.selectTable(newView);
        let extras = this.selectTableTimbre(table.name);
        let responseArray = [];

        let documents = [];
        let arrayDocuments = [];
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        enableSpinner(true);
        $('#btnAuthorization').hide();
        // console.log('con<docEntryArray', docEntryArray);
        for (let index = 0; index < docEntryArray.length; index++) {
            const element = docEntryArray[index];
            // console.log('con<element',element);
            element.status1DocEntry = true;
            element.statusCancelled = true;

            if ((element.Status1 === 'C')) {
                element.status1DocEntry = false;
            }
            if (element.CANCELED === 'Y') {
                element.statusCancelled = false;
            }
            if (action === 13 && element.Canceled === 'Y') {
                element.statusCancelled = false;
            }
            if (action === 14 && (element.CANCELED === 'Y' || element.DocStatus === 'C')) {
                element.statusCancelled = false;
            }
            if (element.U_FMB_Processed === 'Y') {
                element.status1DocEntry = false;
                element.statusCancelled = false;
            }

            let statusAuthorization = "";
            let add = false;
            if (action === 1) {
                add = true;
            } else if (action === 2) {
                add = true;
            } else if (action === 3 && element.statusCancelled) {
                add = true;
            } else if (element.Status === 'Y' && element.status1DocEntry) {
                element.DocEntry = element.IsDraft === 'Y' ? element.DocEntryODRF : element.DocEntryFirme;
                add = true;
                statusAuthorization = 1;
            } else if (element.Status === 'N' && element.status1DocEntry) {
                element.DocEntry = element.IsDraft === 'Y' ? element.DocEntryODRF : element.DocEntryFirme;
                add = true;
                statusAuthorization = 2;
            } else if (element.Status === 'W' && element.status1DocEntry) {
                // add = false;
                // showAlert({ type: 'error', message: `Solo se permite AUTORIZAR o RECHAZAR documentos`, timeOut: 10000 });
                element.DocEntry = element.IsDraft === 'Y' ? element.DocEntryODRF : element.DocEntryFirme;
                add = true;
                statusAuthorization = 3;
            } else if (action === 6 && element.statusCancelled) {
                add = true;
            } else if (action === 9 && element.statusCancelled) {
                add = true;
            } else if (action === 10 && element.statusCancelled) {
                add = true;
            } else if (action === 11 && element.statusCancelled) {
                add = true;
            } else if (action === 12 && element.statusCancelled) {
                add = true;
            } else if (action === 13 && element.statusCancelled) {
                add = true;
            } else if (action === 14 && element.statusCancelled) {
                add = true;
            }

            let serieUpdate = null;
            let serieNameUpdate = null;

            if (actiond === "Update") {
                serieUpdate = element.SeriesCode;
                serieNameUpdate = element.Series;
            }

            let data = {
                id: element.DocEntry,
                FMB_Auto: 1,// element.U_FMB_Auto ? element.U_FMB_Auto : 0,
                WddCode: element.WddCode ? element.WddCode : '',
                StepCode: element.StepCode ? element.StepCode : '',
                Remarks: element.Remarks || '',
                table: table.name,
                destino: extras.destino,
                condicion: extras.action,
                docSubType: extras.docSubType,
                serie: serieUpdate ? serieUpdate : seriesDefault,
                serieName: serieNameUpdate ? serieNameUpdate : seriesDefaultName,
                statusAuthorization: statusAuthorization,
                user_Email: user.E_Mail,
                WtmName: element.WtmName,
                CreateBy: element.U_FMB_CREATEBY,
                ObjType: element.ObjType || '',
                DocNum: element.DocNumOrigin || element.DocNum || element.DocEntry,
                CreatorUserId: element.U_UserSign || element.UserSign || '',
                CreatorUserCode: element.CreatorUserCode || element.UserCreateCode || '',
                Time: moment().format(),
                code: table.name === 'OCPT' ? element.CodigoCarta : '',
                dataGuides
            }

            if (action === 10 || action === 12) {
                data.DocEntry = element.DocEntry
                data.DocNum = element.DocNum
                data.table = table
            }

            if (action === 13) { // Pagos recibidos
                data = {};
                data.DocEntry = element.DocEntry;
                data.DocNum = element.DocNum;
                data.DocDate = element.DocDate;
                data.isPaymentView = true;
            }

            if (action === 14) {
                data = {};
                data.DocEntry = element.DocEntry
                data.DocNum = element.DocNum
                data.table = table
            }

            if (add) {
                documents.push(data);
                let newRequest = action === 3 ? 0 : (index + 1) % 10;

                if (newRequest === 0) {
                    arrayDocuments.push(documents);
                    documents = [];
                } else if ((index + 1) === docEntryArray.length) {
                    arrayDocuments.push(documents);
                    documents = [];
                }
            }
        }
        let response = null;
        // console.log('con<action', action);
        // console.log('con<arrayDocuments', arrayDocuments);
        if (arrayDocuments.length) {
            if (action === 1) {
                showAlert({ type: 'info', message: "Timbrando documentos", timeOut: 5000 });
            } else if (action === 2) {
                showAlert({ type: 'info', message: "Facturando documentos", timeOut: 5000 });
            } else if (action === 3) {
                showAlert({ type: 'info', message: 'Creando documentos', timeOut: 5000 });
            } else if (action === 4) {
                showAlert({ type: 'info', message: 'Autorizando documentos', timeOut: 5000 });
            } else if (action === 5) {
                showAlert({ type: 'info', message: 'Rechazando documentos', timeOut: 5000 });
            } else if (action === 6) {
                showAlert({ type: 'info', message: 'Cancelando documentos', timeOut: 5000 });
            } else if (action === 9) {
                showAlert({ type: 'info', message: 'Timbrando carta porte', timeOut: 5000 });
            } else if (action === 10) {
                showAlert({ type: 'info', message: 'Cancelando documentos', timeOut: 5000 });
            } else if (action === 11) {
                showAlert({ type: 'info', message: 'Mandando a aprobar documentos', timeOut: 5000 });
            } else if (action === 12) {
                showAlert({ type: 'info', message: 'Cancelando documentos', timeOut: 5000 });
            } else if (action === 13) {
                showAlert({ type: 'info', message: 'Cancelando documentos', timeOut: 5000 });
            } else if (action === 14) {
                showAlert({ type: 'info', message: 'Cerrando documentos', timeOut: 5000 });
            }
        }

        if (action === 13) {
            let paymentsToCancel = [...this.state.paymentsToCancel];
            let paymentDocumentDates = { ...this.state.paymentDocumentDates };
            let wasUpdated = false;

            const documentsFlat = arrayDocuments?.flat();
            const requiresDateSelection = documentsFlat?.some(payment => { // Revisar si algún documento tiene fecha distinta
                const documentDate = moment(payment.DocDate).utc().format("DD-MM-YYYY");
                const todayDate = moment(new Date()).format("DD-MM-YYYY");

                return documentDate !== todayDate;
            });

            if (requiresDateSelection) {
                for (const payment of documentsFlat) {
                    const exists = paymentsToCancel.some(x => x.DocEntry === payment.DocEntry);

                    if (!exists) {
                        paymentsToCancel.push(payment);

                        // false = Fecha documento
                        // true = Fecha actual
                        paymentDocumentDates[payment.DocEntry] = false;
                        wasUpdated = true;
                    }
                }

                if (wasUpdated) {
                    this.setState({
                        showCancelPaymentModal: true,
                        isMassive: true,
                        paymentsToCancel,
                        paymentDocumentDates
                    }, () => {
                        $('#cancelDateModal').modal('show');
                        enableSpinner(false);
                    });
                    return { pendingPayentInfo: true };
                }
            }
        }

        let message = false;
        for (let index = 0; index < arrayDocuments.length; index++) {
            const documents = arrayDocuments[index];
            if (action === 1) {//Documento a Timbrar
                response = await apiClient.timbrar(documents);
            }
            if (action === 2) { //Documento autorizado
                response = await apiClient.authorized(documents);
            }
            if (action === 3) { //Crear Documento
                response = await apiClient.createDocumentAuthorized(documents);
            }
            if (action === 4) {//Aceptar documentos
                response = await apiClient.authorizedDocument(documents);
            }
            if (action === 5) {//Rechazar
                response = await apiClient.authorizedDocument(documents);
            }
            if ((action === 6)) {//Documento Cancelado
                response = await apiClient.cancelDocument(documents);
            }
            //#region CARTA PORTE TIMBRADO
            if (action === 9) {
                response = await apiClient.timbrar(documents);
            }
            if (action === 10 || action === 12) {//Cancelar DOCS
                for (let idxDocs = 0; idxDocs < documents.length; idxDocs++) {
                    const doc = documents[idxDocs];
                    response = await apiClient.cancelDocuments(doc);
                    if (response.status === SERVICE_RESPONSE.SUCCESS) {
                        showAlert({ type: 'success', message: response?.message || '', timeOut: 8000 });
                    } else {
                        showAlert({ type: 'error', message: `Error inesperado al cancelar el documento ${doc?.DocNum || ''}. ${response?.message ? ` Error: ${response?.message || ''}` : ''}`, timeOut: 9999999 });
                    }
                }

            }

            if (action === 13) { // Cancelar Pagos recibidos
                const {
                    cancelPaymentMode,
                    cancelPaymentCurrentDate,
                    paymentDocumentDates
                } = this.state;

                for (let idxDocs = 0; idxDocs < documents.length; idxDocs++) {
                    let doc = documents[idxDocs];
                    //#region Asignar currentDate
                    if (cancelPaymentMode === 'global') { // Misma opción para todos
                        doc.currentDate = cancelPaymentCurrentDate;
                    } else {
                        doc.currentDate = paymentDocumentDates?.[doc.DocEntry] ?? false;
                    }
                    //#endregion Asignar currentDate
                    response = await apiClient.CancelIncomingPayments(doc);
                    if (response.status === SERVICE_RESPONSE.SUCCESS) {
                        showAlert({ type: 'success', message: response?.message || '', timeOut: 5000 });
                    } else {
                        showAlert({ type: 'error', message: 'Error inesperado al cancelar el pago ' + (doc?.DocNum || ''), timeOut: 5000 });
                    }
                }
            }

            if (action === 14) {// Cerrar documentos
                for (let idxDocs = 0; idxDocs < documents.length; idxDocs++) {
                    const doc = documents[idxDocs];
                    response = await apiClient.closeDocument(doc);
                    if (response.status === SERVICE_RESPONSE.SUCCESS) {
                        showAlert({ type: 'success', message: response?.message || '', timeOut: 5000 });
                    } else {
                        showAlert({ type: 'error', message: `${response?.message || `Error inesperado al cerrar el documento ${doc?.DocNum || ''}`}`, timeOut: 8000 });
                    }
                }

            }

            if (action === 11) {
                response = await apiClient.approvePartialRequest(documents);
            }

            let arrayResponse = [];
            if (action === 12 || action === 13 || action === 14) {
                arrayResponse = []
            } else if (response.data && (action === 1 || action === 9 || action === 11)) {
                arrayResponse = response.data;
            } else {
                arrayResponse = response ? response.data ? response.data.DocNum ? response.data.DocNum : [] : [] : [];
            }

            for (let index = 0; index < arrayResponse.length; index++) {
                const element = arrayResponse[index];

                if (!element.status) {
                    try {
                        responseArray.push({
                            docNum: element.data ? element.data.DocNum : '',
                            billing: element.data ? element.data.docNumBilling : '',
                            message: element.message ? element.message : '',
                        });

                    } catch (e) {
                        responseArray.push({
                            docNum: '',
                            billing: '',
                            message: '',
                        });
                    }
                } else if (!message) {
                    message = true;
                }

                if (response.status === 2 && !element.status && !message) {
                    message = true;
                }
            }
        }
        enableSpinner(false);
        $('#btnAuthorization').show();
        if (message) {
            if (action === 1 || action === 9) {
                showAlert({ type: 'success', message: "Documentos Timbrados", timeOut: 5000 });
            } else if (action === 2) {
                showAlert({ type: 'success', message: "Documentos facturados", timeOut: 5000 });
            } else if (action === 3) {
                showAlert({ type: 'success', message: 'Documentos creados', timeOut: 5000 });
            } else if (action === 4) {
                showAlert({ type: 'success', message: 'Documentos actualizados', timeOut: 5000 });
            } else if (action === 5) {
                showAlert({ type: 'success', message: 'Documentos rechazados', timeOut: 5000 });
            } else if (action === 6) {
                showAlert({ type: 'success', message: 'Documentos cancelados', timeOut: 5000 });
            } else if (action === 11) {
                showAlert({ type: 'success', message: 'Documentos aprobados correctamente', timeOut: 5000 });
            }

        } else {
            if (action === 2) {
                showAlert({ type: 'error', timeOut: 3500, message: "Error al procesar el Documento" });
            }
            //  else if(action == 3){
            //     showAlert({type: 'error', timeOut: 3500, message: "No pueden crearse documentos procesados y/o cancelados"});
            // } 
            // else if(action == 4){
            //     showAlert({type: 'error', timeOut: 3500, message: "Solo se pueden AUTORIZAR documentos con estatus 'Pendiente y/o Rechazados'"});    
            // } else if(action == 5){
            //     showAlert({type: 'error', timeOut: 3500, message: "Solo se pueden RECHAZAR documentos con estatus 'Pendiente'"});    
            // }
            else if (action === 6) {
                showAlert({ type: 'error', timeOut: 3500, message: "Uno de lo documentos seleccionados ya fue procesado y/o cancelado'" });
            }
            else if (action === 11) {
                showAlert({ type: 'error', timeOut: 3500, message: "Error al aprobar la solicitud de traslado parcial" });
            }
        }
        return responseArray;
    };

    AuthorizedCheckboxActions = async (docEntryArray, action = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { seriesDefault, seriesDefaultName } = this.state;
        let table = this.selectTable(view);
        let extras = this.selectTableTimbre(table.name);
        let responseArray = [];

        for (let document in docEntryArray) {
            enableSpinner(true);
            showAlert({ type: 'info', message: 'Timbrando: ' + docEntryArray[document].DocNum, timeOut: 5000 });

            let serieUpdate = null;
            let serieNameUpdate = null;
            if (action === "Update") {
                serieUpdate = docEntryArray[document].SeriesCode;
                serieNameUpdate = docEntryArray[document].Series;
            }

            let data = {
                id: docEntryArray[document].DocEntry,
                table: table.name,
                destino: extras.destino,
                condicion: extras.action,
                docSubType: extras.docSubType,
                serie: serieUpdate ? serieUpdate : seriesDefault,
                serieName: serieNameUpdate ? serieNameUpdate : seriesDefaultName
            }

            let response = await apiClient.authorized(data);
            enableSpinner(false);

            try {
                responseArray.push({
                    docNum: response.data ? response.data.DocNum : '',
                    billing: response.data ? response.data.docNumBilling : '',
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }

        }
        return responseArray;
    };

    selectSeries = async (action) => {
        const { data, enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { checkboxDataTables } = this.state;
        let table = this.selectTable(view);
        let extras = this.selectTableTimbre(table.name);

        if (extras.action === "Update" || action === 12 || action === 14) {
            await this.setState({
                action: action,
            });
            await this.billing("Update");
            return;
        }

        let docEntryArray = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(data[id]);
            }
        }

        if (docEntryArray.length === 0) {
            showAlert({ type: 'warning', message: "Seleccione un documento" });
            return;
        }

        let dataSerie = {
            docType: 13,
            docSubType: '--'
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);


        let defaultName = null;
        seriesResponse.data.map(serie => {
            if (serie.Series == seriesResponse.data[0].DfltSeries) {
                defaultName = serie.SeriesName;
            }
        });


        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        if (!user || !user.U_FMB_ValidateSeriesOINV) {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrió un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            return;
        }

        let seriesUsers = user.U_FMB_ValidateSeriesOINV.split("|");

        let newArraySeries = [];

        seriesUsers.map(serieUser => {
            seriesResponse.data.map(serieResponse => {
                if (serieResponse.Series === serieUser && serieResponse.DocSubType === table.docSubType) {
                    newArraySeries.push(serieResponse);
                }
            })
        })

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }

        this.setState({
            seriesArray: newArraySeries,
            seriesDefault: "option",
            seriesDefaultName: "",
            action: action,
        });


        $('#selectSeriesModal').modal('show');
    };

    getAllDocumentsToPrint = async (type) => {

        const { enableSpinner, notificationReducer: { showAlert }, view, data, setPrintToDocumentsModal } = this.props;
        const { checkboxDataTables, seriesArray } = this.state;

        let table = this.selectTable(view);
        let extras = this.selectTableTimbre(table.name);
        let docEntryArray = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push({ docEntry: data[id].DocEntry, docNum: data[id].DocNum, type });
            }
        }

        if (docEntryArray.length === 0) {
            showAlert({ type: 'warning', message: "Seleccione un documento" });
            return;
        }
        if (docEntryArray.length > 30) {
            showAlert({ type: 'warning', message: "Tienes seleccionado " + docEntryArray.length + " documentos y solo es posible imprimir 30." });
            return;
        }
        enableSpinner(true);
        let responseallDocuments = await apiClient.getAllDocumentsToPrint(docEntryArray, table.name, view);
        enableSpinner(false);
        if (!Array.isArray(responseallDocuments.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (responseallDocuments.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        await this.setState({
            documentsToPrint: responseallDocuments.data,
            docformat: type,
        });

        await setPrintToDocumentsModal(true);

        $('#printToDocumentsModal').modal('show');

    };

    billing = async (action0 = null, dataGuides = null) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { action } = this.state;
        $('#DocumentCreateModal').modal('hide');

        const { data } = this.props;
        const { checkboxDataTables } = this.state;
        let docEntryArray = [];
        let responseArray = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(data[id]);
            }
        }
        if (action === 3 && !dataGuides) {
            return await this.prepareSunatGuide(true, action0)
        }
        if (dataGuides) {
            let allScopValid = true
            for (let index = 0; index < dataGuides.length; index++) {
                const guide = dataGuides[index];
                for (let idxLines = 0; idxLines < guide.lines.length; idxLines++) {
                    const line = guide.lines[idxLines];
                    if (!line.ValidSCOP) {
                        allScopValid = false;
                        break;

                    }
                }
            }
            if (!allScopValid) {
                showAlert({ type: 'error', message: `Valide todos los códigos SCOP`, timeOut: 5000 });
                return;
            }
        }
        if (action === 4 || action === 5 || action === 10 || action === 12) {
            for (let index = 0; index < docEntryArray.length; index++) {
                const document = docEntryArray[index];
                if (action === 10 || action === 12) {
                    const currStatus = getNCStatus(document)

                    if (currStatus !== 'Abierto') {
                        showAlert({ type: 'error', message: `No se puede cancelar el documento ${document.DocNum} porque está en estado ${currStatus}.`, timeOut: 5000 });
                        return;
                    }

                } else if (document.idCurrentUser !== (document.idAuthorizer).toString()) {
                    showAlert({ type: 'error', message: 'No cuentas con los permisos necesarios para realizar esta acción', timeOut: 5000 });
                    return;
                }
            }
        }

        if (action === 13) { // Pagos recibidos
            for (let index = 0; index < docEntryArray.length; index++) {
                const document = docEntryArray[index];
                if (document.Canceled === 'Y') {
                    showAlert({ type: 'info', message: `El pago ${document.DocNum} ya se encuentra Cancelado.`, timeOut: 5000 });
                }
            }
        }

        if (action === 14) { // Cerrar documentos
            for (let index = 0; index < docEntryArray.length; index++) {
                const document = docEntryArray[index];
                const currStatus = getNCStatus(document)
                if (currStatus === 'Cancelado' || currStatus === 'Cerrado') {
                    showAlert({ type: 'info', message: `El documento ${document.DocNum} ya se encuentra ${currStatus}.`, timeOut: 5000 });
                }
            }
        }

        if (docEntryArray.length > 0) {
            responseArray = await this.billingCheckboxActions(docEntryArray, action0, dataGuides);

            if (responseArray?.pendingPayentInfo) { // Se va a especificar la fecha de cancelación de los pagos
                return;
            }

            this.toggleDocumentSelectedAll(false);

            if (responseArray.length > 0) {
                this.setState({
                    billingResponseArray: responseArray,
                    checkboxDataTables: (new Map()),
                    handleRemarksState: [],
                });
                for (let index = 0; index < responseArray.length; index++) {
                    const element = responseArray[index];
                    showAlert({ type: 'warning', timeOut: 9999999, message: element.message });
                }
            }

            if (action === 13) {
                await this.resetPaymentsToCancel();
            }

            this.searchDocuments();
        } else {
            showAlert({ type: 'info', timeOut: 2000, message: "Seleccione un documento valido" });
            return;
        }
    };

    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        switch (view) {
            case 'quotations':
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                break;
            case 'orderSales':
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                break;
            case 'deliveries':
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                break;
            case 'invoice':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'invoiceAdvance':
                name = "ODPI";
                complement = "DPI1";
                docSubType = "--";
                docType = "203";
                break;
            case 'purchaseDownPayments':
                name = "ODPO";
                complement = "DPO1";
                docSubType = "--";
                docType = "204";
                break;
            case 'pendingTimbraDoc':
                name = "PTDS";
                complement = "";
                docSubType = "--";
                docType = "0117";
                break
            case 'return':
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                break;
            case 'purchaseReturn':
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case 'payment':
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case 'transfers':
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case 'transfersRequest':
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case 'transfersEntry':
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case 'transfersOutput':
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case 'debitNote':
                name = "OINVDN";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                break;
            case 'creditNote':
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                break;
            case 'PurchaseOrder':
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case 'GoodsReceipt':
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;
            case 'PurchaseQuotation':
                name = 'OPQT'; // Cotización de compra
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            case 'PurchaseQuotationDraft': // Cotización de compra en Borrador
                name = 'OPQT';
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            case 'PurchaseRequest':
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;

            case 'invoiceBorrador':
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case 'invoiceAuthorization':
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;
            case 'bussinesPartner':
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case 'inventoryRevaluation':
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case 'SalesHelmets':
                name = "OIGN";
                name2 = "ORIN";
                complement = "IGN1";
                complement2 = "RIN1"
                docSubType = "--";
                docSubType2 = "--";
                docType = "59";
                docType2 = "14"
                break;
            case 'ExitHelmets':
                name = "OIGE";
                name2 = "OINVDN";
                complement = "IGE1";
                complement2 = "INV1"
                docSubType = "--";
                docSubType2 = "DN";
                docType = "60";
                docType2 = "13"
                break;
            case 'purchaseInvoice':
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case 'purchaseCreditNotes':
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;
            case 'outgoingPayment':
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "46";
                break;
            case 'invoiceReserve':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'middleware':
                if (docTypeMiddleware === '22') {
                    name = "OPOR";
                    complement = "POR1";
                    docSubType = "--";
                    docType = "22";
                } else if (docTypeMiddleware === '18') {
                    name = "OPCH";
                    complement = "PCH1";
                    docSubType = "--";
                    docType = "18";
                }

                break;
            //#region CARTA PORTE
            case 'consignmentNote':
                name = "OCPT";
                complement = "CPT1";
                docSubType = "--";
                break;
            case 'citibanamex':
                name = this.state.docFilter;
                complement = this.state.docFilter === 'OPCH' ? "PCH1" : "POR1";
                docSubType = "--";
                break;
            case 'landedCosts':
                name = "OIPF";
                complement = "IPF1";
                docSubType = "--";
                docType = "69";
                break;
            //#endregion
            case 'inventoryPosting':
                name = "OIQR";
                complement = "IQR1";
                docSubType = "--";
                docType = "10000071";
                break;
            case 'reportSelectionCriteria':
                name = "OPOR";
                complement = "RFM1";
                docSubType = "--";
                docType = "22";
                break;
            case 'suggestRefill':
                name = "SRFM";
                complement = "RFM1";
                docSubType = "--";
                break;
            case 'draft':
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case 'SERIES':
                name = "SERIES";
                complement = "SERIES";
                docSubType = "--";
                docType = "SERIES";
                break;
            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return { name, complement, docSubType, docType, name2, complement2, docSubType2, docType2 }
    };

    selectDraftTable = (value = '') => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        switch (String(value)) {
            case 'transfersRequest':
            case '1250000001':
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case 'PurchaseQuotation':
            case '540000006':
            case 'PurchaseQuotationDraft': // Cotización de compra en Borrador
                name = 'OPQT'; // Cotización de compra
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            case 'PurchaseOrder':
            case '22': // Orden de compra en Borrador
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case 'draft':
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            default:
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
        }
        return { name, complement, docSubType, docType, name2, complement2, docSubType2, docType2 }
    };

    selectTableTimbre = table => {
        let destino = "";
        let action = "";
        let docSubType = "";
        switch (table) {
            case 'ORDR':
                destino = "OINV";
                action = "Firme";
                docSubType = "--";
                break;
            case 'ODLN':
                destino = "OINV";
                action = "Firme";
                docSubType = "--";
                break;
            case 'OINV':
                destino = "OINV";
                action = "Update";
                docSubType = "--";
                break;
            case 'PTDS':
                destino = "PTDS";
                action = "Update";
                docSubType = "--";
                break;
            case 'ODPI':
                destino = "ODPI";
                action = "Update";
                docSubType = "--";
                break;
            case 'ORDN':
                destino = "";
                action = "";
                docSubType = "";
                break;
            case 'ORCT':
                destino = "ORCT";
                action = "Update";
                docSubType = "-";
                break;
            case 'OWTR':
                destino = "OWTR";
                action = "Update";
                docSubType = "--";
                break;
            case 'OINVDN':
                destino = "OINV";
                action = "Update";
                docSubType = "DN";
                break;
            case 'ORIN':
                destino = "ORIN";
                action = "Update";
                docSubType = "--";
                break;
            case 'ODRF':
                destino = "--";
                action = "Update";
                docSubType = "--";
                break;
            case 'OWDD':
                destino = "--";
                action = "Update";
                docSubType = "--";
                break;
            //#region CARTA PORTE
            case 'OCPT':
                destino = "--";
                action = "Update";
                docSubType = "--";
                break;
            case 'OQUT':
                destino = "--";
                action = "Update";
                docSubType = "--";
                break;
            //#endregion
            default:
                destino = "";
                action = "";
                docSubType = "";
        }

        return { destino, action, docSubType }
    };


    selectValidateSeries = (table, data) => {
        let series = "";

        switch (table) {
            case 'OQUT':
                series = data.U_FMB_ValidateSeriesOQUT || "";
                break;
            case 'ORDR':
                series = data.U_FMB_ValidateSeriesORDR || "";
                break;
            case 'ODLN':
                series = data.U_FMB_ValidateSeriesODLN || "";
                break;
            case 'OINV':
                series = data.U_FMB_ValidateSeriesOINV || "";
                break;
            case 'ODPI':
                series = data.U_FMB_ValidateSeriesODPI || "";
                break;
            case 'ODPO':
                series = data.U_FMB_ValidateSeriesODPO || "";
                break;
            case 'ORDN':
                series = data.U_FMB_ValidateSeriesORDN || "";
                break;
            case 'ORPD':
                series = data.U_FMB_ValidateSeriesORPD || "";
                break;
            case 'ORCT':
                series = data.U_FMB_ValidateSeriesORCT || "";
                break;
            case 'OWTR':
                series = data.U_FMB_ValidateSeriesOWTR || "";
                break;
            case 'OWTQ':
                series = data.U_FMB_ValidateSeriesOWTQ || "";
                break;
            case 'OIGN':
                series = data.U_FMB_ValidateSeriesOIGN || "";
                break;
            case 'OIGE':
                series = data.U_FMB_ValidateSeriesOIGE || "";
                break;
            case 'OINVDN':
                series = data.U_FMB_ValidateSeriesDN || "";
                break;
            case 'ORIN':
                series = data.U_FMB_ValidateSeriesORIN || "";
                break;
            case 'OPOR':
                series = data.U_FMB_ValidateSeriesOPOR || "";
                break;
            case 'OPDN':
                series = data.U_FMB_ValidateSeriesOPDN || "";
                break;

            case 'OPRQ':
                series = data.U_FMB_ValidateSeriesOPRQ || "";
                break;
            case 'OMRV':
                series = data.U_FMB_ValidateSeriesOMRV || "";
                break;
            case 'OPCH':
                series = data.U_FMB_ValidateSeriesOPCH || "";
                break;
            case 'OVPM':
                series = data.U_FMB_ValidateSeriesOVPM || "";
                break;
            case 'ORPC':
                series = data.U_FMB_ValidateSeriesORPC || "";
                break;
            case 'ODRF':
                series = "";
                break;
            case 'OWDD':
                series = "";
                break;
            case 'OCPT':
                series = "";
                break;
            case 'OIPF':
                series = data.U_FMB_ValidateSeriesOIPF || "";
                break;
            case 'OPQT':
                series = data.U_FMB_ValidateSeriesOPQT || "";
                break;
            default:
                series = "";
        }

        return { series }
    };

    validateNull = (value) => {
        if (value === 0) {
            return value;
        }
        if (!value) {
            return "";
        }

        return (value || '').toString().trim();
    };

    setUserFieldValue = (userFields, index, header) => {
        const { view, notificationReducer: { showAlert }, data } = this.props;

        switch (index) {
            case 0:
                userFields.userFields1 = this.validateNull(header.userFields1);
                break;
            case 1:
                userFields.userFields2 = this.validateNull(header.userFields2);
                break;
            case 2:
                userFields.userFields3 = this.validateNull(header.userFields3);
                break;
            case 3:
                userFields.userFields4 = this.validateNull(header.userFields4);
                break;
            case 4:
                userFields.userFields5 = this.validateNull(header.userFields5);
                break;
            case 5:
                userFields.userFields6 = this.validateNull(header.userFields6);
                break;
            case 6:
                userFields.userFields7 = this.validateNull(header.userFields7);
                break;
            case 7:
                userFields.userFields8 = this.validateNull(header.userFields8);
                break;
            case 8:
                userFields.userFields9 = this.validateNull(header.userFields9);
                break;
            case 9:
                userFields.userFields10 = this.validateNull(header.userFields10);
                break;
            case 10:
                userFields.userFields11 = this.validateNull(header.userFields11);
                break;
            case 11:
                userFields.userFields12 = this.validateNull(header.userFields12);
                break;
            case 12:
                userFields.userFields13 = this.validateNull(header.userFields13);
                break;
            case 13:
                userFields.userFields14 = this.validateNull(header.userFields14);
                break;
            case 14:
                userFields.userFields15 = this.validateNull(header.userFields15);
                break;
            case 15:
                userFields.userFields16 = this.validateNull(header.userFields16);
                break;
            case 16:
                userFields.userFields17 = this.validateNull(header.userFields17);
                break;
            case 17:
                userFields.userFields18 = this.validateNull(header.userFields18);
                break;
            case 18:
                userFields.userFields19 = this.validateNull(header.userFields19);
                break;
            case 19:
                userFields.userFields20 = this.validateNull(header.userFields20);
                break;
            case 20:
                //
                if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
                    header.userFields21 !== '' ? userFields.userFields21 = this.validateNull(header.userFields21) : userFields.userFields21 = '99'
                } else {
                    userFields.userFields21 = this.validateNull(header.userFields21);
                }

                break;
            case 21:
                userFields.userFields22 = this.validateNull(header.userFields22);
                break;
            case 22:
                //

                if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
                    header.userFields23 !== '' ? userFields.userFields23 = this.validateNull(header.userFields23) : userFields.userFields23 = '99'
                } else {
                    userFields.userFields23 = this.validateNull(header.userFields23);
                }
                break;
            case 23:
                userFields.userFields24 = this.validateNull(header.userFields24);
                break;
            case 24:
                //
                if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote') {
                    const displayValue = (view === 'creditNote' && header.U_NAME) ? header.U_NAME : header.userFields25;
                    displayValue !== '' ? userFields.userFields25 = this.validateNull(displayValue) : userFields.userFields25 = '99';
                } else {
                    userFields.userFields25 = this.validateNull(header.userFields25);
                }

                break;
            case 25:
                userFields.userFields26 = this.validateNull(header.userFields26);
                break;
            case 26:
                userFields.userFields27 = this.validateNull(header.userFields27);
                break;
            case 27:
                userFields.userFields28 = this.validateNull(header.userFields28);
                break;
            case 28:
                userFields.userFields29 = this.validateNull(header.userFields29);
                break;
            case 29:
                userFields.userFields30 = this.validateNull(header.userFields30);
                break;
            case 30:
                userFields.userFields31 = this.validateNull(header.userFields31);
                break;
            case 31:
                userFields.userFields32 = this.validateNull(header.userFields32);
                break;
            case 32:
                userFields.userFields33 = this.validateNull(header.userFields33);
                break;
            case 33:
                userFields.userFields34 = this.validateNull(header.userFields34);
                break;
            case 34:
                userFields.userFields35 = this.validateNull(header.userFields35);
                break;
            case 35:
                userFields.userFields36 = this.validateNull(header.userFields36);
                break;
            case 36:
                userFields.userFields37 = this.validateNull(header.userFields37);
                break;
            case 37:
                userFields.userFields38 = this.validateNull(header.userFields38);
                break;
            case 38:
                userFields.userFields39 = this.validateNull(header.userFields39);
                break;
            case 39:
                userFields.userFields40 = this.validateNull(header.userFields40);
                break;
            case 40:
                userFields.userFields41 = this.validateNull(header.userFields41);
                break;
            case 41:
                userFields.userFields42 = this.validateNull(header.userFields42);
                break;
            case 42:
                userFields.userFields43 = this.validateNull(header.userFields43);
                break;
            case 43:
                userFields.userFields44 = this.validateNull(header.userFields44);
                break;
            case 44:
                userFields.userFields45 = this.validateNull(header.userFields45);
                break;
            case 45:
                userFields.userFields46 = this.validateNull(header.userFields46);
                break;
            case 46:
                userFields.userFields47 = this.validateNull(header.userFields47);
                break;
            case 47:
                userFields.userFields48 = this.validateNull(header.userFields48);
                break;
            case 48:
                userFields.userFields49 = this.validateNull(header.userFields49);
                break;
            case 49:
                userFields.userFields50 = this.validateNull(header.userFields50);
                break;
            case 50:
                userFields.userFields51 = this.validateNull(header.userFields51);
                break;
            case 51:
                userFields.userFields52 = this.validateNull(header.userFields52);
                break;
            case 52:
                userFields.userFields53 = this.validateNull(header.userFields53);
                break;
            case 53:
                userFields.userFields54 = this.validateNull(header.userFields54);
                break;
            case 54:
                userFields.userFields55 = this.validateNull(header.userFields55);
                break;
            case 55:
                userFields.userFields56 = this.validateNull(header.userFields56);
                break;
            case 56:
                userFields.userFields57 = this.validateNull(header.userFields57);
                break;
            case 57:
                userFields.userFields58 = this.validateNull(header.userFields58);
                break;
            case 58:
                userFields.userFields59 = this.validateNull(header.userFields59);
                break;
            case 59:
                userFields.userFields60 = this.validateNull(header.userFields60);
                break;
            case 60:
                userFields.userFields61 = this.validateNull(header.userFields61);
                break;
            case 61:
                userFields.userFields62 = this.validateNull(header.userFields62);
                break;
            case 62:
                userFields.userFields63 = this.validateNull(header.userFields63);
                break;
            case 63:
                userFields.userFields64 = this.validateNull(header.userFields64);
                break;
            case 64:
                userFields.userFields65 = this.validateNull(header.userFields65);
                break;
            case 65:
                userFields.userFields66 = this.validateNull(header.userFields66);
                break;
            case 66:
                userFields.userFields67 = this.validateNull(header.userFields67);
                break;
            case 67:
                userFields.userFields68 = this.validateNull(header.userFields68);
                break;
            case 68:
                userFields.userFields69 = this.validateNull(header.userFields69);
                break;
            case 69:
                userFields.userFields70 = this.validateNull(header.userFields70);
                break;
            case 70:
                userFields.userFields71 = this.validateNull(header.userFields71);
                break;
            case 71:
                userFields.userFields72 = this.validateNull(header.userFields72);
                break;
            case 72:
                userFields.userFields73 = this.validateNull(header.userFields73);
                break;
            case 73:
                userFields.userFields74 = this.validateNull(header.userFields74);
                break;
            case 74:
                userFields.userFields75 = this.validateNull(header.userFields75);
                break;
            case 75:
                userFields.userFields76 = this.validateNull(header.userFields76);
                break;
            case 76:
                userFields.userFields77 = this.validateNull(header.userFields77);
                break;
            case 77:
                userFields.userFields78 = this.validateNull(header.userFields78);
                break;
            case 78:
                userFields.userFields79 = this.validateNull(header.userFields79);
                break;
            case 79:
                userFields.userFields80 = this.validateNull(header.userFields80);
                break;
            case 80:
                userFields.userFields81 = this.validateNull(header.userFields81);
                break;
            case 81:
                userFields.userFields82 = this.validateNull(header.userFields82);
                break;
            case 82:
                userFields.userFields83 = this.validateNull(header.userFields83);
                break;
            case 83:
                userFields.userFields84 = this.validateNull(header.userFields84);
                break;
            case 84:
                userFields.userFields85 = this.validateNull(header.userFields85);
                break;
            case 85:
                userFields.userFields86 = this.validateNull(header.userFields86);
                break;
            case 86:
                userFields.userFields87 = this.validateNull(header.userFields87);
                break;
            case 87:
                userFields.userFields88 = this.validateNull(header.userFields88);
                break;
            case 88:
                userFields.userFields89 = this.validateNull(header.userFields89);
                break;
            case 89:
                userFields.userFields90 = this.validateNull(header.userFields90);
                break;
            case 90:
                userFields.userFields91 = this.validateNull(header.userFields91);
                break;
            case 91:
                userFields.userFields92 = this.validateNull(header.userFields92);
                break;
            case 92:
                userFields.userFields93 = this.validateNull(header.userFields93);
                break;
            case 93:
                userFields.userFields94 = this.validateNull(header.userFields94);
                break;
            case 94:
                userFields.userFields95 = this.validateNull(header.userFields95);
                break;
            case 95:
                userFields.userFields96 = this.validateNull(header.userFields96);
                break;
            case 96:
                userFields.userFields97 = this.validateNull(header.userFields97);
                break;
            case 97:
                userFields.userFields98 = this.validateNull(header.userFields98);
                break;
            case 98:
                userFields.userFields99 = this.validateNull(header.userFields99);
                break;
            case 99:
                userFields.userFields100 = this.validateNull(header.userFields100);
                break;
            case 100:
                userFields.userFields101 = this.validateNull(header.userFields101);
                break;
            case 101:
                userFields.userFields102 = this.validateNull(header.userFields102);
                break;
            case 102:
                userFields.userFields103 = this.validateNull(header.userFields103);
                break;
            case 103:
                userFields.userFields104 = this.validateNull(header.userFields104);
                break;
            case 104:
                userFields.userFields105 = this.validateNull(header.userFields105);
                break;
            case 105:
                userFields.userFields106 = this.validateNull(header.userFields106);
                break;
            case 106:
                userFields.userFields107 = this.validateNull(header.userFields107);
                break;
            case 107:
                userFields.userFields108 = this.validateNull(header.userFields108);
                break;
            case 108:
                userFields.userFields109 = this.validateNull(header.userFields109);
                break;
            case 109:
                userFields.userFields110 = this.validateNull(header.userFields110);
                break;
            case 110:
                userFields.userFields111 = this.validateNull(header.userFields111);
                break;
            case 111:
                userFields.userFields112 = this.validateNull(header.userFields112);
                break;
            case 112:
                userFields.userFields113 = this.validateNull(header.userFields113);
                break;
            case 113:
                userFields.userFields114 = this.validateNull(header.userFields114);
                break;
            case 114:
                userFields.userFields115 = this.validateNull(header.userFields115);
                break;
            case 115:
                userFields.userFields116 = this.validateNull(header.userFields116);
                break;
            case 116:
                userFields.userFields117 = this.validateNull(header.userFields117);
                break;
            case 117:
                userFields.userFields118 = this.validateNull(header.userFields118);
                break;
            case 118:
                userFields.userFields119 = this.validateNull(header.userFields119);
                break;
            case 119:
                userFields.userFields120 = this.validateNull(header.userFields120);
                break;
            case 120:
                userFields.userFields121 = this.validateNull(header.userFields121);
                break;
            case 121:
                userFields.userFields122 = this.validateNull(header.userFields122);
                break;
            case 122:
                userFields.userFields123 = this.validateNull(header.userFields123);
                break;
            case 123:
                userFields.userFields124 = this.validateNull(header.userFields124);
                break;
            case 124:
                userFields.userFields125 = this.validateNull(header.userFields125);
                break;
            case 125:
                userFields.userFields126 = this.validateNull(header.userFields126);
                break;
            case 126:
                userFields.userFields127 = this.validateNull(header.userFields127);
                break;
            case 127:
                userFields.userFields128 = this.validateNull(header.userFields128);
                break;
            case 128:
                userFields.userFields129 = this.validateNull(header.userFields129);
                break;
            case 129:
                userFields.userFields130 = this.validateNull(header.userFields130);
                break;
            case 130:
                userFields.userFields131 = this.validateNull(header.userFields131);
                break;

            default:
                break;

        }

        return userFields;
    };

    setUserFieldItemsValue = (userFields, index, header) => {
        const { view, notificationReducer: { showAlert }, data } = this.props;
        switch (index) {
            case 0:
                userFields.userFields1 = this.validateNull(header.userFields1);
                break;
            case 1:
                userFields.userFields2 = this.validateNull(header.userFields2);
                break;
            case 2:
                userFields.userFields3 = this.validateNull(header.userFields3);
                break;
            case 3:
                userFields.userFields4 = this.validateNull(header.userFields4);
                break;
            case 4:
                userFields.userFields5 = this.validateNull(header.userFields5);
                break;
            case 5:
                userFields.userFields6 = this.validateNull(header.userFields6);
                break;
            case 6:
                userFields.userFields7 = this.validateNull(header.userFields7);
                break;
            case 7:
                userFields.userFields8 = this.validateNull(header.userFields8);
                break;
            case 8:
                userFields.userFields9 = this.validateNull(header.userFields9);
                break;
            case 9:
                userFields.userFields10 = this.validateNull(header.userFields10);
                break;
            case 10:
                userFields.userFields11 = this.validateNull(header.userFields11);
                break;
            case 11:
                userFields.userFields12 = this.validateNull(header.userFields12);
                break;
            case 12:
                userFields.userFields13 = this.validateNull(header.userFields13);
                break;
            case 13:
                userFields.userFields14 = this.validateNull(header.userFields14);
                break;
            case 14:
                userFields.userFields15 = this.validateNull(header.userFields15);
                break;
            case 15:
                userFields.userFields16 = this.validateNull(header.userFields16);
                break;
            case 16:
                userFields.userFields17 = this.validateNull(header.userFields17);
                break;
            case 17:
                userFields.userFields18 = this.validateNull(header.userFields18);
                break;
            case 18:
                userFields.userFields19 = this.validateNull(header.userFields19);
                break;
            case 19:
                userFields.userFields20 = this.validateNull(header.userFields20);
                break;
            case 20:
                userFields.userFields21 = this.validateNull(header.userFields21);
                break;
            case 21:
                userFields.userFields22 = this.validateNull(header.userFields22);
                break;
            case 22:
                userFields.userFields23 = this.validateNull(header.userFields23);
                break;
            case 23:
                userFields.userFields24 = this.validateNull(header.userFields24);
                break;
            case 24:
                userFields.userFields25 = this.validateNull(header.userFields25);
                break;
            case 25:
                userFields.userFields26 = this.validateNull(header.userFields26);
                break;
            case 26:
                userFields.userFields27 = this.validateNull(header.userFields27);
                break;
            case 27:
                userFields.userFields28 = this.validateNull(header.userFields28);
                break;
            case 28:
                userFields.userFields29 = this.validateNull(header.userFields29);
                break;
            case 29:
                userFields.userFields30 = this.validateNull(header.userFields30);
                break;
            case 30:
                userFields.userFields31 = this.validateNull(header.userFields31);
                break;
            case 31:
                userFields.userFields32 = this.validateNull(header.userFields32);
                break;
            case 32:
                userFields.userFields33 = this.validateNull(header.userFields33);
                break;
            case 33:
                userFields.userFields34 = this.validateNull(header.userFields34);
                break;
            case 34:
                userFields.userFields35 = this.validateNull(header.userFields35);
                break;
            case 35:
                userFields.userFields36 = this.validateNull(header.userFields36);
                break;
            case 36:
                userFields.userFields37 = this.validateNull(header.userFields37);
                break;
            case 37:
                userFields.userFields38 = this.validateNull(header.userFields38);
                break;
            case 38:
                userFields.userFields39 = this.validateNull(header.userFields39);
                break;
            case 39:
                userFields.userFields40 = this.validateNull(header.userFields40);
                break;
            case 40:
                userFields.userFields41 = this.validateNull(header.userFields41);
                break;
            case 41:
                userFields.userFields42 = this.validateNull(header.userFields42);
                break;
            case 42:
                userFields.userFields43 = this.validateNull(header.userFields43);
                break;
            case 43:
                userFields.userFields44 = this.validateNull(header.userFields44);
                break;
            case 44:
                userFields.userFields45 = this.validateNull(header.userFields45);
                break;
            case 45:
                userFields.userFields46 = this.validateNull(header.userFields46);
                break;
            case 46:
                userFields.userFields47 = this.validateNull(header.userFields47);
                break;
            case 47:
                userFields.userFields48 = this.validateNull(header.userFields48);
                break;
            case 48:
                userFields.userFields49 = this.validateNull(header.userFields49);
                break;
            case 49:
                userFields.userFields50 = this.validateNull(header.userFields50);
                break;
            case 50:
                userFields.userFields51 = this.validateNull(header.userFields51);
                break;
            case 51:
                userFields.userFields52 = this.validateNull(header.userFields52);
                break;
            case 52:
                userFields.userFields53 = this.validateNull(header.userFields53);
                break;
            case 53:
                userFields.userFields54 = this.validateNull(header.userFields54);
                break;
            case 54:
                userFields.userFields55 = this.validateNull(header.userFields55);
                break;
            case 55:
                userFields.userFields56 = this.validateNull(header.userFields56);
                break;
            case 56:
                userFields.userFields57 = this.validateNull(header.userFields57);
                break;
            case 57:
                userFields.userFields58 = this.validateNull(header.userFields58);
                break;
            case 58:
                userFields.userFields59 = this.validateNull(header.userFields59);
                break;
            case 59:
                userFields.userFields60 = this.validateNull(header.userFields60);
                break;
            case 60:
                userFields.userFields61 = this.validateNull(header.userFields61);
                break;
            case 61:
                userFields.userFields62 = this.validateNull(header.userFields62);
                break;
            case 62:
                userFields.userFields63 = this.validateNull(header.userFields63);
                break;
            case 63:
                userFields.userFields64 = this.validateNull(header.userFields64);
                break;
            case 64:
                userFields.userFields65 = this.validateNull(header.userFields65);
                break;
            case 65:
                userFields.userFields66 = this.validateNull(header.userFields66);
                break;
            case 66:
                userFields.userFields67 = this.validateNull(header.userFields67);
                break;
            case 67:
                userFields.userFields68 = this.validateNull(header.userFields68);
                break;
            case 68:
                userFields.userFields69 = this.validateNull(header.userFields69);
                break;
            case 69:
                userFields.userFields70 = this.validateNull(header.userFields70);
                break;
            case 70:
                userFields.userFields71 = this.validateNull(header.userFields71);
                break;
            case 71:
                userFields.userFields72 = this.validateNull(header.userFields72);
                break;
            case 72:
                userFields.userFields73 = this.validateNull(header.userFields73);
                break;
            case 73:
                userFields.userFields74 = this.validateNull(header.userFields74);
                break;
            case 74:
                userFields.userFields75 = this.validateNull(header.userFields75);
                break;
            case 75:
                userFields.userFields76 = this.validateNull(header.userFields76);
                break;
            case 76:
                userFields.userFields77 = this.validateNull(header.userFields77);
                break;
            case 77:
                userFields.userFields78 = this.validateNull(header.userFields78);
                break;
            case 78:
                userFields.userFields79 = this.validateNull(header.userFields79);
                break;
            case 79:
                userFields.userFields80 = this.validateNull(header.userFields80);
                break;
            case 80:
                userFields.userFields81 = this.validateNull(header.userFields81);
                break;
            case 81:
                userFields.userFields82 = this.validateNull(header.userFields82);
                break;
            case 82:
                userFields.userFields83 = this.validateNull(header.userFields83);
                break;
            case 83:
                userFields.userFields84 = this.validateNull(header.userFields84);
                break;
            case 84:
                userFields.userFields85 = this.validateNull(header.userFields85);
                break;
            case 85:
                userFields.userFields86 = this.validateNull(header.userFields86);
                break;
            case 86:
                userFields.userFields87 = this.validateNull(header.userFields87);
                break;
            case 87:
                userFields.userFields88 = this.validateNull(header.userFields88);
                break;
            case 88:
                userFields.userFields89 = this.validateNull(header.userFields89);
                break;
            case 89:
                userFields.userFields90 = this.validateNull(header.userFields90);
                break;
            case 90:
                userFields.userFields91 = this.validateNull(header.userFields91);
                break;
            case 91:
                userFields.userFields92 = this.validateNull(header.userFields92);
                break;
            case 92:
                userFields.userFields93 = this.validateNull(header.userFields93);
                break;
            case 93:
                userFields.userFields94 = this.validateNull(header.userFields94);
                break;
            case 94:
                userFields.userFields95 = this.validateNull(header.userFields95);
                break;
            case 95:
                userFields.userFields96 = this.validateNull(header.userFields96);
                break;
            case 96:
                userFields.userFields97 = this.validateNull(header.userFields97);
                break;
            case 97:
                userFields.userFields98 = this.validateNull(header.userFields98);
                break;
            case 98:
                userFields.userFields99 = this.validateNull(header.userFields99);
                break;
            case 99:
                userFields.userFields100 = this.validateNull(header.userFields100);
                break;
            case 100:
                userFields.userFields101 = this.validateNull(header.userFields101);
                break;
            case 101:
                userFields.userFields102 = this.validateNull(header.userFields102);
                break;
            case 102:
                userFields.userFields103 = this.validateNull(header.userFields103);
                break;
            case 103:
                userFields.userFields104 = this.validateNull(header.userFields104);
                break;
            case 104:
                userFields.userFields105 = this.validateNull(header.userFields105);
                break;
            case 105:
                userFields.userFields106 = this.validateNull(header.userFields106);
                break;
            case 106:
                userFields.userFields107 = this.validateNull(header.userFields107);
                break;
            case 107:
                userFields.userFields108 = this.validateNull(header.userFields108);
                break;
            case 108:
                userFields.userFields109 = this.validateNull(header.userFields109);
                break;
            case 109:
                userFields.userFields110 = this.validateNull(header.userFields110);
                break;
            case 110:
                userFields.userFields111 = this.validateNull(header.userFields111);
                break;
            case 111:
                userFields.userFields112 = this.validateNull(header.userFields112);
                break;
            case 112:
                userFields.userFields113 = this.validateNull(header.userFields113);
                break;
            case 113:
                userFields.userFields114 = this.validateNull(header.userFields114);
                break;
            case 114:
                userFields.userFields115 = this.validateNull(header.userFields115);
                break;
            case 115:
                userFields.userFields116 = this.validateNull(header.userFields116);
                break;
            case 116:
                userFields.userFields117 = this.validateNull(header.userFields117);
                break;
            case 117:
                userFields.userFields118 = this.validateNull(header.userFields118);
                break;
            case 118:
                userFields.userFields119 = this.validateNull(header.userFields119);
                break;
            case 119:
                userFields.userFields120 = this.validateNull(header.userFields120);
                break;
            case 120:
                userFields.userFields121 = this.validateNull(header.userFields121);
                break;
            case 121:
                userFields.userFields122 = this.validateNull(header.userFields122);
                break;
            case 122:
                userFields.userFields123 = this.validateNull(header.userFields123);
                break;
            case 123:
                userFields.userFields124 = this.validateNull(header.userFields124);
                break;
            case 124:
                userFields.userFields125 = this.validateNull(header.userFields125);
                break;
            case 125:
                userFields.userFields126 = this.validateNull(header.userFields126);
                break;
            case 126:
                userFields.userFields127 = this.validateNull(header.userFields127);
                break;
            case 127:
                userFields.userFields128 = this.validateNull(header.userFields128);
                break;
            case 128:
                userFields.userFields129 = this.validateNull(header.userFields129);
                break;
            case 129:
                userFields.userFields130 = this.validateNull(header.userFields130);
                break;
            case 130:
                userFields.userFields131 = this.validateNull(header.userFields131);
                break;

            default:
                break;

        }

        return userFields;
    };

    setUserFieldValueDefault = (userFields, index, field) => {

        switch (index) {
            case 0:
                userFields.userFields1 = this.validateNull(field.Dflt);
                break;
            case 1:
                userFields.userFields2 = this.validateNull(field.Dflt);
                break;
            case 2:
                userFields.userFields3 = this.validateNull(field.Dflt);
                break;
            case 3:
                userFields.userFields4 = this.validateNull(field.Dflt);
                break;
            case 4:
                userFields.userFields5 = this.validateNull(field.Dflt);
                break;
            case 5:
                userFields.userFields6 = this.validateNull(field.Dflt);
                break;
            case 6:
                userFields.userFields7 = this.validateNull(field.Dflt);
                break;
            case 7:
                userFields.userFields8 = this.validateNull(field.Dflt);
                break;
            case 8:
                userFields.userFields9 = this.validateNull(field.Dflt);
                break;
            case 9:
                userFields.userFields10 = this.validateNull(field.Dflt);
                break;
            case 10:
                userFields.userFields11 = this.validateNull(field.Dflt);
                break;
            case 11:
                userFields.userFields12 = this.validateNull(field.Dflt);
                break;
            case 12:
                userFields.userFields13 = this.validateNull(field.Dflt);
                break;
            case 13:
                userFields.userFields14 = this.validateNull(field.Dflt);
                break;
            case 14:
                userFields.userFields15 = this.validateNull(field.Dflt);
                break;
            case 15:
                userFields.userFields16 = this.validateNull(field.Dflt);
                break;
            case 16:
                userFields.userFields17 = this.validateNull(field.Dflt);
                break;
            case 17:
                userFields.userFields18 = this.validateNull(field.Dflt);
                break;
            case 18:
                userFields.userFields19 = this.validateNull(field.Dflt);
                break;
            case 19:
                userFields.userFields20 = this.validateNull(field.Dflt);
                break;
            case 20:
                userFields.userFields21 = this.validateNull(field.Dflt);
                break;
            case 21:
                userFields.userFields22 = this.validateNull(field.Dflt);
                break;
            case 22:
                userFields.userFields23 = this.validateNull(field.Dflt);
                break;
            case 23:
                userFields.userFields24 = this.validateNull(field.Dflt);
                break;
            case 24:
                userFields.userFields25 = this.validateNull(field.Dflt);
                break;
            case 25:
                userFields.userFields26 = this.validateNull(field.Dflt);
                break;
            case 26:
                userFields.userFields27 = this.validateNull(field.Dflt);
                break;
            case 27:
                userFields.userFields28 = this.validateNull(field.Dflt);
                break;
            case 28:
                userFields.userFields29 = this.validateNull(field.Dflt);
                break;
            case 29:
                userFields.userFields30 = this.validateNull(field.Dflt);
                break;
            case 30:
                userFields.userFields31 = this.validateNull(field.Dflt);
                break;
            case 31:
                userFields.userFields32 = this.validateNull(field.Dflt);
                break;
            case 32:
                userFields.userFields33 = this.validateNull(field.Dflt);
                break;
            case 33:
                userFields.userFields34 = this.validateNull(field.Dflt);
                break;
            case 34:
                userFields.userFields35 = this.validateNull(field.Dflt);
                break;
            case 35:
                userFields.userFields36 = this.validateNull(field.Dflt);
                break;
            case 36:
                userFields.userFields37 = this.validateNull(field.Dflt);
                break;
            case 37:
                userFields.userFields38 = this.validateNull(field.Dflt);
                break;
            case 38:
                userFields.userFields39 = this.validateNull(field.Dflt);
                break;
            case 39:
                userFields.userFields40 = this.validateNull(field.Dflt);
                break;
            case 40:
                userFields.userFields41 = this.validateNull(field.Dflt);
                break;
            case 41:
                userFields.userFields42 = this.validateNull(field.Dflt);
                break;
            case 42:
                userFields.userFields43 = this.validateNull(field.Dflt);
                break;
            case 43:
                userFields.userFields44 = this.validateNull(field.Dflt);
                break;
            case 44:
                userFields.userFields45 = this.validateNull(field.Dflt);
                break;
            case 45:
                userFields.userFields46 = this.validateNull(field.Dflt);
                break;
            case 46:
                userFields.userFields47 = this.validateNull(field.Dflt);
                break;
            case 47:
                userFields.userFields48 = this.validateNull(field.Dflt);
                break;
            case 48:
                userFields.userFields49 = this.validateNull(field.Dflt);
                break;
            case 49:
                userFields.userFields50 = this.validateNull(field.Dflt);
                break;
            case 50:
                userFields.userFields51 = this.validateNull(field.Dflt);
                break;
            case 51:
                userFields.userFields52 = this.validateNull(field.Dflt);
                break;
            case 52:
                userFields.userFields53 = this.validateNull(field.Dflt);
                break;
            case 53:
                userFields.userFields54 = this.validateNull(field.Dflt);
                break;
            case 54:
                userFields.userFields55 = this.validateNull(field.Dflt);
                break;
            case 55:
                userFields.userFields56 = this.validateNull(field.Dflt);
                break;
            case 56:
                userFields.userFields57 = this.validateNull(field.Dflt);
                break;
            case 57:
                userFields.userFields58 = this.validateNull(field.Dflt);
                break;
            case 58:
                userFields.userFields59 = this.validateNull(field.Dflt);
                break;
            case 59:
                userFields.userFields60 = this.validateNull(field.Dflt);
                break;
            case 60:
                userFields.userFields61 = this.validateNull(field.Dflt);
                break;
            case 61:
                userFields.userFields62 = this.validateNull(field.Dflt);
                break;
            case 62:
                userFields.userFields63 = this.validateNull(field.Dflt);
                break;
            case 63:
                userFields.userFields64 = this.validateNull(field.Dflt);
                break;
            case 64:
                userFields.userFields65 = this.validateNull(field.Dflt);
                break;
            case 65:
                userFields.userFields66 = this.validateNull(field.Dflt);
                break;
            case 66:
                userFields.userFields67 = this.validateNull(field.Dflt);
                break;
            case 67:
                userFields.userFields68 = this.validateNull(field.Dflt);
                break;
            case 68:
                userFields.userFields69 = this.validateNull(field.Dflt);
                break;
            case 69:
                userFields.userFields70 = this.validateNull(field.Dflt);
                break;
            case 70:
                userFields.userFields71 = this.validateNull(field.Dflt);
                break;
            case 71:
                userFields.userFields72 = this.validateNull(field.Dflt);
                break;
            case 72:
                userFields.userFields73 = this.validateNull(field.Dflt);
                break;
            case 73:
                userFields.userFields74 = this.validateNull(field.Dflt);
                break;
            case 74:
                userFields.userFields75 = this.validateNull(field.Dflt);
                break;
            case 75:
                userFields.userFields76 = this.validateNull(field.Dflt);
                break;
            case 76:
                userFields.userFields77 = this.validateNull(field.Dflt);
                break;
            case 77:
                userFields.userFields78 = this.validateNull(field.Dflt);
                break;
            case 78:
                userFields.userFields79 = this.validateNull(field.Dflt);
                break;
            case 79:
                userFields.userFields80 = this.validateNull(field.Dflt);
                break;
            case 80:
                userFields.userFields81 = this.validateNull(field.Dflt);
                break;
            case 81:
                userFields.userFields82 = this.validateNull(field.Dflt);
                break;
            case 82:
                userFields.userFields83 = this.validateNull(field.Dflt);
                break;
            case 83:
                userFields.userFields84 = this.validateNull(field.Dflt);
                break;
            case 84:
                userFields.userFields85 = this.validateNull(field.Dflt);
                break;
            case 85:
                userFields.userFields86 = this.validateNull(field.Dflt);
                break;
            case 86:
                userFields.userFields87 = this.validateNull(field.Dflt);
                break;
            case 87:
                userFields.userFields88 = this.validateNull(field.Dflt);
                break;
            case 88:
                userFields.userFields89 = this.validateNull(field.Dflt);
                break;
            case 89:
                userFields.userFields90 = this.validateNull(field.Dflt);
                break;
            case 90:
                userFields.userFields91 = this.validateNull(field.Dflt);
                break;
            case 91:
                userFields.userFields92 = this.validateNull(field.Dflt);
                break;
            case 92:
                userFields.userFields93 = this.validateNull(field.Dflt);
                break;
            case 93:
                userFields.userFields94 = this.validateNull(field.Dflt);
                break;
            case 94:
                userFields.userFields95 = this.validateNull(field.Dflt);
                break;
            case 95:
                userFields.userFields96 = this.validateNull(field.Dflt);
                break;
            case 96:
                userFields.userFields97 = this.validateNull(field.Dflt);
                break;
            case 97:
                userFields.userFields98 = this.validateNull(field.Dflt);
                break;
            case 98:
                userFields.userFields99 = this.validateNull(field.Dflt);
                break;
            case 99:
                userFields.userFields100 = this.validateNull(field.Dflt);
                break;
            case 100:
                userFields.userFields101 = this.validateNull(field.Dflt);
                break;
            case 101:
                userFields.userFields102 = this.validateNull(field.Dflt);
                break;
            case 102:
                userFields.userFields103 = this.validateNull(field.Dflt);
                break;
            case 103:
                userFields.userFields104 = this.validateNull(field.Dflt);
                break;
            case 104:
                userFields.userFields105 = this.validateNull(field.Dflt);
                break;
            case 105:
                userFields.userFields106 = this.validateNull(field.Dflt);
                break;
            case 106:
                userFields.userFields107 = this.validateNull(field.Dflt);
                break;
            case 107:
                userFields.userFields108 = this.validateNull(field.Dflt);
                break;
            case 108:
                userFields.userFields109 = this.validateNull(field.Dflt);
                break;
            case 109:
                userFields.userFields110 = this.validateNull(field.Dflt);
                break;
            case 110:
                userFields.userFields111 = this.validateNull(field.Dflt);
                break;
            case 111:
                userFields.userFields112 = this.validateNull(field.Dflt);
                break;
            case 112:
                userFields.userFields113 = this.validateNull(field.Dflt);
                break;
            case 113:
                userFields.userFields114 = this.validateNull(field.Dflt);
                break;
            case 114:
                userFields.userFields115 = this.validateNull(field.Dflt);
                break;
            case 115:
                userFields.userFields116 = this.validateNull(field.Dflt);
                break;
            case 116:
                userFields.userFields117 = this.validateNull(field.Dflt);
                break;
            case 117:
                userFields.userFields118 = this.validateNull(field.Dflt);
                break;
            case 118:
                userFields.userFields119 = this.validateNull(field.Dflt);
                break;
            case 119:
                userFields.userFields120 = this.validateNull(field.Dflt);
                break;
            case 120:
                userFields.userFields121 = this.validateNull(field.Dflt);
                break;
            case 121:
                userFields.userFields122 = this.validateNull(field.Dflt);
                break;
            case 122:
                userFields.userFields123 = this.validateNull(field.Dflt);
                break;
            case 123:
                userFields.userFields124 = this.validateNull(field.Dflt);
                break;
            case 124:
                userFields.userFields125 = this.validateNull(field.Dflt);
                break;
            case 125:
                userFields.userFields126 = this.validateNull(field.Dflt);
                break;
            case 126:
                userFields.userFields127 = this.validateNull(field.Dflt);
                break;
            case 127:
                userFields.userFields128 = this.validateNull(field.Dflt);
                break;
            case 128:
                userFields.userFields129 = this.validateNull(field.Dflt);
                break;
            case 129:
                userFields.userFields130 = this.validateNull(field.Dflt);
                break;
            case 130:
                userFields.userFields131 = this.validateNull(field.Dflt);
                break;
            default:
                break
        }

        return userFields;
    };

    processUserFields = async ({
        fields = [],
        model = {},
        targetProperty = "invFields",
        headerFields = [],
        dateFields = [],
        isOWTRoOWTQ = false,
        isCopy = false, // Mandar en true si se quiere conservar de un documento a otro. Mardar igual el de abajo (Documento copiado o del que se copia)
        header = {},
    }) => {
        const { enableSpinner, view } = this.props;
        const headers = model?.userFieldsHeader || [];
        model[targetProperty] = [];

        const formatted = fields?.filter(field => field.active && field.isFormatted) ?? [];
        enableSpinner(true);
        let getFormattedQueriesRes = await apiClient.getFormattedQueries({ formatted });
        enableSpinner(false);

        let formattedMap = {};
        if (getFormattedQueriesRes?.status) {
            const data = getFormattedQueriesRes?.data ?? [];
            for (const element of data) {
                const { Field = '', Formatted = [] } = element ?? {};
                formattedMap[Field] = Formatted;
            }
        }

        const typeSelectList = [];
        const typeSearchList = [];

        for (const key in formattedMap) {
            const rows = formattedMap[key] ?? [];

            if (!rows?.length) continue;
            let columnsCount = 0;
            const firstRow = rows[0];
            if (Array.isArray(firstRow)) {
                columnsCount = firstRow?.length;
            } else if (typeof firstRow === 'object' && firstRow !== null) {
                columnsCount = Object.keys(firstRow)?.length;
            }

            if (rows?.length < 15 && columnsCount === 2) {
                typeSelectList.push(key);
            } else {
                typeSearchList.push(key);
            }
        }
        model.typeSearchList = typeSearchList ?? [];
        model.formattedMap = targetProperty !== 'invFields' ? model.formattedMap : formattedMap ?? {}; // Revisar esto si se requieren busquedas formateadas (Mostrar la info en tablas) en otros targets

        for (const field of fields) {
            if (!field?.active) continue;
            if (isOWTRoOWTQ && ['U_BPP_MDTD', 'U_BPP_MDSD', 'U_BPP_MDCD', 'U_BPP_MDTS', 'U_RS_MOTIVOIS', 'U_RS_TIPOOPER', 'U_STR_FE_GRE_CodigoMotivoTraslado']?.includes(field?.Field)) { // Estos campos no se requieren
                continue;
            }

            const alias = field.Field;
            const cleanAlias = alias?.startsWith("U_") ? alias?.slice(2) : alias;

            const headerMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

            let hasOptions = headerMatch?.options?.length > 0;
            const typeId = headerMatch?.header?.TypeID;
            const size = headerMatch?.header?.SizeID;
            const descr = headerMatch?.header?.Descr;
            let defaultValue = headerMatch?.header?.Dflt;

            const isHeader = headerFields?.includes(alias) || headerFields?.includes(cleanAlias);

            let type = "text";

            if (dateFields?.includes(alias) || typeId === "D") {
                type = "date";
            } else if (hasOptions && typeId === "A") {
                type = "select";
            } else if (typeId === "B" || typeId === "N") {
                type = "number";
            } else if (typeId === "M") {
                type = "textarea";
            }

            let options = hasOptions ? headerMatch?.options ?? [] : [];

            if (typeSelectList?.includes(alias) && formattedMap[alias]?.length) {

                options = formattedMap[alias]?.map(row => {
                    if (Array.isArray(row)) {
                        return {
                            FldValue: row?.[0] ?? '',
                            Descr: row?.[1] ?? ''
                        };
                    }

                    if (typeof row === 'object' && row !== null) {
                        const keys = Object.keys(row);

                        return {
                            FldValue: row[keys[0]] ?? '',
                            Descr: row[keys[1]] ?? ''
                        };
                    }

                    return {
                        FldValue: '',
                        Descr: ''
                    };
                });

                type = 'select';
                hasOptions = true;
            }
            if (typeSearchList.includes(alias) && formattedMap[alias]?.length) {
                type = 'table';
                hasOptions = false;
            }

            // Override específico
            const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput' || Number(model?.ObjType) === 59 || Number(model?.ObjType) === 60;
            if (isOIGNoOIGE) {
                if (alias === "U_BPP_MDTD") {
                    type = "select";

                    if (headerMatch) {
                        options = [
                            { FldValue: "09", Descr: "Guía" },
                            { FldValue: "DI", Descr: "Documento Interno" },
                        ];
                    }

                    hasOptions = true;
                }
                if (alias === "U_BPP_MDSD") {
                    let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                    let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                    let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                    let seriesPuerta = {}
                    let seriesPlanta = {}
                    try {
                        seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                    } catch (e) {
                        seriesPuerta = {};
                    }
                    try {
                        seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                    } catch (e) {
                        seriesPlanta = {};
                    }
                    const noNeedDefault = true;
                    seriesPuerta = this.parseSeries(seriesPuerta, noNeedDefault);
                    seriesPlanta = this.parseSeries(seriesPlanta, noNeedDefault);
                    const isZonal = Number(user?.Branch?.Type) === 1;
                    options = (
                        isZonal
                            ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                            : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                    )?.filter((option, index, self) =>
                        (option.key === '09' || option.key === 'DI') &&
                        index === self.findIndex(x => x.value === option.value)
                    );

                    if (options?.length) {
                        type = "select";
                        hasOptions = true;
                        field.Static = true;
                    }
                }
                if (alias === "U_BPP_MDCD") {
                    field.Static = true;
                }
            }

            model[targetProperty].push({
                Field: alias,
                Name: descr || field.Name,
                Type: type,
                Size: size,
                isHeader,
                options,
                default: defaultValue ?? "",
                isNumber: type === "number",
                Static: field?.Static || false,
            });


            const fieldValue = header?.[alias];
            if (isCopy) {
                model[alias] = type === 'date' ? moment(fieldValue).format('YYYY-MM-DD') : fieldValue;
            } else if (defaultValue !== undefined && defaultValue !== null && defaultValue !== "") {
                model[alias] = defaultValue;
            } else if (type === "date" && !model[alias]) {
                model[alias] = moment(new Date()).format("YYYY-MM-DD");
            } else {
                model[alias] = "";
            }
        }
    };

    processUserFieldsDetails = ({
        fields = [],
        targetModel = {},
        targetProperty = 'invFields',
        headerFields = [],
        userFieldsService = [],
        header = {},
        dateFields = [],
        isOWTRoOWTQ = false,
    }) => {
        const headers = userFieldsService || [];
        targetModel[targetProperty] = [];

        for (const field of fields) {
            if (!field?.active) continue;
            if (isOWTRoOWTQ && ['U_BPP_MDTD', 'U_BPP_MDSD', 'U_BPP_MDCD', 'U_BPP_MDTS', 'U_RS_MOTIVOIS', 'U_RS_TIPOOPER', 'U_STR_FE_GRE_CodigoMotivoTraslado']?.includes(field?.Field)) { // Estos campos no se requieren
                continue;
            }

            const alias = field.Field;
            const cleanAlias = alias?.startsWith('U_') ? alias?.slice(2) : alias;

            const headerMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

            const hasOptions = headerMatch?.options?.length > 0;
            const typeId = headerMatch?.header?.TypeID;
            const size = headerMatch?.header?.SizeID;
            const descr = headerMatch?.header?.Descr;
            const defaultValue = headerMatch?.header?.Dflt;

            const isHeader = headerFields?.includes(alias) || headerFields?.includes(cleanAlias);

            let type = 'text';

            if (dateFields?.includes(alias) || typeId === 'D') {
                type = 'date';
            } else if (hasOptions && typeId === 'A') {
                type = 'select';
            } else if (typeId === 'B' || typeId === 'N') {
                type = 'number';
            } else if (typeId === 'M') {
                type = 'textarea';
            }

            const headerValue = header?.[alias];

            targetModel[targetProperty].push({
                Field: alias,
                Name: descr || field.Name,
                Type: type,
                Size: size,
                isHeader,
                options: hasOptions ? headerMatch?.options : [],
                default: defaultValue ?? '',
                isNumber: type === 'number',
                Static: field?.Static || false,
            });

            targetModel[alias] = type === 'date' ? moment(headerValue).format('YYYY-MM-DD') : headerValue;
        }
    };

    /// openDetails
    createNewOrderDetails = async (detailsResponse, open) => {
        const { view } = this.props;
        let newOrderModel = new NewOrder();
        let userFields = new UserFields();

        let header = detailsResponse.data.header;
        let items = detailsResponse.data.items || [];
        let checks = detailsResponse.data.paymentChecks;
        let creditCards = detailsResponse.data.paymentCreditCards;
        let userFieldsService = detailsResponse.data.userFields;
        let userFieldsItemsDocument = detailsResponse.data.userFieldsItemsDocument;
        const flagDownPayments = (view === 'purchaseDownPayments' || view === 'invoiceAdvance') ? true : false

        const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput' || Number(newOrderModel?.ObjType) === 59 || Number(newOrderModel?.ObjType) === 60 || Number(header?.ObjType) === 59 || Number(header?.ObjType) === 60;
        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || Number(newOrderModel?.ObjType) === 67 || Number(newOrderModel?.ObjType) === 1250000001 || Number(header?.ObjType) === 67 || Number(header?.ObjType) === 1250000001;
        const isDraftOWTQ = view === 'draft' && Number(newOrderModel?.ObjType) === 1250000001 && !newOrderModel?.newView;

        let status = "";
        if (header.DocStatus === 'C' && header.CANCELED === 'Y') {
            status = "Cancelado"
        } else if (header.DocStatus === 'O' && header.InvntSttus === 'O') {
            status = "Abierto"
        } else if (header.DocStatus === 'O' && header.InvntSttus === 'C' && !flagDownPayments) {
            status = "Entregado"
        } else if ((header.DocStatus === 'C' && header.InvntSttus === 'O' && header.DocTotal === header.PaidToDate && view === 'invoiceReserve') || ((flagDownPayments) && header.DocTotal === header.PaidToDate)) {
            status = "Pagado"
        } else if (header.DocStatus === 'C') {
            status = "Cerrado"
        } else if ((flagDownPayments) && header.DocStatus === 'O' && header.InvntSttus === 'C') { status = "Abierto" }

        if (view !== 'payment') {
            json.allUserFields.forEach((item, index) => {
                userFieldsService.forEach(userfieldItem => {
                    if (item.fieldId === userfieldItem.header.FieldID) {

                        json.allEnableUserFields[index].name = userfieldItem.header.Descr;
                        item.name = userfieldItem.header.Descr;
                        item.fieldType = item.fieldType === 3 ? 3 : userfieldItem.options.length !== 0 ? 2 : 1;
                        item.IdValue = index;
                        const isInvoice = view === 'invoice';
                        const isCreditNote = view === 'creditNote';
                        const isDebitNote = view === 'debitNote';
                        const isOWTRoOWTQ = view === 'transfers' || view === 'transfersRequest' || isDraftOWTQ;

                        if ((isInvoice || isCreditNote || isDebitNote) || isOWTRoOWTQ) {
                            if (item.fieldId === 1) {
                                let validOptions = [];
                                if (isInvoice) {
                                    validOptions = [
                                        { value: '01', label: 'Factura' },
                                        { value: '03', label: 'Boleta' },
                                    ];
                                } else if (isCreditNote) {
                                    validOptions = [
                                        { value: '07', label: 'Nota de crédito' },
                                    ];
                                } else if (isDebitNote) {
                                    validOptions = [
                                        { value: '08', label: 'Nota de débito' }
                                    ];
                                } else {
                                    validOptions = [
                                        { value: '09', label: 'Guia' },
                                        { value: 'DI', label: 'Documento Interno' },
                                    ];
                                }
                                item.options = validOptions;
                            } else if (isOWTRoOWTQ && item.fieldType === 3 && userfieldItem.options.length === 0) {
                            } else {
                                item.options = userfieldItem.options;
                            }
                        } else {
                            item.options = userfieldItem.options;
                        }
                        let newUserFields = this.setUserFieldValue(userFields, index, header);
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }
                        userFields = newUserFields;
                    }
                });
            });
        } else {
            json.userFieldsPayment.forEach((item, index) => {
                userFieldsService.forEach(userfieldItem => {
                    if (item.fieldId === userfieldItem.header.FieldID) {

                        json.allEnableUserFields[index].name = userfieldItem.header.Descr;
                        item.name = userfieldItem.header.Descr;
                        item.fieldType = item.fieldType === 3 ? 3 : userfieldItem.options.length !== 0 ? 2 : 1;
                        item.options = userfieldItem.options;
                        item.IdValue = index;
                        let newUserFields = this.setUserFieldValue(userFields, index, header);
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }
                        userFields = newUserFields;
                    }
                });
            });
        }

        if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || newOrderModel?.isTransferDocument || (isOIGNoOIGE || view === 'payment' || isOWTRoOWTQ)) {
            newOrderModel.userFieldsHeader = userFieldsService ?? [];
            newOrderModel.userFieldsBody = userFieldsItemsDocument ?? [];
        }

        //#region ################## PERCEPCION ################ ✔
        newOrderModel.U_BPP_BPTD = header?.U_BPP_BPTD;
        newOrderModel.U_STR_AR = header?.U_STR_AR;
        newOrderModel.U_STR_AP = header?.U_STR_AP;
        newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = header?.U_LLG_EXCEPTUADO_PERCEPCION;
        if (view === 'invoice') {
            newOrderModel.PerceptionValue = Number(header?.U_BPP_TtPc ?? 0);
        }
        //#endregion ################## PERCEPCION ################ ✔

        newOrderModel.IdOxxoRef = header?.U_FMB_PriKeyOxRef ?? -1;
        newOrderModel.ReserveInvoice = header?.isIns === 'Y' ? 'tYES' : 'tNO';
        newOrderModel.OriginDocumentCreate = view;
        newOrderModel.userFields = userFields;
        newOrderModel.ObjType = header.ObjType;
        newOrderModel.DocType = header.DocType;
        newOrderModel.DocumentType = "F";
        newOrderModel.isAccountPayment = header.DocType === 'A';
        newOrderModel.WddStatus = header.WddStatus;
        newOrderModel.DocEntry = header.DocEntry || "";
        newOrderModel.DocEntryRel = header.DocEntryRel || "";
        newOrderModel.CardCode = header.CardCode;
        newOrderModel.Balance = header.Balance || 0;
        newOrderModel.UserID = 0;
        newOrderModel.DocStatus = header.DocStatus;
        newOrderModel.CardName = header.CardName;
        newOrderModel.CardType = header.CardType || "";
        newOrderModel.NextFolio = header.DocNum;
        newOrderModel.DocNum = header.DocNum;
        newOrderModel.StatusDocument = status;
        newOrderModel.NumAtCard = header.NumAtCard;
        newOrderModel.SerieName = header.SeriesName;
        newOrderModel.SerieCode = header.Series;
        newOrderModel.ExtraDays = header.metodoPago;
        newOrderModel.SerieArray = [];
        newOrderModel.DocDate = moment(header.DocDate).format('YYYY-MM-DD');
        newOrderModel.DocDueDate = moment(header.DocDueDate).format('YYYY-MM-DD');
        newOrderModel.TaxDate = moment(header.TaxDate).format('YYYY-MM-DD');
        newOrderModel.ReqDate = moment(header.ReqDate).format('YYYY-MM-DD');
        newOrderModel.U_FMB_END_DATE = header.U_FMB_END_DATE ? moment(header.U_FMB_END_DATE).format('YYYY-MM-DD') : "";
        newOrderModel.ReqType = header.ReqType;
        newOrderModel.Requester = header.Requester;
        newOrderModel.ReqName = header.ReqName;
        newOrderModel.Branch = header.Branch;
        newOrderModel.BranchName = header.BranchName;
        newOrderModel.Department = header.Department;
        newOrderModel.DepartmentName = header.DepartmentName;
        newOrderModel.Email = header.Email || header.E_Mail;
        newOrderModel.Notify = header.Notify;
        newOrderModel.SlpCode = header.SlpCode;
        newOrderModel.SlpName = header.SlpName;
        newOrderModel.CntctCode = header.CntctCode;
        newOrderModel.CntctName = header.CntntName;
        newOrderModel.OwnerCode = header.OwnerCode || "";
        newOrderModel.OwnerName = header.OwnerName || "";
        newOrderModel.Comments = header.Comments || "";
        newOrderModel.Status = open.Status || "";
        newOrderModel.StepCode = open.StepCode | "";
        newOrderModel.WtmName = open.WtmName;
        newOrderModel.Subtotal = 0;
        newOrderModel.DiscountPercent = parseFloat(header.DiscPrcnt).toFixed(2);
        newOrderModel.Discount = 0;
        newOrderModel.Taxes = 0;
        newOrderModel.Total = 0;
        newOrderModel.DpmAmnt = header.DpmAmnt || 0;
        newOrderModel.DownPaymentAmount = header.DpmAmnt || 0;
        newOrderModel.Items = [];

        newOrderModel.GroupNum = header.GroupNum;
        newOrderModel.GroupName = header.condicionesPago;
        newOrderModel.GroupCode = header.GroupCode;
        newOrderModel.GroupCodeName = header.GroupCodeName;
        newOrderModel.PymCode = header.PeyMethod;
        newOrderModel.PymName = header.payDescription;
        newOrderModel.indexRowDetails = open.index;

        newOrderModel.RateAmnt = Number(header.RateAmnt || 0) / 100;

        //Direccion de entrega para documentos generales
        newOrderModel.Address2 = header.Address2;
        newOrderModel.ShipToCode = header.ShipToCode;
        newOrderModel.UBIGEO = header.ZipCode || '';
        newOrderModel.U_RMO_ID_DIRE = header.U_RMO_ID_DIRE || '';
        // definido desde el usuario
        newOrderModel.TaxeDefaultPartner = header.TaxCode || '';
        newOrderModel.TaxeRateDefaultPartner = header.TaxCodeRate || '';
        newOrderModel.TaxNameDefaultPartner = header.TaxCodeName || '';
        newOrderModel.OcrCode2DefaultPartner = header.OcrCode2 || '';
        newOrderModel.AcctCodeDefaultPartner = header.AcctCodeItem || '';
        newOrderModel.CogsAcctDefaultPartner = header.CogsAcctItem || '';
        newOrderModel.AcctCodeNameDefaultPartner = header.AcctCodeItemName || '';
        newOrderModel.CogsAcctNameDefaultPartner = header.CogsAcctItemName || '';

        //Trasnfers
        newOrderModel.Address = header.Address;
        newOrderModel.Filler = header?.Filler || '';
        newOrderModel.FillerName = "";
        newOrderModel.PickRmrk = header.PickRmrk || '';
        newOrderModel.ToWhsCode = header?.ToWhsCode || '';
        newOrderModel.ToWhsCodeName = "";
        newOrderModel.JrnlMemo = header.JrnlMemo;
        newOrderModel.GroupNumTraslado = header.GroupNum;
        newOrderModel.GroupNumTrasladoName = header.ListName;


        //Pagos
        newOrderModel.TransId = header.TransId || "";
        newOrderModel.CounterRef = header.CounterRef || "";
        newOrderModel.NoDocSum = parseFloat(header.NoDocSum).toFixed(2) || 0;
        newOrderModel.BpAct = header.BpAct || "";
        newOrderModel.BpActFormatCode = header.BpActFormatCode || "";
        newOrderModel.BpActName = "";
        newOrderModel.PayNoDoc = header.PayNoDoc === 'Y' ? true : false;
        newOrderModel.CashSum = header.DocCurr === 'SOL' ? header.CashSum : header.CashSumFC;
        newOrderModel.CreditSum = header.DocCurr === 'SOL' ? header.CreditSum : header.CredSumFC;
        newOrderModel.CheckSum = header.DocCurr === 'SOL' ? header.CheckSum : header.CheckSumFC;
        newOrderModel.TrsfrSum = header.DocCurr === 'SOL' ? header.TrsfrSum : header.TrsfrSumFC;
        if (newOrderModel.isAccountPayment) {
            newOrderModel.PrjCode = header.PrjCode || '';  // Proyecto de pagos a cuenta
            newOrderModel.PaymentDocType = 'A';
            newOrderModel.CardCode = null;
            newOrderModel.CardName = null;
        }
        newOrderModel.canCancelIncomingPayment = header?.Canceled === 'N';
        // trasferencias

        newOrderModel.TrsfrAcct = header.TrsfrAcct;
        newOrderModel.TrsfrAcctName = header.TrsfrAcctName;
        newOrderModel.TrsfrDate = moment(header.TrsfrDate).add(1, 'd').format('YYYY-MM-DD');
        newOrderModel.TrsfrRef = header.TrsfrRef;
        newOrderModel.TrsfrAcctFormatCode = header.TrsfrAcctFormatCode;


        // cheques
        newOrderModel.CheckAcct = header.CheckAcct;
        newOrderModel.CheckList = checks;
        newOrderModel.CheckAcctFormatCode = header.CheckAcctFormatCode;
        //cash
        newOrderModel.CashAcct = header.CashAcct;
        newOrderModel.CashAcctFormatCode = header.CashAcctFormatCode;
        //Entrada de mercancia cascos
        newOrderModel.Casco = 0;
        newOrderModel.DocStatusCasco = header.U_FMB_DocStatusCasco;
        //Campos definidos para Entrada/Salida cascos
        newOrderModel.SerieName2 = header.SerieName2;
        newOrderModel.NextFolio2 = header.NextFolio2;
        //Serie pago Cascos
        newOrderModel.SerieName3 = header.SerieName3;
        newOrderModel.NextFolio3 = header.NextFolio3;
        newOrderModel.Confirmed = header.Confirmed === 'Y' ? true : false;
        newOrderModel.PartSupply = header.PartSupply === 'Y' ? true : false;
        // Tarjetas de credito
        newOrderModel.PaymentsCreditCards = creditCards;

        //Autorizations FMB
        newOrderModel.U_FMB_Auto = header.U_FMB_Auto;

        //Lista de precios C100 /
        newOrderModel.PriceListNum = header.ListNum || "";
        //CreditLine
        newOrderModel.CreditLine = header.CreditLine || 0;
        newOrderModel.transactionId = header.TransId || '';
        newOrderModel.PaidToDate = header.DocCurr === 'SOL' ? header.PaidToDate || 0 : header.PaidFC || 0;
        newOrderModel.BackOrder = header.BackOrder || '';
        newOrderModel.PartDelivr = header.PartDelivr || '';
        newOrderModel.LicTradNum = header.LicTradNum || '';
        //#region ######### TIMBRA-ONE ##################################################
        newOrderModel.U_UDF_UUID = header.U_UDF_UUID || '';
        newOrderModel.U_FMB_TIPO_REL = header.U_FMB_TIPO_REL || '';
        newOrderModel.U_FMB_UUID_RELACIONADO = header.U_FMB_UUID_RELACIONADO ? header.U_FMB_UUID_RELACIONADO.length > 36 ? JSON.parse(header.U_FMB_UUID_RELACIONADO || '[]') : header.U_FMB_UUID_RELACIONADO.length !== 2 && header.U_FMB_UUID_RELACIONADO.length !== 4 ? JSON.parse(`["${header.U_FMB_UUID_RELACIONADO}"]` || '[]') : JSON.parse('[]') : JSON.parse('[]');
        newOrderModel.U_FMB_SELLO = header.U_FMB_SELLO || '';
        newOrderModel.U_FMB_FOLIO = header.U_FMB_FOLIO || '';
        newOrderModel.U_FMB_SERIE = header.U_FMB_SERIE || '';
        newOrderModel.U_FMB_TIPO_RELACION = [];
        newOrderModel.IsCancelCFDI = header.IsCancelCFDI || 'N';
        newOrderModel.U_FMB_DescPP = Number(header.U_FMB_DescPP || 0);
        //#region ######### FOREIGN - TIMBRA-ONE ##################################################

        // CARTA PORTE 
        newOrderModel.U_FMB_FOLIO_PORTE = header.U_FMB_FOLIO_PORTE || '';
        // CARTA PORTE

        for (let index = 0; index < userFieldsService.length; index++) {
            const element = userFieldsService[index];
            if (element.header.AliasID === 'FMB_TIPO_REL') {
                newOrderModel.U_FMB_TIPO_RELACION = element.options || [];
            }
            if ((view === 'transfersEntry' || view === 'transfersOutput') && element.header.AliasID === 'TipoSalida') {
                newOrderModel.U_TipoSalidaOptions = element.options || [];
            }
        }
        //#endregion

        //#region ######### CAMPOS EMPRESA #################################################

        newOrderModel.U_TipoSalida = header.U_TipoSalida || '';
        newOrderModel.U_FMB_SCOP_CODE = header.U_FMB_SCOP_CODE ?? '';
        newOrderModel.NeedScopCode = false;
        newOrderModel.ValidSCOP = true;
        newOrderModel.Project = view === 'PurchaseRequest' ? header?.Project ?? header?.U_RS_PROYECTO ?? '' : header?.Project ?? '';
        newOrderModel.isSalesDocument = isSalesDocument(view);
        newOrderModel.isPurchaseDocument = isPurchaseDocument(view, header?.ObjType);
        newOrderModel.isTransferDocument = this.isTransferDocument(view, header?.ObjType);
        newOrderModel.Ref2 = header?.Ref2 ?? '';
        newOrderModel.U_NAME = header.U_NAME || '';
        newOrderModel.U_FMB_User = header.U_FMB_User || '';
        newOrderModel.U_FMB_OrderTime = header.U_FMB_OrderTime ?? '';
        newOrderModel.typeSearchList = [];
        newOrderModel.formattedMap = {};
        // CAMPOS FACTURACIÓN
        newOrderModel.U_RML_TDOCORG = header.U_RML_TDOCORG || '';
        newOrderModel.U_RML_DOCORG = header.U_RML_DOCORG || '';
        newOrderModel.U_BPP_MDTO = header.U_BPP_MDTO || '';
        newOrderModel.U_BPP_MDSO = header.U_BPP_MDSO || '';
        newOrderModel.U_BPP_MDCO = header.U_BPP_MDCO || '';
        newOrderModel.U_BPP_SDocDate = header.U_BPP_SDocDate
            ? moment(header.U_BPP_SDocDate).format('YYYY-MM-DD')
            : '';
        //#endregion
        // CAMPO PARA AUTORIZACIONES DE PEDIDOS
        newOrderModel.U_RS_AUTOR = header.U_RS_AUTOR || '';

        newOrderModel.isOPRQAuth = header?.isOPRQAuth || 'N'; // SC que viene de autorización

        if (isOIGNoOIGE || isOWTRoOWTQ) {
            newOrderModel.invFields = [];
            this.processUserFieldsDetails({
                fields: invFields,
                targetModel: newOrderModel,
                targetProperty: 'invFields',
                headerFields: isOWTRoOWTQ ? [] : [
                    'U_BPP_MDTS',
                    'U_RS_MOTIVOIS',
                    'U_RS_TIPOOPER',
                    'U_BPP_MDTD',
                    'U_BPP_MDSD',
                    'U_BPP_MDCD',
                ],
                userFieldsService,
                header,
                dateFields: ['U_STR_FE_GRE_FechaTransporte'],
                isOWTRoOWTQ,
            });
        }

        if (view === 'PurchaseRequest' || Number(newOrderModel?.ObjType) === 1470000113) {
            newOrderModel.OPRQFields = [];
            this.processUserFieldsDetails({
                fields: OPRQFields,
                targetModel: newOrderModel,
                targetProperty: 'OPRQFields',
                userFieldsService,
                header,
                headerFields: [
                    'U_RS_PERIODO',
                    'U_RS_MESES',
                ]
            });
        }

        if (isOWTRoOWTQ) {
            newOrderModel.transferFields = [];
            this.processUserFieldsDetails({
                fields: transferFields,
                targetModel: newOrderModel,
                targetProperty: 'transferFields',
                userFieldsService,
                header,
                headerFields: []
            });
        }
        //#endregion

        // Documento relacionado
        newOrderModel.U_FMB_RelatedFolio = header.U_FMB_RelatedFolio ?? '';

        //Tipo cambiario
        newOrderModel.DocCur = header.DocCur;
        newOrderModel.ChangeRate = header.DocRate || 1;
        newOrderModel.DocumentStock = header.DocumentStock || [];

        // Gestión de Citibanamex
        newOrderModel.U_FMB_Bank_Status = header.U_FMB_Bank_Status ?? 'N';

        // CONCILIA-ONE
        newOrderModel.TransferAccount = header.TransferAccount || '';
        newOrderModel.TransferDate = header.TransferDate || '';
        newOrderModel.TransferConcept = header.TransferConcept || '';
        newOrderModel.TransferReference = header.TransferReference || '';
        newOrderModel.TransferTotal = Number(header.TransferTotal || 0.00).toFixed(2);

        // Lista de precios BASE
        newOrderModel.U_FMB_DEF_PLBasePrice = header.U_FMB_DEF_PLBasePrice || '-2';

        // SOLICITAR EDICION DE TRASLADOS PARCIALES
        newOrderModel.Mail_Creator = header.Mail_Creator || '';
        newOrderModel.Name_Creator = header.Name_Creator || '';
        newOrderModel.U_FMB_EditTraslado = header.U_FMB_EditTraslado || 'N';
        newOrderModel.U_FMB_ComTraslado = header.U_FMB_ComTraslado || '';
        newOrderModel.SendRequestEdition = header.SendRequestEdition || 'N';
        newOrderModel.isCreator = header.isCreator || 'N';

        header.OPQTDraft = Number(header.OPQTDraft || 0);
        newOrderModel.OPQTDraft = header.OPQTDraft;

        //#region ######### COMERCIO EXTERIOR Y LEYENDAS FISCALES #########
        newOrderModel.ComercioExterior = JSON.parse(header.ComercioExterior || '{}');
        newOrderModel.isComercioExterior = header.isComercioExterior || 'N';
        newOrderModel.SelectComercio = !!header.isComercioExterior;
        //#endregion ######### COMERCIO EXTERIOR Y LEYENDAS FISCALES #########

        //#region GALLONS CONVERSION
        if (view === 'transfersEntry' || (Number(newOrderModel?.ObjType) === 59)) {
            newOrderModel.U_RS_DENSIDAD = Number(header?.U_RS_DENSIDAD || 0);
        }
        //#endregion GALLONS CONVERSION

        //#region Campos de compras
        newOrderModel.U_RS_IMP = header.U_RS_IMP || false;
        newOrderModel.U_RS_IMP = newOrderModel.U_RS_IMP === 'Y' ? true : false;
        newOrderModel.U_RS_NUMIMP = header.U_RS_NUMIMP || '';
        newOrderModel.U_RS_NivelReq = header.U_RS_NivelReq || '0';
        //#endregion Campos de compras

        if (view === 'creditNote' || view === 'debitNote') {
            newOrderModel.U_RS_SOLAPR = header.U_RS_SOLAPR || '';
            newOrderModel.U_STR_MtvoCD = header.U_STR_MtvoCD || '';
        }
        //#region ATTACHMENT
        newOrderModel.AtcEntry = header.AtcEntry || '';
        newOrderModel.Attachment = header.Attachment ? header.Attachment : [];
        //#endregion ATTACHMENT

        //#region DIMENSIONS
        if (newOrderModel.isSalesDocument && newOrderModel.DocType === 'I') {
            newOrderModel.Dimension1 = await this.getDimension1(newOrderModel);
        }
        //#endregion DIMENSIONS

        newOrderModel.WTCodes = header?.WTCodes || [];
        newOrderModel.RetencionVista = this.RetencionVista(view, header?.ObjType);
        if (newOrderModel?.isPurchaseDocument) {
            newOrderModel.DetraccionVista = this.DetraccionVista(view, header?.ObjType);
            //#region DETRACCIONES
            newOrderModel.U_STR_AfctoDtr = header?.U_STR_AfctoDtr || 'N';
            newOrderModel.OU_STR_AfctoDtr = header?.U_STR_AfctoDtr || 'N';
            newOrderModel.U_STR_TasaDTR = Number(header?.U_STR_TasaDTR || 0);
            newOrderModel.U_STR_CodBnSs = header?.U_STR_CodBnSs || '';
            newOrderModel.U_RS_MONDET = Number(header?.U_RS_MONDET || 0);

            newOrderModel.WTCodesD = header?.WTCodesD || [];
            newOrderModel.U_FMB_BP_Detra = newOrderModel?.WTCodesD?.length ? 'Y' : 'N';
            //#endregion DETRACCIONES
        }
        if (newOrderModel.RetencionVista) {
            //#region RETENCIONES
            newOrderModel.WTCodesR = header?.WTCodesR || [];
            newOrderModel.WTCodesR = newOrderModel.WTCodesR?.filter(wtcode => (wtcode.WTCode || wtcode.WTName || '')?.includes('3%')) ?? [];
            newOrderModel.U_FMB_BP_Reten = newOrderModel?.WTCodesR?.length ? 'Y' : 'N';
            newOrderModel.U_LLG_RETENCI = header?.U_LLG_RETENCI || 'N';
            newOrderModel.MONRET = newOrderModel?.U_LLG_RETENCI === 'Y' ?
                view === 'purchaseInvoice' ?
                    header?.DocCur === 'SOL' ?
                        Number(header?.WTSum || 0)
                        : Number(header?.WTSumFC || 0)
                    : header?.DocCur === 'SOL' ? Number((Number(header?.DocTotal || 0) * 0.03)?.toFixed(2)) : Number((Number(header?.DocTotalFC || 0) * 0.03)?.toFixed(2))
                : 0;
            //#endregion RETENCIONES
        }

        //#region Flujo de caja
        newOrderModel.transferCFWId = header?.transferCFWId || null;
        newOrderModel.cashCFWId = header?.cashCFWId || null;
        newOrderModel.checkCFWId = header?.checkCFWId || null;
        newOrderModel.transferCFWOptions = header?.transferCFWOptions ?? [];
        newOrderModel.cashCFWOptions = header?.cashCFWOptions ?? [];
        newOrderModel.checkCFWOptions = header?.checkCFWOptions ?? [];
        //#endregion Flujo de caja

        let newItems = [];
        let newService = [];
        let newItemsPayment = [];
        let lastLineNum = items.length;

        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            let itemModel = new NewItem();
            let itemModelPayment = new NewItemPayment();
            let serviceModel = new NewService();
            let userFieldsItems = new UserFieldsItem();

            if ((lastLineNum - 1) == index) {
                newOrderModel.LastLineNumItems = item.LineNum;
            }

            itemModel.LineStatus = item.LineStatus === "C" ? true : false;
            itemModel.LineNum = item.LineNum;
            itemModel.BaseType = item.BaseType;
            itemModel.BaseEntry = item.BaseEntry;
            itemModel.BaseLine = item.BaseLine;
            itemModel.ItemCode = item.ItemCode;
            itemModel.ItemName = item.Dscription;
            // itemModel.Quantity = parseFloat(item.Quantity).toFixed(2) || 1;
            itemModel.Quantity = Number(item.Quantity) || 1;
            itemModel.OpenQty = Number(item.OpenQty) || 0;
            // POR1.DelivrdQty no se usa en compras + SP no lo devuelve → derivar
            const rawDelivrd = Number(item.DelivrdQty);
            itemModel.DelivrdQty = (view === 'PurchaseOrder')
                ? (Number.isFinite(rawDelivrd) && rawDelivrd > 0 ? rawDelivrd : (itemModel.Quantity - itemModel.OpenQty))
                : (item.DelivrdQty || 0);
            itemModel.OriginalQuantity = item.Quantity;
            itemModel.OriginalQuantityClose = itemModel.Quantity - itemModel.OpenQty;
            itemModel.U_FMB_OpenQty = item.U_FMB_OpenQty || '0';
            itemModel.U_FMB_DelivrdQty = item.U_FMB_DelivrdQty || '0';
            itemModel.WhsCode = item.WhsCode || '';
            itemModel.WhsName = item.Almacen || '';
            itemModel.OcrCode = item.OcrCode || '';
            itemModel.OcrName = view === 'transfersRequest' ? item.OcrName || '' : '';
            itemModel.OcrCode2 = item.OcrCode2 || '';
            itemModel.OcrName2 = view === 'transfersRequest' ? item.OcrName2 || '' : '';
            itemModel.OcrCode3 = item.OcrCode3 || '';
            itemModel.OcrName3 = view === 'transfersRequest' ? item.OcrName3 || '' : '';
            itemModel.OcrCode4 = item.OcrCode4 || '';
            itemModel.OcrName4 = view === 'transfersRequest' ? item.OcrName4 || '' : '';
            itemModel.OcrCode5 = item.OcrCode5 || '';
            itemModel.OcrName5 = view === 'transfersRequest' ? item.OcrName5 || '' : '';
            itemModel.TaxCode = item.TaxCode;
            itemModel.TaxName = item.TaxName;
            itemModel.TaxeRate = item.Impuesto;
            itemModel.TaxeResult = 0;
            itemModel.DiscountPercent = parseFloat(item?.Descuento ?? '0').toFixed(2); // item.Descuento;
            itemModel.Description = item.Dscription || '';
            itemModel.Discount = 0;
            itemModel.Total = 0;
            itemModel.LineTotal = item.LineTotal || 0;
            itemModel.GrossBuyPr = item.GrossBuyPr || 0;
            itemModel.Filler = item.FromWhsCod;
            itemModel.FillerName = "";
            itemModel.ToWhsCode = item.WhsCode || '';
            itemModel.ToWhsCodeName = "";
            itemModel.wareHouseStock = item.wareHouses;
            itemModel.AcctCode = item.AcctCode || "";
            itemModel.AcctCode2 = item.AcctCode2 || "";
            itemModel.CogsAcct = item.CogsAcct || "";
            itemModel.AcctCodeName = item.AcctCodeName || "";
            itemModel.CogsAcctName = item.CogsAcctName || "";
            itemModel.ItemNew = false;
            itemModel.SalPackUn = item.SalPackUn || 1;
            itemModel.PurPackUn = item.PurPackUn || 1;
            itemModel.UserBaseUn = item.UserBaseUn || '';
            itemModel.ChangeRate = item.Rate || 1;
            itemModel.Currency = item.Currency || itemModel.Currency;
            if (newOrderModel.isSalesDocument || newOrderModel.isPurchaseDocument || isMarketingDoc(newOrderModel.ObjType)) {
                itemModel.Currency = item.Currency || itemModel.Currency || newOrderModel.DocCur || CURRENCY;
                itemModel.LocalCurrency = CURRENCY;
                itemModel.ChangeRateCurrency = Number(item.LineRate) || 1;
            }
            itemModel.ManBtchNum = item.ManBtchNum || 'N';
            itemModel.RevenuesAc = item.RevenuesAc || "";

            itemModel.KilosXComprar = item.U_kilosxcomprar ?? 0;
            itemModel.PesosXPieza = item.U_pesosxpieza ?? 0;
            itemModel.PrecioXKilo = item.U_precioxkilo ?? 0;

            itemModel.Weight = item.Weight ?? 0;
            itemModel.UomCode = item.UomCode ?? '';

            itemModel.FirstBin = item.FirstBin || "";
            itemModel.BinActivat = item.BinActivat || 'N';
            if (itemModel.BinActivat === 'Y' && (view === 'orderSales' || view === 'quotations')) {
                const locations = itemModel?.wareHouseStock?.find(whs => whs.WhsCode === item.WhsCode)?.Location;
                itemModel.DocumentLinesBinAllocations = Array.isArray(locations) ? locations : [];
            }

            if (itemModel.ManBtchNum === 'Y') { // Si es por lotes establecer sus propiedades
                itemModel.OpenLneQty = item.OpenQty;
                itemModel.DocUoMQty = item.OpenQty;
                if (!newOrderModel.ShowBatchInfo) { newOrderModel.ShowBatchInfo = true; }
            }
            // Validar el precio original cuando se cambia las unidades de medida
            if (item.NumPerMsr && Number(item.NumPerMsr) !== 1) {
                if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) {
                    item.Price = roundToDecimals((item.Price / Number(item.NumPerMsr)), 6);
                } else {
                    item.Price = (item.Price / Number(item.NumPerMsr)).toFixed(6);
                }
                itemModel.BaseQty = Number(item.NumPerMsr);
            }

            itemModel.Price = parseFloat(item.Price).toFixed(2);
            itemModel.PriceBefDi = parseFloat(item.PriceBefDi).toFixed(2);
            itemModel.HomePrice = parseFloat(item.Price).toFixed(2);
            itemModel.newPrice = parseFloat(item.Price).toFixed(2);
            itemModel.newHomePrice = parseFloat(item.Price).toFixed(2);
            itemModel.cPrice = parseFloat(item.Price).toFixed(2);
            itemModel.cPrice = parseFloat(item.Price).toFixed(2);

            if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || isMarketingDoc(newOrderModel?.ObjType)) {
                itemModel.Price = roundToDecimals((Number(item.Price) || 0), 6);
                itemModel.PriceBefDi = roundToDecimals((Number(item.PriceBefDi) || 0), 6);
                itemModel.HomePrice = roundToDecimals((Number(item.Price) || 0), 6);
                itemModel.newPrice = roundToDecimals((Number(item.Price) || 0), 6);
                itemModel.newHomePrice = roundToDecimals((Number(item.Price) || 0), 6);
                itemModel.cPrice = roundToDecimals((Number(item.Price) || 0), 6);
                itemModel.cPrice = roundToDecimals((Number(item.Price) || 0), 6);
            }

            itemModel.InvntItem = item.InvntItem || '';
            itemModel.InvntryUom = item.InvntryUom;
            //Centro de costo Segmento 
            itemModel.ItmsGrpCod = item.ItmsGrpCod;
            itemModel.LineVendor = item.LineVendor;
            //itemModel.OnHand=item.OnHand || "";
            itemModel.GPTtlBasPr = item.GPTtlBasPr || 0;
            itemModel.GrossBuyPr = item.GrossBuyPr || 0;
            itemModel.GrssProfit = item.GrssProfit || 0;
            itemModel.MovimientoDiario = item.U_FMB_CesionUso || 0;

            // U_Disponible
            if (view !== "payment" && view !== "outgoingPayment") {
                item.wareHouses.map(warehouseStock => {
                    if (warehouseStock.WhsCode == item.WhsCode) {
                        itemModel.OnHand = warehouseStock.OnHand || 0;
                    }
                });
            }

            //#region ########## Billing Fields ##########
            itemModel.U_BPP_OPER = item.U_BPP_OPER || "-";
            itemModel.U_STR_FECodAfect = item.U_STR_FECodAfect || "";
            //#region GALLONS CONVERSION
            itemModel.U_RS_UMED = item.U_RS_UMED || '';
            itemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
            itemModel.U_RS_PRECIOGL = Number(item.U_RS_PRECIOGL || 0);
            itemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
            itemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
            itemModel.Gallons = item.U_RS_UMED === 'GLN';
            //#endregion GALLONS CONVERSION
            //#endregion

            //#region DETRACCIONES
            itemModel.U_RML_AFEDET = item.U_RML_AFEDET || 'N';
            itemModel.U_RML_CODRET = item.U_RML_CODRET || '';
            itemModel.U_RML_CODSERV = item.U_RML_CODSERV || '';
            itemModel.U_RML_PORCE = Number(item.U_RML_PORCE || 0);
            //#endregion DETRACCIONES

            itemModel.AvgPrice = item.AvgPrice || "";
            itemModel.NewAvgPrice = item.NewAvgPrice || "";
            itemModel.Project = item.Project || '';
            itemModel.NumPerMsr = item.NumPerMsr || 0;
            itemModel.FormatCode = item.FormatCode || '';
            itemModel.FormatCode2 = item.FormatCode2 || '';
            itemModel.ImpuestoRow = item.ImpuestoRow || null;
            if (item.EvalSystem === 'A') {
                itemModel.EvalSystem = "Promedio ponderado";
            } else if (item.EvalSystem === 'B') {
                itemModel.EvalSystem = "Serie / Lote";
            } else if (item.EvalSystem === 'F') {
                itemModel.EvalSystem = "FIFO";
            } else if (item.EvalSystem === 'S') {
                itemModel.EvalSystem = "Estándar";
            }

            if (view !== 'payment' && view !== 'transfers' && view !== 'transfersRequest' && view !== 'invoice' && view !== 'outgoingPayment' && view !== 'invoiceReserve') {
                itemModel.wareHouseStock.map(warehouseStock => {

                    if (itemModel.InvntItem == 'N') {
                        return;
                    }


                    if (warehouseStock.WhsCode == item.WhsCode) {
                        if (warehouseStock.OnHand == 0) {
                            itemModel.stock = false;
                        } else {
                            itemModel.stock = true;
                        }
                    }
                });
            }

            //#region 
            json.allItemsUserFields.map((itemField, index) => {
                userFieldsItemsDocument.map((userfieldItem) => {
                    if (itemField.fieldId == userfieldItem.header.FieldID) {
                        itemField.name = userfieldItem.header.Descr;
                        itemField.fieldType = userfieldItem.options.length != 0 ? 2 : 1;
                        itemField.options = userfieldItem.options;
                        itemField.IdValue = index;
                        let newUserFields = this.setUserFieldItemsValue(userFieldsItems, index, item);
                        if (itemField.fieldType === 2) {
                            itemField.options.push({ FldValue: "", Descr: "" });
                        }
                        userFieldsItems = newUserFields;
                    }
                });
            });
            itemModel.UserFieldsItem = userFieldsItems;

            if (view === "invoiceReserve") {
                itemModel.TargetType = item.TargetType || -1;
                // itemModel.TrgetEntry = item.TrgetEntry || null;
                itemModel.ActualBaseLine = item.ActualBaseLine;
                itemModel.ActualOpenQty = item.ActualOpenQty;
            }


            itemModel.DelivrdQty = item.DelivrdQty || "";
            itemModel.SalUnitMsr = item.SalUnitMsr || "";
            itemModel.BuyUnitMsr = item.BuyUnitMsr || '';
            itemModel.TaxOnly = item.TaxOnly || "N";
            itemModel.TaxStatus = item.TaxStatus || "N";
            if (newOrderModel.isSalesDocument || newOrderModel.isPurchaseDocument || isMarketingDoc(newOrderModel.ObjType)) {
                let isIGV = !itemModel?.TaxCode?.includes("EXO") &&
                    (itemModel?.TaxCode?.includes("IGV") ||
                        itemModel?.TaxName?.toUpperCase()?.includes("IGV"));
                let isEXO = itemModel?.TaxCode?.includes("EXO") ||
                    itemModel?.TaxName?.toUpperCase()?.includes("EXO") ||
                    itemModel?.TaxName?.toUpperCase()?.includes("EXENTO");

                if (isIGV || isEXO) {
                    itemModel.TaxStatus = isIGV ? 'Y' : 'N';
                }
            }
            itemModel.InvQty = item.InvQty || '';
            itemModel.OpenCreQty = item.OpenCreQty || '';
            itemModel.Text = item.Text || '';
            itemModel.PQTReqQty = Number(item.PQTReqQty || 0);

            //#endregion

            //items para pagos


            if (view === 'payment' || view === 'outgoingPayment') {
                newOrderModel.DocCur = header.DocCurr;
            }


            itemModelPayment.DocEntry = item.DocEntry;
            itemModelPayment.DocNum = item.DocNum;
            //this.docType = item.ObjType == '13' ? item.DocSubType == '--' ? 'Factura' : 'Nota de Débito' : "";
            itemModelPayment.docType = item.ObjType;
            itemModelPayment.DocSubType = item.DocSubType;
            itemModelPayment.RefDate = moment(item.TaxDate).utc().format('YYYY-MM-DD');
            itemModelPayment.daysLast = 0;
            itemModelPayment.total = item.DocCur === 'SOL' ? item.DocTotal : item.DocTotalFC;
            itemModelPayment.pastDueBalance = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidToDate) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.totalPago = item.DocCur === 'SOL' ? parseFloat(item.totalPago ? item.totalPago : item.PaidSum).toFixed(4) : item.totalPagoFC;
            itemModelPayment.DocCur = item.DocCur;
            itemModelPayment.totalOutgoing = item.DocCur === 'SOL' ? item.SumApplied : item.totalPagoFC;
            itemModelPayment.saldoVencido = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidSum) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.OcrCode = item.OcrCode;
            itemModelPayment.OcrName = "";
            itemModelPayment.OcrCode2 = item.OcrCode2;
            itemModelPayment.OcrName2 = "";
            itemModelPayment.OcrCode3 = item.OcrCode3;
            itemModelPayment.OcrName3 = "";
            itemModelPayment.OcrCode4 = item.OcrCode4;
            itemModelPayment.OcrName4 = "";
            itemModelPayment.OcrCode5 = item.OcrCode5;
            itemModelPayment.OcrName5 = "";
            itemModelPayment.U_Parcialidad = item.U_Parcialidad;
            itemModelPayment.Memo = item.Memo ?? '';
            itemModelPayment.NumAtCard = item.NumAtCard ?? '';
            if (newOrderModel?.isAccountPayment) { // Pagos a cuenta
                itemModelPayment.AcctCode = item.AcctCode;
                itemModelPayment.AcctName = item.AcctName;
                itemModelPayment.Descrip = item.Descrip;
                itemModelPayment.Price = header.DocCurr === 'SOL' ? Number(item.totalPago || 0) : Number(item.totalPagoFC || 0);
                itemModelPayment.PriceFormat = header.DocCurr === 'SOL' ? Number(item.totalPago || 0) : Number(item.totalPagoFC || 0);
                itemModelPayment.DocCur = header.DocCurr;
            }
            //#region RETENCIONES
            if (view === 'outgoingPayment') {
                itemModelPayment.U_LLG_RETENCI = item.U_LLG_RETENCI || 'N';
                if (itemModelPayment.U_LLG_RETENCI === 'Y') {
                    itemModelPayment.totalO = item.DocCur === 'SOL' ? Number(item.DocTotal || 0) : Number(item.DocTotalFC || 0);
                    itemModelPayment.WitholdingTaxApplied = item.DocCur === 'SOL' ? Number(item.WtAppld || 0) : Number(item.WtAppldFC || 0);
                }
            }
            //#endregion RETENCIONES

            //#region CREDIT PERCEPTIONS
            itemModelPayment.U_PRC_IMP = Number(item.U_PRC_IMP ?? 0);
            //#endregion CREDIT PERCEPTIONS

            newItems.push(itemModel);
            newItemsPayment.push(itemModelPayment);

            //Items  para Servicio
            serviceModel.LineNum = item.LineNum;
            serviceModel.BaseType = item.BaseType;
            serviceModel.BaseEntry = item.BaseEntry;
            serviceModel.Description = item.Dscription || '';
            serviceModel.AcctCode = item.AcctCode || '';
            serviceModel.AcctCodeName = item.AcctName || '';
            serviceModel.TaxCode = item.TaxCode || "";
            serviceModel.Price = item.Price || 0;
            serviceModel.HomePrice = item.Price || 0;
            serviceModel.TaxeRate = item.Impuesto || 0;
            serviceModel.TaxeResult = item.ImpuestoRow || 0;
            serviceModel.NoGlobal = '';
            serviceModel.BaseEntry = item.BaseEntry || '';
            serviceModel.ServiceNew = false;
            serviceModel.Project = item.Project || '';
            serviceModel.OcrCode = item.OcrCode;
            serviceModel.OcrName = "";
            serviceModel.OcrCode2 = item.OcrCode2;
            serviceModel.OcrName2 = "";
            serviceModel.OcrCode3 = item.OcrCode3;
            serviceModel.OcrName3 = "";
            serviceModel.OcrCode4 = item.OcrCode4;
            serviceModel.OcrName4 = "";
            serviceModel.OcrCode5 = item.OcrCode5;
            serviceModel.OcrName5 = "";
            serviceModel.UserFieldsItem = userFieldsItems;
            newService.push(serviceModel);

        }



        newOrderModel.Items = newItems;
        newOrderModel.service = newService;
        newOrderModel.ItemsPayments = newItemsPayment;

        if (newOrderModel.WddStatus == "P") {
            newOrderModel.isDocumentWithAuthorization = true; // servicio 2 donde no actualiza los items solo el documento
        }

        let flagUpdateJustComments = false;
        if (newOrderModel.Items.length > 0) {
            newOrderModel.Items.map((item) => {
                // Valida que las lineas esten cerradas -> true = cerrada
                if (item.LineStatus === true) {
                    flagUpdateJustComments = true;
                    return;
                }
            });
        }

        const hasLlgService = newOrderModel?.isPurchaseDocument && items?.some(line => line.InvntItem === 'N' && Number(line.U_RS_TipoItem) === 1); // Existe un "servicio" en Llamagas
        newOrderModel.searchInvItems = !hasLlgService; // Desmarcar Buscar.Art.Inv si existe un servicio Llamagas

        //Permisos
        let permissions = new Permissions();
        if (view === 'quotations') {
            permissions.editItems = true;
            permissions.editDiscountLine = true;
            permissions.editEmployee = true;
            permissions.editOwner = false;

            if (!newOrderModel.isDocumentWithAuthorization) {
                newOrderModel.servicesToUpdate = 2;
            } else {
                newOrderModel.servicesToUpdate = 2;
            }
        }

        if (view === 'orderSales') {
            if (!newOrderModel.isDocumentWithAuthorization) {
                if (flagUpdateJustComments) {
                    newOrderModel.servicesToUpdate = 3;
                } else {
                    permissions.editItems = true;
                    permissions.editEmployee = true;
                    permissions.editDiscountLine = true;
                    permissions.editOwner = true;
                    newOrderModel.servicesToUpdate = 1;
                }
            } else {
                if (flagUpdateJustComments) {
                    newOrderModel.servicesToUpdate = 3;
                } else {
                    newOrderModel.servicesToUpdate = 2;
                }
            }
        }

        if (view === 'PurchaseOrder' || view === 'PurchaseQuotation' || (view === 'draft' && Number(header?.ObjType) === 22)) {
            if (!newOrderModel.isDocumentWithAuthorization) {
                permissions.editItems = true;
                permissions.editEmployee = true;
                permissions.editDiscountLine = true;
                permissions.editOwner = true;
                newOrderModel.servicesToUpdate = 1;
            } else {
                newOrderModel.servicesToUpdate = 2;
            }
        }

        if (view === 'GoodsReceipt') {
            if (!newOrderModel.isDocumentWithAuthorization) {
                permissions.editItems = false;
                permissions.editEmployee = false;
                permissions.editDiscountLine = false;
                permissions.editOwner = false;
                newOrderModel.servicesToUpdate = 2;
            } else {
                newOrderModel.servicesToUpdate = 2;
            }
        }

        if (view === 'SalesHelmets' || view === 'ExitHelmets') {

            permissions.editItems = true;
            permissions.editEmployee = true;
            permissions.editDiscountLine = false;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;

        }

        if (view === 'PurchaseRequest') {
            if (!newOrderModel.isDocumentWithAuthorization) {
                permissions.editItems = true;
                permissions.editDiscountLine = true;
                permissions.editEmployee = true;
                permissions.editOwner = true;
                newOrderModel.servicesToUpdate = 2;
            } else {
                newOrderModel.servicesToUpdate = 2;
            }
        }

        if (view === 'deliveries') {
            permissions.editItems = false;
            permissions.editDiscountLine = true;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'invoice') {
            permissions.editItems = false;
            permissions.editDiscountLine = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'return') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editDiscountLine = false;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'purchaseReturn') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }


        if (view === 'debitNote') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'creditNote') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'purchaseInvoice') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'purchaseCreditNotes') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }

        if (view === 'invoiceReserve') {
            permissions.editItems = false;
            permissions.editDiscountDocument = false;
            permissions.editEmployee = true;
            permissions.editOwner = true;
            newOrderModel.servicesToUpdate = 2;
        }
        if (isOWTRoOWTQ) {
            //#region ################## LLAMAGAS ################ ✔
            newOrderModel.U_BPP_MDTS = header?.U_BPP_MDTS;
            newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado = header?.U_STR_FE_GRE_CodigoMotivoTraslado;
            newOrderModel.U_FMB_SCOP_CODE = header?.U_FMB_SCOP_CODE ?? null;
            //#endregion ################## LLAMAGAS ################ ✔
        }

        newOrderModel.permissions = permissions;

        return newOrderModel;

    };

    fillBusinessPartnerDetailsModel = (model, open) => {
        let partnerModel = new BusinessPartner();
        const partner = model.data.partner;
        let userFieldsService = model.data.userFields;
        let contactPersons = model.data.contactPersons;
        let deliveriesAddress = model.data.deliveriesAddress;
        let invoicesAddress = model.data.invoicesAddress;
        let PayMethodCodes = model.data.methodsList;
        let BankAccounts = model.data.BankAccounts;


        let userFields = new UserFields();
        json.userFieldsPartners.map((item, index) => {
            userFieldsService.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length != 0 ? 2 : item.fieldType;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValue(userFields, index, partner);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            });
        });

        partnerModel.userFields = userFields;

        partnerModel.update = 1;
        partnerModel.CardCode = partner.CardCode;
        partnerModel.CardName = partner.CardName || '';
        partnerModel.U_FMB_AUX_CARDNAME = partner.U_FMB_AUX_CARDNAME || '';
        partnerModel.GroupCode = partner.GroupCode || '';
        partnerModel.GroupCodeName = partner.GroupName || '';
        partnerModel.Balance = partner.Balance || 0;
        partnerModel.DocCur = partner.Balance || '';
        partnerModel.PayMethodCodes = PayMethodCodes || [];
        partnerModel.DNotesBal = partner.DNotesBal || 0;
        partnerModel.OrdersBal = partner.OrdersBal || 0;
        partnerModel.validFor = partner.validFor || 'N';
        partnerModel.CardType = partner.CardType || '';
        partnerModel.CardTypeName = partner.CardType === 'C' ? 'Cliente' : partner.CardType === 'S' ? 'Proveedor' : 'Lead';
        partnerModel.Currency = partner.Currency || '';
        partnerModel.CurrencyName = partner.CurrencyName || '';
        partnerModel.LicTradNum = partner.LicTradNum || '';
        partnerModel.Phone1 = partner.Phone1 || '';
        partnerModel.Phone2 = partner.Phone2 || '';
        partnerModel.E_mail = partner.E_Mail || '';
        partnerModel.SlpCode = partner.SlpCode || '';
        partnerModel.SlpName = partner.SlpName || '';
        partnerModel.GroupNum = partner.GroupNum || '';
        partnerModel.GroupNumName = partner.GroupNumName || '';
        partnerModel.IntrstRate = partner.IntrstRate || 0;
        partnerModel.PriceListNum = partner.ListNum || '';
        partnerModel.PriceListNumName = partner.PriceListNumName || '';
        partnerModel.Discount = partner.Discount || 0;
        partnerModel.CreditLine = Number(partner.CreditLine || 0);
        partnerModel.CreditLineShow = FORMAT_NUMBER.new(partner.CreditLine || 0, CURRENCY + " ");
        partnerModel.DebtLine = partner.DebtLine || 0;
        partnerModel.DebtLineShow = FORMAT_NUMBER.new(partner.DebtLine || 0, CURRENCY + " ");
        partnerModel.Territory = partner.Territory || '';
        partnerModel.TerritoryName = partner.TerritoryName || '';
        partnerModel.CntctPrsn = partner.CntctPrsn || '';
        partnerModel.ShipToDef = partner.ShipToDef || '';
        partnerModel.BillToDef = partner.BillToDef || '';
        partnerModel.PymCode = partner.PymCode || '';
        partnerModel.PymCodeName = partner.PymCodeName || '';
        partnerModel.RefDetails = partner.RefDetails || '';
        partnerModel.TaxCode = partner.TaxCode || '';
        partnerModel.TaxName = partner.TaxName || '';
        partnerModel.DebPayAcct = partner.DebPayAcct || '';
        partnerModel.DebPayAcctName = partner.DebPayAcctName || '';
        partnerModel.FatherType = partner.FatherType || '';
        partnerModel.VatStatus = partner.VatStatus || '';
        partnerModel.BankAccounts = BankAccounts || [];
        partnerModel.BankCountr = partner.BankCountr || '';
        partnerModel.BankCode = partner.BankCode || '';
        partnerModel.DefaultBankCode = partner.DefaultBankCode || '';
        partnerModel.DflAccount = partner.DflAccount || '';
        partnerModel.DflSwift = partner.DflSwift || '';
        partnerModel.DflBranch = partner.DflBranch || '';
        partnerModel.BankCtlKey = partner.BankCtlKey || '';
        partnerModel.DflIBAN = partner.DflIBAN || '';

        partnerModel.U_RS_Doc1 = partner.U_RS_Doc1 || '';
        partnerModel.U_RS_Doc2 = partner.U_RS_Doc2 || '';
        partnerModel.U_RS_Doc3 = partner.U_RS_Doc3 || '';
        partnerModel.U_RS_Doc4 = partner.U_RS_Doc4 || '';
        partnerModel.U_RS_Doc5 = partner.U_RS_Doc5 || '';
        partnerModel.U_RS_Doc6 = partner.U_RS_Doc6 || '';

        // fields to downpayments
        partnerModel.DownPaymentClearAct = partner.DpmClear || '';
        partnerModel.DownPaymentInterimAccount = partner.DpmIntAct || '';
        partnerModel.DownPaymentInterimAccountName = partner.DpmIntActName || '';
        partnerModel.U_FMB_DescPP = FORMAT_NUMBER.new(partner.U_FMB_DescPP || '0.00', '');
        partnerModel.AtcEntry = partner.AtcEntry || null;
        partnerModel.Attachments = Array.isArray(partner.Attachments) ? partner.Attachments : [];
        partnerModel.NumAtcOrg = Number((partnerModel.Attachments.length || 0).toString());

        partnerModel.EORINumber = partner.EORINumber || '';
        partnerModel.WTLiable = (partner.WTLiable || '') === "Y";
        partnerModel.CrtfcateNO = partner.CrtfcateNO || '';
        partnerModel.ExpireDate = moment(partner.ExpireDate).isValid() ? moment(partner.ExpireDate).utc().format("YYYY-MM-DD") : "";
        partnerModel.AccCritria = partner.AccCritria || '';
        partnerModel.BPWithholdingTaxCollection = JSON.parse(partner.BPWithholdingTaxCollection || '[]');

        let contactPersonArray = [];
        let deliveriesArray = [];
        let invoicesArray = [];
        contactPersons.map((contact, index) => {
            let newContact = new ContactPersons();
            newContact.CntctCode = contact.CntctCode || null;
            newContact.CardCode = contact.CardCode || '';
            newContact.Name = contact.Name || '';
            newContact.Active = contact.Active || '';
            newContact.FirstName = contact.FirstName || '';
            newContact.Title = contact.Title || '';
            newContact.MiddleName = contact.MiddleName || '';
            newContact.Position = contact.Position || '';
            newContact.LastName = contact.LastName || '';
            newContact.Address = contact.Address || '';
            newContact.Tel1 = contact.Tel1 || '';
            newContact.Tel2 = contact.Tel2 || '';
            newContact.Cellolar = contact.Cellolar || '';
            newContact.Fax = contact.Fax || '';
            newContact.E_MailL = contact.E_MailL || '';
            newContact.EmlGrpCode = contact.EmlGrpCode || '';
            newContact.Pager = contact.Pager || '';
            newContact.Notes1 = contact.Notes1 || '';
            newContact.Notes2 = contact.Notes2 || '';
            newContact.Password = contact.Password || '';
            newContact.Gender = contact.Gender || '';
            newContact.Profession = contact.Profession || '';
            newContact.DateOfBirth = moment(contact.DateOfBirth).isValid() ? moment(contact.BirthDate).format("YYYY-MM-DD") : '';
            newContact.CnAddrType = contact.CnAddrType || '';
            newContact.U_AvalSN = contact.U_AvalSN || '';

            contactPersonArray.push(newContact);
            if (partnerModel.CntctPrsn === contact.Name) {
                partnerModel.contactEditIndex = index;
            }
        });

        invoicesAddress.map((address, index) => {
            let newAddress = new Addresses();
            newAddress.Address = address.Address || ''
            newAddress.Address2 = address.Address2 || ''
            newAddress.Address3 = address.Address3 || ''
            newAddress.Street = address.Street || ''
            newAddress.Block = address.Block || ''
            newAddress.City = address.City || ''
            newAddress.ZipCode = address.ZipCode || ''
            newAddress.County = address.County || ''
            newAddress.Country = address.Country || ''
            newAddress.State = address.State || ''
            newAddress.TaxCode = address.TaxCode || ''
            newAddress.StreetNo = address.StreetNo || ''
            newAddress.Building = address.Building || ''
            newAddress.TaxOffice = address.TaxOffice || ''
            newAddress.GlblLocNum = address.GlblLocNum || ''
            newAddress.U_FMB_GPSLat = address.U_FMB_GPSLat || ''
            newAddress.U_FMB_GPSLon = address.U_FMB_GPSLon || ''
            newAddress.U_FMB_RUTA = address.U_FMB_RUTA || ''
            newAddress.U_FMB_Project = address.U_FMB_Project || ''
            newAddress.U_FMB_FICHA_OSIN = address.U_FMB_FICHA_OSIN || ''
            newAddress.U_FMB_OSIN_CAPACIDAD = address.U_FMB_OSIN_CAPACIDAD || ''
            newAddress.U_FMB_OSIN_STATUS = address.U_FMB_OSIN_STATUS || ''
            newAddress.U_FMB_OSIN_TIPAGENT = address.U_FMB_OSIN_TIPAGENT || ''
            newAddress.U_RMO_ID_DIRE = address.U_RMO_ID_DIRE || ''
            newAddress.U_RML_IDDIR_CU = address.U_RML_IDDIR_CU || ''
            newAddress.TypeOfAddress = address.AdresType || ''
            newAddress.provinciasInvoices = address.Provincias || []
            newAddress.distritosInvoices = address.Distritos || []

            invoicesArray.push(newAddress);
            if (partnerModel.BillToDef == address.Address) {
                partnerModel.invoicesAddressEditIndex = index;
            }
        });

        deliveriesAddress.map((address, index) => {
            let newAddress = new Addresses();

            newAddress.Address = address.Address || ''
            newAddress.Address2 = address.Address2 || ''
            newAddress.Address3 = address.Address3 || ''
            newAddress.Street = address.Street || ''
            newAddress.Block = address.Block || ''
            newAddress.City = address.City || ''
            newAddress.ZipCode = address.ZipCode || ''
            newAddress.County = address.County || ''
            newAddress.Country = address.Country || ''
            newAddress.State = address.State || ''
            newAddress.TaxCode = address.TaxCode || ''
            newAddress.StreetNo = address.StreetNo || ''
            newAddress.Building = address.Building || ''
            newAddress.TaxOffice = address.TaxOffice || ''
            newAddress.GlblLocNum = address.GlblLocNum || ''
            newAddress.U_FMB_GPSLat = address.U_FMB_GPSLat || ''
            newAddress.U_FMB_GPSLon = address.U_FMB_GPSLon || ''
            newAddress.U_FMB_RUTA = address.U_FMB_RUTA || ''
            newAddress.U_FMB_Project = address.U_FMB_Project || ''
            newAddress.U_FMB_FICHA_OSIN = address.U_FMB_FICHA_OSIN || ''
            newAddress.U_FMB_OSIN_CAPACIDAD = address.U_FMB_OSIN_CAPACIDAD || ''
            newAddress.U_FMB_OSIN_STATUS = address.U_FMB_OSIN_STATUS || ''
            newAddress.U_FMB_OSIN_TIPAGENT = address.U_FMB_OSIN_TIPAGENT || ''
            newAddress.U_RMO_ID_DIRE = address.U_RMO_ID_DIRE || ''
            newAddress.U_RML_IDDIR_CU = address.U_RML_IDDIR_CU || ''
            newAddress.TypeOfAddress = address.AdresType || ''
            newAddress.provinciasDeliveries = address.Provincias || []
            newAddress.distritosDeliveries = address.Distritos || []

            deliveriesArray.push(newAddress);
            if (partnerModel.ShipToDef == address.Address) {
                partnerModel.deliveriesAddressEditIndex = index;
            }
        });

        partnerModel.ContactPersons = contactPersonArray;
        partnerModel.DeliveriesAddress = deliveriesArray;
        partnerModel.InvoicesAddress = invoicesArray;
        return partnerModel;
    };

    fillInventoryDataDetailsModel = async (model, open) => {
        const { data } = model;
        const mod = data.results[0];
        let inventoryModel = new InventoryModel();
        let userFieldsService = await apiClient.getUserFields({ name: 'OITM' });
        let GroupsItemData = await apiClient.getGroupsItemData();
        const Fabricantes = await apiClient.getProducersData();
        userFieldsService = userFieldsService.data.header || [];
        let userFields = new UserFields();

        json.userFieldsInventory.map((item, index) => {
            userFieldsService.map(userfieldItem => {

                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = item.fieldType === 3 ? 3 : userfieldItem.options.length !== 0 ? 2 : 1;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValue(userFields, index, mod);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;

                }
            });
        });
        inventoryModel.userFields = userFields;
        inventoryModel.ItemCode = mod.ItemCode;
        inventoryModel.itemName = mod.ItemName;
        inventoryModel.invntryUom = mod.InvntryUom;
        inventoryModel.FrgnName = mod.FrgnName;

        inventoryModel.SalUnitMsr = mod.SalUnitMsr;
        inventoryModel.NumInSale = mod.NumInSale;
        inventoryModel.SalPackMsr = mod.SalPackMsr;
        inventoryModel.SalPackUn = mod.SalPackUn;

        inventoryModel.BuyUnitMsr = mod.BuyUnitMsr;
        inventoryModel.NumInBuy = mod.NumInBuy;
        inventoryModel.PurPackMsr = mod.PurPackMsr;
        inventoryModel.PurPackUn = mod.PurPackUn;

        inventoryModel.wareHouses = mod.wareHouses;
        inventoryModel.ItmsGrpCod = mod.ItmsGrpCod;
        inventoryModel.ItmsGrpNam = mod.ItmsGrpNam;
        inventoryModel.UgpCode = mod.UgpCode;
        inventoryModel.UgpName = mod.UgpName;
        inventoryModel.UserText = mod.UserText;
        inventoryModel.PricesList = mod.itemPrice;
        inventoryModel.CodeBars = mod.CodeBars;
        inventoryModel.itemType = mod.ItemType;
        inventoryModel.QryGroup = mod.QryGroups[0];

        inventoryModel.SalesUnitWeight = Number(mod.Weight).toFixed(3);
        inventoryModel.SalesWeightUnit = mod.WghtUnit;
        inventoryModel.ManSerNum = mod.ManSerNum || 'N';
        inventoryModel.ManBtchNum = mod.ManBtchNum || 'N';
        inventoryModel.OnHand = Number(mod.OnHand || 0);
        // new additions
        inventoryModel.PrchseItem = mod?.PrchseItem || 'N';
        inventoryModel.SellItem = mod?.SellItem || 'N';
        inventoryModel.InvntItem = mod?.InvntItem || 'N';
        inventoryModel.FirmCode = mod.FirmCode || '';
        inventoryModel.FirmName = mod.FirmName || '';

        this.setState({
            ListItemsGroup: GroupsItemData.data.GrupoArticulo,
            Producers: Fabricantes?.data ?? [],
            ListUnitMeasuGroup: GroupsItemData.data.GrupoUnidadesMedida, // show
            showInventoryModal: true,
        });

        return inventoryModel;
    };

    loadAddressUbigeo = async (partnerModel) => {
        const { enableSpinner } = this.props;

        const addressGroups = [
            {
                list: partnerModel.DeliveriesAddress,
                provKey: 'provinciasDeliveries',
                distKey: 'distritosDeliveries'
            },
            {
                list: partnerModel.InvoicesAddress,
                provKey: 'provinciasInvoices',
                distKey: 'distritosInvoices'
            }
        ];

        for (const { list, provKey, distKey } of addressGroups) {
            if (!Array.isArray(list)) continue;

            for (const addr of list) {
                if (!addr.County && addr.ZipCode) {
                    try {
                        enableSpinner(true);
                        const resp = await apiClient.getUbigeoByZipCode({
                            zipCode: addr.ZipCode
                        });
                        enableSpinner(false);
                        if (resp?.status === 1 && resp?.data?.U_RS_PROVINCIA) {
                            addr.County = resp.data.U_RS_PROVINCIA;
                        }
                    } catch (e) {
                        enableSpinner(false);
                    }
                }

                if (!addr.State && addr.County && addr.Country) {
                    try {
                        enableSpinner(true);
                        const resp = await apiClient.getDepartamentoByProvincia({
                            provincia: addr.County,
                            country: addr.Country
                        });
                        enableSpinner(false);
                        if (resp?.status === 1 && resp?.data?.StateCode) {
                            addr.State = resp.data.StateCode;
                        }
                    } catch (e) {
                        enableSpinner(false);
                    }
                }

                if (addr.State && addr.Country && (!addr[provKey] || addr[provKey].length === 0)) {
                    try {
                        enableSpinner(true);
                        const resp = await apiClient.getProvincias({
                            code: addr.State,
                            country: addr.Country
                        });
                        enableSpinner(false);
                        if (Array.isArray(resp?.data) && resp.data.length > 0) {
                            addr[provKey] = resp.data;
                        }
                    } catch (e) {
                        enableSpinner(false);
                    }
                }

                if (addr.State && addr.Country && addr.County && (!addr[distKey] || addr[distKey].length === 0)) {
                    try {
                        enableSpinner(true);
                        const resp = await apiClient.getDistritos({
                            code: addr.State,
                            country: addr.Country,
                            provincia: addr.County
                        });
                        enableSpinner(false);
                        if (Array.isArray(resp?.data) && resp.data.length > 0) {
                            addr[distKey] = resp.data;
                        }
                    } catch (e) {
                        enableSpinner(false);
                    }
                }
            }
        }
        return partnerModel;
    }

    openBusinessPartnerDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const businesPartnerResponse = await apiClient.getPartnerDetails(open.CardCode);
        enableSpinner(false);
        if (businesPartnerResponse.status === SERVICE_RESPONSE.SUCCESS) {
            let newOrderModel = this.fillBusinessPartnerDetailsModel(businesPartnerResponse, open);
            newOrderModel = await this.loadAddressUbigeo(newOrderModel);

            this.setState({
                partnerModel: newOrderModel,
                newBusinessPartnerEditMode: { businesPartnerResponse, open },
                partnerModalAction: 2, // show
                showPartnerModal: true,
                userFieldsPartner: businesPartnerResponse?.data?.userFields || null
            });

            $('#BussinesPartner').modal({ backdrop: 'static', keyboard: false }, 'show');
            this.bussinesPartnerModal.setState({
                editMode: false
            });
            return;
        }

        showAlert({ type: 'error', message: businesPartnerResponse.message });
    }

    openInventoryDataDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        enableSpinner(true);
        let inventoryDataResponse = await apiClient.getItemsList('', view, open.ItemCode, 1, 10);
        enableSpinner(false);

        if (inventoryDataResponse.status === SERVICE_RESPONSE.SUCCESS) {

            let newOrderModel = await this.fillInventoryDataDetailsModel(inventoryDataResponse, open);

            let getPriceListResponse = await apiClient.getPriceList();
            if (!Array.isArray(getPriceListResponse.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                return;
            }

            if (getPriceListResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            this.setState({
                inventoryModel: newOrderModel,
                newInventoryDataEditMode: { inventoryDataResponse, open },
                inventoryModalAction: 2,
                prices: getPriceListResponse.data,
            });

            $('#InventoryData').modal({ backdrop: 'static', keyboard: false }, 'show');
            this.inventoryDataModal.setState({
                editMode: false
            });
            return;
        }

        showAlert({ type: 'error', message: inventoryDataResponse.message });
    }

    openDocumentDetails = async (open, edit = null, docTypeMiddleware) => {
        const { view, enableSpinner, notificationReducer: { showAlert }, DraftObjType = '' } = this.props;
        let newView = '';
        let table = this.selectTable(view, open.DocType);
        if (view === 'middleware') {
            if (open.DocType === '22') {
                newView = 'PurchaseOrder';
            } else if (open.DocType === '18') {
                newView = 'purchaseInvoice';
            } else if (open.DocType === '112') {
                newView = 'invoiceBorrador';
            }
        } else {
            newView = view;
        }

        const data = {
            doc: open.DocEntry,
            table: table.name,
            docSubType: table.docSubType,
            view: newView,
            view2: view,
        };

        enableSpinner(true);
        const detailsResponse = await apiClient.getDocumentsDetails(data);
        enableSpinner(false);

        if (detailsResponse.status === SERVICE_RESPONSE.SUCCESS) {

            if (view === 'landedCosts') {
                this.detailsLandedCosts(open, detailsResponse);
                return;
            }

            let header = detailsResponse.data.header;

            let specialPriceResponse = await apiClient.getSpecialsPrice({ CardCode: header.CardCode });
            detailsResponse.data.header.SpecialPrice = specialPriceResponse.data; // agregar precios especiales
            let newOrderModel = await this.createNewOrderDetails(detailsResponse, open);
            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
            let userFieldsConfig = user ? user.U_FMB_UserFields ? JSON.parse(user.U_FMB_UserFields) : json.allEnableUserFields : json.allEnableUserFields;
            let getPriceListResponse = [];
            const isDraftOWTQ = view === 'draft' && (Number(newOrderModel?.ObjType) === 1250000001 || Number(DraftObjType) === 1250000001);
            if (view === 'transfers' || view === 'transfersRequest' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'invoiceAuthorization' || isDraftOWTQ) { //708 AUTO
                getPriceListResponse = await apiClient.getPriceList();
                if (!Array.isArray(getPriceListResponse.data)) {
                    showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                    return;
                }

                if (getPriceListResponse.data.length === 0) {
                    showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                    return;
                }
            }

            //#region ATTACHMENT
            var fileInput = document.getElementById("fileImput2");
            if (fileInput) {
                fileInput.value = null;
            }
            this.setFiles([]);
            //#endregion ATTACHMENT

            this.setState({
                newOrderModel,
                newOrderModelEditMode: { detailsResponse, open },
                documentModalAction: 2, // 2 = showKS
                configHeaderUserFields: userFieldsConfig,
                showDocumentModal: true,
                prices: getPriceListResponse.data,
            }, () => {
                setTimeout(() => {
                    this.documentCreateModal.refreshTotal(newOrderModel);
                }, 250);

                if (!edit) {
                    $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
                }
                this.documentCreateModal.state.editMode = false;
                this.documentCreateModal.restartTabs();
            });

            return;
        }

        showAlert({ type: 'error', message: detailsResponse.message });

    };

    //#region ###### openDetailsModel
    openTipoFiguraDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let tipoFiguraResponse = await apiClient.getFiguraTransporteDetails(open.Code);
        enableSpinner(false);

        if (tipoFiguraResponse.status === SERVICE_RESPONSE.SUCCESS) {
            tipoFiguraResponse.data.manager.PartesTransporte = (tipoFiguraResponse.data.manager.PartesTransporte !== "" && tipoFiguraResponse.data.manager.PartesTransporte !== null) ? JSON.parse(tipoFiguraResponse.data.manager.PartesTransporte) : ""; // esto no es mio ya estaba asi solo lo valide 
            let newTipoFiguraModel = this.fillTipoFiguraDetailsModel(tipoFiguraResponse.data.manager, open);

            this.setState({
                tipoFiguraModel: newTipoFiguraModel,
                newTipoFiguraEditMode: { tipoFiguraResponse, open },
                tipoFiguraModalAction: 2 // show
            });
            $('#FiguraTransporte').modal({ backdrop: 'static', keyboard: false }, 'show');

            this.tipoFiguraModal.setState({
                editMode: false,
            });
            return;
        }
        showAlert({ type: 'error', message: tipoFiguraResponse.message });
    }

    openTransporteDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        this.setState({ tipoTransporte: open.tipoTransporte });
        enableSpinner(true);
        const transporteResponse = await apiClient.getTransporteDetails(open.Code, open.tipoTransporte);
        enableSpinner(false);
        if (transporteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            if (open.tipoTransporte === 'Autotransporte') {
                transporteResponse.data.manager.Remolques = transporteResponse.data.manager.Remolques ? JSON.parse(transporteResponse.data.manager.Remolques) : [];
            } else if (open.tipoTransporte === 'Ferroviario') {
                transporteResponse.data.manager.DerechosDePaso = transporteResponse.data.manager.DerechosDePaso ? JSON.parse(transporteResponse.data.manager.DerechosDePaso) : [];
                transporteResponse.data.manager.Carro = transporteResponse.data.manager.Carro ? JSON.parse(transporteResponse.data.manager.Carro) : [];
                transporteResponse.data.manager.Contenedor = transporteResponse.data.manager.Contenedor ? JSON.parse(transporteResponse.data.manager.Contenedor) : [];
            } else if (open.tipoTransporte === 'Maritimo') {
                transporteResponse.data.manager.Contenedor = transporteResponse.data.manager.Contenedor ? JSON.parse(transporteResponse.data.manager.Contenedor) : [];
            }

            let newTransporteModel = this.fillTransporteDetailsModel(transporteResponse.data.manager, open);
            await this.getPolygons();
            this.setState({
                tipoTransporte: open.tipoTransporte,
                transporteModel: newTransporteModel,
                newTransporteEditMode: { transporteResponse, open },
                transporteModalAction: 2 // show
            });

            $('#Transporte').modal({ backdrop: 'static', keyboard: false }, 'show');
            this.transporteModal.setState({
                editMode: false
            });
            return;
        }
        showAlert({ type: 'error', message: transporteResponse.message });
    }

    openCartaPorteDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const cartaPorteResponse = await apiClient.getCartaPorteDetails(open.Code);
        enableSpinner(false);
        if (cartaPorteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            let newCartaPorteModel = await this.fillCartaPorteDetailsModel(cartaPorteResponse.data.manager, open);
            // Mercancia
            // console.log('con<######### cartaPorteResponse.data ', cartaPorteResponse.data)
            newCartaPorteModel.Mercancias = this.fillMercanciaDetailsModel(cartaPorteResponse.data.Mercancias, open);
            // Ubicaciones 
            newCartaPorteModel.Ubicaciones = this.fillUbicacionDetailsModel(cartaPorteResponse.data.ubicaciones, open);
            newCartaPorteModel.Concepts = this.FillConceptsCartaPorte(cartaPorteResponse.data.Concepts);
            this.setState({
                cartaPorteModel: newCartaPorteModel,
                newCartaPorteEditMode: { cartaPorteResponse, open },
                cartaPorteModalAction: 2, // show
            });
            await this.GetRegimenFiscal();
            $('#CartaPorte').modal({ backdrop: 'static', keyboard: false }, 'show');
            this.cartaPorteModal.setState({
                editMode: false,
                usoInterno: newCartaPorteModel.UsoInterno === 'Y',
            });
            return;
        }
        showAlert({ type: 'error', message: cartaPorteResponse.message });
    }

    //#endregion

    changeDocumentActionModal = async () => {
        await this.setState({
            documentModalAction: 1 // 2 = show
            , refillModelAction: 1
        });
    };

    seriesModalChange = data => {
        const { seriesArray } = this.state;
        let defaultName = "";
        for (let index = 0; index < seriesArray.length; index++) {
            const serie = seriesArray[index];
            if (Number(serie.Series) === Number(data.target.value)) {
                defaultName = serie.SeriesName;
            }
        }

        this.setState({
            seriesDefault: data.target.value,
            seriesDefaultName: defaultName,
        })
    };
    determinateUseNewModal = (view) => {
        let useNewModal = false
        switch (view) {
            case 'transfersRequest':
                // useNewModal = true
                break;

            default:
                useNewModal = false
        }
        return useNewModal
    }

    //newDocument
    createDocument = async () => {
        const { _user } = this.state
        const { enableSpinner, notificationReducer: { showAlert }, view, viewAction, determinateWhsByRoute, DraftObjType = '' } = this.props;
        let today = moment(new Date()).format('YYYY-MM-DD');
        const isDraftOWTQ = view === 'draft' && Number(DraftObjType) === 1250000001;
        if (view === 'wareHouseAdmin' || view === 'reabsResume' || view === 'cutTransfers') {
            viewAction()
            return
        }
        if (view === "transfers") {
            return this.createTransferDocument();
        }
        enableSpinner(true);
        let getPriceListResponse = [];
        if (view === 'transfers' || view === 'transfersRequest' || view === 'transfersEntry' || view === 'transfersOutput' || isDraftOWTQ) {
            getPriceListResponse = await apiClient.getPriceList();

            if (!Array.isArray(getPriceListResponse.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                enableSpinner(false);
                return;
            }

            if (getPriceListResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                enableSpinner(false);
                return;
            }
        }
        if (view === 'inventoryCounting' || view === 'inventoryPosting' || view === 'salesForecast' || view === 'mrpAssistant') {
            const { actions } = this.props;
            actions.createDocument();
            enableSpinner(false);
            return;
        }


        let newOrderModel = new NewOrder();
        let table = isDraftOWTQ ? this.selectDraftTable(DraftObjType) : this.selectTable(view);
        let getCuentaBancosResponse = await apiClient.getCurrencies();

        newOrderModel.Currencies = getCuentaBancosResponse.data;
        let usuario = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        if (view === 'deliveries') {
            newOrderModel.DeliveryAuthorization = 'I'
        }
        if (view === 'transfersEntry') {
            newOrderModel.GroupNum = usuario.Branch.U_FMB_DEF_PLInventoryGenEntryService !== null ? usuario.Branch.U_FMB_DEF_PLInventoryGenEntryService : newOrderModel.GroupNum
        }
        if (view === 'transfersOutput') {
            newOrderModel.GroupNum = usuario.Branch.U_FMB_DEF_PLInventoryGenExitService !== null ? usuario.Branch.U_FMB_DEF_PLInventoryGenExitService : newOrderModel.GroupNum
        }
        const USERID = Number(_user?.USERID);
        if (view === 'PurchaseRequest' && Number(newOrderModel?.ReqType) === 12 && USERID > 0) { // Cargar la info default del usuario
            const personRequest = await apiClient.getUsersList(USERID);
            const user = personRequest?.data?.[0] ?? {}
            newOrderModel.Requester = user?.USER_CODE || '';
            newOrderModel.ReqName = user?.U_NAME || '';
            newOrderModel.Email = user?.E_Mail || '';
            newOrderModel.Branch = user?.Branch || '';
            newOrderModel.BranchName = user?.BranchName || '';
            newOrderModel.Department = user?.Department || '';
            newOrderModel.DepartmentName = user?.DepartmentName || '';
            newOrderModel.CostCenter = '';
            newOrderModel.ReqDate = ''; // Nace sin fecha especificada por que el solicitante debe de llenarla obligatoriamente
        }
        newOrderModel.isSalesDocument = isSalesDocument(view);
        newOrderModel.isPurchaseDocument = isPurchaseDocument(view);
        newOrderModel.isTransferDocument = this.isTransferDocument(view, isDraftOWTQ ? DraftObjType : '');
        //#region DETRACCIONES | RETENCIONES
        if (newOrderModel.isPurchaseDocument) {
            newOrderModel.DetraccionVista = this.DetraccionVista(view);
        }
        newOrderModel.RetencionVista = this.RetencionVista(view);
        //#endregion DETRACCIONES | RETENCIONES
        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };

        //Entrada de Mercancia cascos
        let seriesResponse = await apiClient.getSeries(dataSerie);
        let dataSerie2 = [];
        let seriesResponse2 = [];

        if (view === 'SalesHelmets' || view === 'ExitHelmets') {
            dataSerie2 = {
                docType: table.docType2,
                docSubType: table.docSubType2
            };
            // Nota de credito y debito  Cascos
            seriesResponse2 = await apiClient.getSeries(dataSerie2);
        }

        //Serie Pago Cascos
        let dataSerie3 = [];
        let seriesResponse3 = [];
        if (view === 'SalesHelmets') {
            dataSerie3 = {
                docType: 24,
                docSubType: '--'
            };
            seriesResponse3 = await apiClient.getSeries(dataSerie3);
        }


        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let ValidateSeries = this.selectValidateSeries(table.name, user);

        if ((!user || ValidateSeries.series === "") && view !== 'inventoryRevaluation' && view !== 'reportSelectionCriteria') {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            enableSpinner(false);
            return;
        }
        let getScenarios = [];
        if (view === 'reportSelectionCriteria') {
            getScenarios = await apiClient.getScenarios();
            if (!Array.isArray(getScenarios.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                enableSpinner(false);
                return;
            }

            if (getScenarios.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                enableSpinner(false);
                return;
            }
            // getScenarios = getScenarios.data || [];
        }

        let seriesUsers = ValidateSeries.series.split("|");


        let newArraySeries = [];

        seriesUsers.map(serieUser => {
            seriesResponse.data.map(serieResponse => {
                if (serieResponse.Series == serieUser && serieResponse.DocSubType === table.docSubType) {
                    newArraySeries.push(serieResponse);
                }
            })
        })

        if (newArraySeries.length === 0 && view !== 'reportSelectionCriteria') {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            enableSpinner(false);
            return;
        }


        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";


        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (newArraySeries.length === 1) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }


        if (view === 'SalesHelmets' || view === 'ExitHelmets') {
            let ValidateSeries2 = this.selectValidateSeries(table.name2, user);
            let seriesUsers2 = ValidateSeries2.series.split("|");

            let newArraySeries = [];
            seriesUsers2.map(serieUser => {
                seriesResponse2.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser) {
                        newArraySeries.push(serieResponse);
                    }
                })
            })

            if (newArraySeries.length === 0) {
                showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
                enableSpinner(false);
                return;
            }

            let defaultName = "";
            let defaultcode = "";
            let nextNumber = "";

            newArraySeries.map(serie => {
                if (serie.Series == newArraySeries[0].DfltSeries) {

                    defaultName = serie.SeriesName;
                    defaultcode = serie.Series;
                    nextNumber = serie.NextNumber
                } else {
                    defaultName = newArraySeries[0].SeriesName;
                    defaultcode = newArraySeries[0].Series;
                    nextNumber = newArraySeries[0].NextNumber;
                }
            });

            newOrderModel.SerieArray2 = newArraySeries;
            newOrderModel.SerieName2 = defaultName;
            newOrderModel.SerieCode2 = defaultcode;
            newOrderModel.NextFolio2 = nextNumber;

            ////////////////Serie pago///////////////////
            if (view === 'SalesHelmets') {
                let ValidateSeries3 = this.selectValidateSeries('ORCT', user);
                let seriesUsers3 = ValidateSeries3.series.split("|");
                let newArraySeries2 = [];
                seriesUsers3.map(serieUser => {
                    seriesResponse3.data.map(serieResponse => {
                        if (serieResponse.Series == serieUser) {
                            newArraySeries2.push(serieResponse);
                        }
                    })
                })

                if (newArraySeries2.length === 0) {
                    showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
                    enableSpinner(false);
                    return;
                }

                let defaultName2 = "";
                let defaultcode2 = "";
                let nextNumber2 = "";

                newArraySeries2.map(serie => {
                    if (serie.Series == newArraySeries2[0].DfltSeries) {
                        defaultName2 = serie.SeriesName;
                        defaultcode2 = serie.Series;
                        nextNumber2 = serie.NextNumber
                    }
                    else {
                        defaultName2 = newArraySeries2[0].SeriesName;
                        defaultcode2 = newArraySeries2[0].Series;
                        nextNumber2 = newArraySeries2[0].NextNumber;
                    }
                });

                newOrderModel.SerieArray3 = newArraySeries2;
                newOrderModel.SerieName3 = defaultName2;
                newOrderModel.SerieCode3 = defaultcode2;
                newOrderModel.NextFolio3 = nextNumber2;

            }
        }



        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.StatusDocument = "Abierto";

        //#region ########## USER FIELDS #########################################
        let userFieldsResponse = await apiClient.getUserFields(table);
        let userFieldsHeader = [];
        let userFieldsBody = [];
        if (userFieldsResponse.status) {
            userFieldsHeader = userFieldsResponse.data.header || [];
            userFieldsBody = userFieldsResponse.data.body || [];
        }


        let userFields = new UserFields();
        let userFieldsItems = new UserFieldsItem();


        if (view !== 'payment') {
            for (let index = 0; index < json.allUserFields.length; index++) {
                const item = json.allUserFields[index];
                for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                    const userfield = userFieldsHeader[indez];
                    if (item.fieldId === userfield.header.FieldID) {
                        json.allEnableUserFields[index].name = userfield.header.Descr;
                        item.name = userfield.header.Descr;
                        const isInvoice = (view === 'invoice' && !newOrderModel?.newView) || newOrderModel?.newView === 'invoice';
                        const isCreditNote = (view === 'creditNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'creditNote';
                        const isDebitNote = (view === 'debitNote' && !newOrderModel?.newView) || newOrderModel?.newView === 'debitNote';
                        if ((isInvoice || isCreditNote || isDebitNote) || (view === 'transfersRequest' || newOrderModel?.newView === 'transfersRequest' || view === 'transfers' || newOrderModel?.newView === 'transfers' || isDraftOWTQ)) { // Validación temporal
                            item.fieldType = item.fieldType === 3 ? 3 : userfield.options.length != 0 ? 2 : 1;
                        } else {
                            item.fieldType = item.fieldType === 3 ? 3 : userfield.options?.length != 0 ? 2 : 1;
                        }
                        item.options = userfield.options;
                        item.IdValue = index;
                        let newUserFields = this.setUserFieldValueDefault(userFields, index, userfield.header);
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }
                        //#region SERIES Y CORRELATIVOS
                        if ((isInvoice || isCreditNote || isDebitNote) || (view === 'transfersRequest' || newOrderModel?.newView === 'transfersRequest' || view === 'transfers' || newOrderModel?.newView === 'transfers' || isDraftOWTQ)) { // Validación temporal
                            if (item.fieldId === 1) {//TIPO DE DOCUMENTO
                                let validOptions = [];
                                if (isInvoice) {
                                    validOptions = [
                                        { value: '01', label: 'Factura' },
                                        { value: '03', label: 'Boleta' },
                                    ]
                                } else if (isCreditNote) {
                                    validOptions = [
                                        { value: '07', label: 'Nota de crédito' },
                                    ]
                                } else if (isDebitNote) {
                                    validOptions = [
                                        { value: '08', label: 'Nota de débito' }
                                    ]
                                } else { // Guía
                                    validOptions = [
                                        { value: '09', label: 'Guia' },
                                        { value: 'DI', label: 'Documento Interno' },//AUN NO EXISTE REGISTRO EN DB
                                    ]
                                }
                                item.options = validOptions
                            }
                            if (item.fieldId === 22) {//CORRELATIVO DOCUMENTO
                                //A FUTURO MOSTRAR POSIBLE CORRELATIVO, DE MOMENTO NO ESTAN INDISPENSABLE AL CREAR

                            }
                            if (item.fieldId === 36) {//SERIE DOCUMENTO
                                let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                                let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                                let seriesPuerta = {}
                                let seriesPlanta = {}
                                try {
                                    seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                                } catch (e) {
                                    seriesPuerta = {};
                                }
                                try {
                                    seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                                } catch (e) {
                                    seriesPlanta = {};
                                }
                                const noNeedDefault = isInvoice || isCreditNote || isDebitNote;
                                seriesPuerta = this.parseSeries(seriesPuerta, noNeedDefault)
                                seriesPlanta = this.parseSeries(seriesPlanta, noNeedDefault)
                                const isZonal = Number(user?.Branch?.Type) === 1;
                                item.options = (isZonal
                                    ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                                    : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                                )?.filter((option, index, self) =>
                                    index === self?.findIndex(x => x.value === option.value)
                                );
                            }
                        }
                        //#endregion SERIES Y CORRELATIVOS
                        userFields = newUserFields;
                    }
                }
            }
        } else {
            for (let index = 0; index < json.userFieldsPayment.length; index++) {
                const item = json.userFieldsPayment[index];
                for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                    const userfield = userFieldsHeader[indez];
                    if (item.fieldId === userfield.header.FieldID) {
                        json.allEnableUserFields[index].name = userfield.header.Descr;
                        item.name = userfield.header.Descr;
                        item.fieldType = userfield.options.length != 0 ? 2 : 1;
                        item.options = userfield.options;
                        item.IdValue = index;
                        let newUserFields = this.setUserFieldValueDefault(userFields, index, userfield.header);
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }
                        userFields = newUserFields;
                    }
                }
            }
        }

        newOrderModel.userFields = userFields;

        if (view === 'transfersRequest' || isDraftOWTQ) {
            newOrderModel.CardType = 'C'
            newOrderModel.userFields.userFields1 = '09';
        }
        if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || (view === 'transfersEntry' || view === 'transfersOutput' || view === 'payment' || view === 'transfers' || view === 'transfersRequest' || isDraftOWTQ)) {
            newOrderModel.userFieldsHeader = userFieldsHeader ?? [];
        }
        if (newOrderModel?.isSalesDocument || newOrderModel?.isPurchaseDocument || (view === 'transfersEntry' || view === 'transfersOutput')) {
            newOrderModel.userFieldsBody = userFieldsBody;
        }

        const isOIGNoOIGE = view === 'transfersEntry' || view === 'transfersOutput';
        const isOWTR = view === 'transfers';
        const isOWTRoOWTQ = isOWTR || view === 'transfersRequest' || isDraftOWTQ;
        newOrderModel.typeSearchList = [];
        newOrderModel.formattedMap = {};

        if (isOIGNoOIGE || isOWTRoOWTQ) {
            newOrderModel.GroupNum = -1;
            newOrderModel.invFields = [];
            await this.processUserFields({
                fields: invFields,
                model: newOrderModel,
                targetProperty: "invFields",
                headerFields: isOWTRoOWTQ ? [] : [
                    'U_BPP_MDTS',
                    'U_RS_MOTIVOIS',
                    'U_RS_TIPOOPER',
                    'U_BPP_MDTD',
                    'U_BPP_MDSD',
                    'U_BPP_MDCD'
                ],
                dateFields: ["U_STR_FE_GRE_FechaTransporte"],
                isOWTRoOWTQ
            });
        }

        if (view === "PurchaseRequest") {
            newOrderModel.OPRQFields = [];
            await this.processUserFields({
                fields: OPRQFields,
                model: newOrderModel,
                targetProperty: "OPRQFields",
                headerFields: [
                    'U_RS_PERIODO',
                    'U_RS_MESES',
                ],
            });
        }

        if (isOWTRoOWTQ) {
            newOrderModel.transferFields = [];
            await this.processUserFields({
                fields: transferFields,
                model: newOrderModel,
                targetProperty: "transferFields",
                headerFields: [],
            });
        }

        for (let index = 0; index < json.allItemsUserFields.length; index++) {
            const item = json.allItemsUserFields[index];
            for (let indexz = 0; indexz < userFieldsBody.length; indexz++) {
                const userfieldItem = userFieldsBody[indexz];
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = item.fieldType === 3 ? 3 : userfieldItem.options.length !== 0 ? 2 : 1;
                    item.options = userfieldItem.options;
                    item.IdValue = index;

                    let fieldHeader = userfieldItem.header;

                    if (isPurchaseDocument(view) && fieldHeader.AliasID === 'U_RS_TIPGA') {
                        fieldHeader = {
                            ...fieldHeader,
                            Dflt: ''
                        };
                    }

                    let newUserFieldsItems = this.setUserFieldValueDefault(userFieldsItems, index, fieldHeader);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFieldsItems = newUserFieldsItems;
                }

            }
        }
        newOrderModel.userFieldsItem = userFieldsItems;
        //#endregion


        for (let index = 0; index < userFieldsHeader.length; index++) {
            const element = userFieldsHeader[index];
            if (element.header.AliasID === 'FMB_TIPO_REL') {
                newOrderModel.U_FMB_TIPO_RELACION = element.options || [];
            }
            if ((view === 'transfersEntry' || view === 'transfersOutput') && element.header.AliasID === 'TipoSalida') {
                newOrderModel.U_TipoSalidaOptions = element.options || [];
            }
        }

        let permissions = new Permissions();

        permissions.editItems = true;
        permissions.editDiscountDocument = true;
        permissions.editDiscountLine = true;
        permissions.editEmployee = true;
        permissions.editOwner = true;

        newOrderModel.permissions = permissions;

        newOrderModel.OriginDocumentCreate = view;

        newOrderModel.DocDueDate = newOrderModel.DocDueDate = today;
        let userFieldsConfig = user ? user.U_FMB_UserFields ? JSON.parse(user.U_FMB_UserFields) : json.allEnableUserFields : json.allEnableUserFields;
        if (view === "transfers") {
            newOrderModel.Filler = user?.Branch?.ProjectCode || "";

            let FillerName = ((Array.isArray(user?.Branch?.AvailableWhs)) ? user?.Branch?.AvailableWhs.find(({ WhsCode }) => WhsCode === newOrderModel.Filler)?.WhsName : user?.Sucursal) || "";
            newOrderModel.FillerName = FillerName || "";
        }
        const useNewModal = this.determinateUseNewModal(view)

        //#region Flujo de caja
        let CFWOptions = [];
        if (Sections['FlujoCaja'] && (view === 'payment' || view === 'outgoingPayment')) {
            try {
                enableSpinner(true);
                const CFWRes = await apiClient.getOCFW();
                enableSpinner(false);
                CFWOptions = CFWRes?.data ?? [];
            } catch (error) {
                CFWOptions = []
            }
        }
        //#endregion Flujo de caja

        await this.setState({
            newOrderModel,
            documentModalAction: 1, // 1 = create
            configHeaderUserFields: userFieldsConfig,
            prices: getPriceListResponse.data,
            showDocumentModal: true,
            scenarios: getScenarios.data || [],
            useNewModal,
            CFWOptions
        }, () => {
            if (!useNewModal) {
                this.documentCreateModal.state.editMode = false;
                this.documentCreateModal.restartTabs();
                $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
            }
        });

        enableSpinner(false);
    };


    parseSeries = (data, noNeedDefault = false) => {
        if (!data || typeof data !== 'object') return [];

        const result = [];
        for (const key in data) {
            const value = data[key];
            if (typeof value !== 'string') continue;

            const parts = value.split('|').filter(Boolean);
            for (const part of parts) {
                const [code, flag] = part.split('~');
                const exists = result.some(
                    item => item.value === key && item.label === (code || '-1')
                );
                if (!exists) {

                    result.push({
                        key,
                        code: code || '',
                        isDefault: noNeedDefault ? false : flag === 'D',
                        value: `${key}-${code || (result.length + 1)}`,
                        label: code || '',
                        FldValue: code || '',
                        Descr: code || '',

                    });

                }
            }
        }
        return result;
    }

    getDocumentCorrelative = async (tipoDocumento, serieDocumento) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        if (!tipoDocumento || !serieDocumento) {
            return '';
        }

        try {
            enableSpinner(true);
            const response = await apiClient.getCorrelativo({ tipoDocumento, serieDocumento });

            if (response?.status === 0) {
                showAlert({ type: 'warning', message: response?.message || 'No se encontró un correlativo' });
                return '';
            }

            return response?.data ?? '';
        } catch (error) {
            showAlert({ type: 'error', message: 'Ocurrió un error al obtener el correlativo' });
            return '';
        } finally {
            enableSpinner(false);
        }
    };

    createTransferDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, view, viewAction } = this.props;
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        const today = moment(new Date()).format('YYYY-MM-DD');
        const table = this.selectTable(view);
        const userSeries = this.selectValidateSeries(table.name, user);

        enableSpinner(true);
        const getPriceListResponse = await apiClient.getPriceList();
        enableSpinner(false);

        if (!Array.isArray(getPriceListResponse.data) || !getPriceListResponse?.data?.length) {
            return showAlert({ type: 'info', message: 'No hay información de precios por mostrar' });
        }

        //#region ########## SERIES ##########
        if ((!user || !userSeries?.series)) {
            return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador" });
        }

        const dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };
        enableSpinner(true);
        const seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        if (!Array.isArray(seriesResponse.data) || !seriesResponse?.data?.length) {
            return showAlert({ type: 'info', message: 'No hay series validas por mostrar' });
        }

        const uSeriesArray = userSeries.series.split("|");
        const validSeries = seriesResponse.data.filter(({ Series, ObjectCode, DocSubType }) => uSeriesArray.some((userSerie) => Series === userSerie) && Number(ObjectCode) === Number(table.docType) && DocSubType === table.docSubType);
        let dflSerie = {};

        if (!validSeries.length) {
            return showAlert({ type: "warning", message: "El usuario no tiene serie permitida de escritura" });
        } else if (validSeries.length === 1) {
            dflSerie = validSeries[0];
        }
        //#endregion

        //#region ########## USER FIELDS ##########
        enableSpinner(true);
        const userFieldsResponse = await apiClient.getUserFields(table);
        enableSpinner(false);

        const userFieldsConfig = user?.U_FMB_UserFields ? JSON.parse(user.U_FMB_UserFields) : json.allEnableUserFields;
        const userFieldsHeader = Array.isArray(userFieldsResponse?.data?.header) ? userFieldsResponse.data.header : [];
        const userFieldsBody = Array.isArray(userFieldsResponse?.data?.body) ? userFieldsResponse.data.body : [];
        let userFields = new UserFields();
        let userFieldsItems = new UserFieldsItem();

        json.allUserFields.forEach((userField, index) => {
            const userFieldInfo = userFieldsHeader.find((userFieldH) => userField.fieldId === userFieldH.header.FieldID)
            if (userFieldInfo) {
                json.allEnableUserFields[index].name = userFieldInfo.header.Descr;
                userField.name = userFieldInfo.header.Descr;
                userField.fieldType = userField.fieldType === 3 ? 3 : userFieldInfo.options.length != 0 ? 2 : 1;
                userField.options = userFieldInfo.options;
                userField.IdValue = index;
                let newUserFields = this.setUserFieldValueDefault(userFields, index, userFieldInfo.header);
                if (userField.fieldType === 2) {
                    userField.options.push({ FldValue: "", Descr: "" });
                }
                //SERIES Y CORRELATIVOS
                if (userField.fieldId === 1) {//TIPO DE DOCUMENTO
                    const validOptions = [
                        { value: '09', label: 'Guia' },
                        { value: 'DI', label: 'Documento Interno' },//AUN NO EXISTE REGISTRO EN DB
                    ]
                    userField.options = validOptions
                }
                if (userField.fieldId === 22) {//CORRELATIVO DOCUMENTO
                    //A FUTURO MOSTRAR POSIBLE CORRELATIVO, DE MOMENTO NO ESTAN INDISPENSABLE AL CREAR

                }
                if (userField.fieldId === 36) {//SERIE DOCUMENTO
                    let serPuertaObj = JSON.stringify(user?.U_FMB_ValidateSeriesPUERTA);
                    let serPlantaObj = JSON.stringify(user?.U_FMB_ValidateSeriesSUNAT);
                    let seriesPuerta = {}
                    let seriesPlanta = {}
                    try {
                        seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
                    } catch (e) {
                        seriesPuerta = {};
                    }
                    try {
                        seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
                    } catch (e) {
                        seriesPlanta = {};
                    }
                    seriesPuerta = this.parseSeries(seriesPuerta);
                    seriesPlanta = this.parseSeries(seriesPlanta);
                    const isZonal = Number(user?.Branch?.Type) === 1;
                    userField.options = (isZonal
                        ? (Array.isArray(seriesPuerta) ? seriesPuerta : [])
                        : (Array.isArray(seriesPlanta) ? seriesPlanta : [])
                    )?.filter((option, index, self) =>
                        index === self?.findIndex(x => x.value === option.value)
                    );
                }

                userFields = newUserFields;
            }
        });

        json.allItemsUserFields.forEach((userField, index) => {
            const userFieldInfo = userFieldsBody.find((userFieldB) => userField.fieldId === userFieldB.header.FieldID);
            if (userFieldInfo) {
                json.allEnableUserFields[index].name = userFieldInfo.header.Descr;
                userField.name = userFieldInfo.header.Descr;
                userField.fieldType = userFieldInfo.options.length != 0 ? 2 : 1;
                userField.options = userFieldInfo.options;
                userField.IdValue = index;
                let newUserFieldsItems = this.setUserFieldValueDefault(userFieldsItems, index, userFieldInfo.header);
                if (userField.fieldType === 2) {
                    userField.options.push({ FldValue: "", Descr: "" });
                }
                userFieldsItems = newUserFieldsItems;
            }
        });
        //#endregion

        const Filler = user?.Branch?.ProjectCode || "";
        const FillerName = ((Array.isArray(user?.Branch?.AvailableWhs)) ? user?.Branch?.AvailableWhs.find(({ WhsCode }) => WhsCode === Filler)?.WhsName : user?.Sucursal) || "";

        let newOrderModel = new NewOrder();
        newOrderModel.CardType = 'C'
        newOrderModel.userFields = userFields;
        newOrderModel.userFieldsItem = userFieldsItems;
        newOrderModel.SerieArray = validSeries;
        newOrderModel.SerieName = dflSerie.SeriesName || "";
        newOrderModel.SerieCode = dflSerie.Series || "";
        newOrderModel.NextFolio = dflSerie.NextNumber || "";
        newOrderModel.StatusDocument = "Abierto";
        newOrderModel.OriginDocumentCreate = view;
        newOrderModel.DocDueDate = today;
        newOrderModel.Filler = Filler || "";
        newOrderModel.FillerName = FillerName || "";

        //#region Ramo
        newOrderModel.userFieldsHeader = userFieldsHeader ?? [];

        newOrderModel.GroupNum = -1;
        newOrderModel.invFields = [];
        newOrderModel.typeSearchList = [];
        newOrderModel.formattedMap = {};
        newOrderModel.isTransferDocument = this.isTransferDocument(view);
        await this.processUserFields({
            fields: invFields,
            model: newOrderModel,
            targetProperty: "invFields",
            headerFields: [],
            dateFields: ["U_STR_FE_GRE_FechaTransporte"],
            isOWTRoOWTQ: true
        });

        newOrderModel.transferFields = [];
        await this.processUserFields({
            fields: transferFields,
            model: newOrderModel,
            targetProperty: "transferFields",
        });
        //#endregion Ramo

        await this.setState({
            newOrderModel,
            documentModalAction: 1, // 1 = create
            configHeaderUserFields: userFieldsConfig,
            prices: getPriceListResponse.data,
            showTransfersDocumentModal: true,
        });
        $("#TransfersDocumentModal").modal("show");
        $("#TransfersDocumentModal").on("hide.bs.modal", () => this.setState({ showTransfersDocumentModal: false }));
        enableSpinner(false);
    }

    handleInputChange = async (event) => {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name
        const this2 = this;

        this.setState({
            [name]: value,
            showDocumentModal: true,
        })

        if (name === 'file') {
            let reader = new FileReader()
            reader.readAsArrayBuffer(target.files[0])

            reader.onloadend = async (e) => {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: 'array' });

                let excel = workbook.Sheets[workbook.SheetNames[0]];
                let csv = XLSX.utils.sheet_to_csv(excel, { strip: true, blankRows: false });
                let csvRowsSeparate = csv.split("\n");
                let csvRows = csvRowsSeparate.slice(1, csvRowsSeparate.length);
                await this2.setState({
                    template: csvRows,
                })
                this.newOrder();
            }
        }
    }

    importUsers = async ({ target: { files } }) => {
        const allowedTypes = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"];
        const file = files[0];
        if (!file) return;

        const { notificationReducer: { showAlert } } = this.props;
        if (!allowedTypes.includes(file.type)) { return showAlert({ type: "warning", message: "Solo se permiten archivos de Excel o CSV" }); }

        try {
            const buffer = await file.arrayBuffer();
            const workbook = XLSX.read(buffer);
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            if (!Array.isArray(data) || !data.length) { return showAlert({ type: "warning", message: "El archivo no contiene datos válidos" }); }
            for (const prop of userPropsTemplate) {
                if (!data[0].hasOwnProperty(prop)) { return showAlert({ type: "warning", message: "Los datos no tienen la estrcutura valida" }); }
            }

            await this.setState({ massiveUsers: data });
            $("#MassiveUsersModal").modal("show");
            $("#MassiveUsersModal").on("hidden.bs.modal", () => this.setState({ massiveUsers: [] }));
        } catch (error) {
            showAlert({ type: "warning", message: `Ocurrió un error al leer el archivo: ${error.message}` });
        }
    }

    downloadUsersTemplate = () => {
        const data = {};
        for (const prop of userPropsTemplate) { data[prop] = ""; }
        const worksheet = XLSX.utils.json_to_sheet([data], { header: userPropsTemplate });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla Usuarios");
        XLSX.writeFile(workbook, "Plantilla Usuarios.xlsx");
    }

    newOrder = async () => {
        const { notificationReducer: { showAlert }, view, enableSpinner } = this.props;
        const { template, noOrder, taxCodeExce } = this.state;
        let sheet = template;
        let newOrderModel = new NewOrder();
        let type = 'S';
        let getSocioResponse = {
            data: [],
            message: '',
            status: 0
        }

        //#region ################################# HEADERS DOCUMENT #################################
        let headers = 7;
        let CardCode = null;
        let dato1 = null;
        let dato2 = null;
        let dato3 = null;
        for (let index = 0; index < headers; index++) {

            if (sheet[index] !== '') {
                let csvLine = sheet[index].split(",");
                if (index == 0) {
                    CardCode = (csvLine[1] || '').trim();
                } else if (index == 1) {
                    dato1 = (csvLine[1] || '').trim();
                } else if (index == 2) {
                    dato2 = (csvLine[1] || '').trim();
                } else if (index == 3) {
                    dato3 = (csvLine[1] || '').trim();
                }
            }
        }
        //#endregion

        //#region ######################### BUSINESS #####################################
        getSocioResponse = await apiClient.getPartner(type, CardCode, view);

        if (!Array.isArray(getSocioResponse.data)) {
            showAlert({ type: 'error', message: 'Socio de negocios incorrecto, por favor valide su configuración en dentro del Excel' });
            return;
        }
        if (getSocioResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        let partner = getSocioResponse.data[0];
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.SlpCode = partner.SlpCode || '';
        newOrderModel.SlpName = partner.SlpName || '';
        newOrderModel.CntctCode = partner.CodigoContacto || '';
        newOrderModel.CntctName = partner.Contacto || '';
        newOrderModel.OwnerCode = partner.OwnerCode || '';
        newOrderModel.GroupNum = partner.GroupNum || '';
        newOrderModel.GroupName = partner.PymntGroup || '';
        newOrderModel.PymCode = partner.PymCode || '';
        newOrderModel.PymName = partner.Descript || '';
        newOrderModel.Address = partner.Address || '';
        newOrderModel.deliveriesAddress = [];
        newOrderModel.invoicesAddress = [];
        newOrderModel.ShipToCode = '';
        newOrderModel.Address2 = '';
        //impuesto definido desde el usuario

        newOrderModel.TaxeDefaultPartner = partner.VatGroup;//getTaxesResponse.data[0].Code || '';
        newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate; //getTaxesResponse.data[0].Rate || 0;
        newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName;


        newOrderModel.OcrCode2DefaultPartner = partner.OcrCode2 || '';
        newOrderModel.AcctCodeDefaultPartner = partner.AcctCodeItem || '';
        newOrderModel.CogsAcctDefaultPartner = partner.CogsAcctItem || '';
        newOrderModel.AcctCodeNameDefaultPartner = partner.AcctCodeItemName || '';
        newOrderModel.CogsAcctNameDefaultPartner = partner.CogsAcctItemName || '';

        //pagos
        newOrderModel.BpAct = partner.AcctCode || '';
        newOrderModel.BpActName = partner.AcctName || '';
        newOrderModel.BpActFormatCode = partner.FormatCode || '';
        newOrderModel.BpActCopy = partner.AcctCode || '';
        newOrderModel.BpActNameCopy = partner.AcctName || '';
        newOrderModel.BpActFormatCodeCopy = partner.FormatCode || '';


        //Agregar Direccion Por Defecto

        let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);

        let address = [];
        if (partner.CardType === 'C') {
            address = getAddressResponse.data.deliveriesAddress[0] || [];
        } else {
            address = getAddressResponse.data.invoicesAddress[0] || [];
        }

        newOrderModel.ShipToCode = address ? address.Address : '';
        newOrderModel.Address2 = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";

        //#endregion

        //#region ######################### ITEMS ########################################
        let getItemResponse = null;

        sheet = sheet.slice(headers, sheet.length);
        let items = [];
        for (let index = 0; index < sheet.length; index++) {
            if ((sheet[index]).trim() !== '') {
                let csvLine = sheet[index].split(",");
                let data = {
                    ItemCode: csvLine[0],
                    Quantity: csvLine[1],
                    WhsCode: csvLine[2],
                    Precio: csvLine[3]
                }
                items.push(data);
            }
        }

        enableSpinner(true);
        getItemResponse = await apiClient.getItemsPurchaseOrder(CardCode, items);

        if (getItemResponse.error.length > 0) {
            let errors = getItemResponse.error;
            for (let index = 0; index < errors.length; index++) {
                const element = errors[index];
                showAlert({ type: 'error', timeOut: 5000, message: element.message });
            }
        }

        if (getItemResponse.data.length === 0) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
        }

        let itemsSelected = getItemResponse.data;

        //#endregion

        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];

            const newItemModel = new NewItem();
            newItemModel.ItemCode = item.ItemCode;
            newItemModel.ItemName = item.ItemName;
            newItemModel.Quantity = item.itemQuantity;
            newItemModel.Description = item.ItemName;
            newItemModel.HomePrice = parseFloat(item.price || item.Price);
            newItemModel.Price = parseFloat(item.price || item.Price);
            newItemModel.newHomePrice = parseFloat(item.price || item.Price);
            newItemModel.newPrice = parseFloat(item.price || item.Price);
            newItemModel.cHomePrice = parseFloat(item.price || item.Price);
            newItemModel.cPrice = parseFloat(item.price || item.Price);
            newItemModel.wareHouseStock = item.wareHouses;
            newItemModel.InvntItem = item.InvntItem || '';
            newItemModel.InvntryUom = item.InvntryUom;
            newItemModel.OnHand = item.OnHand || 0;
            newItemModel.PricesList = item.itemPrice || [];
            newItemModel.NoPriceList = item.PriceList;
            newItemModel.SalPackUn = item.SalPackUn;
            newItemModel.PurPackUn = item.PurPackUn;
            newItemModel.WhsCode = item.whsCode || '';
            newItemModel.OcrCode = item.OcrCode || "";
            newItemModel.OcrName = item.OcrName || "";
            newItemModel.OcrCode2 = item.OcrCode2 || "";
            newItemModel.OcrName2 = item.OcrName2 || "";
            newItemModel.OcrCode3 = item.OcrCode3 || "";
            newItemModel.OcrName3 = item.OcrName3 || "";
            newItemModel.OcrCode4 = item.OcrCode4 || "";
            newItemModel.OcrName4 = item.OcrName4 || "";

            if (item.EvalSystem === 'A') {
                newItemModel.EvalSystem = "Promedio móvil";
            } else if (item.EvalSystem === 'B') {
                newItemModel.EvalSystem = "Serie / Lote";
            } else if (item.EvalSystem === 'F') {
                newItemModel.EvalSystem = "FIFO";
            } else if (item.EvalSystem === 'S') {
                newItemModel.EvalSystem = "Estándar";
            }

            newItemModel.TaxCode = newOrderModel.TaxeDefaultPartner || item.TaxCode || 0;
            newItemModel.TaxeRate = newOrderModel.TaxeRateDefaultPartner || item.TaxeRate || 0;
            newItemModel.TaxName = newOrderModel.TaxNameDefaultPartner || item.TaxName || '';
            if (newOrderModel.AcctCodeDefaultPartner) {
                newItemModel.AcctCode = newOrderModel.AcctCodeDefaultPartner || newItemModel.AcctCode;
                newItemModel.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || newItemModel.AcctCodeName;
            }

            if (newOrderModel.CogsAcctDefaultPartner) {
                newItemModel.CogsAcct = newOrderModel.CogsAcctDefaultPartner || newItemModel.CogsAcct;
                newItemModel.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || newItemModel.CogsAcctName;
            }

            newOrderModel.Items.push(newItemModel);


            let sum = 1;
            newOrderModel.Items.map(item => {
                if (item.ItemNew && !item.BaseEntry) {
                    item.LineNum = newOrderModel.LastLineNumItems + sum;
                    sum += 1;
                }
            });

        }
        enableSpinner(false);



        let table = this.selectTable(view);
        let extras = this.selectTableTimbre(table.name);



        let getCuentaBancosResponse = await apiClient.getCurrencies();
        newOrderModel.Currencies = getCuentaBancosResponse.data;


        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };



        let seriesResponse = await apiClient.getSeries(dataSerie);


        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let ValidateSeries = this.selectValidateSeries(table.name, user);

        if (!user || ValidateSeries.series == "" && view !== 'inventoryRevaluation') {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            return;
        }

        let seriesUsers = ValidateSeries.series.split("|");


        let newArraySeries = [];

        seriesUsers.map(serieUser => {
            seriesResponse.data.map(serieResponse => {
                if (serieResponse.Series == serieUser && serieResponse.DocSubType === table.docSubType) {
                    newArraySeries.push(serieResponse);
                }
            })
        })

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }


        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        newArraySeries.map(serie => {
            if (serie.Series == newArraySeries[0].DfltSeries) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        });



        let today = moment(new Date()).format('YYYY-MM-DD');

        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.StatusDocument = "Abierto";

        //#region ########## USER FIELDS #########################################
        let userFieldsResponse = await apiClient.getUserFields(table);
        let userFieldsHeader = [];
        let userFieldsBody = [];
        if (userFieldsResponse.status) {
            userFieldsHeader = userFieldsResponse.data.header || [];
            userFieldsBody = userFieldsResponse.data.body || [];
        }


        let userFields = new UserFields();
        let userFieldsItems = new UserFieldsItem();

        for (let index = 0; index < json.allUserFields.length; index++) {
            const item = json.allUserFields[index];
            for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                const userfieldItem = userFieldsHeader[indez];
                if (item.fieldId === userfieldItem.header.FieldID) {
                    json.allEnableUserFields[index].name = userfieldItem.header.Descr;
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = item.fieldType == 3 ? 3 : userfieldItem.options.length != 0 ? 2 : 1;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValueDefault(userFields, index, userfieldItem.header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            }
        }

        newOrderModel.userFields = userFields;




        for (let index = 0; index < json.allItemsUserFields.length; index++) {
            const item = json.allItemsUserFields[index];
            for (let index = 0; index < userFieldsBody.length; index++) {
                const userfieldItem = userFieldsBody[index];
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length != 0 ? 2 : 1;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFieldsItems = this.setUserFieldValueDefault(userFieldsItems, index, userfieldItem.header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFieldsItems = newUserFieldsItems;
                }
            }
        }

        newOrderModel.userFieldsItem = userFieldsItems;
        //#endregion


        let permissions = new Permissions();

        permissions.editItems = true;
        permissions.editDiscountDocument = true;
        permissions.editEmployee = true;
        permissions.editOwner = true;

        newOrderModel.permissions = permissions;

        //guardar orign de documento para ccines de copiar a:

        newOrderModel.OriginDocumentCreate = view;
        newOrderModel.userFields.userFields5 = noOrder;
        //this.refreshTotal(newOrderModel);


        this.setState({
            documentModalAction: 1,
            partners: [],
            items: []
        });


        this.documentCreateModal.refreshTotal(newOrderModel);
        this.documentCreateModal.state.editMode = false;
        this.documentCreateModal.restartTabs();
        $("#file").val(null);
        $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    }

    updateItemsWhenPartnerChange = async newOrderModel => {
        const { enableSpinner, showAlert, view } = this.props;

        enableSpinner(true);
        let getItemsResponse = await apiClient.getItemsList(newOrderModel.CardCode);
        enableSpinner(false);

        if (!Array.isArray(getItemsResponse.data)) {
            return newOrderModel;
        }

        if (getItemsResponse.data.length === 0) {
            return newOrderModel;
        }

        let itemsUpdate = [];
        newOrderModel.Items.map(item => {
            getItemsResponse.data.map(refreshItem => {
                if (item.ItemCode === refreshItem.ItemCode) {
                    item.Price = refreshItem.Price;
                    item.HomePrice = refreshItem.Price;
                    item.wareHouseStock = refreshItem.wareHouses;
                    item.InvntItem = refreshItem.InvntItem;



                    if (newOrderModel.TaxeDefaultPartner) {
                        item.TaxeCode = newOrderModel.TaxeDefaultPartner || item.TaxeCode;
                    }

                    if (newOrderModel.TaxeRateDefaultPartner) {
                        item.TaxeRate = newOrderModel.TaxeRateDefaultPartner || item.TaxeRate;
                    }

                    if (newOrderModel.TaxNameDefaultPartner) {
                        item.TaxName = newOrderModel.TaxNameDefaultPartner || item.TaxName;
                    }

                    if (newOrderModel.OcrCode2DefaultPartner) {
                        item.OcrCode2 = newOrderModel.OcrCode2DefaultPartner || item.OcrCode2;
                    }

                    if (newOrderModel.AcctCodeDefaultPartner) {
                        item.AcctCode = newOrderModel.AcctCodeDefaultPartner || item.AcctCode;
                        item.AcctCodeName = newOrderModel.AcctCodeNameDefaultPartner || item.AcctCodeName;
                    }

                    if (newOrderModel.CogsAcctDefaultPartner) {
                        item.CogsAcct = newOrderModel.CogsAcctDefaultPartner || item.CogsAcct;
                        item.CogsAcctName = newOrderModel.CogsAcctNameDefaultPartner || item.CogsAcctName;
                    }


                    if (view !== 'transfers' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'creditNote' && view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'return') {

                        refreshItem.wareHouses.map(warehouseStock => {
                            if (item.InvntItem === 'N') {
                                return;
                            }
                            if (warehouseStock.WhsCode == item.WhsCode) {
                                if (warehouseStock.OnHand <= 0) {
                                    showAlert({
                                        type: 'warning',
                                        message: 'El artículo ' + item.ItemCode + ' ya no tiene existencia en el almacén seleccionado',
                                        timeOut: 5000
                                    });
                                    item.stock = false;
                                } else {
                                    item.stock = true;
                                }
                            }
                        })
                    }


                    itemsUpdate.push(item);
                }
            });
        });


        newOrderModel.Items = itemsUpdate;
        return newOrderModel;
    };

    refreshTotal = (newOrderModel, index = null) => {
        const { view } = this.props;

        newOrderModel.Items.map(item => {
            let total = 0;
            item.Price = (item.HomePrice / newOrderModel.ChangeRate).toFixed(2);
            let discount = item.Price * item.Quantity * (item.DiscountPercent / 100);
            item.Discount = discount;
            let impuesto = (item.Price * item.Quantity - item.Discount) * (item.TaxeRate / 100);

            item.TaxeResult = parseFloat(impuesto).toFixed(2);

            total = item.Price * item.Quantity - item.Discount;
            item.Total = total;
        });


        let subTotal = 0;
        let impuestos = 0;
        let discount = 0;
        let total = 0;

        newOrderModel.Items.map(item => {
            subTotal += Number(item.Total);

            impuestos += parseFloat(item.TaxeResult);
        });

        newOrderModel.Subtotal = subTotal;
        newOrderModel.Taxes = impuestos;
        discount = subTotal * (newOrderModel.DiscountPercent / 100);
        //total = (subTotal - discount) + impuestos;

        newOrderModel.Discount = discount;

        let disCountDocumentToItem = discount / newOrderModel.Items.length;

        newOrderModel.Items.map(item => {
            let total = 0;
            let discountItem = item.Price * item.Quantity * (item.DiscountPercent / 100);

            let impuesto =
                (item.Price * item.Quantity - (discountItem + disCountDocumentToItem)) * (item.TaxeRate / 100);

            item.TaxeResult = parseFloat(impuesto).toFixed(2);

            let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
            total = (item.Price * measureUnit) * item.Quantity - item.Discount;
            item.Total = total;



        });
        let sub = 0;
        newOrderModel.Items.map(item => {
            sub += Number(item.Total);
        });
        newOrderModel.Subtotal = sub;

        impuestos = 0;
        newOrderModel.Items.map(item => {
            impuestos += parseFloat(item.TaxeResult);

        });

        newOrderModel.Taxes = sub * parseFloat(newOrderModel.TaxeRateDefaultPartner / 100);
        total = newOrderModel.Subtotal - newOrderModel.Discount + newOrderModel.Taxes;

        newOrderModel.Total = total;


        //PAGOS
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalPago = 0;
        newOrderModel.CheckSum = 0;

        newOrderModel.ItemsPayments.map(item => {
            newOrderModel.totalDocumento += Number(item.total);
            newOrderModel.totalPago += Number(item.totalPago);
        });

        newOrderModel.CheckList.map(item => {
            newOrderModel.CheckSum += Number(item.CheckSum);
        });

        if (newOrderModel.PayNoDoc) {
            newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        }


        newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        if (newOrderModel.DocCur != newOrderModel.DocCurDocumentsPayment) {
            let localCurrency = CURRENCY;
            let rate = 1;
            if (localCurrency == newOrderModel.DocCur) {

                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });

                newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
            } else {

                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCur == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });
                newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
            }
        }

        newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;
        this.refreshModel(newOrderModel);
    };

    sendBusinessPartnerModel = async partnerModel => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { seriesDefault, seriesDefaultName, action } = this.state;
        let data = {
            model: partnerModel,
        };
        let responseArray = [];
        enableSpinner(true);
        let response = await apiClient.createBusinessPartner(data);
        enableSpinner(false);

        if (response.status === 1 && partnerModel?.Attachments?.length) {
            showAlert({ type: "info", message: "Socio creado, cargando anexos" });
            await this.uploadAttachmentsFiles("OCRD", `'${partnerModel.CardCode}'`, partnerModel.Attachments);
        }

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        this.toggleDocumentSelectedAll(false);

        this.setState({
            billingResponseArray: responseArray,
            checkboxDataTables: (new Map()),
        })

        if (response.status === 1) {
            $('#BussinesPartner').modal('hide');
            this.setState({ showPartnerModal: false });
        }

        setTimeout(() => {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open').css('padding-right', '');
            $('#billingResponseModal').modal('show');
        }, 300);

    };

    sendInventoryDataModel = async model => {

        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        let data = {
            model: model,
        };
        let responseArray = [];

        enableSpinner(true);
        let response = await apiClient.createInventoryData(data);
        enableSpinner(false);

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        this.toggleDocumentSelectedAll(false);

        this.setState({
            billingResponseArray: responseArray,
            checkboxDataTables: (new Map()),
        })


        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            $('#InventoryData').modal('hide');
        }

    };

    requestPartialEdit = async () => {
        await this.setState({
            showRequestPartialEdit: !this.state.showRequestPartialEdit,
        });
        $('#areYouAgreeModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    SendRequestPartialEdit = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { newOrderModel } = this.state;
        showAlert({ type: 'info', message: 'Mandando solicitud...' });

        enableSpinner(true);
        let data = {
            DocEntry: newOrderModel.DocEntry || '',
            DocNum: newOrderModel.DocNum || '',
            Mail_Creator: newOrderModel.Mail_Creator || '',
            Name_Creator: newOrderModel.Name_Creator || '',
        }

        let response = await apiClient.submitPartialEditRequest(data);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: response.message });
            this.CloseShowAreYouAgreeModal(); // PARA CERRAR EL MODAL DE ESTAS SEGURO DE MANDAR LA SOLICITUD
            // CERRAR MODAL DE DOCUMENT CREATE MODAL
            $('#DocumentCreateModal').modal('hide');
            this.searchDocuments();
            return;
        }
        showAlert({ type: 'error', message: response.message });
        this.CloseShowAreYouAgreeModal(); // PARA CERRAR EL MODAL DE ESTAS SEGURO DE MANDAR LA SOLICITUD
    };

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showRequestPartialEdit: false,
        });
    };

    SendAprovedPartial = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { newOrderModel } = this.state;

        enableSpinner(true);

        let table = this.selectTable(view);
        let extras = this.selectTableTimbre(table.name);
        let documents = {
            id: newOrderModel.DocEntry,
            table: table.name,
            destino: extras.destino,
            condicion: extras.action,
        }

        let response = await apiClient.approvePartialRequest([documents]);
        enableSpinner(false);

        if (response.status === 2) {
            showAlert({ type: 'success', message: 'Documento aprobado correctamente' });
            $('#DocumentCreateModal').modal('hide');
            this.searchDocuments();
            return;
        }
        showAlert({ type: 'error', message: response.message });
    };

    //#region  ###### sendModel
    sendTipoFiguraModel = async model => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        // model = this.fillTipoFiguraDetailsModel(model),
        let data = { model };
        let responseArray = [];
        enableSpinner(true);
        let response = await apiClient.createFiguraTransporteManager(data);
        enableSpinner(false);
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.toggleDocumentSelectedAll(false);
        this.setState({
            billingResponseArray: responseArray,
        });
        $('#billingResponseModal').modal('show');
        // showAlert({type: 'success', message: "Chofer dado de alta"});
        if (response.status === 1) {
            $('#FiguraTransporte').modal('hide');
        }
    };

    sendTransporteModel = async model => {
        const { enableSpinner } = this.props;
        const { tipoTransporte } = this.state;
        const data = {
            model: model,
            tipoTransporte
        };
        let responseArray = [];
        enableSpinner(true);
        const response = await apiClient.createTransporteManager(data);
        enableSpinner(false);
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        this.toggleDocumentSelectedAll(false);
        this.setState({
            billingResponseArray: responseArray,
        });
        $('#billingResponseModal').modal('show');
        // showAlert({type: 'success', message: "Chofer dado de alta"});
        if (response.status === 1) {
            this.refreshTipoTransporte('Autotransporte');
            $('#Transporte').modal('hide');
        }
    };

    ChangeDisabledButton = async () => {
        await this.setState({
            disableButton: !this.state.disableButton
        })
    }

    sendCartaPorteModel = async model => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        // model = this.fillTipoFiguraDetailsModel(model),
        let UsoInterno = false;
        if (model.UsoInterno && model.UsoInterno === 'Y') { UsoInterno = true; }
        model.Series_OINV = this.state._user.U_FMB_ValidateSeriesOINV;
        let data = { model };
        let responseArray = [];
        data.model.TotalDistRec = parseFloat(data.model.TotalDistRec || 0).toFixed(2);
        data.model.PesoBrutoTotal = parseFloat(data.model.PesoBrutoTotal || 0).toFixed(3);
        data.model.PesoNetoTotal = parseFloat(data.model.PesoNetoTotal || 0).toFixed(3);
        data.model.NumTotalMercancias = parseFloat(data.model.NumTotalMercancias || 0).toFixed(3);
        data.model.CargoPorTasacion = parseFloat(data.model.CargoPorTasacion || 0).toFixed(3);
        // console.log('con<data', data);
        if (!data.model.Transporte) {
            showAlert({ type: 'info', message: `Es necesario agregar un Transporte`, timeOut: 8000 });
            return;
        }
        if (!data.model.FiguraTransporte) {
            showAlert({ type: 'info', message: `Es necesario agregar una Figura de Transporte`, timeOut: 8000 });
            return;
        }
        for (let z = 0; z < data.model.Mercancias.length; z++) {
            const mercancia = data.model.Mercancias[z];
            data.model.ArrayDocEntriesInv.push(mercancia.DocEntry)
        }

        if (!UsoInterno) {
            data.model.ArrayDocEntriesInv = data.model.ArrayDocEntriesInv.filter((element) => element.DocEntry !== '')
            data.model.ArrayDocEntriesInv = [...new Set(data.model.ArrayDocEntriesInv)]
        }
        await this.ChangeDisabledButton();
        data.model.TimeUser = moment().format();
        enableSpinner(true);
        const response = await apiClient.createCartaPorteManager(data);
        enableSpinner(false);
        await this.ChangeDisabledButton()
        if (response.status === 0) {
            showAlert({ type: 'error', message: `Ocurrio un error al crear el documento Carta Porte`, timeOut: 8000 });
            return;
        }

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.toggleDocumentSelectedAll(false);
        this.setState({
            billingResponseArray: responseArray,
            checkboxDataTables: (new Map()),
        });
        $('#billingResponseModal').modal('show');
        // showAlert({type: 'success', message: "Chofer dado de alta"});
        if (response.status === 1) {
            $('#CartaPorte').modal('hide');
        }
    };


    //#endregion

    //#region  ###### deleteModel
    deleteFiguraTransporteModel = async codigo => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        let responseArray = [];
        enableSpinner(true);
        let response = await apiClient.deleteFiguraTransporteManager(codigo);
        enableSpinner(false);
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.setState({
            billingResponseArray: responseArray,
        })
        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            $('#FiguraTransporte').modal('hide');
        }
    };

    deleteTransporteModel = async codigo => {
        const { enableSpinner } = this.props;
        const { tipoTransporte } = this.state;
        let responseArray = [];
        enableSpinner(true);
        let response = await apiClient.deleteTransporteManager(codigo, tipoTransporte);
        enableSpinner(false);
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.setState({
            billingResponseArray: responseArray,
        })
        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            this.refreshTipoTransporte('Autotransporte');
            $('#Transporte').modal('hide');
        }
    };

    deleteCartaPorteModel = async codigo => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        let responseArray = [];
        enableSpinner(true);
        let response = await apiClient.deleteCartaPorteManager(codigo);
        enableSpinner(false);
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.setState({
            billingResponseArray: responseArray,
        })
        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            $('#CartaPorte').modal('hide');
        }
    };
    //#endregion

    refreshContinue = Continue => {
        this.setState({
            Continue
        })
    };

    sendModelContinue = async model => {

        const { notificationReducer: { showAlert }, view } = this.props;
        let items;

        if (model.DocType === "I") {
            if (view === 'landedCosts' && model.SelectOf !== 'landedCosts') {
                if (model.landedCosts.deliveryPrices.filter(price => parseFloat(price.CostSum) > 0).length < 1) {
                    return showAlert({ type: 'error', message: 'Faltan los gastos', timeOut: 8000 });
                }
            }
            if (model.newView === '' && (view === "deliveries" || view === "debitNote" || view === "purchaseReturn")) {

                items = model.Items;
                let itemCounter = [];
                for (let index = 0; index < items.length; index++) {
                    const item = items[index];
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    itemCounter.push({ ItemCode: item.ItemCode, Quantity: item.Quantity, wareHouseStock: item.wareHouseStock, WhsCode: item.WhsCode, UserBaseUn: item.UserBaseUn, SalPackUn: measureUnit });
                    for (let j = 0; j < item.wareHouseStock.length; j++) {
                        const whs = item.wareHouseStock[j];
                        if (item.WhsCode === whs.WhsCode) {

                            if ((item.UserBaseUn === "Y" && (whs.OnHand < item.Quantity)) || (item.UserBaseUn === "N" && (whs.OnHand < (item.Quantity * measureUnit)))) {
                                showAlert({ type: 'error', message: `El artículo ${item.ItemCode} no cuenta con existencia en el almacén seleccionado`, timeOut: 10000 });
                                return
                            }
                        }
                    }
                }
                // Validación de stock para articulos repetidos
                itemCounter.sort((a, b) => (a.ItemCode > b.ItemCode) ? 1 : ((b.ItemCode > a.ItemCode) ? -1 : 0));
                let newItemsArray = [];
                let actual = null;
                let whsCodeActual = '';
                let counter = 0;
                let sum = 0;
                let wareHouseStock = [];
                let WhsCode = '';
                for (let i = 0; i < itemCounter.length; i++) {
                    if (itemCounter[i].ItemCode != actual || itemCounter[i].WhsCode != whsCodeActual) {
                        if (counter > 0) {
                            newItemsArray.push({ ItemCode: actual, Counter: counter, Quantity: sum, wareHouseStock: wareHouseStock, WhsCode: whsCodeActual });
                        }
                        actual = itemCounter[i].ItemCode;
                        whsCodeActual = itemCounter[i].WhsCode;
                        counter = 1;
                        sum = itemCounter[i].UserBaseUn === 'Y' ? itemCounter[i].Quantity : itemCounter[i].Quantity * itemCounter[i].SalPackUn;
                        wareHouseStock = itemCounter[i].wareHouseStock;
                        WhsCode = itemCounter[i].WhsCode;
                    } else {
                        counter++;
                        sum += itemCounter[i].UserBaseUn === 'Y' ? itemCounter[i].Quantity : itemCounter[i].Quantity * itemCounter[i].SalPackUn;

                    }
                }
                if (counter > 0) {
                    newItemsArray.push({ ItemCode: actual, Counter: counter, Quantity: sum, wareHouseStock, WhsCode });
                }

                for (let index = 0; index < newItemsArray.length; index++) {
                    const item = newItemsArray[index];
                    for (let j = 0; j < item.wareHouseStock.length; j++) {
                        const whs = item.wareHouseStock[j];
                        if (item.WhsCode === whs.WhsCode) {
                            if (whs.OnHand < item.Quantity) {
                                showAlert({ type: 'error', message: `La sumatoria de stock del artículo ${item.ItemCode} no cuenta con existencia en el almacén seleccionado`, timeOut: 10000 });
                                return
                            }
                        }
                    }
                }


            } else if (model.newView !== '' && (model.newView === "deliveries" || model.newView === 'debitNote' || model.newView === 'purchaseReturn')) {
                items = model.Items;
                let itemCounter = [];

                for (let index = 0; index < items.length; index++) {
                    const item = items[index];
                    let measureUnit = view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'purchaseInvoice' && view !== 'purchaseCreditNotes' ? item.SalPackUn : item.PurPackUn;
                    itemCounter.push({ ItemCode: item.ItemCode, Quantity: item.Quantity, wareHouseStock: item.wareHouseStock, WhsCode: item.WhsCode, UserBaseUn: item.UserBaseUn, SalPackUn: measureUnit });
                    for (let j = 0; j < item.wareHouseStock.length; j++) {
                        const whs = item.wareHouseStock[j];
                        if (item.WhsCode === whs.WhsCode) {

                            if ((item.UserBaseUn === "Y" && (whs.OnHand < item.Quantity)) || (item.UserBaseUn === "N" && (whs.OnHand < (item.Quantity * measureUnit)))) {
                                showAlert({ type: 'error', message: `El artículo ${item.ItemCode} no cuenta con existencia en el almacén seleccionado`, timeOut: 10000 });
                                return
                            }
                        }
                    }
                }
                // Validación de stock para articulos repetidos
                itemCounter.sort((a, b) => (a.ItemCode > b.ItemCode) ? 1 : ((b.ItemCode > a.ItemCode) ? -1 : 0));
                let newItemsArray = [];
                let actual = null;
                let whsCodeActual = '';
                let counter = 0;
                let sum = 0;
                let wareHouseStock = [];
                let WhsCode = '';

                for (let i = 0; i < itemCounter.length; i++) {
                    if (itemCounter[i].ItemCode != actual || itemCounter[i].WhsCode != whsCodeActual) {
                        if (counter > 0) {
                            newItemsArray.push({ ItemCode: actual, Counter: counter, Quantity: sum, wareHouseStock: wareHouseStock, WhsCode: whsCodeActual });
                        }
                        actual = itemCounter[i].ItemCode;
                        whsCodeActual = itemCounter[i].WhsCode;
                        counter = 1;
                        sum = itemCounter[i].UserBaseUn === 'Y' ? itemCounter[i].Quantity : itemCounter[i].Quantity * itemCounter[i].SalPackUn;
                        wareHouseStock = itemCounter[i].wareHouseStock;
                        WhsCode = itemCounter[i].WhsCode;
                    } else {
                        counter++;
                        sum += itemCounter[i].UserBaseUn === 'Y' ? itemCounter[i].Quantity : itemCounter[i].Quantity * itemCounter[i].SalPackUn;

                    }
                }
                if (counter > 0) {
                    newItemsArray.push({ ItemCode: actual, Counter: counter, Quantity: sum, wareHouseStock, WhsCode });
                }


                for (let index = 0; index < newItemsArray.length; index++) {
                    const item = newItemsArray[index];
                    for (let j = 0; j < item.wareHouseStock.length; j++) {
                        const whs = item.wareHouseStock[j];
                        if (item.WhsCode === whs.WhsCode) {
                            if (whs.OnHand < item.Quantity) {
                                showAlert({ type: 'error', message: `La sumatoria de stock del artículo ${item.ItemCode} no cuenta con existencia en el almacén seleccionado`, timeOut: 10000 });
                                return
                            }
                        }
                    }
                }
            }
        }

        $('#continueModal').modal('show');

    }
    //#region ######## BATCH ############################


    ShowBatchDefinitionModal = async () => {
        await this.setState({
            showBatchDefinitionModal: !this.state.showBatchDefinitionModal,
        });
    };

    ShowBatchSelectionModal = async () => {
        await this.setState({
            showBatchSelectionModal: !this.state.showBatchSelectionModal,
        });
    };

    DocumentNeedsBatch = (view, newView, selectOf) => {
        if (view === 'quotations' && (newView === 'deliveries' || newView === 'invoice')) return true;
        else if (view === 'orderSales' && (newView === 'deliveries' || newView === 'invoice')) return true;
        else if (view === 'deliveries' && (newView === 'return' || newView === '')) return true;
        else if (view === 'invoice' && (selectOf !== 'deliveries')) return true;
        else if (view === 'invoiceReserve' && (newView === 'deliveries' || newView === 'creditNote')) return true;
        else if (view === 'debitNote') return true;
        else if (view === 'return') return true;
        else if (view === 'creditNote') return true;
        else if (view === 'transfersOutput') return true;
        else if (view === 'transfers') return true;
        else if (view === 'transfersRequest' && newView === 'transfers') return true;
        return false;
    }

    ValidateBatch = async (model) => {
        const { view, enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, refillModel } = this.state;
        if (view === 'suggestRefill' && model.newView !== '') model = refillModel

        if (model.DocType === 'I') {
            if ((view === 'PurchaseOrder' && model.newView === 'GoodsReceipt') || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'transfersEntry') {
                let items = model.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isBatchComplete = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                        if (Number(item.SnBUoMQty) !== Number(item.DocUoMQty)) {
                            isBatchComplete = false;
                        }
                    }
                    if (!isBatchComplete) {
                        await this.setState({
                            showBatchDefinitionModal: true,
                        });
                        $('#batchDefinitionModal').modal('show');
                    } else {
                        await this.validateAutorizationModels(model);
                    }
                } else {
                    await this.validateAutorizationModels(model);
                }
            } else if (this.DocumentNeedsBatch(view, model.newView, model.SelectOf)) {
                const isTransfer = view === 'transfers' || (view === 'transfersRequest' && model.newView === 'transfers');
                let items = model.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isBatchComplete = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                        if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                            isBatchComplete = false;
                        }
                    }
                    if (!isBatchComplete) {

                        let itemCode = {};
                        let whs = {}
                        itemsBatch.sort((a, b) => {
                            if (a.ItemCode > b.ItemCode) {
                                return 1;
                            } else if (b.ItemCode > a.ItemCode) {
                                return -1;
                            } else {
                                if (a.WhsCode > b.WhsCode) {
                                    return 1;
                                } else if (b.WhsCode > a.WhsCode) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }
                        });
                        itemsBatch = itemsBatch.filter((item) => {
                            if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                                return false
                            } else {
                                itemCode[item.ItemCode] = true;
                                whs[item.WhsCode] = true;
                                return true;
                            }
                        });
                        let newItemsBatchArray = []
                        for (let index = 0; index < itemsBatch.length; index++) {
                            const item = itemsBatch[index];
                            const WhsCode = isTransfer ? (model.CEDIS_Reception ? 'SAP-R1' : newOrderModel.Filler) : item.WhsCode;
                            newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode })
                        }
                        enableSpinner(true);
                        let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                        enableSpinner(false);

                        if (batchsResponse.status === 0) {
                            showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }
                        let isNewBatch = false;
                        for (let index = 0; index < newOrderModel.Items.length; index++) {
                            const item = newOrderModel.Items[index];
                            for (let index = 0; index < batchsResponse.data.length; index++) {
                                const itemBatch = batchsResponse.data[index];
                                const WhsCode = isTransfer ? (model.CEDIS_Reception ? 'SAP-R1' : newOrderModel.Filler) : item.WhsCode;
                                if (item.ItemCode === itemBatch.ItemCode && WhsCode === itemBatch.WhsCode) {
                                    if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                        isNewBatch = true;
                                    }
                                    item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                }
                            }
                        }
                        if (isNewBatch) {
                            await this.setState({
                                newOrderModel,
                                showBatchSelectionModal: true,
                            });
                            $('#batchSelectionModal').modal('show');
                        } else {
                            showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }

                    } else {
                        await this.validateAutorizationModels(model);
                    }
                } else {
                    await this.validateAutorizationModels(model);
                }
            } else {
                await this.validateAutorizationModels(model);
            }
        } else {
            await this.validateAutorizationModels(model);
        }
    }

    //#endregion

    validateAutorizationModels = async (model) => {
        const { enableSpinner, notificationReducer: { showAlert }, view, DraftObjType = '' } = this.props;
        const { seriesDefault, seriesDefaultName, action } = this.state;
        const isDraftOWTQ = view === 'draft' && (Number(model?.ObjType) === 1250000001 || Number(DraftObjType) === 1250000001) && !model?.newView;

        if (view === 'SalesHelmets' || view === 'ExitHelmets') {
            model.DocType2 = 'S';
        }

        if (model.Items.length === 0 && view !== "payment" && model.DocType === 'I' && view !== 'outgoingPayment' && (view === "transfers" && model.Transit !== '2')) {
            showAlert({ type: 'info', message: "No se agregó artículos en el nuevo documento" });
            return;
        }

        if (model.ShipToCode === '' && (view !== "suggestRefill" && view !== "payment" && view !== "transfers" && view !== "purchaseReturn" && view !== "GoodsReceipt" && view !== "PurchaseOrder" && view !== 'PurchaseQuotation' && view !== "PurchaseRequest" && view !== 'transfersRequest' && view !== "purchaseReturn" && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'inventoryRevaluation' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'outgoingPayment' && view !== 'reportSelectionCriteria' && !isDraftOWTQ)) {
            showAlert({ type: 'info', message: "No se agregó dirección de entrega en el nuevo documento" });
            return;
        }

        if (model.ItemsPayments.length === 0 && view === "payment" && view === 'outgoingPayment' && !model.PayNoDoc) {
            showAlert({ type: 'info', message: "No se agregó documentos en el nuevo pago" });
            return;
        }

        if (!model.SerieCode && (view === "transfers" && model.Transit !== '2')) {
            showAlert({ type: 'info', message: "Selecciona una serie válida" });
            return;
        }

        if ((model?.newView === "PurchaseQuotation" || model?.newView === "PurchaseQuotationDraft")) {
            if (!model.CardCode) {
                showAlert({ type: 'info', message: "No se ha seleccionado un Proveedor" });
                return;
            }
            model.ReqDate = model.DocDate;
        }

        if (model.DocType === 'I' && view !== 'inventoryData' && view !== 'bussinesPartner' && view === 'SalesHelmets' && view === 'ExitHelmets' && view === 'transfersRequest' && view === 'transfers' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
            let error = false;
            model.Items.map((item, index) => {
                if (item.WhsCode === "") {
                    showAlert({ type: 'warning', message: "Seleccione un almacén valido" });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        if (view === 'transfersOutput') {
            let error = false;
            model.Items.map((item, index) => {
                if (Number(item.Quantity) > Number(item.OnHand)) {
                    showAlert({ type: 'warning', message: "La cantidad a retirar es mayor a la cantidad en Stock" });
                    error = true;
                }
            });
            if (error) {
                return;
            }
        }

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};
        let table = this.selectTable(model.OriginDocumentCreate);

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            model: model,
            user_Email: user.E_Mail
        };

        enableSpinner(true);
        const response = await apiClient.autorizationModels(data);
        enableSpinner(false);

        let autorization = [];
        if (response.status === 1) {
            let respo = response.autorization;
            for (let i = 0; i < respo.length; i++) {
                const element = respo[i];
                autorization.push({
                    name: element.nameCond,
                    id: element.wtm,
                    comment: '',
                });
            }

            let autho = {};
            autorization = autorization.filter((element) => autho[element.id] ? false : autho[element.id] = true);
            this.setState({
                comments: autorization,
                auths: respo,
            });
            $('#authorizationModel').modal('show');
        } else {
            this.sendModelToCreateDocument(model);
        }
    }

    sendModelToCreateDocument = async model => {
        const { enableSpinner, view, DraftObjType = '' } = this.props;
        const { comments, auths } = this.state;
        model.view = view;

        const VISTAS_CON_CORRELATIVO = ['transfers', 'transfersRequest'];
        const esBorradorOWTQ = view === 'draft' && Number(model?.ObjType) === 1250000001;
        const esVistaConCorrelativo = VISTAS_CON_CORRELATIVO.includes(model?.OriginDocumentCreate) || esBorradorOWTQ;
        const esPreliminar = model?.createDraft === true || model?.createDraft === 'draft';
        const debeQuitarCorrelativo = esVistaConCorrelativo && !esPreliminar;
        if (debeQuitarCorrelativo) {
            if (model.userFields) model.userFields.userFields5 = '';
            model.U_BPP_MDCD = '';
        }

        let orign = model.Filler;
        let transit = model.wareHouseFinalOptionalValue;
        let destination = model.ToWhsCode;

        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};

        let table = this.selectTable(model.OriginDocumentCreate);
        let draftTable = view === 'draft' && Number(DraftObjType) > 0 ? this.selectDraftTable(DraftObjType) : {};
        let isDraftDoc = view === 'draft' && draftTable?.name && draftTable?.name !== 'ODRF';

        if (model.wareHouseFinalOptional) {
            model.ToWhsCode = model.wareHouseFinalOptionalValue;//Destino
        }

        let data = {
            destino: isDraftDoc ? draftTable.name : table.name,
            docSubType: isDraftDoc ? draftTable.docSubType : table.docSubType,
            model: model,
            user_Email: user.E_Mail,
            comments,
            auths,
            isDraftDoc,
        };
        let responseArray = [];
        let docEntry = model.DocEntry || '';
        let DocEntryRel = model.DocEntryRel || '';


        enableSpinner(true);
        let response = {};
        let responseNote = {};
        let docType = '';
        responseNote.docEntry = '';
        let casco = false;

        if (view === 'SalesHelmets' || view === 'ExitHelmets') {
            data = {
                destino: table.name,
                docSubType: table.docSubType,
                model: model,
                user_Email: user.E_Mail,
                destino_2: table.name2,
                docSubType_2: table.docSubType2,

            };
            docType = table.name2;

            if (docType === 'OINVDN') {
                docType = 'Nota de Débito'
            } else if (docType === 'ORIN') {
                docType = 'Nota de Crédito'
            }
            casco = true;
        }
        if (model.OriginDocumentCreate === 'transfers') {
            response = await apiClient.createNewStockTransfer(data);
        } else {
            if (model.DocumentType === "F") {
                response = await apiClient.createNewDocument(data);
            } else {
                response = await apiClient.createNewDocumentOfraft(data);
            }
        }


        // if ((model.isSelectTo || model.isSelectOf) && response.status === 1) {
        //     model.DocEntry = docEntry;
        //     model.DocEntryRel = DocEntryRel;
        //     model.DocStatus = 'C';
        //     model.DocType = 'I';
        //     model.DocStatusCasco = 'C';
        //     model.servicesToUpdate= 2
        //     model.refreshCascos = true
        //      await this.acceptEditMode(model);
        // }

        // if (comments.length > 0 && response.docEntryODRF) {
        //     let res = await apiClient.setCommentsAutorizations(comments, response.docEntryODRF);
        // }

        enableSpinner(false);
        if (view == 'reportSelectionCriteria') {
            return await response
        }
        let docTypeCasco;
        if (view === 'SalesHelmets' || view === 'ExitHelmets') {
            docType = docType === 'Nota de Débito' ? 'Salida de Mercancía' : 'Entrada de Mercancía'
            docTypeCasco = docType === 'Nota de Débito' ? 'Nota de Débito' : 'Nota de Crédito'
        }

        try {
            if (view === 'SalesHelmets' || view === 'ExitHelmets')//Documento Entrada de mercacia
            {
                responseArray.push({
                    docNum: view === 'SalesHelmets' || view === 'ExitHelmets' ? docType : response.data ? response.data.DocNum : '',
                    billing: response.data ? response.data.docNumBilling : '',
                    message: response.message ? response.message : '',
                });
            }
            if ((view === 'SalesHelmets' || view === 'ExitHelmets') && (response.docNumCasco !== "")) {// Documento Nota de credito o debito 
                responseArray.push({
                    docNum: view === 'SalesHelmets' || view === 'ExitHelmets' ? docTypeCasco : response.data ? response.data.DocNum : '',
                    billing: view === 'SalesHelmets' || view === 'ExitHelmets' ? response.docNumCasco : response.data ? response.data.docNumBilling : '',
                    message: response.message ? response.message : '',
                });
            } else if ((view === 'SalesHelmets' || view === 'ExitHelmets') && (response.docNumCasco === "")) {// Documento Nota de credito o debito 
                responseArray.push({
                    docNum: view === 'SalesHelmets' || view === 'ExitHelmets' ? docTypeCasco : response.data ? response.data.DocNum : '',
                    billing: view === 'SalesHelmets' || view === 'ExitHelmets' ? response.docNumCasco : response.data ? response.data.docNumBilling : '',
                    message: 'Ocurrió un error al realizar el documento',
                });
            }
            const extractMessage = (msg) => {
                if (!msg) return '';
                if (typeof msg === 'string') return msg;
                if (msg?.error?.message?.value) return msg.error.message.value;
                if (msg?.error?.message) return msg.error.message;
                if (msg?.message) return msg.message;
                return JSON.stringify(msg);
            };

            if (!casco) {
                responseArray.push({
                    docNum: response.data ? response.data.DocNum : '',
                    billing: response.data ? response.data.docNumBilling : '',
                    message: extractMessage(response.message),
                });
            }
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }


        //this is optional only in transfers when select  almacen final function branch two create two documents on trasnfers
        if (model.wareHouseFinalOptional) {

            model.Filler = model.wareHouseFinalOptionalValue; //Origen
            model.ToWhsCode = destination;//Destino
            data = {
                destino: table.name,
                docSubType: table.docSubType,
                model: model,
            };

            if (model.DocumentType === "F") {
                response = await apiClient.createNewDocument(data);
            } else {
                response = await apiClient.createNewDocumentOfraft(data);
            }

            enableSpinner(false);

            try {
                responseArray.push({
                    docNum: response.data ? response.data.DocNum : '',
                    billing: response.data ? response.data.docNumBilling : '',
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }
            model.Filler = orign;
            model.wareHouseFinalOptionalValue = transit;
            model.ToWhsCode = destination;
        }


        this.toggleDocumentSelectedAll(false);

        //Validacion para mensaje cuando se crea el pago en Entrada cascos
        if (view === 'SalesHelmets' && !model.isSelectTo) {
            if (!isNaN(response.PayResponse.message) && response.PayResponse.message !== '') {

                try {
                    responseArray.push({
                        docNum: 'Pago',
                        billing: response.PayResponse.message || '',
                        message: 'Pago realizado correctamente',
                    });
                } catch (e) {

                    responseArray.push({
                        docNum: '',
                        billing: '',
                        message: '',
                    });
                }

            } else {
                try {
                    responseArray.push({
                        docNum: 'Pago',
                        billing: '',
                        message: response.PayResponse ? 'Ocurrió un error al realizar el pago ' + response.PayResponse.message : '',
                    });
                } catch (e) {

                    responseArray.push({
                        docNum: '',
                        billing: '',
                        message: '',
                    });
                }

            }
        }

        this.setState({
            billingResponseArray: responseArray,
            checkboxDataTables: (new Map()),
            comments: [],
            auths: [],
        })

        $('#billingResponseModal').modal('show');

        if (response.status === 1) {
            this.sendNotification(view, data, response);
            //#region ATTACHMENT
            var fileInput = document.getElementById("fileImput2");
            if (fileInput) {
                fileInput.value = null;
            }
            this.setFiles([]);
            //#endregion ATTACHMENT
            $('#DocumentCreateModal').modal('hide');
            $('#TransfersDocumentModal').modal('hide');
        }

    };
    showDocsRecommend = async (arrayDocs, listOrders) => {
        const { enableSpinner, showAlert } = this.props
        let createdDocs = []
        let updateDocs = []
        enableSpinner(true)
        await apiClient.updateRecommendationType(listOrders)
        enableSpinner(false)
        for (let index = 0; index < arrayDocs.length; index++) {
            const curr = arrayDocs[index];
            try {
                const { OrderType } = curr.line;
                if (OrderType !== "W") {
                    let response = await this.createDocRecommend(curr.document);
                    if (response.status === SERVICE_RESPONSE.SUCCESS) {
                        const aux = {
                            docNum: response.data.DocNum,
                            billing: response.data.docNumBilling,
                            message: response.message,
                        }
                        createdDocs.push(aux)

                        const aux2 = {
                            DocEntry: curr.line.DocEntry,
                            AbsEntry: curr.line.AbsEntry,
                            OrderType: curr.line.OrderType
                        }
                        updateDocs.push(aux2)
                    } else {
                        const aux = {
                            docNum: index + 1,
                            billing: `ERROR`,
                            message: response.message || "Ocurrio un error al procesar la información",
                        }
                        createdDocs.push(aux)
                    }
                } else {
                    let validItem = await apiClient.getProductionItem({ ItemCode: curr.line.ItemCode || "" });
                    if (validItem.status) {
                        validItem = validItem.data;
                        let response = await apiClient.createNewDocProd({
                            destino: "OWOR",
                            model: {
                                series: null,
                                itemCode: validItem.ItemCode,
                                orderType: validItem.OrderType,
                                docDate: moment().format("YYYY-MM-DD"),
                                dueDate: moment().format("YYYY-MM-DD"),
                                originEntry: null,
                                origin: "M",
                                comments: "Origen PNM - BRANCH",
                                whs: curr.line.Warehouse,
                                items: validItem.ItemLines
                            }
                        });
                        if (response.status === SERVICE_RESPONSE.SUCCESS) {
                            const aux = {
                                docNum: response.data.DocNum,
                                billing: response.data.docNumBilling || index + 1,
                                message: response.message || "Documento creado",
                            }
                            createdDocs.push(aux)
                        } else {
                            const aux = {
                                docNum: index + 1,
                                billing: `ERROR`,
                                message: response.message || "Ocurrio un error al procesar la información",
                            }
                            createdDocs.push(aux)
                        }
                    } else {
                        const aux = {
                            docNum: index + 1,
                            billing: `ERROR`,
                            message: validItem.message || "Ocurrio un error al procesar la información",
                        }
                        createdDocs.push(aux)
                    }
                }
            } catch (error) {
            }

        }
        enableSpinner(true)
        let responseAPI = await apiClient.updateRecommendationTable(updateDocs)
        enableSpinner(false)
        if (responseAPI.status === SERVICE_RESPONSE.ERROR) {
            showAlert({ type: 'error', message: 'No se actualizaron los registros;Documentos Creados' });
        }

        this.setState({
            billingResponseArray: createdDocs,
            checkboxDataTables: (new Map()),
            comments: [],
            auths: [],

        })
        $('#billingResponseModal').modal('show');
    }

    createDocRecommend = async (currOrderModel) => {
        return new Promise((resolve) => {
            resolve(this.sendModelToCreateDocument(currOrderModel))
        });
    }

    updateCommentsAuthorizationModel = (event, index) => {
        const { comments } = this.state;
        comments[index].comment = event.nativeEvent.target.value;
        this.setState({
            comments
        });
    }

    billingDetails = async (id, action) => {
        await this.toggleDocumentSelectedAll(false);
        await this.toggleDocumentSelected(id);

        this.selectSeries(action);
    }

    CancelEditMode = async () => {
        const { newOrderModelEditMode } = this.state;
        let newOrderResponse = await this.createNewOrderDetails(newOrderModelEditMode.detailsResponse, newOrderModelEditMode.open);
        //#region ATTACHMENT
        const auxObj = newOrderResponse.Attachment?.filter(objeto => !("New" in objeto));
        newOrderResponse.Attachment = auxObj;
        var fileInput = document.getElementById("fileImput2");
        if (fileInput) {
            fileInput.value = null;
        }
        this.setFiles([]);
        //#endregion ATTACHMENT

        this.setState({
            newOrderModel: newOrderResponse,
        }, () => {
            setTimeout(() => {
                this.documentCreateModal.refreshTotal(newOrderResponse);
            }, 150);
        })

    };

    CancelEditModePartner = () => {
        const { newBusinessPartnerEditMode } = this.state;
        let newOrderResponse = this.fillBusinessPartnerDetailsModel(newBusinessPartnerEditMode.businesPartnerResponse, newBusinessPartnerEditMode.open);
        this.setState({
            partnerModel: newOrderResponse,
        });
    };

    CancelEditModeInventory = async () => {
        const { newInventoryDataEditMode } = this.state;
        let newOrderResponse = await this.fillInventoryDataDetailsModel(newInventoryDataEditMode.inventoryDataResponse, newInventoryDataEditMode.open);
        this.setState({
            inventoryModel: newOrderResponse,
        });
    };

    //#region  ###### CancelEditMode
    CancelEditModeFiguraTransporte = () => {
        const { newTipoFiguraEditMode } = this.state;
        let newOrderResponse = this.fillTipoFiguraDetailsModel(newTipoFiguraEditMode.tipoFiguraResponse.data.manager, newTipoFiguraEditMode.open);
        this.setState({
            tipoFiguraModel: newOrderResponse,
        });
    };

    CancelEditModeTransporte = () => {
        const { newTransporteEditMode } = this.state;
        let newOrderResponse = this.fillTransporteDetailsModel(newTransporteEditMode.transporteResponse.data.manager, newTransporteEditMode.open);
        this.setState({
            transporteModel: newOrderResponse,
        });
    };

    CancelEditModeCartaPorte = (recoveryModel) => {
        // const { cartaPorteModel } = this.state;
        // $('#CartaPorte').modal('hide');
        // let newOrderResponse = this.fillCartaPorteDetailsModel(newCartaPorteEditMode.cartaPorteResponse.data.manager, newCartaPorteEditMode.open);
        // this.setState({
        //     cartaPorteModel: newOrderResponse,
        // });
        this.setState({ cartaPorteModel: recoveryModel, });
    };
    //#endregion

    acceptEditModePartner = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newBusinessPartnerEditMode } = this.state;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};

        let data = {
            model: model,
            email: user.E_Mail
        };

        enableSpinner(true);
        let response = await apiClient.updateBusinessPartner(data);
        enableSpinner(false);

        const updateAttachments = Array.isArray(model?.Attachments) ? model.Attachments.filter(({ AbsEntry }) => !AbsEntry).length : 0;
        if (response.status === 1 && (updateAttachments || ((model?.Attachments?.length || 0) !== (model.NumAtcOrg || 0)))) {
            showAlert({ type: "info", message: "Socio actualizado, cargando anexos" });
            await this.uploadAttachmentsFiles("OCRD", `'${model.CardCode}'`, model.Attachments, model.AtcEntry);
        }

        let responseArray = [];

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        if (response.status === 0) {
            $('#billingResponseModal').modal('show');
            this.setState({
                billingResponseArray: responseArray,
                checkboxDataTables: (new Map()),
            })
        }

        if (response.status === 1) {
            await this.openBusinessPartnerDetails(newBusinessPartnerEditMode.open, true);
            showAlert({ type: 'success', message: response.message });
            this.bussinesPartnerModal.setState({
                editMode: false
            })
        }

    }

    sendAuthModelPartner = async (model) => {
        await this.setState({
            comments: [{ name: "Modificación de socio de negocio", comment: "" }],
            authModelPartner: JSON.parse(JSON.stringify(model)),
        });
        $('#authorizationModalParnter').modal('show');
        $("#authorizationModalParnter").on("hidden.bs.modal", async () => {
            await this.setState({
                comments: [],
                authModelPartner: null,
            });
        })
    }

    acceptEditModeInventory = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newInventoryDataEditMode } = this.state;
        if (Number(model.SalesUnitWeight || '0') > 0 && (!model.SalesWeightUnit || model.SalesWeightUnit === '')) {
            showAlert({ type: 'warning', message: 'Seleccione una unidad de medida valida' });
            return;
        }
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};

        let data = {
            model: model,
            email: user.E_Mail
        };
        enableSpinner(true);
        let response = await apiClient.updateInventoryData(data);
        enableSpinner(false);


        let responseArray = [];

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: 'Invalid data ',
            });
        }

        if (response.status === 0) {
            $('#billingResponseModal').modal('show');
            this.setState({
                billingResponseArray: responseArray,
                checkboxDataTables: (new Map())
            })
        }

        if (response.status === 1) {
            await this.openInventoryDataDetails(newInventoryDataEditMode.open, true);
            showAlert({ type: 'success', message: response.message });
            this.inventoryDataModal.setState({
                editMode: false
            })
        }

    }

    //#region   ###### acceptEditMode
    acceptEditModeFiguraTransporte = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newTipoFiguraEditMode } = this.state;
        const data = {
            model: model,
        };
        enableSpinner(true);
        let response = await apiClient.updateFiguraTransporteManager(data);
        enableSpinner(false);
        let responseArray = [];
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.setState({
            billingResponseArray: responseArray,
        })
        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            await this.openTipoFiguraDetails(newTipoFiguraEditMode.open, true);
            // showAlert({type: 'success', message: response.message});
            this.tipoFiguraModal.setState({
                editMode: false
            })
        }
    }

    acceptDeleteFigTranport = () => {
        const { tipoFiguraModel } = this.state;
        this.deleteFiguraTransporteModel(tipoFiguraModel.CodigoFiguraTransporte)
    }

    acceptEditModeTransporte = async model => {
        const { enableSpinner } = this.props;
        const { newTransporteEditMode, tipoTransporte } = this.state;
        const data = {
            model: model,
            tipoTransporte
        };
        enableSpinner(true);
        const response = await apiClient.updateTransporteManager(data);
        enableSpinner(false);
        let responseArray = [];
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.setState({
            billingResponseArray: responseArray,
        })
        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            await this.openTransporteDetails(newTransporteEditMode.open, true);
            this.transporteModal.setState({
                editMode: false
            })
        }
    }

    acceptDeleteTranport = () => {
        const { transporteModel, tipoTransporte } = this.state;
        if (tipoTransporte === 'Aereo') { this.deleteTransporteModel(transporteModel.CodigoTransporteAereo) }
        else if (tipoTransporte === 'Autotransporte') { this.deleteTransporteModel(transporteModel.CodigoAutotransporte) }
        else if (tipoTransporte === 'Ferroviario') { this.deleteTransporteModel(transporteModel.CodigoTransporteFerroviario) }
        else if (tipoTransporte === 'Maritimo') { this.deleteTransporteModel(transporteModel.CodigoTransporteMaritimo) }
    }

    acceptEditModeCartaPorte = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newCartaPorteEditMode } = this.state;
        const data = {
            model: model,
        };
        enableSpinner(true);
        const response = await apiClient.updateCartaPorteManager(data);
        enableSpinner(false);
        let responseArray = [];
        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }
        this.setState({
            billingResponseArray: responseArray,
        })
        $('#billingResponseModal').modal('show');
        if (response.status === 1) {
            await this.openCartaPorteDetails(newCartaPorteEditMode.open, true);
            // showAlert({type: 'success', message: response.message});
            this.cartaPorteModal.setState({
                editMode: false
            })
        }
    }
    //#endregion

    acceptEditMode = async model => {
        const { enableSpinner, notificationReducer: { showAlert }, view, DraftObjType = '' } = this.props;
        const { seriesDefault, seriesDefaultName, action, newOrderModelEditMode } = this.state;
        const isDraftOWTQ = view === 'draft' && (Number(model?.ObjType) === 1250000001 || Number(DraftObjType) === 1250000001) && !model?.newView;


        if (model.Items.length === 0 && !model.PayNoDoc) {
            showAlert({ type: 'info', message: "No se agregó artículos en el documento" });
            return;
        }

        if (view !== 'invoiceBorrador' && view !== 'invoiceAuthorization' && view !== 'transfersEntry' && view !== 'transfersOutput' && view !== 'transfers' && view !== 'SalesHelmets' && view !== 'ExitHelmets' && view !== 'GoodsReceipt' && view !== 'purchaseReturn' && view !== 'PurchaseRequest' && view !== 'payment' && view !== 'transfersRequest' && !isDraftOWTQ) {
            let flagTaxCode = false;
            model.Items.map((item) => {
                if (!item.TaxCode || item.TaxCode === '') {
                    flagTaxCode = true;
                    return;
                }
            });

            if (flagTaxCode) {
                showAlert({ type: 'warning', message: " Uno de los artículos no posee el indicador de impuestos" });
                return;
            }
        }

        //#region GALLONS CONVERSION
        // if ((model?.isSalesDocument || model?.isTransferDocument) && model?.DocType === 'I') {
        if ((model?.isSalesDocument) && model?.DocType === 'I') {
            let isGallonValid = true;
            let itemMessage = '';
            for (const item of model.Items) {
                if (Granel?.includes(Number(item?.ItmsGrpCod)) && item?.U_RS_UMED === 'GLN' && (!item?.U_RS_CANTG || Number(item?.U_RS_CANTG) <= 0)) {
                    itemMessage = `La cantidad de galones del artículo ${item?.ItemCode || item?.ItemName} debe de ser mayor a 0`;
                    isGallonValid = false;
                    break;
                }
                if (Granel?.includes(Number(item?.ItmsGrpCod)) && item?.U_RS_UMED === 'GLN' && (!item?.U_RS_PRECIOGL || Number(item?.U_RS_PRECIOGL) <= 0)) {
                    itemMessage = `El artículo ${item?.ItemCode || item?.ItemName} no cuenta con un precio valido para la conversión a galones`;
                    isGallonValid = false;
                    break;
                }
            }
            if (!isGallonValid) {
                showAlert({ type: "warning", message: itemMessage, timeOut: 5000 });
                return
            };
        }
        //#endregion GALLONS CONVERSION

        if (model?.DocType === 'I' && model?.isSalesDocument) {
            if (model.Items?.length) {
                let error = false;
                model.Items.map(Item => {
                    if (Item.WhsCode === '' && Item.InvntItem === 'Y') {
                        showAlert({
                            type: 'warning',
                            message: 'Seleccione un almacén para el artículo ' + Item.ItemCode
                        });
                        error = true;
                    }
                });
                if (error) {
                    return;
                }
            }

            // Si es Tipo de Atencion RUT - ABS - RCF entonces se revisan los almacenes validos para planta o zonal
            if (model?.DocType === 'I'
                && model?.isSalesDocument
                && !(await this.setWhsByRouteDocs(model?.userFields?.userFields28, true))
            ) {
                return;
            }
        }

        if (model?.isPurchaseDocument) {
            if (!model?.Project) {
                showAlert({ type: 'warning', message: `Es necesario un valor para el campo de Proyecto`, timeOut: 5000 });
                return;
            }
            if (
                (
                    model?.newView === 'PurchaseQuotation' || model?.newView === 'PurchaseQuotationDraft' ||
                    view === 'PurchaseQuotation' || view === 'PurchaseQuotationDraft' || Number(model?.ObjType) === 540000006
                    || view === 'PurchaseRequest' || Number(model?.ObjType) === 1470000113
                ) &&
                (
                    !model?.ReqDate ||
                    isNaN(new Date(model.ReqDate)?.getTime())
                )
            ) {
                showAlert({ type: 'warning', message: 'Es necesario especificar la Fecha Necesaria', timeOut: 5000 });
                return;
            }
        }

        //#region DIMENSIONS
        if (model?.DocType === 'I' && (model?.isSalesDocument || model?.isPurchaseDocument || model?.isTransferDocument)) {
            let flagD = false;

            const validations = [
                { field: 'OcrCode', label: 'CANAL' },
                { field: 'OcrCode2', label: 'SEDES' },
                { field: 'OcrCode3', label: 'SUCURSAL' },
                { field: 'OcrCode4', label: 'NEGOCIO' },
                { field: 'OcrCode5', label: 'CECO' },
            ];

            for (const item of model?.Items) {
                if (!item.isTemporary) {
                    const invalid = validations?.find(v => !item[v.field]);
                    if (invalid) {
                        flagD = true;
                        showAlert({ type: "warning", message: `Es necesario un valor para  el campo "${invalid.label}" para el artículo ${item.ItemCode || item.ItemName}`, timeOut: 5000 });
                        return;
                    }
                }
            }

            if (flagD) {
                return;
            }
        }
        //#endregion DIMENSIONS

        //#region Campos RAMO
        const isOWTRoOWTQ =
            view === 'transfers' ||
            view === 'transfersRequest' ||
            Number(model?.ObjType) === 67 ||
            Number(model?.ObjType) === 1250000001 ||
            isDraftOWTQ;

        const isOIGNoOIGE =
            // view === 'transfersEntry' ||
            // view === 'transfersOutput' ||
            // Number(model?.ObjType) === 59 ||
            // Number(model?.ObjType) === 60;
            false; // Descomentar en caso de que se active edición de estos documentos

        if ((isOWTRoOWTQ || isOIGNoOIGE) && !(await this.documentCreateModal?.validateRAMOFields(model, invFields, this.getUserFieldHeaderValue, isOWTRoOWTQ, isOIGNoOIGE))) {
            return; // No continuar si fallaron las validaciones de RAMO
        }
        //#endregion Campos RAMO

        if (model?.DocType === 'I' && model?.isPurchaseDocument && !model?.newView && (view === 'PurchaseRequest' || Number(model?.ObjType) === 1470000113)) {
            let flagD = false;
            const validations = [
                { field: 'TaxCode', label: 'Indicador I.', preffix: 'el' },
            ];

            for (const item of model?.Items) {
                if (!item.isTemporary) {
                    const invalid = validations?.find(v => !item[v.field]);
                    if (invalid) {
                        flagD = true;
                        showAlert({ type: "warning", message: `Es necesario un valor para ${invalid.preffix ? `${invalid.preffix} ` : ''}"${invalid.label}" para el artículo ${item.ItemCode || item.ItemName}`, timeOut: 5000 });
                        return;
                    }
                }
            }

            if (flagD) {
                return;
            }
        }

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};
        let table = this.selectTable(view);
        let extras = this.selectTableTimbre(table.name);
        let draftTable = view === 'draft' && (model?.ObjType || DraftObjType) ? this.selectDraftTable(model?.ObjType || DraftObjType) : {};
        let isDraftDoc = view === 'draft' && draftTable?.name && draftTable?.name !== 'ODRF';

        let data = {
            destino: isDraftDoc ? draftTable.name : table.name,
            docSubType: isDraftDoc ? draftTable.docSubType : table.docSubType,
            model: model,
            email: user.E_Mail,
            isDraftDoc
        };
        enableSpinner(true);
        let response = {};
        if (model.DocumentType === "F") {
            response = await apiClient.updateDocument(data);
        } else {
            response = await apiClient.updateDocumentOfraft(data);
        }

        enableSpinner(false);


        let responseArray = [];

        try {
            responseArray.push({
                docNum: response.data ? response.data.DocNum : '',
                billing: response.data ? response.data.docNumBilling : '',
                message: response.message ? response.message : '',
            });
        } catch (e) {
            responseArray.push({
                docNum: '',
                billing: '',
                message: '',
            });
        }

        if (response.status === 0) {
            $('#billingResponseModal').modal('show');
            this.setState({
                billingResponseArray: responseArray,
                checkboxDataTables: (new Map()),
            })
        }

        if (response.status === 1 && (model.refreshCascos === true || model.DocStatusCasco === 'C')) {
            $('#DocumentCreateModal').modal('hide');
            this.searchDocuments();
        }
        else if (response.status === 1 && model.refreshCascos === false) {
            await this.openDocumentDetails(newOrderModelEditMode.open, true);
            showAlert({ type: 'success', message: response.message });
        }
    };

    refreshPartnerModel = partnerModel => {
        this.setState({
            partnerModel
        })
    };

    refreshInventoryModel = inventoryModel => {
        this.setState({
            inventoryModel
        })
    };

    //#region   #### refreshModel
    refreshFiguraTransporteModel = tipoFiguraModel => {
        this.setState({
            tipoFiguraModel
        })
    };

    refreshTransporteModel = transporteModel => {
        this.setState({
            transporteModel
        })
    };

    refreshTipoTransporte = tipoTransporte => {
        let transporteModel = {};
        if (tipoTransporte === 'Aereo') {
            transporteModel = new TransporteAereo();
        } else if (tipoTransporte === 'Autotransporte') {
            transporteModel = new Autotransporte();
        } else if (tipoTransporte === 'Ferroviario') {
            transporteModel = new TransporteFerroviario();
        } else if (tipoTransporte === 'Maritimo') {
            transporteModel = new TransporteMaritimo();
        }
        this.setState({
            tipoTransporte,
            transporteModel
        });
    };

    refreshCartaPorteModel = cartaPorteModel => {
        this.setState({
            cartaPorteModel
        })
    };
    //#endregion

    refreshModel = newOrderModel => {

        this.setState({
            newOrderModel
        })
    };
    fillGLAccountsPartner = async () => {
        const { glAccounts, partnerModel } = this.state
        partnerModel.DebPayAcct = partnerModel.CardType === 'S' ? glAccounts.AcreedorNacional : glAccounts.ClienteNacional || '';
        partnerModel.DebPayAcctName = partnerModel.CardType === 'S' ? glAccounts.AcreedorNacionalName : glAccounts.ClienteNacionalName || '';

        partnerModel.DownPaymentInterimAccount = partnerModel.CardType === 'S' ? glAccounts.AcreedorAnticipo : glAccounts.ClienteAnticipo || '';
        partnerModel.DownPaymentInterimAccountName = partnerModel.CardType === 'S' ? glAccounts.AcreedorAnticipoName : glAccounts.ClienteAnticipoName || '';

        this.refreshPartnerModel(partnerModel)
    }
    openBussinesPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;
        const userRole = user?.FMB_Role || user?.U_FMB_role;
        const counterRole = user?.FMB_CounterRol || user?.U_FMB_CounterRol;
        const hasPermission = userRole === 'admin1' || (userRole === 'counter1' && counterRole === 'manager');
        if (!user || !hasPermission) {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);
        let glAccounts = await apiClient.getGLAccounts({ type: 'All' });
        glAccounts = glAccounts?.data?.[0] ?? {}

        let partnerModel = new BusinessPartner();

        let userFieldsService = await apiClient.getUserFields({ name: 'OCRD' });
        userFieldsService = userFieldsService.data.header || [];

        let userFields = new UserFields();

        json.userFieldsPartners.map((item, index) => {
            userFieldsService.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length !== 0 ? 2 : item.fieldType;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValueDefault(userFields, index, userfieldItem.header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            });
        });

        partnerModel.userFields = userFields;

        // Poner por defecto la lista de precios
        let groupCodeResponse = await apiClient.getPriceList();

        if (Array.isArray(groupCodeResponse.data) && groupCodeResponse.data.length > 0) {
            const findPriceListDefault = groupCodeResponse.data.find(
                pricelist => pricelist.ListNum === 1
            );
            partnerModel.PriceListNum = findPriceListDefault?.ListNum || '';
            partnerModel.PriceListNumName = findPriceListDefault?.ListName || '';
        }

        // Asignar la moneda por defecto
        let currencyResponse = await apiClient.getCurrenciesPartner();

        if (Array.isArray(currencyResponse.data) && currencyResponse.data.length > 0) {
            const findCurrencyDefault = currencyResponse.data.find(
                currency => currency.CurrName === 'Monedas (todas)'
            );
            partnerModel.Currency = findCurrencyDefault?.CurrCode || '';
            partnerModel.CurrencyName = findCurrencyDefault?.CurrName || '';  // <-- Agregar esta línea
        }

        // Asignar el empleado de ventas por default
        let getEmployeeResponse = await apiClient.getEmployeeList();

        if (Array.isArray(getEmployeeResponse.data) && getEmployeeResponse.data.length > 0) {
            const findEmployeeDefault = getEmployeeResponse.data.find(
                employee => employee.SlpName === 'VENTA OFICINA'
            );
            partnerModel.SlpCode = findEmployeeDefault?.SlpCode || '';
            partnerModel.SlpName = findEmployeeDefault?.SlpName || '';
        }
        this.setState({
            partnerModel,
            partnerModalAction: 1,
            showPartnerModal: true, // show
            userFieldsPartner: userFieldsService,
            glAccounts,
        });

        $('#BussinesPartner').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    openInventoryData = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;


        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;

        if (!user || user.FMB_Role !== 'admin1') {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);
        let inventoryModel = new InventoryModel();
        let userFieldsService = await apiClient.getUserFields({ name: 'OITM' });
        let GroupsItemData = await apiClient.getGroupsItemData();
        const Fabricantes = await apiClient.getProducersData();

        userFieldsService = userFieldsService.data.header || [];
        let userFields = new UserFields();

        json.userFieldsInventory.map((item, index) => {
            userFieldsService.map(userfieldItem => {

                if (item.fieldId === userfieldItem.header.FieldID) {
                    item.name = userfieldItem.header.Descr;
                    item.fieldType = userfieldItem.options.length != 0 ? 2 : 1;
                    item.options = userfieldItem.options;
                    item.IdValue = index;
                    let newUserFields = this.setUserFieldValue(userFields, index, userfieldItem.header);
                    if (item.fieldType === 2) {
                        item.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            });
        });

        inventoryModel.userFields = userFields;
        await this.setState({
            inventoryModel,
            inventoryModalAction: 1, // show
            ListItemsGroup: GroupsItemData.data.GrupoArticulo,
            ListUnitMeasuGroup: GroupsItemData.data.GrupoUnidadesMedida,
            showInventoryModal: true,
            Producers: Fabricantes?.data ?? [],
        });

        $('#InventoryData').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    //#region Open Modal
    openFiguraTransporte = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;
        let tipoFiguraModel = new TiposFigura();
        if (!user) {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }
        enableSpinner(true);
        this.setState({
            tipoFiguraModel,
            tipoFiguraModalAction: 1 // show
        });
        $('#FiguraTransporte').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    openTransporte = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;
        let transporteModel = new Autotransporte();
        if (!user) {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }
        enableSpinner(true);
        await this.getPolygons();
        this.setState({
            transporteModel,
            transporteModalAction: 1 // show
        });
        $('#Transporte').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    citiOption = async (option) => {
        const { checkboxDataTables, docFilter } = this.state;
        const { generateTXT } = this.props
        switch (option) {
            case 1://GENERATE TXT FOR CITI
                generateTXT(checkboxDataTables, docFilter)
                break;
            case 2://Subir archivos de pagos
                await this.setState({ showFileUploader: true });
                $("#FileUploaderModal").modal("show");
                break;
            default:
                break;
        }
    }

    openCartaPorte = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;
        let cartaPorteModel = new CartaPorte();
        cartaPorteModel.Catalogo_USO_CFDI = USO_CFDI_CATALOG;

        if (!user) {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);
        await this.GetRegimenFiscal();
        const usoInternoAuthorizedResponse = await apiClient.getValidateUser();
        this.setState({
            cartaPorteModel,
            cartaPorteModalAction: 1 // show
        });
        const usoInternoAuthorized = usoInternoAuthorizedResponse.status === 1;
        this.cartaPorteModal.setState({ usoInternoAuthorized, usoInterno: false });

        $('#CartaPorte').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    //#endregion

    //#region Close Documents
    CloseDocuments = async () => {
        const { notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state;

        let allDocs = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                if (data[id].DocStatus !== "O") {
                    return showAlert({ type: 'warning', message: "Seleccione solo documentos abiertos" });
                }

                allDocs.push({ docEntry: data[id].DocEntry, docNum: data[id].DocNum });
            }
        }

        if (allDocs.length === 0) {
            return showAlert({ type: 'warning', message: "Seleccione un documento abierto para continuar" });
        }

        await this.setState({
            showWarningModal: true,
            WarningModalOptions: {
                message: "La operación de cerrar documentos no se puede revertir, ¿Seguro que deseas continuar?",
                action: this.ContinueCloseDocuments,
            },
        });
        $("#warningModal").modal("show");
        $("#warningModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showWarningModal: false,
                WarningModalOptions: {},
            });
        })
    }

    ContinueCloseDocuments = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state;

        const docType = (this.selectTable(this.props.view))?.name || null;
        let allDocs = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                if (data[id].DocStatus !== "O") {
                    return showAlert({ type: 'warning', message: "Seleccione solo documentos abiertos" });
                }

                allDocs.push({ docEntry: data[id].DocEntry, docNum: data[id].DocNum });
            }
        }

        if (allDocs.length === 0) {
            return showAlert({ type: 'warning', message: "Seleccione un documento abierto para continuar" });
        }

        showAlert({ type: 'info', message: "Procesando documentos, esto puede tardar unos minutos" });
        let error = false;

        enableSpinner(true);
        for (let i = 0; i < allDocs.length; i += 5) {
            if (i !== 0) { showAlert({ type: 'info', message: "Seguimos procesando los documentos, no cierre ni recargue la pagina por favor", timeOut: 10000 }); }
            const docs = allDocs.slice(i, i + 5);
            let responseDocuments = await apiClient.closeDocuments({ docType, docs });

            if (responseDocuments.status === SERVICE_RESPONSE.ERROR) {
                showAlert({ type: 'error', message: `Occurio un error inseperado al procesar los dumentos: ${docs.map(doc => doc.docNum).join(', ')}` });
                error = true;
            } else {
                const docsWithError = responseDocuments.data.filter(({ status }) => status === SERVICE_RESPONSE.ERROR);
                if (docsWithError.length > 0) {
                    for (const doc of docsWithError) {
                        showAlert({ type: 'warning', message: doc.message });
                    }
                    error = true;
                }
            }
        }
        enableSpinner(false);

        if (error) {
            showAlert({ type: 'info', message: "El proceso ha termiado con algunos errores, vuelva a intentarlo" });
        } else {
            showAlert({ type: 'success', message: "Documentos cerrados correctamente" });
        }

        this.searchDocuments();
    }
    //#endregion

    //#region Close Documents As Invoice
    closeDocumentsAsInvoice = async () => {
        const { notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state;

        let allDocs = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                if (data[id].DocStatus !== "O") {
                    return showAlert({ type: 'warning', message: "Seleccione solo documentos abiertos" });
                }

                allDocs.push({ docEntry: data[id].DocEntry, docNum: data[id].DocNum });
            }
        }

        if (allDocs.length === 0) {
            return showAlert({ type: 'warning', message: "Seleccione un documento abierto para continuar" });
        }

        await this.setState({
            showWarningModal: true,
            WarningModalOptions: {
                message: "¿Seguro que deseas copiar los siguientes Documentos a Factura?",
                action: this.ContinueCloseDocumentsAsInvoice,
            },
        });
        $("#warningModal").modal("show");
        $("#warningModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showWarningModal: false,
                WarningModalOptions: {},
            });
        })
    }

    ContinueCloseDocumentsAsInvoice = async () => {
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        const { enableSpinner, notificationReducer: { showAlert }, view, data } = this.props;
        const { checkboxDataTables } = this.state;

        const objInfo = (this.selectTable(view));
        let allDocs = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                if (data[id].DocStatus !== "O") {
                    return showAlert({ type: 'warning', message: "Seleccione solo documentos abiertos" });
                }

                allDocs.push({ docEntry: data[id].DocEntry, docNum: data[id].DocNum });
            }
        }

        if (allDocs.length === 0) {
            return showAlert({ type: 'warning', message: "Seleccione un documento abierto para continuar" });
        }

        showAlert({ type: 'info', message: "Validando información" });
        let series = (user.U_FMB_ValidateSeriesOINV || "").split("|").filter(serie => !!serie);

        enableSpinner(true);
        let docsValidation = await apiClient.validateDocsToBill({ series, docs: allDocs, objInfo });
        enableSpinner(false);

        if (!docsValidation?.status) {
            return showAlert({ type: "error", message: docsValidation?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 5000 });
        } else {
            if (docsValidation.status === 2) {
                showAlert({ type: "warning", message: "Hay documentos con información incompleta de lotes", timeOut: 5000 });
                let incompleteBatchDocs = [];
                for (const line of docsValidation.data) {
                    if (line.WithError) {
                        let document = incompleteBatchDocs.find(({ DocEntry }) => Number(DocEntry) === Number(line.DocEntry));
                        const newLine = {
                            ManBtchNum: 'Y',
                            LineNum: line.LineNum,
                            ItemCode: line.ItemCode,
                            ItemName: line.ItemName,
                            WhsCode: line.WhsCode,
                            Quantity: Number(line.OpenQty || 0),
                            OpenLneQty: line.OpenQty - line.SelectedQty,
                            SnBUoMQty: Number(line.SelectedQty || 0),
                            BatchNumbers: JSON.parse(line.BatchNumbers),
                            AvailableBatchNumbers: JSON.parse(line.AvailableBatchNumbers),
                        };

                        if (!document) {
                            document = new NewOrder();
                            document.DocEntry = line.DocEntry;
                            document.DocNum = allDocs.find(({ docEntry }) => Number(docEntry) === Number(line.DocEntry))?.docNum || -1;
                            document.Items.push(newLine);
                            incompleteBatchDocs.push(document);
                        } else {
                            document.Items.push(newLine);
                        }
                    }
                }
                await this.setState({ showBatchSelectionModal: true, massiveDocs: true, massiveDocsTemp: { series, docs: allDocs, docsValidation: docsValidation.data, objInfo }, incompleteBatchDocs, newOrderModel: incompleteBatchDocs[0], currentDocument: 0 });
                $("#batchSelectionModal").modal("show");
                $("#batchSelectionModal").on("hidden.bs.modal", async () => { await this.setState({ showBatchSelectionModal: false, massiveDocs: false, massiveDocsTemp: {}, incompleteBatchDocs: [], currentDocument: -1 }); })
            } else {
                this.ProcessCloseDocumentsAsInvoice({ series, docs: allDocs, docsValidation: docsValidation.data, objInfo });
            }
        }
    }

    RemoveIncompleteBatchDoc = async (DocEntry) => {
        let massiveDocsTemp = JSON.parse(JSON.stringify(this.state.massiveDocsTemp));

        for (let i = 0; i < massiveDocsTemp.docs.length; i++) {
            if (Number(massiveDocsTemp.docs[i].docEntry) === Number(DocEntry)) {
                massiveDocsTemp.docs.splice(i, 1);
                i--;
            }
        }

        await this.setState({ massiveDocsTemp });
    }

    NextDocument = async () => {
        let massiveDocsTemp = JSON.parse(JSON.stringify(this.state.massiveDocsTemp));
        const { incompleteBatchDocs, currentDocument, newOrderModel } = this.state;

        for (const item of newOrderModel.Items) {
            let batchLine = massiveDocsTemp.docsValidation.find(({ DocEntry, ItemCode, LineNum }) => Number(DocEntry) === newOrderModel.DocEntry && Number(LineNum) === Number(item.LineNum) && ItemCode === item.ItemCode);
            if (batchLine) {
                batchLine.BatchNumbers = JSON.stringify(item.BatchNumbers);
            }
        }

        if (currentDocument < (incompleteBatchDocs.length - 1)) {
            await this.setState({
                massiveDocsTemp,
                newOrderModel: incompleteBatchDocs[currentDocument + 1],
                currentDocument: currentDocument + 1
            })
        } else {
            $("#batchSelectionModal").modal("hide");
            this.ProcessCloseDocumentsAsInvoice(massiveDocsTemp);
        }
    }

    ProcessCloseDocumentsAsInvoice = async (data) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { series, docs, docsValidation, objInfo } = data;

        showAlert({ type: 'info', message: "Procesando documentos, esto puede tardar unos minutos" });
        let billingResponseArray = [];
        enableSpinner(true);
        for (let i = 0; i < docs.length; i++) {
            if (i !== 0 && !(i % 5)) { showAlert({ type: 'info', message: "Seguimos procesando los documentos, NO cierre ni recargue la pagina por favor", timeOut: 10000 }); }
            const document = docs[i];
            const batchInfo = Array.isArray(docsValidation) ? docsValidation.filter(({ DocEntry }) => Number(DocEntry) === Number(document.docEntry)) : [];
            let responseDocuments = await apiClient.copyDocsToBill({ series, document, batchInfo, objInfo });

            billingResponseArray.push({ docNum: document.docNum || "", message: responseDocuments?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", billing: responseDocuments?.data || "" });
        }
        enableSpinner(false);

        await this.setState({ billingResponseArray });
        $("#billingResponseModal").modal("show");
        $("#billingResponseModal").on("hidden.bs.modal", async () => { await this.setState({ billingResponseArray: [] }); })

        this.searchDocuments();
    }
    //#endregion


    searchBusinessParter = (event, option) => {
        if (option === 1) {
            this.setState({
                groupCodeValue: event.nativeEvent.target.value,
            })
        }

        if (option === 2) {
            this.setState({
                priceValue: event.nativeEvent.target.value,
            })
        }

        if (option === 3) {
            this.setState({
                employeeValue: event.nativeEvent.target.value,
            })
        }
        if (option === 4) {
            this.setState({
                docStatus: event.nativeEvent.target.value,
            })
        }

        if (option === 5) {
            this.setState({
                isCanceled: event.nativeEvent.target.value,
            })
        }

        setTimeout(() => {
            this.searchDocuments()
        }, 100)
    };

    selectStatusDoc = (event) => {
        let status = event.nativeEvent.target.value;

        this.setState({
            docStatus: status
        });
    };

    handleSwitchChange = nr => () => {
        const { switch1 } = this.state;
        let switchNumbers = `switch${nr}`;
        this.setState({
            switch1: !this.state[switchNumbers]
        });
    }

    generateCsv = async () => {
        const { view, headers, notificationReducer: { showAlert }, enableSpinner, totalRows, data } = this.props;
        const { groupCodeValue, employeeValue, docStatus } = this.state;
        let resposnerCsv;
        if (view === "SalesHelmets") {
            let date = {
                dateInit: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD'),
                dateFinal: moment(document.getElementById("fechaFin").value).format('YYYYMMDD'),
                groupCodeValue,
                employeeValue,
                docStatus
            };

            enableSpinner(true);
            resposnerCsv = await apiClient.getDataCsv(date);
            enableSpinner(false);

            if (!Array.isArray(resposnerCsv.data)) {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
                return;
            }

            if (resposnerCsv.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }
        // if (view === "orderSales" || view === "quotations") {
        //     let data = {
        //         dateInit: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD'),
        //         dateFinal: moment(document.getElementById("fechaFin").value).format('YYYYMMDD'),
        //         groupCodeValue,
        //         docStatus
        //     };

        //     enableSpinner(true);
        //     resposnerCsv = await apiClient.getDataCsvORDR(data);
        //     enableSpinner(false);

        //     if (!Array.isArray(resposnerCsv.data)) {
        //         showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
        //         return;
        //     }

        //     if (resposnerCsv.data.length === 0) {
        //         showAlert({ type: 'info', message: 'No hay Información por mostrar' });
        //         return;
        //     }
        // }

        let datafilter = [];

        data.map(fila => {
            if (view === "PurchaseRequest") {
                let obj = {
                    Serie: fila.Series || '',
                    Num_Doc: fila.DocNum || '',
                    Solicitante: fila.Requester || '',
                    Nombre: fila.ReqName || '',
                    Fecha_Cont: moment(fila.DocDate).utc().format("DD-MM-YYYY") || '',
                    Empl_Ventas: fila.SlpCode || '',
                    Titular_Doc: fila.OwnerCode || '',
                    Comentarios: fila.Comments || '',
                    Total: fila.DocTotal || '',
                    Estatus: fila.DocStatus === 'C' ? 'Cerrado' : 'Abierto' || '',
                    Fecha_EntregaVencimiento: moment(fila.DocDueDate).utc().format("DD-MM-YYYY") || '',
                    Docs_Vencidos: fila.DocsVencidos || '',
                    Facturado: fila.Facturado || '',
                    Pagado: fila.Pagado || '',
                    Vencido: fila.MontoVencido || ''
                }
                datafilter.push(obj)
            } else {
                if (view === "creditNote") {
                    let obj = {
                        Serie: fila.Series || '',
                        Estatus: fila.DocStatus === 'C' ? 'Cerrado' : 'Abierto' || '',
                        Num_Doc: fila.DocNum || '',
                        Cliente: fila.CardCode || '',
                        Nombre: fila.CardName || '',
                        Fecha_Cont: moment(fila.DocDate).utc().format("DD-MM-YYYY") || '',
                        Comentarios: fila.Comments || '',
                        Empl_Ventas: fila.SlpCode || '',
                        Titular_Doc: fila.OwnerCode || '',
                        Total: fila.DocTotal || '',
                        Fecha_EntregaVencimiento: moment(fila.DocDueDate).utc().format("DD-MM-YYYY") || '',
                        Referencia: fila.NumAtCard || '',
                        Docs_Vencidos: fila.DocsVencidos || '',
                        Facturado: fila.Facturado || '',
                        Pagado: fila.Pagado || '',
                        Vencido: fila.MontoVencido || ''
                    }
                    datafilter.push(obj)

                } else {
                    let obj = {
                        Serie: fila.Series || '',
                        Num_Doc: fila.DocNum || '',
                        Cliente: fila.CardCode || '',
                        Nombre: fila.CardName || '',
                        Fecha_Cont: moment(fila.DocDate).utc().format("DD-MM-YYYY") || '',
                        Empl_Ventas: fila.SlpCode || '',
                        Titular_Doc: fila.OwnerCode || '',
                        Comentarios: fila.Comments || '',
                        Total: fila.DocTotal || '',
                        Estatus: fila.DocStatus === 'C' ? 'Cerrado' : 'Abierto' || '',
                        Fecha_EntregaVencimiento: moment(fila.DocDueDate).utc().format("DD-MM-YYYY") || '',
                        Docs_Vencidos: fila.DocsVencidos || '',
                        Facturado: fila.Facturado || '',
                        Pagado: fila.Pagado || '',
                        Vencido: fila.MontoVencido || ''
                    }
                    datafilter.push(obj)
                }
            }
        });


        let data_2 = resposnerCsv ? resposnerCsv.data || [] : datafilter;
        this.setState({ dataCsv: data_2 })
        setTimeout(() => {
            this.csvLink.current.link.click();
        }, 500);
    }

    authorizationReport = () => {
        const { view, headers, notificationReducer: { showAlert }, enableSpinner, totalRows, data } = this.props;
        let newArray = []
        data.map((registro) => {
            let docDate = new Date(registro.DocDate);
            let docDueDate = new Date(registro.DocDueDate);

            docDate.setMinutes(docDate.getMinutes() + docDate.getTimezoneOffset());
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let CreateTime = (registro.CreateTime || '').toString();
            let updateTime = (registro.UpdateTime || '').toString();
            let createTimeHour = '';
            let updateTimeHour = '';

            if (CreateTime.length > 0) {
                let position = CreateTime.length - 2;
                createTimeHour = CreateTime.slice(0, position) + ":" + CreateTime.slice(position, CreateTime.length)
            }
            if (updateTime.length > 0) {
                let position = updateTime.length - 2;
                updateTimeHour = updateTime.slice(0, position) + ":" + updateTime.slice(position, updateTime.length)
            }
            let obj = {
                Estatus: registro.Status1 === 'W' || registro.Status1 === 'WN' ? 'Pendiente' : registro.Status1 === 'Y' ? 'Autorizado' : registro.Status1 === 'N' ? 'Rechazado' : registro.Status1 === 'C' ? 'Cancelado' : '',
                Modelo_Autorizacion: registro.WtmName,
                Documento_Origen: registro.DocNumOrigin && registro.DocNumOrigin !== -1 ? registro.DocNumOrigin : 'Sin orígen',
                CLiente: registro.CardCode,
                Nombre: registro.CardName,
                Total: registro.DocTotal,
                Fecha_de_contabilizacion: registro.DocDueDate,
                Tiempo_de_fabricacion: createTimeHour,
                Fecha_de_produccion: registro.CreateDate,
                Tiempo: updateTimeHour
            }
            newArray.push(obj);
        });
        this.setState({ dataCsv: newArray })
        setTimeout(() => {
            this.csvLink.current.link.click();
        }, 500);
    }

    CloseAdminUserActions = async () => {
        const { UpdateConfigUserFields } = this.props
        await this.setState({
            showBusinessPartnerFields: false
        })
        UpdateConfigUserFields(null);

    }

    OpenAdministratorUsers = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { itemsDashboard } = this.state;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;
        if (!user || user.FMB_Role !== 'admin1') {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        enableSpinner(true);
        let dataSerie = {
            docType: '',
            docSubType: ''
        };
        let seriesResponse = await apiClient.getSeries(dataSerie);
        if (!Array.isArray(seriesResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (seriesResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        for (let index = 0; index < itemsDashboard.length; index++) {
            const element = itemsDashboard[index];
            element.selected = false;
        }

        let modelUsers = new AdministratorUsers();
        modelUsers.E_Mail = '';
        modelUsers.U_FMB_passwd = '';
        modelUsers.itemsDashboard = itemsDashboard;
        modelUsers.series = seriesResponse.data || [];

        const walletPermissions = await apiClient.getWalletUserPermissions('-1');

        if (walletPermissions.status == SERVICE_RESPONSE.SUCCESS) {
            modelUsers.walletPermissions = this.setWalletPermissions(walletPermissions.data.UserPermissions || [], walletPermissions.data.WalletModules || [])
        }
        await this.setState({
            adminUsersModel: modelUsers,
            adminUsersModalAction: 1,
            showAdminUsersModal: true, // show
            showBusinessPartnerFields: true,

        });

        $('#adminUsersModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        enableSpinner(false);
    };

    refreshToken = async (userId) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        const tokenResponse = await apiClient.getTwoStepsKey(userId);
        await this.setState({
            token: { twoStepsKeyDecrypt: tokenResponse.data?.token ?? {} },
            infoToken: {
                date: tokenResponse.data?.infoToken?.date ?? null,
                time: tokenResponse.data?.infoToken?.time ?? null
            }
        });
        enableSpinner(false);
    }

    showPassword = async (userId) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        await apiClient.showPassword(userId);
        enableSpinner(false);
    }
    setWalletPermissions = (userPermissions, WalletModules) => {
        for (let index = 0; index < WalletModules.length; index++) {
            const walletModule = WalletModules[index];
            const findModule = userPermissions.find(userPermission => userPermission.WalletPermission === walletModule.idWalletPermissions)

            if (findModule) {
                walletModule.Active = findModule.Active
            } else {
                walletModule.Active = 'N'
            }
        }
        return WalletModules;

    }
    OpenAdministratorUsersDetails = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, UpdateConfigUserFields } = this.props;
        enableSpinner(true);
        const usersResponse = await apiClient.getAdminUsersDetails(open.User);
        if (usersResponse.status === SERVICE_RESPONSE.SUCCESS) {

            const newOrderModel = await this.fillsAdministratorUsersDetailsModel(usersResponse, open);

            const walletPermissions = await apiClient.getWalletUserPermissions(newOrderModel.USERID);

            if (walletPermissions.status == SERVICE_RESPONSE.SUCCESS) {
                newOrderModel.walletPermissions = this.setWalletPermissions(walletPermissions.data.UserPermissions || [], walletPermissions.data.WalletModules || [])
            }
            const configFields = { businessPartner: JSON.parse(usersResponse.data.user.U_FMB_ConfigModules).businessPartner }

            let data = {};
            for (const key in configFields.businessPartner) {
                data["show_" + key] = configFields.businessPartner[key].show
                data["edit_" + key] = configFields.businessPartner[key].edit
            }
            await UpdateConfigUserFields(data);

            await this.setState({
                adminUsersModel: newOrderModel,
                newAdminUsersEditMode: { usersResponse, open },
                adminUsersModalAction: 2, // show
                showAdminUsersModal: true,
                showBusinessPartnerFields: true,

            });

            enableSpinner(false);

            $('#adminUsersModal').modal({ backdrop: 'static', keyboard: false }, 'show');
            this.administratorUsersModal.setState({
                editMode: false
            });

            return;
        }
        enableSpinner(false);
        showAlert({ type: 'error', message: usersResponse.message });

    };

    fillsAdministratorUsersDetailsModel = async (model, open) => {
        const { showAlert } = this.props;
        let { itemsDashboard } = this.state;
        let adminUsersModel = new AdministratorUsers();
        let user = model.data.user;
        let dash = user.U_FMB_Modulos ? user.U_FMB_Modulos : null;
        if (dash) {
            dash = JSON.parse(dash);
            for (const key in itemsDashboard) {
                if (Object.hasOwnProperty.call(itemsDashboard, key)) {
                    const module = itemsDashboard[key];
                    if (!dash.hasOwnProperty(key)) {
                        module.active = false;
                        dash[key] = module;
                    }
                }
            }
            itemsDashboard = dash;
        } else {
            for (const key in itemsDashboard) {
                if (Object.hasOwnProperty.call(itemsDashboard, key)) {
                    let module = itemsDashboard[key];
                    module.active = false;
                }
            }
        }
        // SERIES
        let dataSerie = {
            docType: '',
            docSubType: ''
        };

        let seriesResponse = await apiClient.getSeries(dataSerie);
        if (!Array.isArray(seriesResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (seriesResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        // SERIES

        adminUsersModel.update = 1;
        adminUsersModel.USERID = user.USERID || '';
        adminUsersModel.USER_CODE = user.USER_CODE || '';
        adminUsersModel.U_NAME = user.U_NAME || '';
        adminUsersModel.E_Mail = user.E_Mail || '';
        adminUsersModel.U_FMB_passwd = user.U_FMB_passwd || '';
        adminUsersModel.OldPassword = user.OldPassword || '';
        adminUsersModel.U_FMB_passwdDecrypt = user.U_FMB_passwdDecrypt || '';
        adminUsersModel.U_FMB_passwdNew = user.U_FMB_passwdNew || '';
        adminUsersModel.U_FMB_passwdConfirm = user.U_FMB_passwdConfirm || '';
        adminUsersModel.U_FMB_role = user.U_FMB_role || '';
        adminUsersModel.U_FMB_UserFields = user.U_FMB_UserFields || '';
        adminUsersModel.U_FMB_ValidateSeriesOINV = user.U_FMB_ValidateSeriesOINV || '';
        adminUsersModel.U_FMB_ValidateSeriesORDR = user.U_FMB_ValidateSeriesORDR || '';
        adminUsersModel.U_FMB_ValidateSeriesODLN = user.U_FMB_ValidateSeriesODLN || '';
        adminUsersModel.U_FMB_ValidateSeriesORDN = user.U_FMB_ValidateSeriesORDN || '';
        adminUsersModel.U_FMB_ValidateSeriesORCT = user.U_FMB_ValidateSeriesORCT || '';
        adminUsersModel.U_FMB_ValidateSeriesOWTR = user.U_FMB_ValidateSeriesOWTR || '';
        adminUsersModel.U_FMB_ValidateSeriesDN = user.U_FMB_ValidateSeriesDN || '';
        adminUsersModel.U_FMB_ValidateSeriesORIN = user.U_FMB_ValidateSeriesORIN || '';
        adminUsersModel.U_FMB_ValidateSeriesOWTQ = user.U_FMB_ValidateSeriesOWTQ || '';
        adminUsersModel.U_FMB_ValidateSeriesOIGN = user.U_FMB_ValidateSeriesOIGN || '';
        adminUsersModel.U_FMB_ValidateSeriesOIGE = user.U_FMB_ValidateSeriesOIGE || '';
        adminUsersModel.U_FMB_ValidateSeriesOPOR = user.U_FMB_ValidateSeriesOPOR || '';
        adminUsersModel.U_FMB_ValidateSeriesOPRQ = user.U_FMB_ValidateSeriesOPRQ || '';
        adminUsersModel.U_FMB_ValidateSeriesORPD = user.U_FMB_ValidateSeriesORPD || '';
        adminUsersModel.U_FMB_ValidateSeriesOMRV = user.U_FMB_ValidateSeriesOMRV || '';
        adminUsersModel.U_FMB_ValidateSeriesOPDN = user.U_FMB_ValidateSeriesOPDN || '';
        adminUsersModel.U_FMB_ValidateSeriesOVPM = user.U_FMB_ValidateSeriesOVPM || '';
        adminUsersModel.U_FMB_ValidateSeriesOPCH = user.U_FMB_ValidateSeriesOPCH || '';
        adminUsersModel.U_FMB_ValidateSeriesORPC = user.U_FMB_ValidateSeriesORPC || '';
        adminUsersModel.U_FMB_ValidateSeriesOQUT = user.U_FMB_ValidateSeriesOQUT || '';
        adminUsersModel.U_FMB_ValidateSeriesOPQT = user.U_FMB_ValidateSeriesOPQT || '';
        adminUsersModel.U_FMB_Modulos = user.U_FMB_Modulos || '';
        adminUsersModel.U_FMB_CC = user.U_FMB_CC || '';

        adminUsersModel.U_FMB_Sucursal = user.U_FMB_Sucursal || '';
        adminUsersModel.U_FMB_Caja = user.U_FMB_Caja || '';
        adminUsersModel.U_Active = user.U_Active || '';
        adminUsersModel.U_CardCode = user.U_CardCode || '';
        adminUsersModel.U_SlpCode = user.U_SlpCode || -1;
        adminUsersModel.U_Discount = user.U_Discount || 0;
        adminUsersModel.descuento = user.descuento || 0;
        adminUsersModel.itemsDashboard = itemsDashboard || [];
        adminUsersModel.series = seriesResponse.data || [];
        adminUsersModel.newSeries = [];
        adminUsersModel.U_FMB_ConfigModules = user.U_FMB_ConfigModules ? JSON.parse(user.U_FMB_ConfigModules) : '';

        adminUsersModel.U_FMB_CounterRol = user.U_FMB_CounterRol || '';
        adminUsersModel.CounterPermission = await this.FillCounterPermissions(user.CounterPermission);
        adminUsersModel.BranchPermission = await this.FillBranchPermissions(user.BranchPermission);
        adminUsersModel.CCP_UsoInterno = user.CCP_UsoInterno;
        adminUsersModel.user_MIT = user?.MIT_user ?? "";
        adminUsersModel.pass_MIT = user?.MIT_pass ?? "";
        adminUsersModel.user_MIT_decrypt = user?.user_MIT_decrypt ?? "";
        adminUsersModel.pass_MIT_decrypt = user?.pass_MIT_decrypt ?? "";
        adminUsersModel.U_FMB_UserId = user.U_FMB_UserId || '';

        return adminUsersModel;
    };

    FillCounterPermissions = (dataPermissions) => {
        let permissionsModel = new CounterPermissions();
        if (dataPermissions !== '' && dataPermissions !== undefined && dataPermissions !== null) {
            let counterP = JSON.parse(dataPermissions);
            permissionsModel.EditPrice = counterP.EditPrice || false;
            permissionsModel.EditDiscount = counterP.EditDiscount || false;
        }
        return permissionsModel;
    }

    FillBranchPermissions = (dataPermissions) => {
        let permissionsModel = new BranchPermissions();
        if (dataPermissions !== '' && dataPermissions !== undefined && dataPermissions !== null) {
            const permissions = JSON.parse(dataPermissions);
            permissionsModel.CloseDocuments = permissions.CloseDocuments || false;
            permissionsModel.ProductionPrices = permissions?.ProductionPrices || false;
            permissionsModel.CancelClosePurchaseOrder = permissions?.CancelClosePurchaseOrder || false;
            permissionsModel.EditPurchaseOrder = permissions?.EditPurchaseOrder || false;
            permissionsModel.ChangeTaxRate = permissions?.ChangeTaxRate || false;
            permissionsModel.PendingCashCut = permissions?.PendingCashCut || false;
        }
        return permissionsModel;
    }

    //#region Citibanamex
    changeDocFilter = async value => {
        await this.setState({ docFilter: value });
        this.searchDocuments()
    };
    changeDocSuggestion = async value => {
        const { changeDocTypeSuggestion, } = this.props
        await changeDocTypeSuggestion(value);
        await this.useSuggestionsDoc(true)
    }
    useSuggestionsDoc = async (goSearch) => {
        if (!goSearch) {
            await this.setState(prevState => ({ suggestionDocs: !prevState.suggestionDocs }));
        }
        const { search, view, searchSuggestDoc, changeDocTypeSuggestion, docTypeSuggestion, resetDataTable } = this.props;
        const { priceValue, groupCodeValue, employeeValue, PageNumber, searchValue, docStatus, docNumSearch, groupSucursal, searchSerieName, docFilter, docStatusSearchAuthoBP } = this.state;
        let date = {
            // dateInit: moment(document.getElementById("fechaInicio").value).format('YYYYMMDD'),
            // dateFinal: moment(document.getElementById("fechaFin").value).format('YYYYMMDD'),
            groupCodeValue,
            employeeValue,
            docStatus,
            docNumSearch: docNumSearch ? docNumSearch === '' ? '--' : docNumSearch : '--',
            searchSerieName: searchSerieName ? searchSerieName === '' ? '--' : searchSerieName : '--',
            docFilter: docFilter ? docFilter : 'OPCH',
            docTypeSuggestion: docTypeSuggestion
        };
        this.toggleDocumentSelectedAll(false);

        this.setState({
            checkboxDataTables: (new Map()),
        });
        if (this.state.suggestionDocs) {
            await searchSuggestDoc(date);
        } else {
            resetDataTable()
            date.dateInit = moment(document.getElementById("fechaInicio").value).format('YYYYMMDD')
            date.dateFinal = moment(document.getElementById("fechaFin").value).format('YYYYMMDD')
            changeDocTypeSuggestion('expiredDocs')
            await search(date);
        }
        setTimeout(() => {
            this.setState({
                docNumSearch: '',
            });
        }, 250);
    }

    selectBusinessParter = async (selectedBP) => {
        await this.changeBPCode(selectedBP.CardCode);
        $('#VendorsModal').modal('hide');
        this.searchDocuments();
    }

    changeBPCode = async (value) => {
        const { vendorData } = this.props;
        const auxVendor = { ...vendorData };
        auxVendor.CardCode = value
        this.refreshVendor(auxVendor);
    };
    //#endregion

    //#region ######### fillDetailsModel
    fillTipoFiguraDetailsModel = (model, open) => {
        let tipoFiguraModel = new TiposFigura();

        tipoFiguraModel.update = 1;
        tipoFiguraModel.CodigoFiguraTransporte = model.CodigoFiguraTransporte || model.FiguraTransporte;
        // cartaporte20:FiguraTransporte:TiposFigura
        tipoFiguraModel.TipoFigura = model.TipoFigura;
        tipoFiguraModel.RFC = model.RFC;
        tipoFiguraModel.NombreFigura = model.NombreFigura;
        tipoFiguraModel.NumLicencia = model.NumLicencia;
        tipoFiguraModel.NumRegIdTrib = model.NumRegIdTrib;
        tipoFiguraModel.ResidenciaFiscalFigura = model.ResidenciaFiscalFigura;
        // cartaporte20:FiguraTransporte:TiposFigura:PartesTransporte
        tipoFiguraModel.PartesTransporte = model.PartesTransporte ? model.PartesTransporte : [model.PartesTransporte]; // (0, ilimitado) 
        // cartaporte20:FiguraTransporte:TiposFigura:Domicilio
        tipoFiguraModel.Calle = model.Calle;
        tipoFiguraModel.NumeroExterior = model.NumeroExterior;
        tipoFiguraModel.NumeroInterior = model.NumeroInterior;
        tipoFiguraModel.Colonia = model.Colonia;
        tipoFiguraModel.Localidad = model.Localidad;
        tipoFiguraModel.Referencia = model.Referencia;
        tipoFiguraModel.Municipio = model.Municipio;
        tipoFiguraModel.Estado = model.Estado;
        tipoFiguraModel.Pais = model.Pais;
        tipoFiguraModel.CodigoPostal = model.CodigoPostal;

        tipoFiguraModel.Email = model.Email;
        tipoFiguraModel.Password = model.Password;
        tipoFiguraModel.U_FMB_Sucursal = model.pk_Sucursal ?? 0;
        tipoFiguraModel.IdVHCL = model.IdVHCL ?? -1;

        return tipoFiguraModel;
    }

    fillTransporteDetailsModel = (model, open) => {
        const { tipoTransporte } = this.state;
        switch (tipoTransporte) {
            case 'Aereo':
                let aereoModel = new TransporteAereo();

                aereoModel.update = 1;
                aereoModel.CodigoTransporteAereo = model.CodigoTransporteAereo || model.TransporteAereo;

                // cartaporte20:Mercancias:TransporteAereo
                aereoModel.PermSCT = model.PermSCT;
                aereoModel.NumPermisoSCT = model.NumPermisoSCT;
                aereoModel.MatriculaAeronave = model.MatriculaAeronave;
                aereoModel.NombreAseg = model.NombreAseg;
                aereoModel.NumPolizaSeguro = model.NumPolizaSeguro;
                aereoModel.NumeroGuia = model.NumeroGuia;
                aereoModel.LugarContrato = model.LugarContrato;
                aereoModel.CodigoTransportista = model.CodigoTransportista;
                aereoModel.RFCEmbarcador = model.RFCEmbarcador;
                aereoModel.NumRegIdTribEmbarc = model.NumRegIdTribEmbarc;
                aereoModel.ResidenciaFiscalEmbarc = model.ResidenciaFiscalEmbarc;
                aereoModel.NombreEmbarcador = model.NombreEmbarcador;
                return aereoModel;
                break;
            case 'Autotransporte':
                let autotransporteModel = new Autotransporte();
                autotransporteModel.update = 1;
                autotransporteModel.CodigoAutotransporte = model.CodigoAutotransporte || model.Autotransporte;
                // cartaporte20:Mercancias:Autotransporte
                autotransporteModel.PermSCT = model.PermSCT;
                autotransporteModel.NumPermisoSCT = model.NumPermisoSCT;
                // cartaporte20:Mercancias:Autotransporte:IdentificacionVehicular
                autotransporteModel.ConfigVehicular = model.ConfigVehicular;
                autotransporteModel.PlacaVM = model.PlacaVM;
                autotransporteModel.AnioModeloVM = model.AnioModeloVM;
                // cartaporte20:Mercancias:Autotransporte:Seguros
                autotransporteModel.AseguraRespCivil = model.AseguraRespCivil;
                autotransporteModel.PolizaRespCivil = model.PolizaRespCivil;
                autotransporteModel.AseguraMedAmbiente = model.AseguraMedAmbiente;
                autotransporteModel.PolizaMedAmbiente = model.PolizaMedAmbiente;
                autotransporteModel.AseguraCarga = model.AseguraCarga;
                autotransporteModel.PolizaCarga = model.PolizaCarga;
                autotransporteModel.PrimaSeguro = model.PrimaSeguro;
                // cartaporte20:Mercancias:Autotransporte:Remolques
                autotransporteModel.Remolques = model.Remolques;
                autotransporteModel.CodigoUnidad = model.CodigoUnidad;
                autotransporteModel.TipodeUnidad = model.TipodeUnidad;
                autotransporteModel.PesoBrutoVehicular = model?.PesoBrutoVehicular ?? ''; //NUEVO 30
                autotransporteModel.U_FMB_Sucursal = model?.pk_Sucursal ?? "";
                autotransporteModel.SupportWeight = model?.SupportWeight ?? 0.0;
                //SERIES AND CONSECUTIVES
                let currSeries = model?.U_FMB_ValidateSeriesSUNAT;
                try {
                    autotransporteModel.U_FMB_ValidateSeriesSUNAT = JSON.parse(currSeries && currSeries.trim() !== "" ? currSeries : "{}");
                } catch (e) {
                    autotransporteModel.U_FMB_ValidateSeriesSUNAT = {};
                }


                autotransporteModel.U_FMB_Driver = model.U_FMB_Driver;
                autotransporteModel.U_AbsEntry = model?.U_AbsEntry ?? "";
                autotransporteModel.U_FMB_BinLocation = model.U_FMB_BinLocation;
                autotransporteModel.U_FMB_SellType = model.U_FMB_SellType;
                autotransporteModel.Items = model.Items || [];
                autotransporteModel.Polygon = model?.Polygon ?? null;
                autotransporteModel.roadMap = model?.roadMap ?? null
                return autotransporteModel;
                break;
            case 'Ferroviario':
                let ferroviarioModel = new TransporteFerroviario();
                ferroviarioModel.update = 1;
                ferroviarioModel.CodigoTransporteFerroviario = model.CodigoTransporteFerroviario || model.TransporteFerroviario;
                // cartaporte20:Mercancias:TransporteFerroviario
                ferroviarioModel.TipoDeServicio = model.TipoDeServicio;
                ferroviarioModel.TipoDeTrafico = model.TipoDeTrafico;
                ferroviarioModel.NombreAseg = model.NombreAseg;
                ferroviarioModel.NumPolizaSeguro = model.NumPolizaSeguro;
                // cartaporte20:Mercancias:TransporteFerroviario:DerechosDePaso
                ferroviarioModel.DerechosDePaso = model.DerechosDePaso;
                // cartaporte20:Mercancias:TransporteFerroviario:Carro
                ferroviarioModel.Carro = model.Carro;
                // cartaporte20:Mercancias:TransporteFerroviario:Carro:Contenedor
                ferroviarioModel.Contenedor = model.Contenedor;
                return ferroviarioModel;
                break;
            case 'Maritimo':
                let maritimoModel = new TransporteMaritimo();
                maritimoModel.update = 1;
                maritimoModel.CodigoTransporteMaritimo = model.CodigoTransporteMaritimo || model.TransporteMaritimo;
                // cartaporte20:Mercancias:TransporteMaritimo
                maritimoModel.PermSCT = model.PermSCT;
                maritimoModel.NumPermisoSCT = model.NumPermisoSCT;
                maritimoModel.NombreAseg = model.NombreAseg;
                maritimoModel.NumPolizaSeguro = model.NumPolizaSeguro;
                maritimoModel.TipoEmbarcacion = model.TipoEmbarcacion;
                maritimoModel.Matricula = model.Matricula;
                maritimoModel.NumeroOMI = model.NumeroOMI;
                maritimoModel.AnioEmbarcacion = model.AnioEmbarcacion;
                maritimoModel.NombreEmbarc = model.NombreEmbarc;
                maritimoModel.NacionalidadEmbarc = model.NacionalidadEmbarc;
                maritimoModel.UnidadesDeArqBruto = model.UnidadesDeArqBruto;
                maritimoModel.TipoCarga = model.TipoCarga;
                maritimoModel.NumCertITC = model.NumCertITC;
                maritimoModel.Eslora = model.Eslora;
                maritimoModel.Manga = model.Manga;
                maritimoModel.Calado = model.Calado;
                maritimoModel.LineaNaviera = model.LineaNaviera;
                maritimoModel.NombreAgenteNaviero = model.NombreAgenteNaviero;
                maritimoModel.NumAutorizacionNaviero = model.NumAutorizacionNaviero;
                maritimoModel.NumViaje = model.NumViaje;
                maritimoModel.NumConocEmbarc = model.NumConocEmbarc;
                // cartaporte20:Mercancias:TransporteMaritimo:Contenedor
                maritimoModel.Contenedor = model.Contenedor;
                return maritimoModel;
                break;
            default:
                break;
        }
    };

    // Carta Porte
    fillCartaPorteDetailsModel = async (model, open) => {
        let cartaPorteModel = new CartaPorte();
        cartaPorteModel.update = 1;
        cartaPorteModel.TypeDoc = model.ObjType;
        cartaPorteModel.CodigoCarta = model.CodigoCarta;
        cartaPorteModel.CardCode = model.CardCode;
        cartaPorteModel.CardName = model.CardName;
        cartaPorteModel.DocEntry = model.DocEntry;
        cartaPorteModel.DocNum = model.DocNum;
        // cartaporte20:CartaPorte
        cartaPorteModel.Version = model.Version;
        cartaPorteModel.TranspInternac = model.TranspInternac;
        cartaPorteModel.EntradaSalidaMerc = model.EntradaSalidaMerc;
        cartaPorteModel.PaisOrigenDestino = model.PaisOrigenDestino;
        cartaPorteModel.ViaEntradaSalida = model.ViaEntradaSalida;
        cartaPorteModel.TotalDistRec = model.TotalDistRec;
        // cartaporte20:Ubicaciones
        // cartaPorteModel.Ubicaciones             = model.Ubicaciones;
        // cartaporte20:Mercancias
        cartaPorteModel.PesoBrutoTotal = model.PesoBrutoTotal;
        cartaPorteModel.UnidadPeso = model.UnidadPeso;
        cartaPorteModel.PesoNetoTotal = model.PesoNetoTotal;
        cartaPorteModel.NumTotalMercancias = model.NumTotalMercancias;
        cartaPorteModel.CargoPorTasacion = model.CargoPorTasacion;
        // cartaporte20:Mercancias:Mercancia
        // cartaPorteModel.Mercancias              = model.Mercancias;

        // // cartaporte20:Mercancias:Autotransporte
        // cartaPorteModel.Autotransporte          = model.Autotransporte;
        // // cartaporte20:Mercancias:TransporteMaritimo
        // cartaPorteModel.TransporteMaritimo      = model.TransporteMaritimo;
        // // cartaporte20:Mercancias:TransporteAereo
        // cartaPorteModel.TransporteAereo         = model.TransporteAereo;
        // // cartaporte20:Mercancias:TransporteFerroviario
        // cartaPorteModel.TransporteFerroviario   = model.TransporteFerroviario;

        cartaPorteModel.Transporte = model.Transporte;
        cartaPorteModel.TipoTransporte = model.TipoTransporte;

        // cartaporte20:FiguraTransporte
        cartaPorteModel.FiguraTransporte = model.FiguraTransporte;

        // NEW FIELDS
        cartaPorteModel.UsoCFDI = await this.ValidateUSoCFDI(model.U_FMB_USO_CFDI);
        cartaPorteModel.U_FMB_UUID = model?.U_FMB_UUID ?? '';
        cartaPorteModel.SerieCode = model?.Series ?? '';
        cartaPorteModel.SerieName = model?.SeriesName ?? '';
        // NEW FIELDS 3.0
        cartaPorteModel.IdCCP = model.IdCCP ?? '';

        // cancelacion de CP
        cartaPorteModel.CanceledCFDI = model.CancelRequest ?? 'N';
        cartaPorteModel.xml_Process = model.xml_Process ?? '';
        cartaPorteModel.MotivoRelacion = model.CFDITypeRelation ?? '00';
        cartaPorteModel.DocNumFlete = model.DocNumFlete || 0;
        cartaPorteModel.TotalFlete = Number(model.Flete || 0).toFixed(2);
        if (model.UUIDRelationed && model.UUIDRelationed !== null && model.UUIDRelationed !== undefined) {
            try {
                cartaPorteModel.CFDI_Relacionados = JSON.parse(model.UUIDRelationed) ?? [];
            } catch (error) {
                cartaPorteModel.CFDI_Relacionados = []
            }
        }

        // Configuración de remolques
        cartaPorteModel.ConfRemolques = model.ConfRemolques ?? [];

        // Carta Porte de uso interno
        if (model.UsoInterno && model.UsoInterno === 'Y') {
            cartaPorteModel.UsoInterno = model.UsoInterno;
            cartaPorteModel.CardName = model.CardName;
            cartaPorteModel.LicTradNum = model.LicTradNum;
            cartaPorteModel.ZipCode = model.ZipCode;
            cartaPorteModel.GroupNum = model.GroupNum;
            cartaPorteModel.U_FMB_REGIMEN_FISCAL = model.U_FMB_REGIMEN_FISCAL;
            cartaPorteModel.U_FMB_METODO_PAGO = model.U_FMB_METODO_PAGO;
            cartaPorteModel.U_FMB_FORMA_PAGO = model.U_FMB_FORMA_PAGO;
            cartaPorteModel.Currency = model.Currency;
        }
        return cartaPorteModel;
    }

    ValidateUSoCFDI = (cfdiBack) => {
        let USOCFDI = '';
        const finded = USO_CFDI_CATALOG.find((element) => element.code === cfdiBack);
        USOCFDI = finded !== undefined ? cfdiBack : USO_CFDI_CATALOG[10].code;

        return USOCFDI

    }

    cleanCartaPorteModel = () => {
        this.setState({ cartaPorteModel: new CartaPorte() })
    }

    // Mercancia Carta Porte 
    fillMercanciaDetailsModel = (model, open) => {
        let arrayModel = [];
        // console.log('con<######### model ', model)
        for (let i = 0; i < model.length; i++) {
            let item = new Mercancia();
            item.update = 1;
            item.Index = model[i].Index || i;
            item.Code = model[i].Code;
            // cartaporte20:Mercancias:Mercancia
            item.claveProdServ = model[i].BienesTransp;
            item.BienesTransp = model[i].BienesTransp;
            item.ClaveSTCC = model[i].ClaveSTCC;
            item.Descripcion = model[i].Descripcion;
            item.Cantidad = model[i].Cantidad;
            item.HomeQuantity = model[i].HomeQuantity;
            item.ClaveUnidad = model[i].ClaveUnidad;
            item.Unidad = model[i].Unidad;
            item.Dimensiones = model[i].Dimensiones;
            item.MaterialPeligroso = model[i].MaterialPeligroso;
            item.CveMaterialPeligroso = model[i].CveMaterialPeligroso;
            item.Embalaje = model[i].Embalaje;
            item.DescripEmbalaje = model[i].DescripEmbalaje;
            item.PesoEnKg = model[i].PesoEnKg;
            item.ValorMercancia = model[i].ValorMercancia;
            item.Moneda = model[i].Moneda;
            item.FraccionArancelaria = model[i].FraccionArancelaria;
            item.UUIDComercioExt = model[i].UUIDComercioExt;
            // cartaporte20:Mercancias:Mercancia:Pedimentos
            item.Pedimentos = model[i].Pedimentos;
            // cartaporte20:Mercancias:Mercancia:GuiasIdentificacion
            item.GuiasIdentificacion = model[i].GuiasIdentificacion;
            // cartaporte20:Mercancias:Mercancia:CantidadTransporta
            item.CantidadTransporta = model[i].CantidadTransporta;
            // cartaporte20:Mercancias:Mercancia:DetalleMercancia
            item.UnidadPesoMerc = model[i].UnidadPesoMerc;
            item.PesoBruto = model[i].PesoBruto;
            item.PesoNeto = model[i].PesoNeto;
            item.PesoTara = model[i].PesoTara;
            item.NumPiezas = model[i].NumPiezas;
            item.NumAtCard = model[i].NumAtCard;
            arrayModel.push(item);

        }
        return arrayModel;
    }
    // Ubicaciones Carta Porte
    fillUbicacionDetailsModel = (model, open) => {
        let arrayModel = [];
        for (let i = 0; i < model.length; i++) {
            let ubicacionModel = new UbicacionPorte();
            ubicacionModel.update = 1;
            ubicacionModel.Codigo = model[i].Code || i;
            // cartaporte20:Ubicaciones:Ubicación
            ubicacionModel.TipoUbicacion = model[i].TipoUbicacion;
            ubicacionModel.IDUbicacion = model[i].IDUbicacion;
            ubicacionModel.RFCRemitenteDestinatario = model[i].RFCRemitenteDestinatario;
            ubicacionModel.NombreRemitenteDestinatario = model[i].NombreRemitenteDestinatario;
            ubicacionModel.NumRegIdTrib = model[i].NumRegIdTrib;
            ubicacionModel.ResidenciaFiscal = model[i].ResidenciaFiscal;
            ubicacionModel.NumEstacion = model[i].NumEstacion;
            ubicacionModel.NombreEstacion = model[i].NombreEstacion;
            ubicacionModel.NavegacionTrafico = model[i].NavegacionTrafico;
            ubicacionModel.FechaHoraSalidaLlegada = moment(model[i].FechaHoraSalidaLlegada).format('YYYY-MM-DDTHH:mm:ss');
            ubicacionModel.TipoEstacion = model[i].TipoEstacion;
            ubicacionModel.DistanciaRecorrida = model[i].DistanciaRecorrida;
            // cartaporte20:Ubicaciones:Ubicacion:Domicilio
            ubicacionModel.Calle = model[i].Calle;
            ubicacionModel.NumeroExterior = model[i].NumeroExterior;
            ubicacionModel.NumeroInterior = model[i].NumeroInterior;
            ubicacionModel.Colonia = model[i].Colonia;
            ubicacionModel.Localidad = model[i].Localidad;
            ubicacionModel.Referencia = model[i].Referencia;
            ubicacionModel.Municipio = model[i].Municipio;
            ubicacionModel.Estado = model[i].Estado;
            ubicacionModel.Pais = model[i].Pais;
            ubicacionModel.CodigoPostal = model[i].CodigoPostal;
            arrayModel.push(ubicacionModel);
        }
        return arrayModel;
    }

    // CONCEPTS
    FillConceptsCartaPorte = (conceptsArray) => {
        let auxConcepts = [];
        for (let y = 0; y < conceptsArray.length; y++) {
            const conceptDB = conceptsArray[y];
            let conceptModel = new ConceptoPorte();
            conceptModel.Cantidad = conceptDB.Cantidad;
            conceptModel.ClaveUnidad = conceptDB.ClaveUnidad;
            conceptModel.Unidad = conceptDB.Unidad;
            conceptModel.ShowUnidad = conceptDB.ShowUnidad;
            conceptModel.ClaveProdServ = conceptDB.ClaveProdServ;
            conceptModel.Descripcion = conceptDB.Descripcion;
            conceptModel.ValorUnitario = conceptDB.ValorUnitario;
            conceptModel.ObjetoImp = conceptDB.ObjetoImp;
            conceptModel.NoIdentificacion = conceptDB.NoIdentificacion;
            conceptModel.Importe = conceptDB.Importe;
            conceptModel.idFMBConcept = conceptDB.idFMBConcept;
            conceptModel.Descuento = conceptDB.Descuento;

            auxConcepts.push(conceptModel);
        }
        return auxConcepts;
    }

    //#endregion

    AcceptEditModeAdministratorUsers = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newAdminUsersEditMode } = this.state;
        if (model.USER_CODE === '') {
            showAlert({ type: 'warning', message: "Aviso: El código no puede ir vacío" })
            return;
        }
        if (model.U_NAME === '') {
            showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            return;
        }
        if (model.E_Mail === '') {
            showAlert({ type: 'warning', message: "Aviso: El correo no puede ir vacío" })
            return;
        }
        if (!EMAIL_FORMAT_REGEX.test(model.E_Mail)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });
        if (model.U_FMB_CC !== '' && !EMAIL_FORMAT_REGEX.test(model.U_FMB_CC)) {
            showAlert({ type: 'warning', message: "Aviso: Por favor, revisa el formato, Ejemplo: nombre@correo.com" })
            return;
        }
        if (model.U_FMB_role === '' || model.U_FMB_role === '---') {
            showAlert({ type: 'warning', message: "Aviso: El tipo de usuario no puede ir vacío" })
            return;
        }
        if ((model.U_FMB_Sucursal === '' || model.U_FMB_Sucursal === '---')) {
            showAlert({ type: 'warning', message: "Aviso: Escoge alguna sucursal" })
            return;
        }
        if ((model.U_FMB_Sucursal === '' || model.U_FMB_Sucursal === '---') && model.U_FMB_role != '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge alguna sucursal" })
            return;
        }
        if ((model.U_FMB_ConfigModules === '' || model.U_FMB_ConfigModules === '---') && model.U_FMB_role !== 'branch1') {
            showAlert({ type: 'warning', message: "Aviso: Guarda las configuraciones de usuario." })
            return;
        }
        if ((model.U_FMB_CounterRol === '' || model.U_FMB_CounterRol === '---') && model.U_FMB_role !== 'branch1') {
            showAlert({ type: 'warning', message: "Aviso: Escoge rol para CounterOne" })
            return;
        }



        for (const key in model.itemsDashboard) {
            if (Object.hasOwnProperty.call(model.itemsDashboard, key)) {
                let module = model.itemsDashboard[key];
                delete module.selected
            }
        }
        let itemsDashboard = model.itemsDashboard;
        let series = model.series;
        model.U_FMB_Modulos = model.itemsDashboard;
        let data = {
            model: model,
        };
        enableSpinner(true);
        let response = await apiClient.updateAdminUsers(data);
        enableSpinner(false);

        if (response.status === 1) {
            await this.OpenAdministratorUsersDetails(newAdminUsersEditMode.open, true);
            showAlert({ type: 'success', message: response.message });
            this.administratorUsersModal.setState({
                editMode: false
            })
            $('#adminUsersModal').modal('hide');
            this.searchDocuments();
        } else {
            const safeMessage = response?.message?.trim() ? response.message : 'Ocurrió un error al actualizar el usuario. Intenta nuevamente.';
            showAlert({ type: 'error', message: safeMessage });
            model.itemsDashboard = itemsDashboard;
            model.series = series;
            await this.setState({
                adminUsersModel: model
            })
        }
    };

    SendAdministratorUsersModel = async adminUsersModel => {
        const { enableSpinner, notificationReducer: { showAlert }, UpdateConfigUserFields } = this.props;

        if (adminUsersModel.USER_CODE === '') {
            showAlert({ type: 'warning', message: "Aviso: El código no puede ir vacío" })
            return;
        }
        if (adminUsersModel.U_NAME === '') {
            showAlert({ type: 'warning', message: "Aviso: El nombre no puede ir vacío" })
            return;
        }
        if (adminUsersModel.E_Mail === '') {
            showAlert({ type: 'warning', message: "Aviso: El correo no puede ir vacío" })
            return;
        }
        if (!EMAIL_FORMAT_REGEX.test(adminUsersModel.E_Mail)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });
        if (adminUsersModel.U_FMB_CC !== '' && !EMAIL_FORMAT_REGEX.test(adminUsersModel.U_FMB_CC)) {
            showAlert({ type: 'warning', message: "Aviso: Por favor, revisa el formato, Ejemplo: nombre@correo.com" })
            return;
        }
        if (adminUsersModel.U_FMB_role === '' || adminUsersModel.U_FMB_role === '---') {
            showAlert({ type: 'warning', message: "Aviso: El tipo de usuario no puede ir vacío" })
            return;
        }
        if (adminUsersModel.U_FMB_passwd === '') {
            showAlert({ type: 'warning', message: "Aviso: La contraseña no puede ir vacía" })
            return;
        }
        if ((adminUsersModel.U_FMB_Sucursal === '' || adminUsersModel.U_FMB_Sucursal === '---') && adminUsersModel.U_FMB_role !== '---') {
            showAlert({ type: 'warning', message: "Aviso: Escoge alguna sucursal" })
            return;
        }
        if ((adminUsersModel.U_FMB_CounterRol === '' || adminUsersModel.U_FMB_CounterRol === '---') && adminUsersModel.U_FMB_role !== 'branch1') {
            showAlert({ type: 'warning', message: "Aviso: Escoge rol para CounterOne" })
            return;
        }
        if ((adminUsersModel.U_FMB_CounterRol === '' || adminUsersModel.U_FMB_CounterRol === '---') && adminUsersModel.U_FMB_role !== 'branch1') {
            showAlert({ type: 'warning', message: "Aviso: Escoge rol para CounterOne" })
            return;
        }
        if ((adminUsersModel.U_FMB_ConfigModules === '' || adminUsersModel.U_FMB_ConfigModules === '---')) {
            showAlert({ type: 'warning', message: "Aviso: Guarda las configuraciones de usuario." })
            return;
        }

        let itemsDashboard = adminUsersModel.itemsDashboard;
        let series = adminUsersModel.series;
        // adminUsersModel.itemsDashboard = []; 708
        // adminUsersModel.series = [];
        // adminUsersModel.newSeries = [];
        if (adminUsersModel.U_FMB_Modulos === '') {
            adminUsersModel.U_FMB_Modulos = adminUsersModel.itemsDashboard;
        }
        const data = {
            model: adminUsersModel,
        };
        // return
        enableSpinner(true);
        let response = await apiClient.createAdminUsers(data);
        enableSpinner(false);

        if (response.status === 1) {
            showAlert({ type: 'success', message: response.message });
            setTimeout(() => {

                UpdateConfigUserFields(null)
                this.setState({
                    showBusinessPartnerFields: false,
                })
                $('#adminUsersModal').modal('hide');
            }, 100);
            this.searchDocuments();
        } else {
            showAlert({ type: 'error', message: response.message });
            adminUsersModel.itemsDashboard = itemsDashboard;
            adminUsersModel.series = series;
            await this.setState({
                adminUsersModel
            })
        }
    };

    RefreshAdministratorUsersModel = adminUsersModel => {
        this.setState({
            adminUsersModel
        })
    };

    CancelEditModeAdministratorUsers = async () => {
        const { newAdminUsersEditMode } = this.state;
        let newOrderResponse = await this.fillsAdministratorUsersDetailsModel(newAdminUsersEditMode.usersResponse, newAdminUsersEditMode.open);
        this.setState({
            adminUsersModel: newOrderResponse,
        });
    };

    ChangePasswordAdministratorUsers = async adminUsersModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newAdminUsersEditMode } = this.state;
        if (adminUsersModel.OldPassword === '') {
            showAlert({ type: 'warning', message: 'Por favor escriba su contraseña actual' })
            return;
        }

        if (adminUsersModel.OldPassword !== adminUsersModel.U_FMB_passwdDecrypt) {
            showAlert({ type: 'error', message: 'Aviso: La contraseña actual es incorrecta' })
            return;
        }

        if (adminUsersModel.U_FMB_passwdNew === '') {
            showAlert({ type: 'warning', message: 'Aviso: Escribe una contraseña nueva' })
            return;
        }

        if (adminUsersModel.U_FMB_passwdConfirm === '') {
            showAlert({ type: 'warning', message: 'Aviso: Vuelve a escribir tu nueva contraseña' })
            return;
        }

        if (adminUsersModel.U_FMB_passwdNew !== adminUsersModel.U_FMB_passwdConfirm) {
            showAlert({ type: 'error', message: 'Aviso: Las contraseñas no coinciden' })
            return;
        }

        if (adminUsersModel.U_FMB_passwdNew === adminUsersModel.U_FMB_passwdConfirm && adminUsersModel.OldPassword === adminUsersModel.U_FMB_passwdDecrypt) {

            let data = {
                code: adminUsersModel.USERID,
                password: adminUsersModel.U_FMB_passwdNew
            }

            enableSpinner(true);
            let response = await apiClient.updatePassAdminUsers(data);
            enableSpinner(false);

            if (response.status === 1) {
                await this.OpenAdministratorUsersDetails(newAdminUsersEditMode.open, true);
                showAlert({ type: 'success', message: response.message });
                $('#changePasswordModal').modal('hide');
            }
        }
    };

    SaveMITData = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { adminUsersModel, newAdminUsersEditMode } = this.state;

        if (adminUsersModel.new_user_MIT === '') {
            showAlert({ type: 'error', message: 'NO PUEDES GUARDAR VACIO EL USUARIO MIT' })
            return;
        }
        if (adminUsersModel.new_pass_MIT === '') {
            showAlert({ type: 'error', message: 'NO PUEDES GUARDAR VACIO LA CONTRASEÑA MIT' })
            return;
        }

        const data = {
            mit_user: adminUsersModel.new_user_MIT,
            mit_pass: adminUsersModel.new_pass_MIT,
            code: adminUsersModel.USERID,
        }

        enableSpinner(true);
        const response = await apiClient.saveMITData(data);
        enableSpinner(false);

        if (response.status !== 1) {
            showAlert({ type: 'error', message: response.message })
            return
        }

        if (response.status === 1) {
            await this.OpenAdministratorUsersDetails(newAdminUsersEditMode.open, true);
            showAlert({ type: 'success', message: response.message });
            $('#changePasswordModal').modal('hide');
        }


    }

    DeleteAdministratorUsers = async adminUsersModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        let data = {
            code: adminUsersModel.USERID,
        }

        enableSpinner(true);
        let response = await apiClient.deleteAdminUsers(data);
        enableSpinner(false);

        if (response.status === 1) {
            showAlert({ type: 'success', message: response.message });
            $('#adminUsersModal').modal('hide');
            this.searchDocuments();
        }
    };

    SearchUsers = (selectedOption, option) => {
        if (option === 1) {
            this.setState({
                groupSucursal: selectedOption ? selectedOption.value : '---',
                PageNumber: 1
            }, () => {
                this.searchDocuments();
            });
        }
    };

    CloseDocumentModal = async () => {
        await this.setState({
            showDocumentModal: false,
            useNewModal: false
        });

    }

    EnnableUpdateTimbraDocModal = async () => {
        await this.setState({
            showUpdateTimbraDocModal: !this.state.showUpdateTimbraDocModal
        })
    }

    ChangeEditModeTimbraDocModal = async () => {
        await this.setState({
            editModeUpdateTimbraDocModel: !this.state.editModeUpdateTimbraDocModel,
            actionUpdateTimbraDoc: !this.state.actionUpdateTimbraDoc
        })
        // await this.ChangeActionTimbraDoc();
    }

    ChangeActionTimbraDoc = async () => {
        await this.setState({
            actionUpdateTimbraDoc: !this.state.actionUpdateTimbraDoc
        })
    }

    OpenPendingTimbraDocsDetail = async (document) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const typeDoc = $('#selectDocTypeDocumentSearchPTD').val() ?? '--';
        if (typeDoc === '--') {
            showAlert({ type: 'info', timeOut: 5000, message: "No has seleccionado un tipo de documento para buscar" });
            return
        }

        const data = {
            Document: document,
            TypeDoc: typeDoc
        }

        enableSpinner(true);
        const detailsResponse = await apiClient.getInfoPendingTimbraDocs(data);
        enableSpinner(false);

        if (detailsResponse.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: detailsResponse?.message ?? 'Error' });
            return
        }
        const filledUpdateDocModel = await this.FilleUpdateDocModel(detailsResponse.data);
        await this.GetRegimenFiscal();
        await this.GetUseCFDI();

        await this.setState({
            updateTimbraDocModel: filledUpdateDocModel,
            timbraDocCache: document
        })

        await this.EnnableUpdateTimbraDocModal();
        $('#updateTimbraDocModal').modal('show');

    }

    OpenCitibanamexDetail = async (document) => {

    }

    FilleUpdateDocModel = (data) => {
        if (data === null) return
        let newUpdateModel = new TimbraDocModel();
        newUpdateModel.DocEntry = data?.DocEntry ?? '';
        newUpdateModel.TypeDoc = data?.TypeDoc ?? '';
        newUpdateModel.CardName = data?.CardName ?? '';
        newUpdateModel.LicTradNum = data?.LicTradNum ?? '';
        newUpdateModel.ZipCode = data?.billAddress?.ZipCode ?? '';
        newUpdateModel.U_FMB_FORMA_PAGO = data?.U_FMB_FORMA_PAGO ?? '';
        newUpdateModel.U_FMB_METODO_PAGO = data?.U_FMB_METODO_PAGO ?? '';
        newUpdateModel.U_FMB_REGIMEN_FISCAL = data?.U_FMB_REGIMEN_FISCAL ?? '';
        newUpdateModel.U_FMB_USO_CFDI = data?.U_FMB_USO_CFDI ?? '';
        newUpdateModel.U_FMB_AUX_CARDNAME = data?.U_FMB_AUX_CARDNAME ?? '';
        // newUpdateModel.TimbraDate = data.U_FMB_USO_CFDI ? data?.TimbraDate : moment(new Date()).format('YYYY-MM-DD');

        return newUpdateModel;
    }

    GetUseCFDI = async () => {
        if (this.state.CFDI && this.state.CFDI.length === 0) {
            const cfdi = await apiClient.getUsoCFDI();
            if (Array.isArray(cfdi.data) && cfdi.data.length) {
                this.setState({
                    CFDI: cfdi.data,
                });
            }
        }
    };

    GetRegimenFiscal = async () => {
        if (this.state.RegimenFiscal && this.state.RegimenFiscal.length === 0) {
            const regimenFiscal = await apiClient.getRegimenFiscal();
            if (Array.isArray(regimenFiscal.data) && regimenFiscal.data.length) {
                this.setState({
                    RegimenFiscal: regimenFiscal.data,
                });
            }
        }
    };

    CloseUpdateDocModel = async () => {
        $('#updateTimbraDocModal').modal('hide');
        await this.setState({
            editModeUpdateTimbraDocModel: false,
            showUpdateTimbraDocModal: false,
            updateTimbraDocModel: new TimbraDocModel(),
        })

    }

    UpdateTimbraDocModel = async (updateTimbraDocModel) => {
        await this.setState({
            updateTimbraDocModel
        })
    }

    UpdateTimbraDoc = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { updateTimbraDocModel, timbraDocCache } = this.state;

        const typeDoc = $('#selectDocTypeDocumentSearchPTD').val() ?? '--';
        if (typeDoc === '--') {
            showAlert({ type: 'info', timeOut: 5000, message: "No has seleccionado un tipo de documento para buscar" });
            return
        }
        if (!this.ValidateTimbraDocModel()) return

        const data = {
            updateTimbraDocModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.updateTimbraDocModel(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error' });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: `Actualizado con exito` });
        if (timbraDocCache !== null) await this.CloseUpdateDocModel(timbraDocCache);

    }

    ValidateTimbraDocModel = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { updateTimbraDocModel } = this.state
        let flag = true;
        const typeDoc = $('#selectDocTypeDocumentSearchPTD').val() ?? '--';
        // validate if a some property has a emty value

        if (updateTimbraDocModel.CardName === '') {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo NOMBRE esta vacio" });
            return
        }
        if (Number(typeDoc) !== 24 && updateTimbraDocModel.LicTradNum === '') {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo RUT esta vacio" });
            return
        }
        if (Number(typeDoc) !== 24 && updateTimbraDocModel.ZipCode === '') {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo CÓDIGO POSTAL FACTURACION esta vacio" });
            return
        }
        if (updateTimbraDocModel.U_FMB_FORMA_PAGO === '') {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo FORMA PAGO esta vacio" });
            return
        }
        if (updateTimbraDocModel.U_FMB_REGIMEN_FISCAL === '') {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo REGIMEN FISCAL esta vacio" });
            return
        }
        if (updateTimbraDocModel.U_FMB_USO_CFDI === '') {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo USO CFDI esta vacio" });
            return
        }
        if (!RFC_FORMAT.test(updateTimbraDocModel.LicTradNum)) {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo RUT no cumple con los parametros validos para un RUT" });
            return
        }
        if (updateTimbraDocModel.CardName.length > 100) {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo NOMBRE tiene mas de 100 caracteres y no esta permitido" });
            return
        }
        if (updateTimbraDocModel.U_FMB_AUX_CARDNAME.length > 200) {
            showAlert({ type: 'warning', timeOut: 5000, message: "EL campo NOMBRE tiene mas de 200 caracteres y no esta permitido" });
            return
        }
        if (updateTimbraDocModel.U_FMB_METODO_PAGO && updateTimbraDocModel.U_FMB_METODO_PAGO !== '') {
            if (updateTimbraDocModel.U_FMB_METODO_PAGO && updateTimbraDocModel.U_FMB_FORMA_PAGO !== '') {
                if (updateTimbraDocModel.U_FMB_METODO_PAGO === 'PUE' && updateTimbraDocModel.U_FMB_FORMA_PAGO === '99') {
                    showAlert({ type: "info", message: `El método "Pago en una exhibición" no puede ir con la forma de pago "Por definir"` });
                    return
                } else if (updateTimbraDocModel.U_FMB_METODO_PAGO === 'PPD' && updateTimbraDocModel.U_FMB_FORMA_PAGO !== '99') {
                    showAlert({ type: "info", message: `El método "Pago en parcialidades o diferido" solo puede ir con la forma de pago "Por definir"` });
                    return
                }
            }
            else {
                showAlert({ type: "warning", message: `Seleccione un método de pago valido` });
                return
            }
        }

        return flag;
    }

    refreshVendor = vendorData => {
        const { refreshVendor } = this.props;
        refreshVendor(vendorData);
    };

    //#region ######### AUTHO PARTNERS #################################################
    ChangeAuthoTypeBP = async (value) => {
        await this.setState({
            docStatusSearchAuthoBP: value
        })
    }

    ChangeAuthoPartnersAction = async (value) => {
        await this.setState({
            authoPartnersAction: value
        })
    }

    ChangeAttentionType = async (value, section = 1) => {
        if (section === 2) {
            await this.setState({
                U_FMB_AttentionType2: value
            })
        } else {
            await this.setState({
                U_FMB_AttentionType: value
            })
        }
    }

    SendAuthorizations = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props
        const { checkboxDataTables, authoPartnersAction, docStatusSearchAuthoBP } = this.state
        let selectedPartners = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                selectedPartners.push(data[id]);
            }
        }

        if (selectedPartners.length === 0) {
            showAlert({ type: 'error', message: 'No has seleccionado ningun registro' });
            return;
        }

        if (authoPartnersAction === '') {
            showAlert({ type: 'error', message: 'No has seleccionado el tipo de autorizacion.' });
            return;
        }

        if (docStatusSearchAuthoBP !== 'W') {
            showAlert({ type: 'error', message: 'Solo puedes realizar acciones con solicitudes de autorizacion pendientes.' });
            return;
        }

        const dataSend = {
            selectedPartners,
            authoPartnersAction
        }

        enableSpinner(true);
        const responseApi = await apiClient.sendAuthorizations(dataSend);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return;
        }

        if (responseApi?.data?.cardCodesActionFail?.length) {
            this.setState({
                billingResponseArray: responseApi.data.cardCodesActionFail.map((message) => ({ docNum: "", message: message, billing: "ERROR" })),
            })

            return $('#billingResponseModal').modal('show');
        }

        showAlert({ type: 'success', message: responseApi.message });

        this.setState({
            driverModel: new Driver(),
            driverModalAction: 1
        })
        await this.searchDocuments();

    }

    ShowAuthorizePartnersDetails = async (info) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const partnerObject = JSON.parse(info.body);
        if (Number(info.type) === 2) {
            const data = {
                CardCode: partnerObject.CardCode,
                partnerObject
            }
            enableSpinner(true);
            const responseApi = await apiClient.showAuthorizePartnerDetails(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: responseApi.message });
                return
            }
            const authorizeModel = await this.FillAuthorizePartnerInfo(responseApi.data.headerInfo, responseApi.data.shipDirection, responseApi.data.billDirection, partnerObject.BPAddresses);
            await this.setState({
                authorizePartnerModel: authorizeModel
            })
        } else if (info.type === 1) {
            const authorizeModel = await this.FillExistedInfoNewPartner(partnerObject);
            await this.setState({
                authorizePartnerModel: authorizeModel
            })
        }
        await this.setState({
            ennableDetailAuthoPartner: true,
            typeAuthoPartner: info.type
        })
        $('#approveBusinessPartnerModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    }

    CloseActionsAuthorizePartners = async () => {
        $('#approveBusinessPartnerModal').modal('hide');
        await this.setState({
            ennableDetailAuthoPartner: false,
            authorizePartnerModel: new AuthorizePartnerModel(),
        })

    }

    FillExistedInfoNewPartner = (newPartner) => {
        let authorizePartnerModel = new AuthorizePartnerModel();
        authorizePartnerModel.CardCode = newPartner.CardCode ?? '';
        authorizePartnerModel.CardName = newPartner.CardName ?? '';
        authorizePartnerModel.E_Mail = newPartner.EmailAddress ?? '';
        authorizePartnerModel.Phone1 = newPartner.Phone1 ?? '';
        authorizePartnerModel.LicTradNum = newPartner.FederalTaxID ?? '';

        if (newPartner.BPAddresses) {
            for (let index = 0; index < newPartner.BPAddresses.length; index++) {
                const address = newPartner.BPAddresses[index];
                if (address.AddressType === "bo_ShipTo") {
                    //#region ######### newShipDirection #################################################
                    authorizePartnerModel.NewShipDirection.Address = address.AddressName ?? '';
                    authorizePartnerModel.NewShipDirection.Street = address.Street ?? '';
                    authorizePartnerModel.NewShipDirection.Block = address.Block ?? '';

                    authorizePartnerModel.NewShipDirection.City = address.City ?? '';
                    authorizePartnerModel.NewShipDirection.ZipCode = address.ZipCode ?? '';
                    authorizePartnerModel.NewShipDirection.County = address.County ?? '';

                    authorizePartnerModel.NewShipDirection.State = address.State ?? '';
                    authorizePartnerModel.NewShipDirection.Country = address.Country ?? '';

                    authorizePartnerModel.NewShipDirection.TypeOfAddress = address.AddressType ?? '';
                    authorizePartnerModel.NewShipDirection.U_FMB_GPSLat = address.U_FMB_GPSLat ?? '';
                    authorizePartnerModel.NewShipDirection.U_FMB_GPSLon = address.U_FMB_GPSLon ?? '';
                    //#endregion
                } else if (address.AddressType === "bo_BillTo") {
                    //#region ######### newShipDirection #################################################
                    authorizePartnerModel.NewBillDirection.Address = address.AddressName ?? '';
                    authorizePartnerModel.NewBillDirection.Street = address.Street ?? '';
                    authorizePartnerModel.NewBillDirection.Block = address.Block ?? '';

                    authorizePartnerModel.NewBillDirection.City = address.City ?? '';
                    authorizePartnerModel.NewBillDirection.ZipCode = address.ZipCode ?? '';
                    authorizePartnerModel.NewBillDirection.County = address.County ?? '';

                    authorizePartnerModel.NewBillDirection.State = address.State ?? '';
                    authorizePartnerModel.NewBillDirection.Country = address.Country ?? '';

                    authorizePartnerModel.NewBillDirection.TypeOfAddress = address.AddressType ?? '';
                    authorizePartnerModel.NewBillDirection.U_FMB_GPSLat = address.U_FMB_GPSLat ?? '';
                    authorizePartnerModel.NewBillDirection.U_FMB_GPSLon = address.U_FMB_GPSLon ?? '';
                    //#endregion
                }
            }

        }

        return authorizePartnerModel;
    }

    FillAuthorizePartnerInfo = (headerInfo, shipDirection, billDirection, arrayNewDirections) => {
        let authorizePartnerModel = new AuthorizePartnerModel();

        authorizePartnerModel.CardCode = headerInfo.CardCode ?? '';
        authorizePartnerModel.CardName = headerInfo.CardName ?? '';
        authorizePartnerModel.E_Mail = headerInfo.E_Mail ?? '';
        authorizePartnerModel.LicTradNum = headerInfo.LicTradNum ?? '';
        authorizePartnerModel.Phone1 = headerInfo.Phone1 ?? '';
        //#region ######### shipDirection #################################################
        authorizePartnerModel.OriginShipDirection.Address = shipDirection.Address ?? '';
        authorizePartnerModel.OriginShipDirection.Street = shipDirection.Street ?? '';
        authorizePartnerModel.OriginShipDirection.Block = shipDirection.Block ?? '';

        authorizePartnerModel.OriginShipDirection.City = shipDirection.City ?? '';
        authorizePartnerModel.OriginShipDirection.ZipCode = shipDirection.ZipCode ?? '';
        authorizePartnerModel.OriginShipDirection.County = shipDirection.County ?? '';

        authorizePartnerModel.OriginShipDirection.State = shipDirection.State ?? '';
        authorizePartnerModel.OriginShipDirection.Country = shipDirection.Country ?? '';

        authorizePartnerModel.OriginShipDirection.U_FMB_GPSLat = shipDirection.U_FMB_GPSLat ?? '';
        authorizePartnerModel.OriginShipDirection.U_FMB_GPSLon = shipDirection.U_FMB_GPSLon ?? '';
        //#endregion

        //#region ######### billDirection #################################################
        authorizePartnerModel.OrigiBillDirection.Address = billDirection.Address ?? '';
        authorizePartnerModel.OrigiBillDirection.Street = billDirection.Street ?? '';
        authorizePartnerModel.OrigiBillDirection.Block = billDirection.Block ?? '';

        authorizePartnerModel.OrigiBillDirection.City = billDirection.City ?? '';
        authorizePartnerModel.OrigiBillDirection.ZipCode = billDirection.ZipCode ?? '';
        authorizePartnerModel.OrigiBillDirection.County = billDirection.County ?? '';

        authorizePartnerModel.OrigiBillDirection.State = billDirection.State ?? '';
        authorizePartnerModel.OrigiBillDirection.Country = billDirection.Country ?? '';

        authorizePartnerModel.OrigiBillDirection.U_FMB_GPSLat = billDirection.U_FMB_GPSLat ?? '';
        authorizePartnerModel.OrigiBillDirection.U_FMB_GPSLon = billDirection.U_FMB_GPSLon ?? '';
        //#endregion

        if (arrayNewDirections && Array.isArray(arrayNewDirections)) {
            for (let index = 0; index < arrayNewDirections.length; index++) {
                const address = arrayNewDirections[index];
                if (address.AddressType === "bo_ShipTo") {
                    //#region ######### newShipDirection #################################################
                    authorizePartnerModel.NewShipDirection.Address = address.AddressName ?? '';
                    authorizePartnerModel.NewShipDirection.Street = address.Street ?? '';
                    authorizePartnerModel.NewShipDirection.Block = address.Block ?? '';

                    authorizePartnerModel.NewShipDirection.City = address.City ?? '';
                    authorizePartnerModel.NewShipDirection.ZipCode = address.ZipCode ?? '';
                    authorizePartnerModel.NewShipDirection.County = address.County ?? '';

                    authorizePartnerModel.NewShipDirection.State = address.State ?? '';
                    authorizePartnerModel.NewShipDirection.Country = address.Country ?? '';

                    authorizePartnerModel.NewShipDirection.TypeOfAddress = address.AddressType ?? '';
                    authorizePartnerModel.NewShipDirection.U_FMB_GPSLat = address.U_FMB_GPSLat ?? '';
                    authorizePartnerModel.NewShipDirection.U_FMB_GPSLon = address.U_FMB_GPSLon ?? '';
                    //#endregion
                } else if (address.AddressType === "bo_BillTo") {
                    //#region ######### newShipDirection #################################################
                    authorizePartnerModel.NewBillDirection.Address = address.AddressName ?? '';
                    authorizePartnerModel.NewBillDirection.Street = address.Street ?? '';
                    authorizePartnerModel.NewBillDirection.Block = address.Block ?? '';

                    authorizePartnerModel.NewBillDirection.City = address.City ?? '';
                    authorizePartnerModel.NewBillDirection.ZipCode = address.ZipCode ?? '';
                    authorizePartnerModel.NewBillDirection.County = address.County ?? '';

                    authorizePartnerModel.NewBillDirection.State = address.State ?? '';
                    authorizePartnerModel.NewBillDirection.Country = address.Country ?? '';

                    authorizePartnerModel.NewBillDirection.TypeOfAddress = address.AddressType ?? '';
                    authorizePartnerModel.NewBillDirection.U_FMB_GPSLat = address.U_FMB_GPSLat ?? '';
                    authorizePartnerModel.NewBillDirection.U_FMB_GPSLon = address.U_FMB_GPSLon ?? '';
                    //#endregion
                }
            }
        }

        return authorizePartnerModel;
    }

    //#endregion

    //#region ######### ADMINISTRATOR DELIVERIES 2.0 #################################################

    // RefreshRouteDoc = async (DeliveryRouteDoc) => {
    //     await this.setState({ DeliveryRouteDoc });
    // }

    RefreshRouteDoc = (DeliveryRouteDoc) => {
        return new Promise((resolve) => {
            this.setState({ DeliveryRouteDoc }, () => {
                resolve();
            });
        });
    };

    GetEstimatedRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { DeliveryRouteDoc, _user } = this.state

        enableSpinner(true);
        const responseApi = await apiClient.GetEstimatedRoute();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        DeliveryRouteDoc.Code = `${_user?.Branch?.CodeBranchOffice ?? ''}RTDL${((Number(responseApi.data?.lastRow?.IdORDL ?? 1) + 1) ?? '')}`;
        this.RefreshRouteDoc(DeliveryRouteDoc)
    }

    NewDocumentDelivery = async () => {
        await this.setState({
            DeliveryRouteDoc: new RouteDocDelivery(),
            DocDeliveryAction: 1,  //show,
            MountDocDeliveryModal: true
        })

        await this.GetEstimatedRoute();
        await this.GetAdminDeliveriesData();
        await this.getPolygons();
        $('#NewDocDelivery20').modal({ backdrop: 'static', keyboard: false }, 'show');
    }

    getPolygons = async () => {
        const search = {}
        const responseApi = await apiClient.getPolygons(search);
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                ActualRoutes: responseApi?.data || []
            })
        }
    }

    GetAdminDeliveriesData = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getAdminDeliveriesData();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }
        let drivers = responseApi.data?.drivers ?? []
        let vehicles = responseApi.data?.vehicles ?? []
        if (view === 'transports' || view === 'adminDeliveries20') {
            drivers = responseApi.data?.driversVentas ?? []
            drivers = drivers ? drivers.map(driver => ({
                value: driver?.empID ?? -1,
                label: `${driver.firstName} ${driver.lastName}`
            })) : [];

            vehicles = vehicles ? vehicles.map(vehicle => ({
                value: vehicle?.CodigoAutotransporte ?? -1,
                label: `Placa: ${vehicle.PlacaVM} - ${vehicle.CodigoUnidad}`,
                U_FMB_Driver: vehicle?.U_FMB_Driver ?? -1,
                pk_Sucursal: vehicle?.pk_Sucursal ?? null
            })) : [];
        }
        await this.setState({
            availableDrivers: drivers ?? [],
            availableVehicles: vehicles ?? [],
            // ActualRoutes: responseApi.data?.routes ?? []
        });
    }

    GenerateRouteDocByIA = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { availableVehicles, DeliveryRouteDoc } = this.state
        if (DeliveryRouteDoc.CodigoAutotransporte === "") {
            showAlert({ type: 'info', message: `PARA ESTA VERSION DEBES DE SELECCIONAR EL VEHICULO DISPONIBLE` });
            return
        }
        const findVehicle = availableVehicles.find((element) => Number(element.CodigoAutotransporte) === Number(DeliveryRouteDoc.CodigoAutotransporte));

        if (findVehicle === undefined) return

        if (isNaN(findVehicle.SupportWeight)) {
            showAlert({ type: 'info', message: `EL TRANSPORTE SELECCIONADO NO TIENE UN VALOR VALIDO EN EL PESO SOPORTADO` });
        }

        const data = {
            DeliveryRouteDoc,
            SupportWeight: Number(findVehicle.SupportWeight) * 1000
        }

        enableSpinner(true);
        const responseApi = await apiClient.GenerateRouteDocByIA(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        if (responseApi.data.Lines && responseApi.data.Lines.length === 0) {
            showAlert({ type: 'warning', message: `BOTIÑO: LO SIENTO CON EL PESO SELECCIONADO (${Number(findVehicle.SupportWeight)}) NO PUDE DETERMINAR MERCANCIA A ENTREGAR` });
            return;
        } else if (responseApi.data.Lines && responseApi.data.Lines.length > 0) {
            showAlert({ type: 'info', message: `ESTAS SON LAS MERCANCIAS QUE SUGIERO ENVIAR POR EL PESO SOPORTADO POR LA UNIDAD ${findVehicle.TipodeUnidad}`, timeOut: 7000 });
        }

        const newRouteModel = await this.FillRouteDocByR2D2(responseApi.data, DeliveryRouteDoc);
        const Waypoints = await this.DefineWaypoints(newRouteModel.DocsLines)
        this.setState({
            DeliveryRouteDoc: newRouteModel,
            Waypoints
        });

    }

    OpenAvailableManualLines = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { U_FMB_AttentionType2 = '' } = this.state;

        enableSpinner(true);
        let data = { U_FMB_AttentionType: U_FMB_AttentionType2 };
        const responseApi = await apiClient.GetAvailableManualLines(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        if (responseApi.data.length > 0) {
            await this.setState({
                AvailableDeliveryLines: responseApi.data ?? [],
                MountListAvailableLines: true
            })
            $('#pendingDeliveries').modal({ backdrop: 'static', keyboard: false }, 'show');
        } else {
            showAlert({ type: 'info', message: `No hay entregas a clientes disponibles` });
        }
    }

    SaveChooseManualLines = async (newMap) => {
        await this.setState({
            checkboxDocDeliveries: newMap
        })
    }

    ChangeAnyPropInState = async (propName, value) => {
        await this.setState({
            [propName]: value
        })
    }

    CloseActionListDocsDeliveries = async () => {

        await this.setState({
            AvailableDeliveryLines: [],
            MountListAvailableLines: false
        })
    }

    FillOneLineWithData = (suggestLine, LineByBot) => {
        let lineDocDelivery = new DocsLineRouteDelivery();

        lineDocDelivery.IdRDL1 = suggestLine?.IdRDL1 ?? -1;
        lineDocDelivery.DocEntry = suggestLine.DocEntry ?? -1;
        lineDocDelivery.DocNum = suggestLine.DocNum ?? -1;

        lineDocDelivery.CardCode = suggestLine.CardCode;
        lineDocDelivery.CardName = suggestLine.CardName;
        lineDocDelivery.U_FMB_GPSLat = suggestLine.U_FMB_GPSLat;
        lineDocDelivery.U_FMB_GPSLon = suggestLine.U_FMB_GPSLon;

        lineDocDelivery.DocTotal = suggestLine.LineTotal ?? 0.0;
        lineDocDelivery.Weight = suggestLine.Weight ?? -1;

        lineDocDelivery.IdORDL = suggestLine.IdORDL ?? -1;
        // lineDocDelivery.DocStatus = suggestLine.DocStatus; 
        // lineDocDelivery.Comments = suggestLine.Comments || '';
        // lineDocDelivery.NewDocEntry = suggestLine.NewDocEntry || '';

        lineDocDelivery.ObjType = suggestLine.ObjType ?? -1;
        lineDocDelivery.NumAtCard = suggestLine.NumAtCard ?? "";
        lineDocDelivery.ItemName = suggestLine.Dscription ?? "";
        lineDocDelivery.Quantity = suggestLine.Quantity ?? "";
        lineDocDelivery.LineTotal = suggestLine.LineTotal ?? 0.0;
        lineDocDelivery.TotalWeightLine = suggestLine?.weight ?? 0.0;
        lineDocDelivery.LineByBot = LineByBot;
        lineDocDelivery.LineNum = suggestLine?.LineNum ?? -1;
        lineDocDelivery.ShipToCode = suggestLine.ShipToCode ?? "";
        lineDocDelivery.Address = suggestLine.Address ?? "";
        lineDocDelivery.Priority = suggestLine.value ?? -1;
        lineDocDelivery.AddressDesc = suggestLine.AddressDesc ?? null;
        lineDocDelivery.ItemCode = suggestLine.ItemCode ?? "";

        //VENTA GRANEL
        lineDocDelivery.U_RS_TIPOV = suggestLine.U_RS_TIPOV ?? "";
        lineDocDelivery.U_RS_CANTG = suggestLine.U_RS_CANTG ?? "";
        lineDocDelivery.U_RS_PRECIOGL = suggestLine.U_RS_PRECIOGL ?? "";
        lineDocDelivery.U_RS_TOTALGL = suggestLine.U_RS_TOTALGL ?? "";
        lineDocDelivery.U_RS_UMED = suggestLine.U_RS_UMED ?? "";
        lineDocDelivery.ItmsGrpCod = suggestLine.ItmsGrpCod ?? "";

        lineDocDelivery.ColorPriority = this.DefineColorByPriority(lineDocDelivery.Priority)

        return lineDocDelivery
    }

    DefineColorByPriority = (Priority) => {
        let color = '#8c8c8c';
        switch (Priority) {
            case -1: /* no set prority */
                color = '#8c8c8c';
                break;
            case 3:/* ALTA, IT MUST TO DELIVER FIRST */
                color = '#EF9A9A';
                break;
            case 2:/* MEDIA, NORMAL CUSTEMER  */
                color = '#ffff00';
                break;
            case 1:/* CASUALLY CUSTOMER */
                color = '#4cd964';
                break;
            default:
                color = '#8c8c8c';
                break;
        }

        return color;
    }


    FillRouteDocByR2D2 = (infoDoc, DeliveryRouteDoc) => {
        let docDelivery = new RouteDocDelivery();
        docDelivery = DeliveryRouteDoc;
        docDelivery.DocsLines = [];

        if (infoDoc.Lines && infoDoc.Lines.length > 0) {
            for (let index = 0; index < infoDoc.Lines.length; index++) {
                const suggestLine = infoDoc.Lines[index];
                docDelivery.DocsLines.push(this.FillOneLineWithData(suggestLine, true))
            }
            docDelivery.NumMerch = infoDoc?.Header?.TotalItems ?? 0;
            docDelivery.WeightCharged = infoDoc?.Header?.TotalWeight ?? 0;
        }
        docDelivery.DocsLines = this.ProcessDeliveryDocsLines(docDelivery.DocsLines)
        return docDelivery
    }

    ChargeLinesManualToDeliveryDoc = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const { checkboxDocDeliveries, DeliveryRouteDoc, AvailableDeliveryLines } = this.state
        let auxDocDeliveryLines = DeliveryRouteDoc.DocsLines;

        // last version 
        // for (let [id, value] of checkboxDocDeliveries.entries()) {
        //     if (value) {
        //         const chooseLine = AvailableDeliveryLines[id];
        //         auxDocDeliveryLines.push(this.FillOneLineWithData(chooseLine, false));
        //     }
        // }
        // new version get availableLines by doc
        let findInfo = [];

        for (let [id, value] of checkboxDocDeliveries.entries()) {
            if (value) {
                const chooseLine = AvailableDeliveryLines[id];
                const findLine = auxDocDeliveryLines.findIndex(currLine => Number(currLine?.DocEntry ?? -1) === Number(chooseLine?.DocEntry ?? -2) && Number(currLine?.ObjType ?? -1) === Number(chooseLine?.ObjType ?? -2))

                if (findLine == -1) {
                    findInfo.push({ DocEntry: chooseLine.DocEntry, ObjType: chooseLine.ObjType, DocNum: chooseLine.DocNum, NumAtCard: chooseLine.NumAtCard })
                }
                // auxDocDeliveryLines.push(this.FillOneLineWithData(chooseLine, false));
            }
        }
        if ((findInfo?.length ?? 0) == 0) {
            return showAlert({ type: "error", message: `Este documento ya fue seleccionado.` });
        }

        const data = {
            docs: findInfo
        }

        enableSpinner(true);
        const responseApi = await apiClient.getAvailableInfoToRoute(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        for (let n = 0; n < responseApi.data.length; n++) {
            const element = responseApi.data[n];
            auxDocDeliveryLines.push(this.FillOneLineWithData(element, false));
        }



        DeliveryRouteDoc.DocsLines = auxDocDeliveryLines;
        DeliveryRouteDoc.NumMerch = DeliveryRouteDoc.DocsLines.length ?? 0;
        DeliveryRouteDoc.WeightCharged = DeliveryRouteDoc.DocsLines.reduce((accumulator, transaction) => { return accumulator + transaction.TotalWeightLine; }, 0);

        const Waypoints = await this.DefineWaypoints(DeliveryRouteDoc.DocsLines)

        this.RefreshRouteDoc(DeliveryRouteDoc);
        this.CloseActionListDocsDeliveries()
        this.setState({
            Waypoints
        })
    }

    AffectLinesByKey = async (affectKey, valueToSet) => {
        const { DeliveryRouteDoc } = this.state
        let auxArrayLines = DeliveryRouteDoc.DocsLines;
        for (let x = 0; x < auxArrayLines.length; x++) {
            const lineAdded = auxArrayLines[x];
            const actualKey = `${lineAdded.ShipToCode},${lineAdded.CardCode}`
            if (actualKey === affectKey) {
                lineAdded.Priority = valueToSet;
            }
        }
        let auxArray = DeliveryRouteDoc.DocsLines;
        DeliveryRouteDoc.DocsLines = []
        DeliveryRouteDoc.DocsLines = this.ProcessDeliveryDocsLines(auxArray)
        this.RefreshRouteDoc(DeliveryRouteDoc)
    }

    ProcessDeliveryDocsLines = (docs) => {
        const groupedDocs = {};

        // Agrupar los documentos por ShipToCode y CardCode
        docs.forEach(doc => {
            const key = `${doc.ShipToCode},${doc.CardCode}`;
            if (!groupedDocs[key]) {
                groupedDocs[key] = [];
            }
            groupedDocs[key].push(doc);
        });

        // Asignar colores a cada grupo
        Object.keys(groupedDocs).forEach(key => {
            groupedDocs[key].forEach(doc => {
                doc.ColorPriority = this.DefineColorByPriority(doc.Priority);;
            });
        });

        // Convertir el objeto agrupado de vuelta a un array
        const docsArray = Object.values(groupedDocs).flat();

        // Ordenar el array por Priority de mayor a menor
        docsArray.sort((a, b) => b.Priority - a.Priority);

        return docsArray;
    }

    DefineWaypoints = (DocsLines) => {
        let Waypoints = []
        if (DocsLines.length === 0) return Waypoints

        for (let i = 0; i < DocsLines.length; i++) {
            const docLine = DocsLines[i];
            if (validCoordinate(docLine.U_FMB_GPSLon, docLine.U_FMB_GPSLat)) {
                const aux = {
                    lng: parseFloat(docLine.U_FMB_GPSLon),
                    lat: parseFloat(docLine.U_FMB_GPSLat),
                    ShipToCode: docLine?.ShipToCode ?? '',
                    CardName: docLine?.CardName ?? '',
                };
                Waypoints.push(aux);
                // Waypoints.push(aux);
            }
        }

        return Waypoints
    }

    CloseModalActions = () => {
        this.setState({
            Waypoints: []
        })
        $('#NewDocDelivery20').modal('hide');
    }

    CreateDeliveryDocument20 = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { DeliveryRouteDoc, U_FMB_AttentionType2 = '' } = this.state
        DeliveryRouteDoc.U_FMB_AttentionType = U_FMB_AttentionType2;
        const data = {
            DeliveryRouteDoc
        }

        enableSpinner(true);
        const responseApi = await apiClient.createdRouteDeliveries20(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: 'success', message: "Documento creado con exito", timeOut: 5000 });

        this.CloseModalActions();
        this.searchDocuments();
    }

    OpenDeliveryDocDetails20 = async (open, edit = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { DeliveryRouteDoc } = this.state
        const data = {
            Code: open.Code
        }
        // await this.GetAdminDeliveriesData()
        enableSpinner(true);
        const responseApi = await apiClient.getRouteDeliveryDetails20(data);

        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return;
        }

        const newDeliveryDoc = await this.FillRouteDocDetails(responseApi.data);
        const Waypoints = await this.DefineWaypoints(newDeliveryDoc.DocsLines)

        await this.getPolygons();
        this.RefreshRouteDoc(newDeliveryDoc);
        await this.setState({
            DocDeliveryAction: 2,
            Waypoints,
            MountDocDeliveryModal: true,
        })
        $('#NewDocDelivery20').modal({ backdrop: 'static', keyboard: false }, 'show');

    }

    FillRouteDocDetails = (responseApiData) => {
        let newDocumentDetails = new RouteDocDelivery();
        newDocumentDetails.IdRTDOC = responseApiData.Header.IdRTDOC ?? -1;
        newDocumentDetails.Code = responseApiData.Header.Code ?? '';
        newDocumentDetails.IdRoute = responseApiData.Header.Id_Route ?? '';
        newDocumentDetails.InitialDate = responseApiData.Header.DeliveryDate;
        newDocumentDetails.DocStatus = responseApiData.Header.DocStatus;
        newDocumentDetails.CodigoAutotransporte = responseApiData.Header.IdVHCL;
        newDocumentDetails.NumMerch = responseApiData.Lines?.length ?? 0
        newDocumentDetails.WeightCharged = responseApiData?.Header?.TotalWeight ?? 117;
        newDocumentDetails.TransferRoute = responseApiData?.Header?.TransferRoute ?? null;
        newDocumentDetails.AttentionType = responseApiData?.Header?.AttentionType ?? '';
        newDocumentDetails.Status = responseApiData?.Header?.Status ?? '';
        if (this.state.availableDrivers && this.state.availableDrivers.length > 0) {
            const finded = this.state.availableDrivers.findIndex((element) => Number(element.value) === Number(responseApiData.Header.IdVDRV))
            if (finded !== undefined) {
                newDocumentDetails.AuxIndexDriver = finded ?? ""
                newDocumentDetails.IdVDRV = this.state.availableDrivers?.[finded]?.value ?? -1
            }
        }

        if (responseApiData.Lines.length > 0) {

            for (let x = 0; x < responseApiData.Lines.length; x++) {
                const registerLine = responseApiData.Lines[x];
                let lineDocDelivery = new DocsLineRouteDelivery();
                lineDocDelivery.IdTDOC1 = registerLine.IdTDOC1;
                lineDocDelivery.IdRDL1 = registerLine.IdRTDOC;
                lineDocDelivery.DocEntry = registerLine.DocEntry ?? -1;
                lineDocDelivery.DocNum = registerLine.DocNum ?? -1;
                lineDocDelivery.ShipToCode = registerLine.ShipToCode ?? null;

                lineDocDelivery.CardCode = registerLine.CardCode ?? -1;
                lineDocDelivery.CardName = registerLine.CardName;

                lineDocDelivery.U_FMB_GPSLat = registerLine.U_FMB_GPSLat;
                lineDocDelivery.U_FMB_GPSLon = registerLine.U_FMB_GPSLon;

                lineDocDelivery.ObjType = registerLine.ObjType ?? -1;
                lineDocDelivery.NumAtCard = registerLine.NumAtCard ?? "";
                lineDocDelivery.ItemName = registerLine.Dscription ?? "";
                lineDocDelivery.Quantity = registerLine.Quantity ?? "";
                lineDocDelivery.LineTotal = registerLine.LineTotal ?? 0.0;
                lineDocDelivery.TotalWeightLine = registerLine?.TotalWeightLine ?? 0.0;
                lineDocDelivery.LineByBot = registerLine.CreateByBot === 'Y' ? true : 'N';
                lineDocDelivery.LineNum = registerLine?.LineNum ?? -1;
                lineDocDelivery.ProcessStatus = registerLine?.ProcessStatus ?? "";
                lineDocDelivery.Priority = Number(registerLine.Priority)
                    ?? -1;
                lineDocDelivery.ColorPriority = this.DefineColorByPriority(lineDocDelivery.Priority)

                lineDocDelivery.AddressDesc = registerLine.AddressDesc ?? null;
                lineDocDelivery.ItemCode = registerLine.ItemCode ?? "";
                lineDocDelivery.Transfered = registerLine.Transfered ?? "";
                //########VTA GRANEL
                lineDocDelivery.U_RS_TIPOV = registerLine?.U_RS_TIPOV ?? "";
                lineDocDelivery.U_RS_CANTG = registerLine?.U_RS_CANTG ?? "";
                lineDocDelivery.U_RS_PRECIOGL = registerLine?.U_RS_PRECIOGL ?? "";
                lineDocDelivery.U_RS_TOTALGL = registerLine?.U_RS_TOTALGL ?? "";
                lineDocDelivery.U_RS_UMED = registerLine?.U_RS_UMED ?? "";
                lineDocDelivery.ItmsGrpCod = registerLine?.ItmsGrpCod ?? -1;
                lineDocDelivery.UMV = registerLine?.UMV ?? '';
                lineDocDelivery.SalUnitMsr = registerLine?.SalUnitMsr ?? '';

                newDocumentDetails.NumMerch =
                    newDocumentDetails.DocsLines.push(lineDocDelivery);

            }
            let auxArray = newDocumentDetails.DocsLines;
            newDocumentDetails.DocsLines = []
            newDocumentDetails.DocsLines = this.ProcessDeliveryDocsLines(auxArray)

        }

        return newDocumentDetails;
    }


    UpdateRouteDoc = async (RouteDoc) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            RouteDoc
        }
        enableSpinner(true);
        const responseApi = await apiClient.updateRouteDeliveryDetails20(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return;
        }

        this.CloseModalActions();
        await this.setState({
            MountDocDeliveryModal: false
        })
        showAlert({ type: 'success', message: responseApi.message, timeOut: 5000 });

    }

    sendNotification = async (view, data, response) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { DocNum, docNumBilling } = response.data;
        const { Filler, createDraft = null } = data.model;
        let pk_Sucursal, destination, type, title, message, timeOut;
        let params = {};
        if ((view === 'transfersRequest' || (view === 'draft' && data?.isDraftDoc && data?.destino === 'OWTQ' && createDraft === 'draft')) && response.docEntry) {
            let error = false;
            params.Filler = Filler;
            const sucursal = await apiClient.getDataNotifications('2', params);

            if (sucursal.status === 1) {
                pk_Sucursal = sucursal.data[0]?.pk_Sucursal;
                destination = 3; // Usuarios de sucursal
                title = 'Solicitud Traslado';
                message = `Se ha generado un nuevo documento de Solicitud de Traslado ${DocNum || docNumBilling || '(Número no disponible)'}`;
                type = 4; // Aviso
                timeOut = 15000;

                const data = { pk_Sucursal, title, message, type, timeOut, destination };

                const response = await apiClient.saveNotification(data);

                if (response.status === 1) {
                    showAlert({ type: 'info', message: 'Se esta notificado a la sucursal responsable del almacen', timeOut: 10000 });
                } else {
                    error = true;
                }

            } else {
                error = true;
            }

            if (error) {
                showAlert({ type: 'warning', message: 'No se pudo notificar a la sucursal responsable del almacen', timeOut: 10000 });
            }
        }
    }

    detailsLandedCosts = async (open, response) => {
        const { enableSpinner } = this.props;
        const { header, items, lines2 } = response.data;
        const { CardCode, SuppName, AgentCode, AgentName, DocCur, DocNum, SerieName, DocDate, DocDueDate } = header;
        const { Ref1, AgentNum, IncCustom, Descr, BeforeVat, Vat1, Vat2, DocTotal } = header;
        const newOrderModel = await this.createNewOrderDetails(response, open);

        Object.assign(newOrderModel, {
            CardCode, CardName: SuppName,
            AgentCode, AgentName,
            DocCur, SerieName,
            NextFolio: DocNum, DocDate,
            DocDueDate, Comments: Descr,
            landedCosts: {
                Ref1,
                AgentNum,
                IncCustom: IncCustom === 'Y',
                BeforeVat,
                Vat1,
                Vat2,
            },
            DocTotal, Items: items
        });

        enableSpinner(true);
        const deliveryPrices = await apiClient.getRecordsTable('OALC');
        enableSpinner(false);

        newOrderModel.landedCosts.deliveryPrices = deliveryPrices.data || [];

        newOrderModel.landedCosts.deliveryPrices.forEach(deliveryPrice => {
            lines2.forEach(line => {
                if (deliveryPrice.AlcCode === line.AlcCode) {
                    Object.assign(deliveryPrice, {
                        CostSum: line.CostSum,
                        OhType: line.OhType,
                        InCustCalc: line.InCustCalc === 'Y',
                    });
                }
            });
        });

        this.setState({
            newOrderModel,
            documentModalAction: 2,
            showDocumentModal: true,
        }, () => {
            $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
            this.documentCreateModal.state.editMode = false;
            this.documentCreateModal.restartTabs();
        });

    }

    //#endregion

    //#region ######### SUGGEST REFILL DOCUMENTS #################################################
    CloseSuggestRefillModal = async () => {
        await this.setState({
            showSuggestRefill: false
        })
    }

    OpenSuggestRefillModal = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props;
        const { _user } = this.state
        if (!_user) {
            showAlert({ type: 'error', message: 'No cuentas con permiso para realizar esta acción', timeOut: 5000 });
            return;
        }

        let refillDoc = new SuggestRefillDocument();
        refillDoc.UserName = _user?.USER_CODE ?? '';
        refillDoc.Branch = _user?.Branch?.IdBranch ?? '';
        refillDoc.BranchName = _user?.Sucursal ?? '';
        refillDoc.newView = view;
        refillDoc.OriginDocumentCreate = view;
        await this.setState({
            refillModel: refillDoc,
            refillModelAction: 1, // show
            showSuggestRefill: true,
        });

        $('#SuggestRefillModal').modal({ backdrop: 'static', keyboard: false }, 'show');

    }


    RefreshRefillModel = async (refillModel) => {
        await this.setState({
            refillModel
        })
    };

    SendSuggestRefillModel = async model => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const auxModel = Object.assign({}, model);
        const items = model.Items;
        let itemsProcessed = 0;
        let billingResponseArray = [];

        auxModel.Items = [];
        showAlert({ type: 'info', message: "Procesando documento", timeOut: 5000 });

        enableSpinner(true);
        while (itemsProcessed < (items.length || 0)) {
            if (itemsProcessed && (itemsProcessed % 1000) === 0) { showAlert({ type: 'info', message: "Procesando documento, NO recargue la página", timeOut: 3000 }); }

            const lastItem = itemsProcessed + 100 < items.length ? itemsProcessed + 100 : items.length;
            let message = "";

            auxModel.Items = items.slice(itemsProcessed, lastItem);
            const response = await apiClient.createSuggestRefillItems({ refillDocModel: auxModel });

            if (!response?.status) {
                message = `Ocurrio un error al procesar el documento, desde la linea ${itemsProcessed + 1} "${items[itemsProcessed].ItemCode}" hasta la linea ${lastItem} "${items[lastItem].ItemCode}": ${response?.message || "Ocurrio un error inesperado"}`;
                showAlert({ type: 'warning', message, timeOut: 10000 });
            } else { message = response?.message || ''; }

            itemsProcessed += 100;
            billingResponseArray.push({
                docNum: response?.data || '',
                message: message,
                billing: '',
            });
        }
        enableSpinner(false);

        $('#SuggestRefillModal').modal('hide');
        $('#billingResponseModal').modal('show');

        this.setState({ showSuggestRefill: false, billingResponseArray });
        this.searchDocuments()
    };

    openSuggestRefillDetails = async (document) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        const data = {
            DocEntry: document.DocEntry
        };

        enableSpinner(true);
        const detailsResponse = await apiClient.getSuggestFillDocDetails(data);
        enableSpinner(false);

        if (detailsResponse.status !== 1) {
            showAlert({ type: 'error', message: detailsResponse.message });
            return
        }
        const fillModel = await this.FillSuggestRefillDocsDetails(detailsResponse.data)

        this.setState({
            refillModel: fillModel,
            refillModelAction: 2, //show
            showSuggestRefill: true,
        });
        $('#SuggestRefillModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };


    FillSuggestRefillDocsDetails = (details) => {
        let suggestDoc = new SuggestRefillDocument();
        suggestDoc.DocEntry = details.Header.DocEntry;
        suggestDoc.DocNum = details.Header.DocNum;
        suggestDoc.DocDate = details.Header.DocDate;
        suggestDoc.Series = details.Header.Series;
        suggestDoc.SerieName = details.Header.Series; // 
        suggestDoc.DocStatus = details.Header.DocStatus;
        suggestDoc.NumAtCard = details.Header.NumAtCard;
        suggestDoc.UserName = details.Header.UserName;
        suggestDoc.Branch = details.Header.Branch;
        suggestDoc.BranchName = details.Header.BranchName
        suggestDoc.newView = this.props.view;
        suggestDoc.OriginDocumentCreate = this.props.view;
        suggestDoc.Comments = details.Header.Comments ?? ''

        for (let n = 0; n < details.Lines.length; n++) {
            const infoItem = details.Lines[n];

            let itemModel = new NewItem();
            itemModel.ItemCode = infoItem.ItemCode;
            itemModel.ItemName = infoItem.Dscription;
            itemModel.WhsCode = infoItem.WhsCode;
            itemModel.Quantity = infoItem.Quantity;
            itemModel.LineStatus = infoItem.LineStatus === 'O' ? false : true;
            itemModel.Price = parseFloat(infoItem?.PRICE || 0)
            itemModel.HomePrice = parseFloat(infoItem?.PRICE || 0)
            itemModel.TaxeRate = parseFloat(infoItem?.TAXRATE || 0)
            itemModel.MovimientoDiario = infoItem?.CESIONUSO_DAY || 0;
            suggestDoc.Items.push(itemModel)

        }

        return suggestDoc;
    }

    UpdateStateFieldByKey = async (key, value) => {
        await this.setState({
            [key]: value
        })
    }
    //#endregion

    printDelivaryAcuse = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state
        let docsArray = [];

        for (let [id, value] of checkboxDataTables.entries()) { if (value) { docsArray.push(data[id].IdRTDOC); } }

        if (!docsArray?.length) {
            return showAlert({ type: 'warning', message: 'No has seleccionado ningun documento' });
        } else if (docsArray.length > 30) {
            return showAlert({ type: 'warning', message: 'Solo se pueden imprimir 30 elementos por petición' });
        }

        enableSpinner(true);
        const responseApi = await apiClient.printDelivaryAcuse({ docs: docsArray });
        enableSpinner(false);

        if (!responseApi.status) {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos" });
        } else {
            const getFieldName = responseApi.headers.get('content-disposition');

            if (getFieldName !== null) {
                try {
                    responseApi.blob().then(blob => {
                        const pdfUrl = window.URL.createObjectURL(blob);
                        const pdfViewer = document.getElementById('pdfPrinterViewer');
                        pdfViewer.innerHTML = `<iframe src="${pdfUrl}" style="width: 100%; height: 100%; border: none;"></iframe>`;
                    });
                    $("#printDocumentsModal").modal("show");
                } catch (e) {
                    showAlert({ type: 'error', message: 'Error al traer PDF', timeOut: 5000 });
                }
            }
            else {
                showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
            }
        }
    }

    //#region ######### Internal Reconciliations ###############################
    OpenReconciliationModal = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        await this.setState({ showReconciliationModal: true });
        $("#ReconciliationModal").modal("show");
        $("#ReconciliationModal").on("hidden.bs.modal", async () => {
            await this.setState({ showReconciliationModal: false });
        });
    }
    //#endregion

    showGroupNumModal = async (groupNum = null, searchGroupNum = false) => {
        await this.setState({ showGroupNumModal: true, searchGroupNum, groupNum });
        $("#GroupNumbersModal").modal("show");
        $("#GroupNumbersModal").on("hidden.bs.modal", async () => {
            await this.setState({ showGroupNumModal: false, searchGroupNum: false, groupNum: null });
        });
    }

    CreateNewPriceList = async () => {
        const { data } = this.props;
        // await addLine(true);

        // IR HASTA LA ULTIMA PAGINA DEL DOCUMENTO
        // this.table.page('last').draw('page');
        // this.getTableInfoResult();
        const newLists = data.map(o => ({ ListName: o.ListName, ListNum: o.ListNum }));
        await this.setState({
            showPriceListModal: true,
            priceListAction: 1,
            priceListsModel: new PriceListsModel(),
            newArrayLists: newLists || [],
        });
        $('#NewPriceListModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    ClosePriceListModal = async () => {
        await this.setState({
            showPriceListModal: false,
            editModePriceList: false,
        });
    };

    SendNewPriceList = async (index = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { priceListsModel } = this.state;
        if (priceListsModel.ListName === '') {
            showAlert({ type: 'info', message: 'El campo nombre de la lista de precios no puede ir vacío.' });
            return;
        }

        enableSpinner(true);
        let data = {
            model: priceListsModel,
        };

        let response = await apiClient.CreateNewPriceList(data);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: response.message });

            $('#NewPriceListModal').modal('hide');
            this.ClosePriceListModal();
        } else {
            showAlert({ type: 'error', message: response.message });
        }
        enableSpinner(false);
    };

    DetailsPriceList = async (value) => {
        const { data, openDetails } = this.props;

        let resutl = await openDetails(value);
        let GroupsItemData = await apiClient.getGroupsItemData();
        const Fabricantes = await apiClient.getProducersData();

        const newLists = data.map(o => ({ ListName: o.ListName, ListNum: o.ListNum }));
        await this.setState({
            showPriceListModal: true,
            priceListAction: 2,
            priceListsModel: resutl,
            newArrayLists: newLists || [],
            ListItemsGroup: GroupsItemData.data.GrupoArticulo,
            Producers: Fabricantes?.data ?? [],
        });
        $('#NewPriceListModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    changeEditModePriceList = () => {
        this.setState({
            editModePriceList: !this.state.editModePriceList,
        });
    };

    refreshPriceListModel = priceListsModel => {
        this.setState({
            priceListsModel
        })
    };

    AddnewArrayLists = async () => {
        const { newArrayLists, priceListsModel } = this.state;

        const listName = (priceListsModel.ListName || "").trim();
        if (!listName) {
            return;
        }

        let updatedArray = [...newArrayLists];

        if (updatedArray.length > 0 && updatedArray[updatedArray.length - 1].isNew) {
            updatedArray[updatedArray.length - 1] = {
                ...updatedArray[updatedArray.length - 1],
                ListName: listName,
            };
        } else {
            const maxListNum = updatedArray.length > 0
                ? Math.max(...updatedArray.map(line => line.ListNum || 0))
                : 0;

            priceListsModel.ListNum = maxListNum + 1;
            priceListsModel.BASE_NUM = maxListNum + 1;

            const newItem = {
                ListName: listName,
                ListNum: priceListsModel.ListNum,
                isNew: true,
            };

            updatedArray.push(newItem);
        }

        await this.refreshPriceListModel(priceListsModel);
        await this.setState({ newArrayLists: updatedArray });

    };

    UpdatePriceList = async (index = null, onlyItems = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { priceListsModel } = this.state;

        if (priceListsModel.ListName === '') {
            showAlert({ type: 'info', message: 'El campo nombre de la lista de precios no puede ir vacío.' });
            return;
        }

        enableSpinner(true);
        let data = {
            model: priceListsModel,
        };
        let response;

        if (!onlyItems) {
            response = await apiClient.UpdatePriceList(data);
        }

        if (!priceListsModel?.Items?.length) {
            if (response.status === SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: 'success', message: response.message });

                $('#NewPriceListModal').modal('hide');
                this.ClosePriceListModal();
            } else {
                showAlert({ type: 'error', message: response.message });
            }
        } else {
            if (!onlyItems) {
                if (response.status === SERVICE_RESPONSE.SUCCESS) {
                    showAlert({ type: 'success', message: response.message });
                } else {
                    enableSpinner(false);
                    return showAlert({ type: 'error', message: response.message });
                }
            }

            showAlert({ type: 'info', message: "Actualizando artículos, esto podria demorar NO cierre NI recargue la página", timeOut: 10000 });

            let items = [];
            let errors = [];
            let firstPetition = false;

            for (let i = 0; i < priceListsModel.Items.length; i++) {
                const item = priceListsModel.Items[i];
                items.push(item);

                let newRequest = (i + 1) % 5;
                if (newRequest === 0 || (i + 1) === priceListsModel.Items.length) {
                    if (!firstPetition) { firstPetition = true; }
                    else { showAlert({ type: 'info', message: "Segui,ps actualizando artículos, NO cierre NI recargue la página", timeOut: 10000 }); }

                    response = await apiClient.UpdateItemPriceList({ items });

                    if (!response?.status) {
                        if (Array.isArray(response?.data)) { errors = errors.concat(response.data); }
                        else { errors = errors.concat(items); }
                    }

                    items = [];
                }
            }

            if (errors.length) {
                showAlert({ type: 'info', message: "El proceso ha terminado con errores", timeOut: 10000 });
                for (const error of errors) {
                    showAlert({ type: 'warning', message: error.message || `Ha ocurrido un error inesperado al actualizar el artículo ${error.ItemCode || ''}`, timeOut: 10000 });
                }
            } else {
                showAlert({ type: 'success', message: "Artíuclos actualizados correctamente", timeOut: 10000 });
            }

            $('#NewPriceListModal').modal('hide');
            this.ClosePriceListModal();
        }
        enableSpinner(false);
    };


    //#region ######################## TIMBRADO DE NOMINAS #########################
    OpenRegisterNomina = async () => {
        await this.UpdateStateFieldByKey('enableTimbraNomModal', true)
        $('#TimbradoNominasModal').modal('show');
    }

    RefreshNomModel = async (nomModel) => {
        await this.UpdateStateFieldByKey('timbraNomModel', nomModel)
    }

    CreateNominaDoc = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = {
            model: this.state.timbraNomModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.CreateNominaDoc(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error en la creacion del docuemnto de nomina' });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message });
        $('#TimbradoNominasModal').modal('hide');
        await this.UpdateStateFieldByKey('enableTimbraNomModal', false)
        this.searchDocuments()
    }

    OpenDocumentNominaDetails = async (params) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = {
            primaryKey: params.IdNom,
        }

        enableSpinner(true);
        const responseApi = await apiClient.GetNominaDoc(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error en la creacion del docuemnto de nomina' });
            return
        }

        const filledData = await this.FillNominaModel(responseApi.data);

        await this.setState({
            timbraNomModel: filledData,
            enableTimbraNomModal: true

        });
        $('#TimbradoNominasModal').modal('show');

    }

    FillNominaModel = (data) => {
        let fillModel = new TimbradoNomina();
        // 117> quitar la linea de abajo
        fillModel.conceptos = [];

        const header = data.Header;
        fillModel.UUID = header?.UUID ?? '';
        fillModel.IdNom = header.IdNom ?? -1
        // Comprobante
        fillModel.exportacion = header?.Exportacion ?? '';
        fillModel.fecha = moment(header?.Fecha).format('YYYY-MM-DD') ?? '';
        fillModel.lugarExpedicion = header?.LugarExpedicion ?? '';
        fillModel.metodoPago = header?.MetodoPago ?? '';
        fillModel.moneda = header?.Moneda ?? '';
        fillModel.tipoDeComprobante = header?.TipoDeComprobante ?? '';
        fillModel.total = header?.Total ?? '';
        fillModel.descuento = header?.Descuento ?? '';
        fillModel.subTotal = header?.SubTotal ?? '';
        fillModel.version = header?.Version ?? '';

        // CfdiRelacionados
        fillModel.cfdiRelacionados = {
            tipoRelacion: header?.CfdiTipoRela ?? '',
            relacionados: JSON.parse(header.CfdiRela ?? "[]")
        };

        // Receptor
        fillModel.receptor = {
            nombre: header?.RecepNombre ?? '',
            rfc: header?.RecepRfc ?? '',
            usoCFDI: header?.RecepUsoCfdi ?? '',
            regimenFiscalReceptor: header?.RecepRegimenFiscal ?? '',
            domicilioFiscalReceptor: header?.RecepDomicilioFiscal ?? ''
        };

        // Conceptos
        for (let n = 0; n < data.Lines.length; n++) {
            const concept = data.Lines[n];
            const auxModel = {
                cantidad: concept.Cantidad ?? 0,
                claveProdServ: concept.ClaveProdServ ?? 0,
                claveUnidad: concept.ClaveUnidad ?? 0,
                descripcion: concept.Descripcion ?? 0,
                descuento: concept.Descuento ?? 0,
                importe: concept.Importe ?? 0,
                objetoImp: concept.ObjetoImp ?? 0,
                valorUnitario: concept.ValorUnitario ?? 0,
            }
            fillModel.conceptos.push(auxModel)
        }

        // Nomina
        fillModel.nomina = {
            version: header?.NomVersion ?? '',
            tipoNomina: header?.NomTipo ?? '',
            fechaPago: header?.NomFechaPago ?? '',
            fechaInicialPago: header?.NomFechaInicialPago ?? '',
            fechaFinalPago: header?.NomFechaFinalPago ?? '',
            numDiasPagados: header?.NomNumDiasPagados ?? '',
            totalPercepciones: header?.NomTotalPercepciones ?? '',
            totalDeducciones: header?.NomTotalDeducciones ?? '',
            totalOtrosPagos: header?.NomTotalOtrosPagos ?? '',

            emisor: {
                registroPatronal: header?.NomEmRegistroPatronal ?? ''
            },

            receptor: {
                curp: header?.NomRecepCurp ?? '',
                cuentaBancaria: header?.NomRecepCuentaBancaria ?? '',

                numSeguridadSocial: header?.NomRecepNumSeguridadSocial ?? '',
                fechaInicioRelLaboral: header?.NomRecepFechaInicioRelLaboral ?? '',
                antiguedad: header?.NomRecepAntiguedad ?? '',
                tipoContrato: header?.NomRecepTipoContrato ?? '',
                sindicato: header?.NomRecepSindicato ?? '',
                tipoJornada: header?.NomRecepTipoJornada ?? '',
                tipoRegimen: header?.NomRecepTipoRegimen ?? '',
                numEmpleado: header?.NomRecepNumEmpleado ?? '',
                departamento: header?.NomRecepDepartamento ?? '',
                puesto: header?.NomRecepPuesto ?? '',
                riesgoPuesto: header?.NomRecepRiesgoPuesto ?? '',
                periodicidadPago: header?.NomRecepPeriodicidadPago ?? '',

                salarioBaseCotApor: header?.NomRecepSalarioBaseCotAPor ?? '',
                salarioDiarioIntegrado: header?.NomRecepSalarioDiarioIntegrado ?? '',
                claveEntFed: header?.NomRecepClaveEntFed ?? ''
            },

            // falta esta info en la base
            percepciones: {
                totalGravado: header?.NomPercepTotalGravados ?? '',
                totalExento: header?.NomPercepExento ?? '',
                totalSueldos: header?.NomPercepTotalSueldos ?? '',
                percepcion: JSON.parse(header?.NomPercepArray ?? "[]")
            },

            deducciones: {
                totalOtrasDeducciones: header?.NomDeducTotalOtrasDeducc ?? '',
                totalImpuestosRetenidos: header?.NomDeducTotalImpuestosRet ?? '',
                deduccion: JSON.parse(header.NomDeducArray ?? "[]")
            },

            otrosPagos: JSON.parse(header?.NomOtrosPagosArray ?? "[]")
        };


        return fillModel;
    }

    CloseNominaModal = async () => {
        $('#TimbradoNominasModal').modal('hide');
        await this.setState({
            timbraNomModel: new TimbradoNomina(),
            enableTimbraNomModal: false

        });

    }

    TimbraNomina = async () => {
        const { notificationReducer: { showAlert }, data, enableSpinner } = this.props;
        const { checkboxDataTables } = this.state;

        let docEntryArray = [];
        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(data[id]);
            }
        }

        if (docEntryArray.length === 0) {
            showAlert({ type: 'info', timeOut: 2000, message: "Seleccione las nominas que se mandaran a timbrar" });
            return;
        }

        enableSpinner(true);
        const responseArray = await apiClient.TimbraNominas(docEntryArray);
        enableSpinner(false);

        this.toggleDocumentSelectedAll(false);
        if (responseArray?.status === 0) {
            showAlert({ type: 'info', timeOut: 2000, message: `Error inesperado en el proceso de timbrado ${responseArray.message ?? ''}` });
            return;

        }
        if (responseArray?.data?.length > 0) {

            for (let index = 0; index < responseArray.data.length; index++) {
                const element = responseArray.data[index];
                const alertType = element.status === 0 ? 'warning' : 'success';
                showAlert({ type: alertType, timeOut: 9999999, message: element.message });
            }
        }
        this.searchDocuments();
    }

    RefreshEmployeeNomModel = async (employeeNomModel) => {
        await this.UpdateStateFieldByKey('employeeNomModel', employeeNomModel)
    }

    OpenRegisterEmployeeNomina = async () => {
        await this.UpdateStateFieldByKey('enableEmployeeNomModal', true)
        $('#EmployeeNominasModal').modal('show');
    }

    CreateEmployeeNominaDoc = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = {
            model: this.state.employeeNomModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.CreateEmployeeNom(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error en la creacion del empleado' });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message });
        $('#EmployeeNominasModal').modal('hide');
        await this.UpdateStateFieldByKey('enableEmployeeNomModal', false)
        this.searchDocuments()
    }

    CloseEmployeeNominaModal = async () => {
        $('#EmployeeNominasModal').modal('hide');
        await this.setState({
            employeeNomModel: new TimbradoNomina(),
            enableEmployeeNomModal: false
        });

    }
    openTanquesModal = async (params) => {


    }
    OpenDocumentEmployeeNomDetails = async (params) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = {
            primaryKey: params.IdNomEmployee,
        }

        enableSpinner(true);
        const responseApi = await apiClient.ReadEmployeeNom(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error al abrir el detalle del empleado' });
            return
        }

        const filledData = this.FillEmployeeNomModel(responseApi.data?.employee ?? null)
        await this.setState({
            employeeNomModel: filledData,
            enableEmployeeNomModal: true

        });
        $('#EmployeeNominasModal').modal('show');

    }

    FillEmployeeNomModel = (info) => {
        let model = new EmployeeNomina()

        if (info == null) return model;
        model = info;


        return model
    }


    DowloadMassive = () => {
    }


    //#endregion

    //#region ######################## ATTACHMENTS ########################
    uploadAttachmentsFiles = async (table, id, files, absEntry = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;
        let attachments = [];

        enableSpinner(true);
        for (const file of files) {
            if (file.AbsEntry) { attachments.push(file); continue; }
            const responseAPI = await apiClient.uploadAttachmentFile(file);

            if (!responseAPI?.status) {
                showAlert({ type: 'warning', message: `Error al cargar el archivo (${file.FileName}): ${responseAPI?.message || "Ocurrió un error inesperado"}` }, 5000);
                continue;
            }

            file.FileName = responseAPI.data || file.FileName;
            attachments.push(file);
        }

        await apiClient.updateAttachments({ table, id, attachments, absEntry });
        enableSpinner(false);
    }

    DownloadAttachmentsFiles = async (file) => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;
        enableSpinner(true);
        const responsePdf = await apiClient.downloadAttachmentFile(file);
        enableSpinner(false);
        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try { responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end))); }
            catch (e) { showAlert({ type: 'error', message: `Error al traer el anexo`, timeOut: 5000 }); }
        } else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    setFiles = async (files) => {
        this.setState({
            files
        })
    }
    //#endregion ######################## ATTACHMENTS ########################

    setWhsByRouteDocsV1 = () => {
        const { disWhs } = this.props
        const { newOrderModel, _user } = this.state
        // if (newOrderModel.userFields.userFields43 == 'RUT') {
        if (newOrderModel.userFields.userFields28 == 'RCF') {
            newOrderModel.Items.forEach(item =>
                item.WhsCode = disWhs.WhsCode
            )
        } else {
            newOrderModel.Items.forEach(item =>
                item.WhsCode = _user.Branch.ProjectCode
            )
        }
        this.refreshModel(newOrderModel)
    }

    setWhsByRouteDocs = async (U_FMB_AttentionType = null, isForCreation = false) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        const { newOrderModel } = this.state;

        if (newOrderModel?.isSalesDocument && newOrderModel?.DocType === 'I' && (U_FMB_AttentionType === 'RUT' || U_FMB_AttentionType === 'RCF' || U_FMB_AttentionType === 'ABS' || U_FMB_AttentionType === 'DST') && newOrderModel?.Items?.length) { // DST: se agrega DST a la condición de entrada
            // Listado de almacenes basado en:
            // TIPO DE ATENCION     PLANTA          ZONAL          MAESTRA
            // Autoabastecimiento   008 || 001      001            008 || 001   ///ACTUALIZACION SOLICITADA POR DAVID EL 24/6/2026
            // Distribuidor         008             001            008 || 001  // DST: misma lógica que Autoabastecimiento
            // Ruta CF              009             009            009
            // RUTA                 009 || 099      NO APLICA      009 || 099

            let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
            let U_FMB_WHS_TYPE = user?.Branch?.Type || ''; // Saber si es planta o zonal
            if (!U_FMB_WHS_TYPE) {
                showAlert({ type: 'error', message: 'No se ha identificado el tipo de sede, es necesario volver a seleccionar los almacenes para los artículos', timeOut: 5000 });
                return false;
            }

            const noAplica = U_FMB_AttentionType === 'RUT' && Number(U_FMB_WHS_TYPE) === 1; // RUT - Zonal
            let whsType = [];

            if (U_FMB_AttentionType === 'ABS' || U_FMB_AttentionType === 'DST') { // Autoabastecimiento / Distribuidor // DST: se agrega DST a esta condición
                whsType = Number(U_FMB_WHS_TYPE) === 2 ? ['008', '001'] : // Planta
                    Number(U_FMB_WHS_TYPE) === 1 ? ['001'] : // Zonal
                        Number(U_FMB_WHS_TYPE) === 3 ? ['008', '001'] : // Maestra
                            [];
            } else if (U_FMB_AttentionType === 'RUT') { // Ruta
                whsType = Number(U_FMB_WHS_TYPE) === 2 || Number(U_FMB_WHS_TYPE) === 3 ? ['009', '099'] : // Planta
                    [];
            } else { // Ruta CF
                whsType = ['009'];
            }

            const validWhsCodes = [...new Set(
                (newOrderModel?.Items ?? [])
                    .map(item => item?.WhsCode)
                    .filter(code => typeof code === 'string' && code.trim() !== '')
                    .map(code => `''${code}''`)
            )].join(',');

            let data = {
                validWhsCodes
            }
            let checkWhs = [];
            if (data?.validWhsCodes) {
                enableSpinner(true);
                let resCheckWhs = await apiClient.checkWhscodes(data);
                enableSpinner(false);

                if (resCheckWhs?.status === 1) {
                    checkWhs = resCheckWhs?.data || [];
                }
            }

            let isValid = true;
            let newPrice = false;
            for (const item of newOrderModel?.Items) {
                if (item?.WhsCode) {
                    const existsValidWhs = checkWhs?.some(whs =>
                        whs.WhsCode === item.WhsCode &&
                        (whsType?.includes(whs.U_RS_TipoAlmacen ?? '') || noAplica || (whs.U_RS_TipoAlmacen ?? '') == '005' || (newOrderModel?.CodigoUnidad && U_FMB_AttentionType === 'RCF'))
                    );

                    if (!existsValidWhs) { // No es válido el almacén para el tipo de sede actual
                        isValid = false;
                        item.whsSelected = false;
                        item.WhsCode = '';
                        item.WhsName = '';
                        //#region Precio Llamagas
                        const envasado = Envasados?.includes(Number(item?.ItmsGrpCod));
                        const glpGranel = Granel?.includes(Number(item?.ItmsGrpCod));
                        if (!item?.isTemporary && (envasado || glpGranel)) { // Si el articulo es GLP Granel o Envasado mandar precio a 0 ya que el precio depende del almacén
                            newPrice = true;
                            item.HomePrice = 0;
                            item.Price = 0;
                        }
                        //#endregion Precio Llamagas
                        //#region DIMENSIONS
                        item.OcrCode2 = '';
                        item.OcrCode3 = '';
                        item.Dimension2 = false;
                        item.Dimension3 = false;
                        //#endregion DIMENSIONS

                        if (!isForCreation) {
                            showAlert({ type: 'info', message: `Al cambiar el Tipo de Atención es necesario volver a seleccionar el almacén para el artículo ${item.ItemCode}`, timeOut: 6000 });
                        } else {
                            showAlert({ type: 'info', message: `El almacén del artículo ${item.ItemCode} no es válido para el tipo de sede actual por lo que es necesario volver a seleccionar el almacén`, timeOut: 6000 });
                        }
                    }
                }
            }
            if (!isValid) {
                if (!newPrice) {
                    await this.refreshModel(newOrderModel);
                } else {
                    await this.refreshTotal(newOrderModel);
                }
                return false;
            }
        }
        return true;
    }

    getUserFieldHeaderValue = (alias = '', newOrderModel = {}, fieldInfo = false, view = '') => {
        if (!alias) return '';

        const headers = newOrderModel?.userFieldsHeader || [];
        const cleanAlias = alias?.startsWith('U_') ? alias.slice(2) : alias;

        const headerMatch = headers?.find(h => h.header?.AliasID === cleanAlias);
        if (!headerMatch) return '';

        const fieldId = headerMatch.header.FieldID;
        const allFields = view === 'payment' ? json?.userFieldsPayment || [] : json?.allUserFields || [];
        const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);
        if (!fieldInfo) {
            if (foundIndex === -1) return '';
            const fieldNumber = foundIndex + 1;
            return newOrderModel?.userFields?.[`userFields${fieldNumber}`] || '';
        } else {
            return {
                Value: newOrderModel?.[`U_${cleanAlias}`] || '',
                headerMatch,
                foundIndex: foundIndex === -1 ? null : foundIndex,
                fieldNumber: foundIndex === -1 ? null : foundIndex + 1,
            }
        }
    };

    getItemUserFieldValue = (alias = '', item = {}, newOrderModel = {}) => {
        if (!alias) return '';

        const headers = newOrderModel?.userFieldsBody || [];
        const cleanAlias = alias?.startsWith('U_') ? alias.slice(2) : alias;

        const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);
        if (!bodyMatch) return '';

        const fieldId = bodyMatch?.header?.FieldID;
        const allFields = json?.allItemsUserFields || [];
        const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);
        if (foundIndex === -1) return '';

        const fieldNumber = foundIndex + 1;
        return item?.UserFieldsItem?.[`userFields${fieldNumber}`] || '';
    };

    //#region DIMENSIONS
    getDimension1 = async (newOrderModel, U_FMB_AttentionType = null, U_FMB_AttentionChannel = null) => {
        const { GroupCode, GroupCodeName } = newOrderModel;

        let Dimension1 = '';
        const group = GroupCode;
        const name = GroupCodeName?.toUpperCase() || '';

        const groupCodes = [
            { code: 146, tag: 'C03', dimension: 'C05' }, // C03 - Canalizado
            { code: 147, tag: 'C04', dimension: 'C02' }, // C04 - Distribuidor
            { code: 148, tag: 'C05', dimension: 'C02' }, // C05 - Punto de venta
            { code: 149, tag: 'C06', dimension: 'C01' }, // C06 - Corporativo
            { code: 151, tag: 'C07', dimension: 'C07' }, // C07 - Estaciones de servicio
            { code: 152, tag: 'C08', dimension: 'C06' }, // C08 - Granel Clasico
        ];

        Dimension1 = groupCodes?.find(m => Number(m.code) === Number(group) || name?.includes(m.tag))?.dimension || '';

        if (Dimension1) { return Dimension1; }

        //#region C01 - Consumidor Final - CF | C02 - Horeca
        let isC01 = Number(GroupCode) === 100 || GroupCodeName?.toUpperCase()?.includes('C01');
        let isC02 = Number(GroupCode) === 145 || GroupCodeName?.toUpperCase()?.includes('C02');
        if (isC01 || isC02) {
            U_FMB_AttentionType = U_FMB_AttentionType ? U_FMB_AttentionType : await this.getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel); // Tipo de atención
            U_FMB_AttentionChannel = U_FMB_AttentionChannel ? U_FMB_AttentionChannel : await this.getUserFieldHeaderValue('U_FMB_AttentionChannel', newOrderModel); // Canal de atención

            if (U_FMB_AttentionType === 'VPU') {
                Dimension1 = 'C04';
            } else if (U_FMB_AttentionType === 'RCF') {
                if (U_FMB_AttentionChannel === 'CALL' || U_FMB_AttentionChannel === 'CAL') {
                    Dimension1 = 'C08';
                } else if (U_FMB_AttentionChannel === 'VED') {
                    Dimension1 = 'C03';
                }
            }
        }
        //#endregion C01 - Consumidor Final - CF | C02 - Horeca

        return Dimension1
    }

    getDimension1ByUserField = async (U_FMB_AttentionType = null, U_FMB_AttentionChannel = null) => {
        const { notificationReducer: { showAlert } } = this.props
        const { newOrderModel } = this.state;
        const isU_FMB_AttentionType = U_FMB_AttentionType ? true : false;

        if (U_FMB_AttentionType !== null) { // Se busca el canal
            U_FMB_AttentionChannel = await this.getUserFieldHeaderValue('U_FMB_AttentionChannel', newOrderModel); // Canal de atención
        } else { // Se busca el tipo
            U_FMB_AttentionType = await this.getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel); // Tipo de atención
        }

        if (newOrderModel?.isSalesDocument && newOrderModel?.DocType === 'I'
            && ((U_FMB_AttentionType === 'VPU')
                || (U_FMB_AttentionType === 'RCF' && (U_FMB_AttentionChannel === 'CALL' || U_FMB_AttentionChannel === 'CAL' || U_FMB_AttentionChannel === 'VED'))
            )
            && newOrderModel?.Items?.length
            && (
                (Number(newOrderModel?.GroupCode) === 100 || newOrderModel?.GroupCodeName?.includes('C01')) // C01 - Consumidor Final - CF
                || (Number(newOrderModel?.GroupCode) === 145 || newOrderModel?.GroupCodeName?.includes('C02')) // C02 - Horeca
            )
        ) { // Es Consumidor Final o es de Horeca y tiene valor en tipo de atencion o canal de atencion
            let Dimension1 = await this.getDimension1(newOrderModel, U_FMB_AttentionType, U_FMB_AttentionChannel);
            if (Dimension1 && newOrderModel?.Items?.length) {
                const otherDimension1 = newOrderModel.Items?.some(item => item.OcrCode !== Dimension1);
                if (otherDimension1) {
                    for (const item of newOrderModel?.Items) {
                        item.OcrCode = Dimension1;
                        item.Dimension1 = true;
                    }

                    showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al ${isU_FMB_AttentionType ? 'Tipo de Atención' : 'Canal de Atención'}`, timeOut: 6000 });
                    await this.refreshModel(newOrderModel);
                }
            }
        }
    }
    //#region DIMENSIONS

    //#region ######################## SCOP CODE ########################

    ValidateScoopCode = async () => {
        const { notificationReducer: { showAlert }, enableSpinner, view } = this.props;
        const { newOrderModel } = this.state

        // VALIDAR SI DEJAMOS ESTA CONDICIONAL MIENTRAS DEJO SOLO CON QUE NO VAYA VACIO
        // const regex = /^[PDECTO]\d{7}$/i;
        // if (!regex.test(newOrderModel.U_FMB_SCOP_CODE)) {
        //     showAlert({ type: 'error', timeOut: 5000, message: 'Insertar un codigo SCOP valido por favor' });
        //     return
        // }
        if (newOrderModel.U_FMB_SCOP_CODE === '') {
            showAlert({ type: 'error', timeOut: 5000, message: 'Insertar un codigo SCOP valido por favor' });
            return
        }

        let whsCode = '';
        if (view !== 'transfers') {
            whsCode = newOrderModel.Items.length > 0 ? newOrderModel.Items[0]?.WhsCode : '';
        } else {
            whsCode = newOrderModel.Items.length > 0 ? newOrderModel.Items[0]?.Filler : '';
        }
        if (whsCode === '') {
            showAlert({ type: 'error', timeOut: 5000, message: 'Debe de cargar al menos un articulo con almacen seleccionado' });
            return;
        }

        const data = {
            scopCode: newOrderModel.U_FMB_SCOP_CODE,
            whsCode: whsCode,
            objType: newOrderModel.ObjectType
        }

        enableSpinner(true);
        const responseApi = await apiClient.ValidateScopCode(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? '' });
            return
        }

        if (!responseApi?.data?.FMB_ValidScoop) {
            showAlert({ type: 'error', timeOut: 5000, message: `Este codigo SCOP no es valido ` });
            showAlert({ type: 'info', timeOut: 5000, message: `Estatus: ${responseApi?.data?.estado ?? ''} ` });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message ?? '' });
        let copyOrderModel = { ...newOrderModel }

        copyOrderModel.ValidSCOP = responseApi.data.FMB_ValidScoop ? responseApi.data.FMB_ValidScoop : false;
        copyOrderModel.U_LLG_ESTADO_SCOP = responseApi?.data?.estado ?? '';
        copyOrderModel.U_LLG_PLACA_SCOP = responseApi?.data?.detalle?.camion?.placa ?? '';
        copyOrderModel.U_LLG_CAPACIDAD_SCOP = responseApi?.data?.detalle?.camion?.capacidadKg ?? '';
        copyOrderModel.U_LLG_FPEDIDO_SCOP = responseApi?.data?.fechaPedido ?? '';

        this.refreshModel(copyOrderModel)

    }

    CleanSCOPFields = () => {
        const { newOrderModel } = this.state
        let copyOrderModel = { ...newOrderModel };

        copyOrderModel.ValidSCOP = false;
        copyOrderModel.U_LLG_ESTADO_SCOP = '';
        copyOrderModel.U_LLG_PLACA_SCOP = '';
        copyOrderModel.U_LLG_CAPACIDAD_SCOP = '';
        copyOrderModel.U_LLG_FPEDIDO_SCOP = '';

        this.refreshModel(copyOrderModel)

    }

    //#endregion ######################## SCOP CODE ########################

    SaveSeries = () => {
        const { property, transporteModel, propertyCode } = this.state;
        let newSeries = transporteModel.newSeries;
        let series = '';
        for (let index = 0; index < newSeries.length; index++) {
            const element = newSeries[index];
            if (element.selected) {
                series += `${element.Series}${element?.default ? '~D' : ''}|`;

            }
        }
        if (propertyCode) {
            transporteModel[property] = transporteModel[property] || {};
            transporteModel[property][propertyCode] = series;

        } else {
            transporteModel[property] = series;

        }
        this.refreshTransporteModel(transporteModel);
        this.CloseSeriesModal();
        $('#seriesModal').modal('hide');
    };
    CloseSeriesModal = () => {
        const { transporteModel } = this.state
        this.setState({
            showSeriesModal: !this.state.showSeriesModal,
            checkboxDocSeries: (new Map()),
        });
        transporteModel.newSeries = [];
        this.refreshTransporteModel(transporteModel);
        $('#seriesModal').modal('hide');

    }
    OpenSeriesModal = async (serie, value, docType = null) => {
        const { series, NameProperty } = this.props
        const { transporteModel } = this.state
        let table = await this.selectTable(serie);
        let seriesNuevas = [];
        let selected = [];
        transporteModel.newSeries = [];
        let nameProperty = NameProperty(serie);
        for (let index = 0; index < series.length; index++) {
            let element = series[index];
            element.selected = false;
            if (table.docType == 'SERIES') {
                if (element.Remark === 'SERIES' && element.ObjectCode === docType) {
                    seriesNuevas.push(element)
                }
            } else if (element.Remark !== 'SERIES' && element.ObjectCode === table.docType && element.DocSubType === table.docSubType && element.DocSubTypeNNM1 === table.docSubType && element.NextNumber <= element.LastNum) {
                seriesNuevas.push(element)
            }
        }
        if (value) {
            selected = value.split("|");
            for (let index = 0; index < selected.length; index++) {
                let idSerie = selected[index];
                const defSerie = idSerie?.split('~') ?? null
                idSerie = defSerie?.[0] ?? idSerie
                const defaultSerie = (defSerie?.[1] ?? '') == 'D' ?? false
                for (let index = 0; index < seriesNuevas.length; index++) {
                    let pos = seriesNuevas[index];
                    if (pos.Series === parseInt(idSerie) || String(pos.Series) === String(idSerie)) {
                        pos.selected = true;
                        pos.default = defaultSerie;

                    }
                }
            }
        } else {
            for (let index = 0; index < seriesNuevas.length; index++) {
                const pos = seriesNuevas[index];
                pos.selected = false;
            }
        }

        transporteModel.newSeries = seriesNuevas;

        await this.setState({
            property: nameProperty.name,
            propertyCode: docType,
            showSeriesModal: !this.state.showSeriesModal,
        });
        this.refreshTransporteModel(transporteModel);
        $('#seriesModal').modal('show');
    };

    isTransferDocument = (view = '', ObjType = 0) => {
        const inventoryMap = {
            transfersRequest: 1250000001,
            transfers: 67,
            // transfersEntry: 59,
            // transfersOutput: 60,
        };

        const objTypeNumber = Number(ObjType);

        return (
            view in inventoryMap ||
            Object.values(inventoryMap).includes(objTypeNumber)
        );
    };

    //#region DETRACCIONES
    DetraccionVista = (view, ObjType = 0) => {
        const purchaseDocument = ['PurchaseOrder', 'GoodsReceipt', 'purchaseInvoice']
        let DetraccionVista = purchaseDocument?.includes(view);
        const purchaseObjTypes = [22, 20, 18];
        if (!DetraccionVista) {
            DetraccionVista = purchaseObjTypes?.includes(Number(ObjType));
        }
        return DetraccionVista;
    }
    //#endregion DETRACCIONES

    //#region RETENCIONES
    RetencionVista = (view, ObjType = 0) => {
        const document = ['PurchaseOrder', 'GoodsReceipt', 'purchaseInvoice', 'outgoingPayment']
        let RetencionVista = document?.includes(view);
        const documentObjTypes = [22, 20, 18, 46];
        if (!RetencionVista) {
            RetencionVista = documentObjTypes?.includes(Number(ObjType));
        }
        return RetencionVista;
    }
    //#endregion RETENCIONES
    prepareSunatGuide = async (force = null, action0 = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state
        let docEntryArray = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(data[id]);
            }
        }

        if (docEntryArray.length === 0) {
            showAlert({ type: 'warning', message: "Seleccione un documento" });
            return;
        }
        const search = {
            guides: docEntryArray
        }
        enableSpinner(true)
        const resposeApi = await apiClient.prepareSunatGuide(search)
        enableSpinner(false)
        if (resposeApi?.status === SERVICE_RESPONSE.SUCCESS) {
            if ((resposeApi?.data?.length ?? 0) == 0 && force) {
                this.billing(action0, [])
            } else {
                this.setState({
                    sunatGuideData: resposeApi?.data ?? [],
                    showSunatGuideModal: true,
                    action0GuideData: action0,
                    forceProcess: force,
                }, () => {
                    $('#sunatGuideModal').modal('show');
                })
            }

        } else {
            if (!force) {
                showAlert({ type: 'warning', message: resposeApi?.message ?? 'Información no disponible' });
            } else {
                this.billing(action0, [])
            }
        }
    }
    refreshGuideData = (sunatGuideData) => {
        this.setState({
            sunatGuideData
        })
    }
    reprint = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state
        let docsArray = [];

        for (let [id, value] of checkboxDataTables.entries()) {

            if (value) {
                if ((data?.[id]?.DocNum ?? '') == '') {
                    return showAlert({ type: 'warning', message: `La ruta ${(data?.[id]?.Code ?? '--')} no cuenta con Hoja de Ruta` });
                } else {
                    docsArray.push(data[id].id);
                }
            }
        }

        enableSpinner(true);
        const responseApi = await apiClient.rePrintRoadMap({ docs: docsArray });
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            try {

                const base64 = responseApi?.data?.file;

                if (!base64 || typeof base64 !== "string") {
                    return showAlert({ type: 'error', message: 'El documento es inválido' });
                }

                const base64Regex = /^[A-Za-z0-9+/=]+$/;
                if (!base64Regex.test(base64)) {
                    return showAlert({ type: 'error', message: 'No se pudo leer el documento' });
                }

                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf" });

                if (blob.size === 0) {
                    return showAlert({ type: 'error', message: 'El PDF está vacío' });
                }

                const pdfUrl = window.URL.createObjectURL(blob);
                const pdfViewer = document.getElementById('pdfPrinterViewer');

                if (!pdfViewer) {
                    return showAlert({ type: 'error', message: 'No puedes visualizar el PDF' });
                }

                pdfViewer.innerHTML = `
                    <iframe 
                        src="${pdfUrl}" 
                        style="width: 100%; height: 100%; border: none;">
                    </iframe>
                `;

                $("#printDocumentsModal").modal("show");

            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF CTCH' });

            }
        } else {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 10000 });
        }
    }
    cancelHR = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state
        let docsArray = [];
        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docsArray.push({ IdRTDOC: data[id].IdRTDOC, Code: data[id].Code });
            }
        }
        if (!docsArray?.length) {
            return showAlert({ type: 'warning', message: 'No has seleccionado ninguna ruta' });
        } else if (docsArray.length > 30) {
            return showAlert({ type: 'warning', message: 'Solo puedes selecionar máximo 30 rutas' });
        }

        enableSpinner(true);
        const responseApi = await apiClient.deleteRoadMap({ docs: docsArray });
        enableSpinner(false);

        if (!responseApi.status) {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos" });
        } else {
            showAlert({ type: 'success', message: responseApi?.message || "OK" });
            setTimeout(async () => {
                this.searchDocuments()
            }, 100);
        }
    }
    printRoadmapPreview = async (action) => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables } = this.state
        let docsArray = [];

        for (let [id, value] of checkboxDataTables.entries()) {

            if (value) {
                if ((data?.[id]?.DocNum ?? '') != '') {
                    return showAlert({ type: 'warning', message: `La ruta ${(data?.[id]?.Code ?? '--')} ya cuenta con Hoja de Ruta` });
                } else {
                    docsArray.push(data[id].IdRTDOC);
                }
            }
        }
        if (!docsArray?.length) {
            return showAlert({ type: 'warning', message: 'No has seleccionado ninguna ruta' });
        } else if (docsArray.length > 30) {
            return showAlert({ type: 'warning', message: 'Solo puedes selecionar máximo 30 rutas' });
        }

        enableSpinner(true);
        const responseApi = await apiClient.printRoadmapPreview({ option: action, docs: docsArray });
        enableSpinner(false);

        if (!responseApi.status) {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos" });
        } else {
            // Mostrar modal con el detalle para mandar solicitud de traslado
            await this.setState({
                showRoadmapPreview: true, // show
                RoadmapPreview: responseApi.data || [],
                optionSelected: action,
            });
            $('#roadMapModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        }
    }

    CloseRoadmapPreview = async () => {
        await this.setState({
            showRoadmapPreview: false
        })

        $('#roadMapModal').modal('hide');
    };

    SendRoadmap = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, data } = this.props;
        const { checkboxDataTables, optionSelected, RoadmapPreview } = this.state
        let docsArray = [];

        for (let [id, value] of checkboxDataTables.entries()) { if (value) { docsArray.push(data[id].IdRTDOC); } }

        if (!docsArray?.length) {
            return showAlert({ type: 'warning', message: 'No has seleccionado ningun documento' });
        } else if (docsArray.length > 30) {
            return showAlert({ type: 'warning', message: 'Solo se pueden imprimir 30 elementos por petición' });
        }

        enableSpinner(true);
        const responseApi = await apiClient.printRoadmap({ option: optionSelected, docs: RoadmapPreview });
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            try {

                const base64 = responseApi?.data?.file;

                if (!base64 || typeof base64 !== "string") {
                    return showAlert({ type: 'error', message: 'El documento es inválido' });
                }

                const base64Regex = /^[A-Za-z0-9+/=]+$/;
                if (!base64Regex.test(base64)) {
                    return showAlert({ type: 'error', message: 'No se pudo leer el documento' });
                }

                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf" });

                if (blob.size === 0) {
                    return showAlert({ type: 'error', message: 'El PDF está vacío' });
                }

                const pdfUrl = window.URL.createObjectURL(blob);

                const pdfViewer = document.getElementById('pdfPrinterViewer');

                if (!pdfViewer) {
                    return showAlert({ type: 'error', message: 'No puedes visualizar el PDF' });
                }

                pdfViewer.innerHTML = `
                    <iframe 
                        src="${pdfUrl}" 
                        style="width: 100%; height: 100%; border: none;">
                    </iframe>
                `;

                $("#printDocumentsModal").modal("show");

            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF CTCH' });

            }
        } else {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 10000 });
        }
    };

    resetCheckboxes = () => {
        return new Promise((resolve) => {
            this.setState({
                checkboxDataTables: new Map(),
            }, () => {
                resolve(true);
            });
        });
    };

    //#region Massive Incoming Payments Cancellation
    changeCancelPaymentDate = async (value) => {
        this.setState({ cancelPaymentCurrentDate: value });
    }

    changeCancelPaymentMode = (cancelPaymentMode) => {
        this.setState({ cancelPaymentMode });
    }

    changePaymentDocumentDate = (docEntry, currentDate) => {
        this.setState((prevState) => ({
            paymentDocumentDates: {
                ...prevState.paymentDocumentDates,
                [docEntry]: currentDate
            }
        }));
    }

    resetPaymentsToCancel = () => {
        return new Promise((resolve) => {
            this.setState({
                showCancelPaymentModal: false,
                cancelPaymentCurrentDate: false,
                isMassive: false,
                paymentsToCancel: [],
                cancelPaymentMode: 'global',
                paymentDocumentDates: {},
            }, () => {
                resolve(true);
            });
        });
    }

    determinateDocumentTypeAndSeries = (view = '') => {

    }
    //#endregion Massive Incoming Payments Cancellation

    render() {
        const {
            view,
            headers,
            notificationReducer: { showAlert },
            enableSpinner,
            totalRows,
            data,
            priceList,
            listEmployees,
            groupCodes,
            ListItemsGroup,
            renderReducer: { renderToPrint },
            sucursales,
            jefeArea,
            userConfig,
            vendorData,
            openVendor,
            showVendorsModal,
            vendorsList,
            totalPage,
            cleanData,
            showCitiBanamexModal,
            transactionDocs,
            typeTransaction,
            refreshDocuments,
            openAgreeModal,
            sendInfo,
            hideAgreeModal,
            generateTXT,
            downloadTXT,
            addTransaction,
            docTypeSuggestion,
            GetEntryTransfersData,
            showMVentasAdminModal,
            setShowMVentasModal,
            modules,
            detailsData,
            setDetailsData,
            saveUser,
            billingResponse,
            disWhs,
            SetInitialSeries,
            documentTypeSeries,
            ShowCollectModalModal,
            depositos,
            DraftObjType = '',
            changeDraftObjType,
        } = this.props;
        const {
            billingResponseArray,
            docNumSearch,
            seriesArray,
            seriesDefault,
            inventoryModel,
            partnerModel,
            newOrderModel,
            documentModalAction,
            partnerModalAction,
            inventoryModalAction,
            prices,
            ListUnitMeasuGroup,
            PageNumber,
            rows,
            dataCsv,
            comments,
            documentsToPrint,
            configHeaderUserFields,
            showDocumentModal,
            showInventoryModal,
            showPartnerModal,
            showGroupNumModal,
            searchGroupNum,
            groupNum,
            showAdminUsersModal,
            adminUsersModalAction,
            adminUsersModel,
            bussinesPartnerArray,
            showBatchDefinitionModal,
            showBatchSelectionModal,
            _user,
            token, infoToken,
            showBusinessPartnerFields,
            // vriable para funcion ocultar campos del modal CArta porte
            isPorteFields,
            //#region States CARTA PORTE
            tipoFiguraModel,
            tipoFiguraModalAction,
            transporteModel,
            tipoTransporte,
            transporteModalAction,
            cartaPorteModel,
            cartaPorteModalAction,
            // catalogsPorte
            listCountries,
            //#endregion
            showUpdateTimbraDocModal,
            updateTimbraDocModel,
            CFDI,
            RegimenFiscal,
            editModeUpdateTimbraDocModel,
            actionUpdateTimbraDoc,
            searchSerieName,
            searchVendor,
            docFilter,

            // m-suite
            ennableDetailAuthoPartner,
            typeAuthoPartner,
            authorizePartnerModel,
            docStatusSearchAuthoBP,
            suggestionDocs,

            showWarningModal,
            WarningModalOptions,
            scenarios,
            showReconciliationModal,
            clientList,
            showPriceListModal,
            priceListAction,
            priceListsModel,
            newArrayLists,
            editModePriceList,
            showRequestPartialEdit,
            ObjType,
            userFieldsPartner,
            property,
            propertyCode,
            showSeriesModal,
            U_FMB_AttentionType,
            U_FMB_AttentionType2,
            showTransfersDocumentModal,
            files,
            authModelPartner,
            docformat,
            showRoadmapPreview,
            RoadmapPreview,
            optionSelected,
            showResumeTransportModal,
            sunatGuideData,
            showSunatGuideModal,
            forceProcess,
            action0GuideData,
            useNewModal,
            massiveUsers,
            showCancelPaymentModal,
            cancelPaymentCurrentDate,
            isMassive,
            paymentsToCancel,
            cancelPaymentMode,
            paymentDocumentDates,
            CFWOptions = [],
        } = this.state;
        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        let bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        let writeAccess = true;
        let allowClose = _user?.BranchPermission?.CloseDocuments || false;

        for (const key in itemsDashboard) {
            if (Object.hasOwnProperty.call(itemsDashboard, key)) {
                const module = itemsDashboard[key];
                if (key === view) {
                    writeAccess = module.Wr
                }
            }
        }

        let total = totalRows ? totalRows[0] ? totalRows[0].TotalRows : 30 : 30
        let excelName = view === "SalesHelmets" || view === "ExitHelmets" ? view === "SalesHelmets" ? "EntradaCascos" : "SalidaCascos" : view;
        const showCartaPorte = view === "consignmentNote" || view === "figuresTransport" || view === "transports";

        let today = moment(new Date()).format('YYYYMMDD-hmm:ss');

        let flag = true;

        if (view !== 'Middleware') {
            for (let index = 0; index < data.length; index++) {
                const doc = data[index];
                if (doc.DocStatus === 'C') {
                    flag = false;
                }
            }
        }
        let report = data.length > 0 ? true : false;
        const opcionesSucursales = Array.isArray(sucursales)
            ? sucursales.map(sucur => ({
                value: sucur.pk_Sucursal,
                label: sucur.nombre
            }))
            : [];
        const checkbox = {
            data: view === 'transport' ? this.state.checkboxDocSeries : this.state.checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
            checkAll: this.selectAll
        }

        const scoopTools = {
            checkScoop: this.ValidateScoopCode,
            cleanScoopFields: this.CleanSCOPFields
        }

        const isDraftOWTQ = view === 'draft' && (Number(newOrderModel?.ObjType) === 1250000001 || Number(DraftObjType) === 1250000001);
        const isOPORView = view === 'PurchaseOrder' || (view === 'draft' && String(DraftObjType) === '22');

        return (
            <div>
                {showSunatGuideModal &&
                    <SunatGuideModal
                        data={sunatGuideData}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        hideModal={() => this.setState({ showSunatGuideModal: false, sunatGuideData: [] })}
                        forceProcess={forceProcess}
                        continueCreate={() => this.billing(action0GuideData, sunatGuideData)}
                        refreshSunatGuideData={this.refreshGuideData}
                        view={view}
                    />
                }
                <CSVLink
                    data={dataCsv}
                    filename={`${excelName}${today}.csv`}
                    className="hidden"
                    ref={this.csvLink}
                    target="_blank"
                />

                <ContinueModal
                    refreshContinue={this.refreshContinue}
                    newOrderModel={newOrderModel}
                    autorizationModels={this.ValidateBatch}
                />

                <AuthorizationModel
                    newOrderModel={newOrderModel}
                    comments={comments}
                    updateComments={this.updateCommentsAuthorizationModel}
                    createDocument={this.sendModelToCreateDocument}
                    view={view}
                />

                <AuthorizationModalParnter
                    authModels={comments}
                    model={authModelPartner}
                    updateComments={this.updateCommentsAuthorizationModel}
                    continueAction={this.acceptEditModePartner} />

                <PrintDocumentsModal />


                {this.state.MountDocDeliveryModal &&
                    <DocDelivery
                        showAlert={showAlert}
                        action={this.state.DocDeliveryAction}
                        Waypoints={this.state.Waypoints}
                        RouteDoc={this.state.DeliveryRouteDoc}
                        Drivers={this.state.availableDrivers}
                        Vehicles={this.state.availableVehicles}
                        AvailableDeliveryLines={this.state.AvailableDeliveryLines}
                        ActionLinesChoose={this.SaveChooseManualLines}
                        ChargeLinesManualToDeliveryDoc={this.ChargeLinesManualToDeliveryDoc}
                        RefreshRouteDoc={this.RefreshRouteDoc}
                        GenerateRouteDocByIA={this.GenerateRouteDocByIA}
                        CloseModalActions={this.CloseModalActions}
                        OpenAvailableManualLines={this.OpenAvailableManualLines}
                        SendModel={this.CreateDeliveryDocument20}
                        ChangeAnyPropInState={this.ChangeAnyPropInState}
                        CloseActionListDocsDeliveries={this.CloseActionListDocsDeliveries}
                        AffectLinesByKey={this.AffectLinesByKey}
                        acceptEditMode={this.UpdateRouteDoc}
                        State={this.state}
                        ref={(ref) => this.docDeliveryModal = ref}
                        U_FMB_AttentionType2={U_FMB_AttentionType2}
                        ChangeAttentionType={this.ChangeAttentionType}
                    />


                }

                {showDocumentModal && (useNewModal ?
                    <DocumentModal
                        view={view}
                        newOrderModel={newOrderModel}
                        refreshModel={this.refreshModel}
                        docFilter={docFilter}
                        action={documentModalAction}
                        CloseDocumentModal={this.CloseDocumentModal}
                        requestPartialEdit={this.requestPartialEdit}
                        prices={prices}
                        scoopTools={scoopTools}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        getDimension1={this.getDimension1}
                    /> :
                    <DocumentCreateModal
                        view={view}
                        newOrderModel={newOrderModel}
                        checkbox={checkbox}
                        cancelEditMode={this.CancelEditMode}
                        acceptEditMode={this.acceptEditMode}
                        showAlert={showAlert}
                        selectTable={this.selectTable}
                        selectDraftTable={this.selectDraftTable}
                        setUserFieldValue={this.setUserFieldValue}
                        selectValidateSeries={this.selectValidateSeries}
                        setUserFieldValueDefault={this.setUserFieldValueDefault}
                        changeDocumentActionModal={this.changeDocumentActionModal}
                        enableSpinner={enableSpinner}
                        billing={this.billingDetails}
                        refreshModel={this.refreshModel}
                        createDocument={this.sendModelContinue}
                        action={documentModalAction}
                        prices={prices}
                        openConfigUserFieldsHeaders={this.openConfigUserFieldsHeaders}
                        configHeaderUserFields={configHeaderUserFields}
                        CloseDocumentModal={this.CloseDocumentModal}
                        writeAccess={writeAccess}
                        ref={(ref) => this.documentCreateModal = ref}
                        ShowBatchDefinitionModal={this.ShowBatchDefinitionModal}
                        docFilter={docFilter}
                        generateTXT={generateTXT}
                        downloadTXT={downloadTXT}
                        scenarios={scenarios}
                        createDocRecommend={this.validateAutorizationModels}
                        showDocs={this.showDocsRecommend}
                        requestPartialEdit={this.requestPartialEdit}
                        SendAprovedPartial={this.SendAprovedPartial}
                        disWhs={disWhs}
                        setWhsByRouteDocs={this.setWhsByRouteDocs}
                        getUserFieldHeaderValue={this.getUserFieldHeaderValue}
                        getItemUserFieldValue={this.getItemUserFieldValue}
                        getDimension1={this.getDimension1}
                        getDimension1ByUserField={this.getDimension1ByUserField}
                        scoopTools={scoopTools}
                        file={files}
                        setFiles={this.setFiles}
                        processUserFields={this.processUserFields}
                        searchDocuments={this.searchDocuments}
                        parseSeries={this.parseSeries}
                        CFWOptions={CFWOptions}
                        isDraftOWTQ={isDraftOWTQ}
                        DraftObjType={DraftObjType}
                    />)}

                {showTransfersDocumentModal &&
                    <TransfersDocumentModal
                        view={view}
                        newOrderModel={newOrderModel}
                        checkbox={checkbox}
                        cancelEditMode={this.CancelEditMode}
                        acceptEditMode={this.acceptEditMode}
                        showAlert={showAlert}
                        selectTable={this.selectTable}
                        selectDraftTable={this.selectDraftTable}
                        setUserFieldValue={this.setUserFieldValue}
                        selectValidateSeries={this.selectValidateSeries}
                        setUserFieldValueDefault={this.setUserFieldValueDefault}
                        changeDocumentActionModal={this.changeDocumentActionModal}
                        enableSpinner={enableSpinner}
                        billing={this.billingDetails}
                        refreshModel={this.refreshModel}
                        createDocument={this.sendModelContinue}
                        action={documentModalAction}
                        prices={prices}
                        openConfigUserFieldsHeaders={this.openConfigUserFieldsHeaders}
                        configHeaderUserFields={configHeaderUserFields}
                        CloseDocumentModal={this.CloseDocumentModal}
                        writeAccess={writeAccess}
                        ShowBatchDefinitionModal={this.ShowBatchDefinitionModal}
                        docFilter={docFilter}
                        generateTXT={generateTXT}
                        downloadTXT={downloadTXT}
                        scenarios={scenarios}
                        createDocRecommend={this.validateAutorizationModels}
                        showDocs={this.showDocsRecommend}
                        requestPartialEdit={this.requestPartialEdit}
                        SendAprovedPartial={this.SendAprovedPartial}
                        disWhs={disWhs}
                        setWhsByRouteDocs={this.setWhsByRouteDocs}
                        getDimension1ByUserField={this.getDimension1ByUserField}
                        scoopTools={scoopTools}
                        getUserFieldHeaderValue={this.getUserFieldHeaderValue}
                        parseSeries={this.parseSeries}
                        processUserFields={this.processUserFields}
                        processUserFieldsDetails={this.processUserFieldsDetails}
                    />}

                {showRequestPartialEdit &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas solicitar la edición del traslado de mercancía?'}
                        accept={this.SendRequestPartialEdit}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }

                {showPriceListModal &&
                    <NewPriceListModal
                        action={priceListAction}
                        CloseDocumentModal={this.ClosePriceListModal}
                        priceListsModel={priceListsModel}
                        SendNewPriceList={this.SendNewPriceList}
                        refreshModel={this.refreshPriceListModel}
                        showAlert={showAlert}
                        newArrayLists={newArrayLists}
                        AddnewArrayLists={this.AddnewArrayLists}
                        editMode={editModePriceList}
                        changeEditModePriceList={this.changeEditModePriceList}
                        UpdatePriceList={this.UpdatePriceList}
                        enableSpinner={enableSpinner}
                        itemGroupArray={this.state.ListItemsGroup}
                        firmArray={this.state.Producers} />
                }

                {showPartnerModal &&
                    <BussinesPartnerModal
                        view={view}
                        partnerModel={partnerModel}
                        action={partnerModalAction}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        writeAccess={writeAccess}
                        refreshModel={this.refreshPartnerModel}
                        sendModel={this.sendBusinessPartnerModel}
                        cancelEditMode={this.CancelEditModePartner}
                        acceptEditMode={this.acceptEditModePartner}
                        sendAuthModel={this.sendAuthModelPartner}
                        ref={(ref) => this.bussinesPartnerModal = ref}
                        showGroupNumModal={this.showGroupNumModal}
                        downloadAttachmentsFiles={this.DownloadAttachmentsFiles}
                        userFieldsPartner={userFieldsPartner}
                        fillGLAccountsPartner={this.fillGLAccountsPartner}
                    />}

                {showGroupNumModal &&
                    <GroupNumbersModal enableSearch={searchGroupNum} GroupNum={groupNum || null} />
                }

                {showInventoryModal &&
                    <InventoryDataModal
                        view={view}
                        inventoryModel={inventoryModel}
                        action={inventoryModalAction}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        refreshModel={this.refreshInventoryModel}
                        sendModel={this.sendInventoryDataModel}
                        cancelEditMode={this.CancelEditModeInventory}
                        acceptEditMode={this.acceptEditModeInventory}
                        ListItemsGroup={ListItemsGroup}
                        ListUnitMeasuGroup={ListUnitMeasuGroup}
                        prices={prices}
                        writeAccess={writeAccess}
                        ref={(ref) => this.inventoryDataModal = ref}
                        Producers={this.state.Producers}
                    />
                }

                {showAdminUsersModal &&
                    <AdministratorUsersModal
                        view={view}
                        adminUsersModel={adminUsersModel}
                        action={adminUsersModalAction}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        refreshModel={this.RefreshAdministratorUsersModel}
                        sendModel={this.SendAdministratorUsersModel}
                        cancelEditMode={this.CancelEditModeAdministratorUsers}
                        acceptEditMode={this.AcceptEditModeAdministratorUsers}
                        changePassword={this.ChangePasswordAdministratorUsers}
                        deleteUser={this.DeleteAdministratorUsers}
                        selectTable={this.selectTable}
                        selectDraftTable={this.selectDraftTable}
                        sucursales={sucursales}
                        jefeArea={jefeArea}
                        writeAccess={writeAccess}
                        bussinesPartnerArray={bussinesPartnerArray}
                        ref={(ref) => this.administratorUsersModal = ref}
                        userConfig={userConfig}
                        closeAdministratoruserModal={this.CloseAdminUserActions}
                        showBusinessPartnerFields={showBusinessPartnerFields}
                        token={token}
                        infoToken={infoToken}
                        refreshToken={this.refreshToken}
                        showPassword={this.showPassword}
                        saveMITData={this.SaveMITData}

                    />}
                {/* //#region  Modales CARTA PORTE */}
                {showCartaPorte &&
                    <>
                        <CartaPorteModal
                            view={view}
                            model={cartaPorteModel}
                            action={cartaPorteModalAction}
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            countries={listCountries}
                            disableButton={this.state.disableButton}
                            ref={(ref) => this.cartaPorteModal = ref}
                            refreshModel={this.refreshCartaPorteModel}
                            sendModel={this.sendCartaPorteModel}
                            deleteModel={this.deleteCartaPorteModel}
                            acceptEditMode={this.acceptEditModeCartaPorte}
                            cancelEditMode={this.CancelEditModeCartaPorte}
                            openFiguraTrans={this.openTipoFiguraDetails}
                            openTransporte={this.openTransporteDetails}
                            billing={this.billing}
                            _user={_user}
                            openDetails={this.openCartaPorteDetails}
                            searchDocuments={this.searchDocuments}

                            cleanCartaPorteModel={this.cleanCartaPorteModel}
                            regimenFiscal={RegimenFiscal}
                        />

                        <FiguraTransporteModal
                            view={view}
                            model={tipoFiguraModel}
                            action={tipoFiguraModalAction}
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            countries={listCountries}
                            ref={(ref) => this.tipoFiguraModal = ref}

                            refreshModel={this.refreshFiguraTransporteModel}
                            sendModel={this.sendTipoFiguraModel}
                            acceptEditMode={this.acceptEditModeFiguraTransporte}
                            cancelEditMode={this.CancelEditModeFiguraTransporte}
                            acceptDeleteModel={this.acceptDeleteFigTranport}
                        />
                        {showResumeTransportModal &&
                            <ResumeTransportModal
                                enableSpinner={enableSpinner}
                                showAlert={showAlert}
                                hideModal={() => this.setState({ showResumeTransportModal: false })}
                            />
                        }

                        <TransporteModal
                            view={view}
                            model={transporteModel}
                            action={transporteModalAction}
                            showAlert={showAlert}
                            enableSpinner={enableSpinner}
                            countries={listCountries}
                            ref={(ref) => this.transporteModal = ref}

                            tipoTransporte={tipoTransporte}
                            refreshTipoTransporte={this.refreshTipoTransporte}

                            refreshModel={this.refreshTransporteModel}
                            sendModel={this.sendTransporteModel}
                            acceptEditMode={this.acceptEditModeTransporte}
                            cancelEditMode={this.CancelEditModeTransporte}
                            acceptDeleteModel={this.acceptDeleteTranport}

                            // Configuración de remolques
                            cartaPorteModel={cartaPorteModel}
                            cartaPorteAction={cartaPorteModalAction}
                            cartaPorteEditMode={this.cartaPorteModal?.state?.editMode ?? false}
                            refreshCartaPorteModel={this.refreshCartaPorteModel}
                            SetInitialSeries={SetInitialSeries}
                            documentTypeSeries={documentTypeSeries}
                            OpenSeriesModal={this.OpenSeriesModal}
                            property={property}
                            propertyCode={propertyCode}
                            showSeriesModal={showSeriesModal}
                            checkbox={checkbox}
                            SaveSeries={this.SaveSeries}
                            CloseSeriesModal={this.CloseSeriesModal}
                            Drivers={this.state.availableDrivers}
                            ActualRoutes={this.state.ActualRoutes}

                        />
                    </>
                }
                {/* // #endregion */}

                {/* TIMBRADO DE NOMINA COMPONENTS */}
                {this.state.enableTimbraNomModal &&
                    <NominaModal
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        model={this.state.timbraNomModel}
                        action={this.state.nominaModalAction}
                        refreshModel={this.RefreshNomModel}
                        sendModel={this.CreateNominaDoc}
                        closeModalActions={this.CloseNominaModal}
                    />
                }

                {this.state.enableEmployeeNomModal &&
                    <EmployeeNominaModal
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        model={this.state.employeeNomModel}
                        action={this.state.employeeNomModalAction}
                        refreshModel={this.RefreshEmployeeNomModel}
                        sendModel={this.CreateEmployeeNominaDoc}
                        closeModalActions={this.CloseEmployeeNominaModal}
                    />
                }


                {/* //#region  Suggest Refill Module */}
                {this.state.showSuggestRefill &&
                    <SuggestRefillModal
                        view={view}
                        newOrderModel={this.state.refillModel}
                        action={this.state.refillModelAction}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        refreshModel={this.RefreshRefillModel}
                        SendSuggestRefillModel={this.SendSuggestRefillModel}
                        createDocument={this.sendModelContinue}
                        CloseDocumentModal={this.CloseSuggestRefillModal}
                        selectTable={this.selectTable}
                        selectDraftTable={this.selectDraftTable}
                        selectValidateSeries={this.selectValidateSeries}
                        changeDocumentActionModal={this.changeDocumentActionModal}

                    />
                }



                {showRoadmapPreview &&
                    <RoadMapPreviewModal
                        RoadmapPreview={RoadmapPreview}
                        CloseRoadmapPreview={this.CloseRoadmapPreview}
                        sendModel={this.SendRoadmap}
                        option={optionSelected}
                        showAlert={showAlert}
                    // enableSpinner={enableSpinner}
                    // ref={(ref) => this.administratorUsersModal = ref}
                    />}

                <BillingResponseModal array={billingResponse || billingResponseArray} refreshTable={this.searchDocuments} />

                <SelectSeriesModal view={view} seriesArray={seriesArray} seriesDefault={seriesDefault}
                    onchange={this.seriesModalChange} billing={this.billing} />

                <RenderConfigHeaderDataTableEnabled
                    view={view} headers={headers}
                    dataConfig={this.state.configHeaderTable}
                    toggleChangeConfig={this.toggleConfig}
                    onAcceptConfig={this.onAcceptConfig} />

                <RenderConfigUserFieldsEnabled
                    view={view} headers={headers}
                    dataConfig={this.state.configHeaderUserFields}
                    toggleConfigUserFields={this.toggleConfigUserFields}
                    onAcceptConfigUserFields={this.onAcceptConfigUserFields}
                    onCloseConfigUserFields={this.onCloseConfigUserFields} />

                {renderToPrint &&
                    <PrintToDocumentsModal
                        data={documentsToPrint}
                        format={docformat}
                        view={view}
                        _user={_user} />
                }

                {ennableDetailAuthoPartner &&
                    <ApproveBusinessPartnerModal
                        typeAuthoPartner={typeAuthoPartner}
                        partnerModel={authorizePartnerModel}
                        CloseActionsAuthorizePartners={this.CloseActionsAuthorizePartners}
                    />
                }

                {showBatchDefinitionModal &&
                    <BatchDefinitionModal
                        newOrderModel={newOrderModel}
                        showAlert={showAlert}
                        ShowBatchDefinitionModal={this.ShowBatchDefinitionModal}
                        cleanData={() => this.setState({ showBatchDefinitionModal: false })}
                        refreshModel={this.refreshModel} />
                }

                {showBatchSelectionModal &&
                    <BatchSelectionModal
                        massiveDocs={this.state.massiveDocs}
                        nextDocument={this.NextDocument}
                        removeIncompleteBatchDoc={this.RemoveIncompleteBatchDoc}
                        newOrderModel={newOrderModel}
                        showAlert={showAlert}
                        ShowBatchSelectionModal={this.ShowBatchSelectionModal}
                        refreshModel={this.refreshModel} />
                }

                {showVendorsModal &&
                    <VendorsModal
                        data={vendorsList}
                        vendorData={vendorData}
                        totalPage={totalPage}
                        cleanData={cleanData}
                        showAlert={showAlert}
                        selectBusinessParter={this.selectBusinessParter}
                    />
                }

                {showCitiBanamexModal &&
                    <CitibanamexTransactionsModal
                        docs={transactionDocs}
                        refreshDocuments={refreshDocuments}
                        openAgreeModal={openAgreeModal}
                        hideAgreeModal={hideAgreeModal}
                        sendInfo={() => sendInfo(docFilter)}
                        typeTransaction={typeTransaction}
                        enableSpinner={enableSpinner}
                        addTransaction={addTransaction} />
                }

                {showMVentasAdminModal &&
                    <MVentasAdminUsersModal
                        setShowMVentasModal={setShowMVentasModal}
                        modules={modules}
                        detailsData={detailsData}
                        setDetailsData={setDetailsData}
                        saveUser={saveUser}
                        enableSpinner={enableSpinner}
                    />
                }

                {showCancelPaymentModal &&
                    <CancelPaymentModal
                        cancelCurrentDate={cancelPaymentCurrentDate}
                        changeCancelDate={this.changeCancelPaymentDate}
                        continueAction={this.billing}
                        isMassive={true}
                        documents={paymentsToCancel}
                        cancelMode={cancelPaymentMode}
                        changeCancelMode={this.changeCancelPaymentMode}
                        documentDates={paymentDocumentDates}
                        changeDocumentDate={this.changePaymentDocumentDate}
                        resetPaymentsToCancel={this.resetPaymentsToCancel}
                    />
                }

                {view === 'citibanamex' &&
                    <div className="form-inline" style={{ important: true, paddingTop: 10, paddingBottom: 0 }}>
                        <div className="form-group mb-2 mt-2 mr-3">
                            <label className="Proveedor label-responsive"><strong>Proveedor:&nbsp;&nbsp;</strong></label>
                            <input type="text" className="btn-outline-secondary p-2"
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, maxWidth: 200 }}
                                id="Inptvendor"
                                placeholder="Código del proveedor"
                                onKeyPress={(ev) => { if (ev.key === 'Enter') { openVendor(); } }}
                                onChange={(ev) => this.changeBPCode(ev.target.value)}
                                value={vendorData.CardCode ? vendorData.CardCode : ''} />
                        </div>
                        <div className="form-group mb-2 mt-2 mr-3">
                            <label className="Proveedor label-responsive">
                                <strong>
                                    <span className="d-none d-xl-inline">Tipo de documento:&nbsp;&nbsp;</span>
                                    <span className="d-inline d-xl-none">Tipo doc:&nbsp;&nbsp;</span>
                                </strong>
                            </label>
                            <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearchCiti"
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                onChange={(event) => this.changeDocFilter(event.target.value)}>
                                <option value="OPCH">Facturas</option>
                                <option value="OPOR">Ordenes</option>
                            </select>
                        </div>
                        <div className="form-group mb-2 mt-2 mr-3">
                            <label className="Proveedor label-responsive"><strong>Sugerencias:&nbsp;&nbsp;</strong></label>
                            <label className="switch">
                                <input type="checkbox" checked={this.state.suggestionDocs} onChange={() => this.useSuggestionsDoc()} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        {this.state.suggestionDocs &&
                            <div className="form-group mb-2 mt-2 mr-3">
                                <label className="Proveedor label-responsive"><strong>Estado de {this.state.docFilter == 'OPCH' ? 'la factura' : ' la orden'}:&nbsp;&nbsp;</strong></label>
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearchCiti"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    value={docTypeSuggestion} onChange={(event) => this.changeDocSuggestion(event.target.value)}>
                                    <option value="expiredDocs">Vencidas</option>
                                    <option value="close2Exp">Próximas a vencer</option>
                                    <option value="inTime">Recientes</option>
                                    {/* <option value="1">Todos</option> */}
                                </select>
                            </div>
                        }
                    </div>
                }

                {view === 'collectView' &&
                    <>
                        <div className={'row d-flex justify-content-center mb-1'}>
                            <div className="col-12 col-sm-3 col-md-2 col-lg-2 d-flex justify-content-center mb-2">
                                <button className="btn btn-outline-success btn-active" style={{ whiteSpace: 'nowrap' }} onClick={() => ShowCollectModalModal(1, this.state.checkboxDataTables)}>
                                    <i className="fa fa-money" aria-hidden="true"></i>&nbsp;
                                    Abonar
                                </button>
                            </div>
                            <div className="col-12 col-sm-3 col-md-2 col-lg-2 d-flex justify-content-center mb-2">
                                <button className="btn btn-outline-success btn-active" style={{ whiteSpace: 'nowrap' }} onClick={() => depositos(1, this.state.checkboxDataTables)}>
                                    <i className="fa fa-money" aria-hidden="true"></i>&nbsp;
                                    Depósitos
                                </button>
                            </div>
                        </div>
                    </>
                }

                {(view !== "bussinesPartner" && view !== "inventoryData" && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'reportSelectionCriteria' && view !== 'adminUsersMVentas' && view !== 'wareHouseAdmin' && view !== 'priceLists' && view !== 'collectView' && view !== 'reabsResume' && view !== 'cutTransfers' && view !== 'pendingCuts') /*&& view !== 'consignmentNote')*/ ?

                    <div className="form-inline" style={{ important: true, paddingTop: 10, paddingBottom: 0 }}>

                        <div className="form-group mb-2 mr-1">
                            <label className="Desde label-responsive"><strong>Desde:&nbsp;&nbsp;</strong></label>
                            <input id="fechaInicio"
                                disabled={this.state.suggestionDocs}
                                className="form-control btn-outline-secondary listSerie " type="date"
                                placeholder="Fecha min" autoComplete="off"
                                max='9999-12-31'
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()} />
                        </div>

                        <div className="form-group mb-2">
                            <label className="Hasta label-responsive"><strong> &nbsp;&nbsp;Hasta:&nbsp;&nbsp;</strong></label>
                            <input id="fechaFin"
                                disabled={this.state.suggestionDocs}
                                className="form-control btn-outline-secondary listSerie " type="date"
                                placeholder="Fecha min" autoComplete="off"
                                max='9999-12-31'
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()} />
                        </div>

                        <div className="form-group mb-2">
                            {(view === "payment") &&
                                <label className="label-responsive"><strong> &nbsp;&nbsp;Tipo:&nbsp;&nbsp;</strong></label>}
                            {(view === "payment") &&
                                <select name="select" className="btn-outline-secondary select-responsive mr-sm-2 mr-1" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={(event) => this.searchBusinessParter(event, 3)}>
                                    <option value="---">Pago Normal</option>
                                    <option value="T">Timbrado</option>
                                    <option value="ST">Sin Timbrar</option>
                                    {/* <option value="1">Pago Cascos</option> */}
                                </select>}
                        </div>

                        {(view === 'payment' &&
                            <div className="form-group mb-2">
                                <label className="label-responsive">
                                    <strong> &nbsp;&nbsp;Estado:&nbsp;&nbsp;</strong>
                                </label>
                                <select
                                    name="select"
                                    className="btn-outline-secondary select-responsive mr-sm-2 mr-1"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    value={this.state.docStatus}
                                    onChange={(event) => this.searchBusinessParter(event, 4)}
                                >
                                    <option value="N">No Cancelado</option>
                                    <option value="Y">Cancelado</option>
                                </select>
                            </div>
                        )}
                        {((view === 'PurchaseRequest') &&
                            <div className="form-group mb-2">
                                <label className="label-responsive">
                                    <strong> &nbsp;&nbsp;Estado:&nbsp;&nbsp;</strong>
                                </label>
                                <select
                                    name="select"
                                    className="btn-outline-secondary select-responsive mr-sm-2 mr-1"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    value={this.state.isCanceled}
                                    onChange={(event) => this.searchBusinessParter(event, 5)}
                                >
                                    <option value="N">No Cancelado</option>
                                    <option value="Y">Cancelado</option>
                                </select>
                            </div>
                        )}

                        {(view === "authorizePartners") &&
                            <>
                                <div className="form-group mb-2 ml-1">
                                    <label className="label-responsive"><strong>Tipo:&nbsp;&nbsp;</strong></label>
                                    <select name="select" className="btn-outline-secondary select-responsive mr-sm-2 mr-1" id="selectDocTypeDocumentSearch"
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        onChange={async (event) => {
                                            await this.ChangeAuthoTypeBP(event.target.value);
                                            await this.searchDocuments();

                                        }}
                                        value={docStatusSearchAuthoBP ?? ""}
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="W">Pendientes</option>
                                        <option value="Y">Autorizados</option>
                                        <option value="N">Rechazados</option>

                                    </select>
                                </div>
                                <div className="form-group mb-2 ml-0">
                                    <label className="label-responsive"></label>
                                    < button
                                        className="btn btn-primary mr-2 btnNuevo mr-sm-2"
                                        title="Buscar registros de socios"
                                        onClick={() => this.searchDocuments()}>
                                        <span className="d-none d-xxl-inline">Buscar registros de socios</span>
                                        <span className="d-inline d-xxl-none">Buscar socios</span>
                                        <i className="fas fa-search ml-2"></i>
                                    </button>
                                </div>

                            </>

                        }

                        &nbsp;&nbsp;

                        <div className="form-group mb-2">
                            {(view === "orderSales" || view === "deliveries" || view === "invoice" || view === "return" || view === "debitNote" || view === "creditNote" || view === "PurchaseOrder" || view === "GoodsReceipt" || view === "purchaseReturn" || view === "purchaseInvoice" || view === 'purchaseCreditNotes' || view === "SalesHelmets" || view === "ExitHelmets" || view === "invoiceReserve" || view === "quotations" || view === "transfersRequest" || view === "PurchaseQuotation") &&
                                <label className="label-responsive" >
                                    <strong>
                                        <span className="d-none d-xl-inline">&nbsp;&nbsp;Estatus del Documento:&nbsp;&nbsp;</span>
                                        <span className="d-inline d-xl-none">&nbsp;Est. Doc:&nbsp;</span>
                                    </strong>
                                </label>}
                            {(view === "deliveries" || view === "invoice" || view === "return" || view === "debitNote" || view === "creditNote" || view === "PurchaseOrder" || view === "GoodsReceipt" || view === "purchaseReturn" || view === "purchaseInvoice" || view === 'purchaseCreditNotes' || view === "SalesHelmets" || view === "ExitHelmets" || view === "invoiceReserve" || view === "quotations" || view === "citibanamex" || view === "transfersRequest" || view === "PurchaseQuotation") &&

                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    disabled={this.state.suggestionDocs}
                                    onChange={(event) => this.searchBusinessParter(event, 4)}>
                                    <option value="---">Todos</option>
                                    <option value="O">Abierto</option>
                                    <option value="C">Cerrado</option>
                                    {(view === "invoice" || view === "debitNote" || view === "creditNote" || view === "invoiceReserve") && <option value="T">Timbrado</option>}
                                    {(view === "invoice" || view === "debitNote" || view === "creditNote" || view === "invoiceReserve") && <option value="ST">Sin timbrar</option>}
                                    {view === "invoiceReserve" ? <option value="P">Pagado</option> : ""}
                                </select>
                            }
                            {view === "orderSales" &&
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={(event) => this.searchBusinessParter(event, 4)}>
                                    <option value="---">Todos</option>
                                    <option value="O">Abierto</option>
                                    <option value="1">Proceso de autorización</option>
                                    <option value="3">Documento autorizado</option>
                                    <option value="2">Documento rechazado</option>
                                    <option value="C">Cerrado</option>
                                </select>
                            }

                            {view === "consignmentNote" &&
                                <>
                                    <label className="label-responsive"><strong> Tipo de carta porte: &nbsp;&nbsp;</strong></label>
                                    <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearchCP"
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        onChange={(event) => this.searchDocuments()}>
                                        <option value="-">Todas</option>
                                        <option value="I">Ingreso</option>
                                        <option value="T">Traslado</option>
                                    </select>
                                </>
                            }

                            {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceAdvance' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote') &&
                                <>
                                    <label className="label-responsive">
                                        <strong>
                                            <span className="d-none d-xl-inline">&nbsp;&nbsp;Búsqueda por serie:&nbsp;&nbsp;</span>
                                            <span className="d-inline d-xl-none">&nbsp;&nbsp;Búsq. Serie:&nbsp;&nbsp;</span>
                                        </strong>
                                    </label>
                                    <input type="text" className="btn-outline-secondary input-sm input-responsive"
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, maxWidth: 110 }}
                                        id="txtDocNum"
                                        placeholder="Nombre serie"
                                        onKeyDown={event => event.keyCode === 13 && this.searchDocuments()}
                                        onChange={(event) => this.ChangeSearchSerieName(event.target.value)}
                                        value={searchSerieName || ''}
                                    />
                                </>
                            }

                            &nbsp;
                            {(view !== "middleware" && view !== "bussinesPartner" && view !== "inventoryData" && view !== "invoiceAuthorization" && view !== "invoiceBorrador" && view !== "administratorUsers" && view !== "figuresTransport" && view !== "transports" && view !== "consignmentNote" && view !== "pendingTimbraDoc" && view !== 'authorizePartners' && view !== 'adminDeliveries20' && view !== 'salesForecast' && view !== 'mrpAssistant' && view !== "adminUsersMVentas" && view !== "employeeNomina" && view !== "canalizadoTanque" && view !== "collectView") &&
                                <>
                                    <label className="label-responsive">
                                        <strong>
                                            <span className="d-none d-xl-inline">&nbsp;&nbsp;Búsqueda del Documento:&nbsp;&nbsp;</span>
                                            <span className="d-inline d-xl-none">&nbsp;Búsq. Doc:&nbsp;</span>
                                        </strong>
                                    </label>
                                    <input type="text" className="btn-outline-secondary input-sm input-responsive"
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, maxWidth: 110 }}
                                        id="txtDocNum"
                                        placeholder="DocNum"
                                        onKeyDown={event => event.keyCode === 13 && this.searchDocuments()}
                                        onChange={(event) => this.searchByDocNum(event)}
                                        value={docNumSearch || ''}
                                    />
                                </>
                            }
                        </div>
                        &nbsp;

                        {(view === 'PurchaseRequest' || isOPORView) &&
                            <div className="input-group p-0 mb-2 mr-1 col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                                <Select
                                    options={[...new Set((data || []).map(d => isOPORView ? d.SucursalLinea : d.Sucursal).filter(Boolean))].map(nombre => ({ value: nombre, label: nombre }))}
                                    value={this.state.selectedSucursal}
                                    onChange={(selectedOptions) => {
                                        this.setState({ selectedSucursal: selectedOptions || [] });
                                    }}
                                    placeholder="Filtrar por Sucursal"
                                    isMulti={true}
                                    isSearchable={true}
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                    styles={{
                                        container: (base) => ({ ...base, flex: 1 }),
                                        control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 200, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da" }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        valueContainer: (base) => ({ ...base, maxHeight: 40, overflowY: 'auto', flexWrap: 'wrap' }),
                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                        singleValue: (base) => ({ ...base, color: "#000" })
                                    }}
                                />
                            </div>
                        }
                        {isOPORView &&
                            <div className="input-group p-0 mb-2 mr-1 col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                                <Select
                                    options={[...new Set((data || []).map(d => d.SlpCode).filter(Boolean))].map(nombre => ({ value: nombre, label: nombre }))}
                                    value={this.state.selectedAnalista}
                                    onChange={(selectedOptions) => {
                                        this.setState({ selectedAnalista: selectedOptions || [] });
                                    }}
                                    placeholder="Filtrar por Analista"
                                    isMulti={true}
                                    isSearchable={true}
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                    styles={{
                                        container: (base) => ({ ...base, flex: 1 }),
                                        control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 200, /*maxWidth: 400,*/ borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da" }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        valueContainer: (base) => ({ ...base, maxHeight: 40, overflowY: 'auto', flexWrap: 'wrap' }),
                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                        singleValue: (base) => ({ ...base, color: "#000" })
                                    }}
                                />
                            </div>
                        }

                        <div className="form-group mb-2">
                            {(view === "invoiceAuthorization" || view === "invoiceBorrador") &&
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={this.searchDocuments}>
                                    <option value="--">---</option>
                                    <option value="23">Oferta De Venta</option>
                                    <option value="17">Orden De Venta</option>
                                    <option value="15">Entrega</option>
                                    <option value="13">Factura</option>
                                    {Modules.InvoiceAdvance && <option value="203">Factura de anticipo</option>}
                                    <option value="16">Devolución</option>
                                    <option value="21">Devolución de Mercancía</option>
                                    <option value="13DN">Nota de Débito</option>
                                    <option value="14">Nota de Crédito</option>
                                    {/*<option value="24">Pago</option>*/}
                                    <option value="67">Traslado de Mercancía</option>
                                    <option value="59">Entrada de Mercancía</option>
                                    <option value="60">Salida de Mercancía</option>
                                    <option value="1470000113">Solicitud de Compra</option>
                                    <option value="22">Orden de Compra</option>
                                    <option value="18">Factura proveedor</option>
                                    {Modules.PurchaseDownPayments && <option value="204">Factura de anticipo (PROVEEDOR)</option>}
                                    <option value="20">Entrada de Mercancia (PROVEEDOR)</option>
                                    <option value="21">Devolucion de Mercancia (PROVEEDOR)</option>
                                    <option value="18DM">Nota de Débito (PROVEEDOR)</option>
                                    <option value="19">Nota de Crédito (PROVEEDOR)</option>

                                </select>}
                            {view === "pendingTimbraDoc" &&
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearchPTD"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={this.searchDocuments}>
                                    <option value="--">Selecciona un tipo de documento</option>
                                    <option value="13">Factura</option>
                                    <option value="203">Facturas de anticipo</option>
                                    <option value="14">Nota de Crédito</option>
                                    <option value="24">Pago</option>


                                </select>}
                            {view === "draft" &&
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={async (event) => {
                                        this.setState({ selectedSucursal: [], selectedAnalista: [] });
                                        await changeDraftObjType(event?.target?.value);
                                        await this.searchDocuments();
                                    }}
                                    value={DraftObjType}
                                >
                                    <option value="540000006">Oferta de Compra</option>
                                    <option value="22">Orden de Compra</option>
                                    <option value="1250000001">Solicitud de traslado</option>
                                </select>
                            }
                        </div>
                        &nbsp;&nbsp;
                        <div className="form-group mb-2">
                            {(view === "invoiceBorrador") &&
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentStockValidator"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={this.searchDocuments}>
                                    <option selected value="-">Seleccione un estatus</option>
                                    <option value="W">Pendientes</option>
                                    <option value="T">Terminados</option>
                                    <option value="C">Cancelados</option>
                                    {ObjType === "67" && <option value="PAR">Parciales</option>}
                                    {/* <option value="1">Stock Ajustado</option>
                            <option value="0">Artículos sin stock</option>
                            <option value="SN">Sin procesar por SN</option> */}
                                </select>}
                        </div>
                        &nbsp;&nbsp;
                        <div className="form-group mb-2">
                            {(view === "invoiceAuthorization") &&
                                <select name="select" className="btn-outline-secondary select-responsive mr-sm-2 mr-1" id="selectDocTypeDocumentSearch2"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={this.searchDocuments}>
                                    <option value="--">Todos</option>
                                    <option value="WN">Pendientes/Rechazados</option>
                                    <option value="W">Pendientes</option>
                                    <option value="Y">Autorizados</option>
                                    <option value="N">Rechazados</option>
                                    {/* <option value="---">Reporte</option> */}
                                </select>}
                        </div>

                        <div className="form-group mb-2">
                            {(view === "middleware") &&
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearchOMDL"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, marginRight: '15px' }}
                                    onChange={this.searchDocuments}>
                                    <option value="---">Todos</option>
                                    <option value="W">Pendientes</option>
                                    <option value="Y">Procesados</option>
                                </select>
                            }
                        </div>
                        {view === "pendingTimbraDoc" &&
                            <>
                                <div className="form-group mb-2 ml-0">
                                    <label className="label-responsive mb-0">
                                        <strong>
                                            <span className="d-none d-xl-inline">&nbsp;&nbsp;Cliente:&nbsp;&nbsp;</span>
                                            <span className="d-inline d-xl-none">Cliente:</span>
                                        </strong>
                                    </label>
                                    <input
                                        className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2 input-responsive respinp mr-1'
                                        style={{ display: 'inline-flex', marginLeft: '5px' }}
                                        placeholder="Codigo de cliente"
                                        autoComplete="off"
                                        id='PTD_CardCode'
                                        type='text'
                                        aria-controls='dataTableTimbra'
                                        onKeyPress={(eve) => {
                                            if (eve.key === 'Enter') {
                                                this.searchDocuments()
                                            }
                                        }}
                                    />
                                </div>

                                <div className="form-group mb-2 ml-0">
                                    <label className="label-responsive mb-0">
                                        <strong>
                                            <span className="d-none d-xl-inline">&nbsp;&nbsp;DocNum:&nbsp;&nbsp;</span>
                                            <span className="d-inline d-xl-none">DocNum:</span>
                                        </strong>
                                    </label>
                                    <input
                                        className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2 input-responsive respinp mr-1'
                                        style={{ display: 'inline-flex', marginLeft: '5px' }}
                                        placeholder="No. Documento"
                                        autoComplete="off"
                                        id='PTD_DocNum'
                                        type='text'
                                        aria-controls='dataTableTimbra'
                                        onKeyPress={(eve) => {
                                            if (eve.key === 'Enter') {
                                                this.searchDocuments()
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        }
                        {view === "adminDeliveries20" &&
                            <div className="form-group mb-2 ml-0">
                                <label className="label-responsive"><strong>Tipo de atención:&nbsp;&nbsp;</strong></label>
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                    onChange={async (event) => {
                                        await this.ChangeAttentionType(event?.target?.value);
                                        await this.searchDocuments();
                                    }}
                                    value={U_FMB_AttentionType ?? ""}
                                >
                                    <option value="">Seleccionar</option>
                                    <option value="RCF">Ruta Cliente Final</option>
                                    <option value="RUT">Ruta Distribuidores</option>
                                </select>
                            </div>
                        }


                        {(view === "middleware" || view === "invoiceAuthorization" || view === 'pendingTimbraDoc' || view === 'adminUsersMVentas') &&
                            <div className="form-group mb-2 ml-0">
                                <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2 input-responsive respinp sugerido' style={{ display: 'inline-flex', marginLeft: '5px' }} placeholder="Buscar en tabla" autoComplete="off" id='searchDataTable'
                                    type='search' aria-controls='dataTableTimbra' onChange={this.SearchInTable} />
                            </div>}
                        &nbsp;&nbsp;
                        {view !== 'authorizePartners' &&
                            <button className="btn btn-active" data-toggle="tooltip" data-placement="top" title="Buscar" onClick={this.searchDocuments}>
                                <i className="fas fa-search"></i>
                            </button>
                        }


                    </div>

                    :

                    <div className="form-inline" style={{ important: true, paddingTop: 10, paddingBottom: 0 }}>
                        {(view !== "inventoryData" && view !== "administratorUsers" && view !== "figuresTransport" && view !== "transports" && view !== "consignmentNote" && view !== 'reportSelectionCriteria' && view !== "adminUsersMVentas" && view !== "wareHouseAdmin" && view !== "priceLists" && view !== 'canalizadoTanque' && view !== "collectView" && view !== "reabsResume" && view !== 'cutTransfers' && view !== 'pendingCuts') ?
                            <div className="form-group mb-2">
                                <label className="label-responsive"><strong>Grupo:&nbsp;&nbsp;</strong></label>
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 250 }}
                                    onChange={(event) => this.searchBusinessParter(event, 1)}>
                                    <option value="---">---</option>
                                    {!!groupCodes && groupCodes.map(group => {
                                        return (<option value={group.GroupCode}>{group.GroupName}</option>)
                                    })}
                                </select>&nbsp;


                                <label className="label-responsive">
                                    <strong>&nbsp;&nbsp;<span className="d-none d-xl-inline">Lista de precio:</span>
                                        <span className="d-inline d-xl-none">Precio:</span>&nbsp;&nbsp;
                                    </strong>
                                </label>
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 250 }}
                                    onChange={(event) => this.searchBusinessParter(event, 2)}>
                                    <option value="---">---</option>
                                    {!!priceList && priceList.map(price => {
                                        return (<option value={price.ListNum}>{price.ListName}</option>)
                                    })}
                                    <option value={-1}>Último precio de compra</option>
                                    <option value={-2}>Último precio determinado</option>
                                </select>&nbsp;



                                <br className="hide-pc" />

                                <label className="label-responsive"><strong>&nbsp;&nbsp;Empleado:&nbsp;&nbsp;</strong></label>
                                <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 250 }}
                                    onChange={(event) => this.searchBusinessParter(event, 3)}>
                                    <option value="---">---</option>
                                    {!!listEmployees && listEmployees.map(employee => {
                                        return (<option value={employee.SlpCode}>{employee.SlpName}</option>)
                                    })}
                                </select>

                            </div>

                            :
                            (view !== 'administratorUsers' && view !== "figuresTransport" && view !== "transports" && view !== "consignmentNote" && view !== 'reportSelectionCriteria' && view !== "adminUsersMVentas" && view !== "wareHouseAdmin" && view !== "priceLists" && view !== 'canalizadoTanque' && view !== "collectView" && view !== "reabsResume" && view !== 'cutTransfers' && view !== 'pendingCuts') ?
                                <div className="form-group mb-2">
                                    <label className="label-responsive"><strong>Grupo:&nbsp;&nbsp;</strong></label>
                                    <select name="select" className="btn-outline-secondary select-responsive" id="selectDocTypeDocumentSearch"
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, width: 150 }}
                                        onChange={(event) => this.searchBusinessParter(event, 1)}>
                                        <option value="---">---</option>
                                        {!!ListItemsGroup && ListItemsGroup.map(group => {
                                            return (
                                                <option value={group.ItmsGrpCod}>{group.ItmsGrpNam}</option>
                                            )
                                        })}
                                    </select>&nbsp;
                                </div>
                                :
                                view !== "figuresTransport" && view !== "transports" && view !== "consignmentNote" && view !== 'reportSelectionCriteria' && view !== "adminUsersMVentas" && view !== "wareHouseAdmin" && view !== "priceLists" && view !== 'canalizadoTanque' && view !== "collectView" && view !== "reabsResume" && view !== 'cutTransfers' && view !== 'pendingCuts' ?
                                    <div className="form-group mb-2">
                                        <label className="label-responsive"><strong>Sucursal:&nbsp;&nbsp;</strong></label>
                                        <Select options={opcionesSucursales}
                                            value={opcionesSucursales.find(option => String(option.value) === String(this.state.groupSucursal)) || null}
                                            onChange={(selectedOption) => { this.SearchUsers(selectedOption, 1); }}
                                            placeholder={opcionesSucursales.length > 0 ? "Selecciona sucursal" : "Cargando sucursales"}
                                            isSearchable={true}
                                            isClearable={true}
                                            noOptionsMessage={() => "No se encontraron coincidencias"}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: 40,
                                                    minHeight: 40,
                                                    width: 300,
                                                    minWidth: 300,
                                                    maxWidth: 300,
                                                    borderRadius: 4,
                                                    backgroundColor: "transparent",
                                                    borderColor: "#ced4da"
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "#000"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    color: "#000"
                                                })
                                            }}
                                            isDisabled={opcionesSucursales.length === 0}
                                        />&nbsp;
                                    </div>
                                    :
                                    <></>
                        }
                        {!restrictedViewsSearch.includes(view) && <button className="btn btn-active" data-toggle="tooltip" data-placement="top"
                            title={!labelViewsSearch.includes(view) ? 'Buscar por fecha' : 'Buscar'}
                            onClick={this.searchDocuments}>
                            <i className="fas fa-search"></i>
                        </button>}

                    </div>
                }

                <FactoryActions
                    props={this.props}
                    state={this.state}
                    openTransporte={this.openTransporte}
                    writeAccess={writeAccess}
                    searchDocuments={this.searchDocuments}
                    openTransportResume={this.openTransportResume}
                    printRoadmapPreview={this.printRoadmapPreview}
                    createNewRouteDelivery={this.NewDocumentDelivery}
                    printDelivaryAcuse={this.printDelivaryAcuse}
                    showAlert={showAlert}
                    reprint={this.reprint}
                    prepareSunatGuide={this.prepareSunatGuide}
                    cancelHR={this.cancelHR}
                />

                {/*<div> */}
                {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
                {renderDataTableActions(this.SearchInTable, this.createDocument, this.selectSeries, view, this.openBussinesPartner, this.openInventoryData, this.handleInputChange,
                    this.openConfigTableHeaders, this.generateCsv, flag, report, this.authorizationReport, this.getAllDocumentsToPrint, this.OpenAdministratorUsers, writeAccess,
                    this.openFiguraTransporte, this.openTransporte, this.openCartaPorte, this.citiOption, this.ChangeAuthoPartnersAction, this.SendAuthorizations,
                    this.NewDocumentDelivery, allowClose, this.closeDocumentsAsInvoice, this.CloseDocuments, GetEntryTransfersData, this.OpenSuggestRefillModal, this.printDelivaryAcuse, this.OpenReconciliationModal,
                    this.showGroupNumModal, this.CreateNewPriceList, this.OpenRegisterNomina, this.TimbraNomina, this.DowloadMassive, this.OpenRegisterEmployeeNomina,
                    this.printRoadmapPreview, this.importUsers, this.downloadUsersTemplate, DraftObjType, _user?.BranchPermission, this.props.pendingCutsActions
                )}

                <br />

                <div className="w-100 table-scroll">
                    {this.renderTable()}
                </div>
                <br />

                <div className="d-flex flex-wrap justify-content-end align-items-center">
                    <div className="form-group mb-2">
                        {(view !== 'bussinesPartner' && view !== 'inventoryData' && view !== 'administratorUsers' && view !== "adminUsersMVentas" && view !== "pendingCuts") &&
                            <label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right registros" style={{ width: 195 }}>
                                Registros por página:
                            </label>}
                    </div>
                    {(view !== 'bussinesPartner' && view !== 'inventoryData' && view !== 'administratorUsers' && view !== "adminUsersMVentas" && view !== "pendingCuts") &&
                        <div className="form-group mb-2">
                            <select
                                className="col col-form-label col-form-label-sm text-right"
                                style={{ width: 80 }}
                                id='changePaginateSelect'
                                onChange={this.changePaging}>
                                <option value={view === 'invoiceAuthorization' ? "100" : "10"}>{view === 'invoiceAuthorization' ? "100" : "10"}</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value={view === 'invoiceAuthorization' ? "10" : "100"}>{view === 'invoiceAuthorization' ? "10" : "100"}</option>
                            </select>&nbsp;&nbsp;
                        </div>}

                    <div className="form-group mb-2">
                        {(view !== 'bussinesPartner' && view !== 'inventoryData' && view !== 'administratorUsers' && view !== "adminUsersMVentas" && view !== "pendingCuts") &&
                            <label htmlFor="colFormLabelSm" id="tableInfo"
                                className="col-form-label col-form-label-sm">
                            </label>}

                        {(view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === "adminUsersMVentas" || view === "pendingCuts") &&
                            <label htmlFor="colFormLabelSm"
                                className="col-form-label col-form-label-sm">
                                {rows} de {total}
                            </label>}
                    </div>

                    <div className="d-flex align-items-center mb-2 flex-nowrap">
                        <button className="btn btn-link btn-sm " style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Primera" onClick={this.first}><i
                                className="fas fa-chevron-left btn-first"></i></button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Anterior" onClick={this.previous}><i
                                className="fas fa-chevron-left"></i></button>
                        {(view === 'bussinesPartner' || view === 'inventoryData' || view === 'administratorUsers' || view === "adminUsersMVentas" || view === "pendingCuts") &&
                            <label htmlFor="colFormLabelSm"
                                className="col-form-label col-form-label-sm">
                                {PageNumber}
                            </label>}
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Siguiente" onClick={this.next}><i
                                className="fas fa-chevron-right"></i></button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Última" onClick={this.last}><i
                                className="fas fa-chevron-right btn-last"></i></button>
                    </div>

                </div>
                <br></br><br></br>
                {showUpdateTimbraDocModal &&
                    <UpdateTimbraDocs
                        model={updateTimbraDocModel}
                        CFDI={CFDI}
                        RegimenFiscal={RegimenFiscal}
                        action={actionUpdateTimbraDoc}
                        editMode={editModeUpdateTimbraDocModel}
                        CloseUpdateDocModel={this.CloseUpdateDocModel}
                        ChangeEditModeTimbraDocModal={this.ChangeEditModeTimbraDocModal}
                        UpdateTimbraDocModel={this.UpdateTimbraDocModel}
                        AcceptEditMode={this.UpdateTimbraDoc}
                    />
                }

                <FileUploaderModal
                    enableSpinner={enableSpinner} />

                {showWarningModal &&
                    <WarningModal
                        title='Advertencia'
                        message={WarningModalOptions?.message || ""}
                        btnAccept='Continuar'
                        btnCancel='Cancelar'
                        size={WarningModalOptions?.size || "modal-md"}
                        accept={WarningModalOptions?.action || (() => { })}
                        cancel={() => { }} />
                }
                {showReconciliationModal &&
                    <ReconciliationModal
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        clientList={clientList} />
                }

                {(!!massiveUsers.length) &&
                    <MassiveUsersModal
                        users={massiveUsers} />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(DataTables);
